(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 5602:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
exports.Z = _defineProperty;
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


/***/ }),

/***/ 4782:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 816:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



const base64 = __webpack_require__(4782)
const ieee754 = __webpack_require__(8898)
const customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.lW = Buffer
__webpack_unused_export__ = SlowBuffer
exports.h2 = 50

const K_MAX_LENGTH = 0x7fffffff
__webpack_unused_export__ = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    const arr = new Uint8Array(1)
    const proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  const buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  const valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  const b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length)
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  const length = byteLength(string, encoding) | 0
  let buf = createBuffer(length)

  const actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  const length = array.length < 0 ? 0 : checked(array.length) | 0
  const buf = createBuffer(length)
  for (let i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    const copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  let buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    const len = checked(obj.length) | 0
    const buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  let x = a.length
  let y = b.length

  for (let i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  let i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  const buffer = Buffer.allocUnsafe(length)
  let pos = 0
  for (i = 0; i < list.length; ++i) {
    let buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)
        buf.copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  const len = string.length
  const mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  let loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  let loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  const i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  const len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (let i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  const len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (let i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  const len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (let i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  const length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  let str = ''
  const max = exports.h2
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  let x = thisEnd - thisStart
  let y = end - start
  const len = Math.min(x, y)

  const thisCopy = this.slice(thisStart, thisEnd)
  const targetCopy = target.slice(start, end)

  for (let i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  let indexSize = 1
  let arrLength = arr.length
  let valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  let i
  if (dir) {
    let foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      let found = true
      for (let j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  const remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  const strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  let i
  for (i = 0; i < length; ++i) {
    const parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  const remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  let loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  const res = []

  let i = start
  while (i < end) {
    const firstByte = buf[i]
    let codePoint = null
    let bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      let secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  const len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  let res = ''
  let i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  let ret = ''
  end = Math.min(buf.length, end)

  for (let i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  let ret = ''
  end = Math.min(buf.length, end)

  for (let i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  const len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  let out = ''
  for (let i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  const bytes = buf.slice(start, end)
  let res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (let i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  const len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  const newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let val = this[offset]
  let mul = 1
  let i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  let val = this[offset + --byteLength]
  let mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const lo = first +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 24

  const hi = this[++offset] +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    last * 2 ** 24

  return BigInt(lo) + (BigInt(hi) << BigInt(32))
})

Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const hi = first * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    this[++offset]

  const lo = this[++offset] * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    last

  return (BigInt(hi) << BigInt(32)) + BigInt(lo)
})

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let val = this[offset]
  let mul = 1
  let i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let i = byteLength
  let mul = 1
  let val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  const val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  const val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const val = this[offset + 4] +
    this[offset + 5] * 2 ** 8 +
    this[offset + 6] * 2 ** 16 +
    (last << 24) // Overflow

  return (BigInt(val) << BigInt(32)) +
    BigInt(first +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 24)
})

Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    this[++offset]

  return (BigInt(val) << BigInt(32)) +
    BigInt(this[++offset] * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    last)
})

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    const maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  let mul = 1
  let i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    const maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  let i = byteLength - 1
  let mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function wrtBigUInt64LE (buf, value, offset, min, max) {
  checkIntBI(value, min, max, buf, offset, 7)

  let lo = Number(value & BigInt(0xffffffff))
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  let hi = Number(value >> BigInt(32) & BigInt(0xffffffff))
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  return offset
}

function wrtBigUInt64BE (buf, value, offset, min, max) {
  checkIntBI(value, min, max, buf, offset, 7)

  let lo = Number(value & BigInt(0xffffffff))
  buf[offset + 7] = lo
  lo = lo >> 8
  buf[offset + 6] = lo
  lo = lo >> 8
  buf[offset + 5] = lo
  lo = lo >> 8
  buf[offset + 4] = lo
  let hi = Number(value >> BigInt(32) & BigInt(0xffffffff))
  buf[offset + 3] = hi
  hi = hi >> 8
  buf[offset + 2] = hi
  hi = hi >> 8
  buf[offset + 1] = hi
  hi = hi >> 8
  buf[offset] = hi
  return offset + 8
}

Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE (value, offset = 0) {
  return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'))
})

Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE (value, offset = 0) {
  return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'))
})

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    const limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  let i = 0
  let mul = 1
  let sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    const limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  let i = byteLength - 1
  let mul = 1
  let sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE (value, offset = 0) {
  return wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'))
})

Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE (value, offset = 0) {
  return wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'))
})

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  const len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      const code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  let i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    const bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    const len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// CUSTOM ERRORS
// =============

// Simplified versions from Node, changed for Buffer-only usage
const errors = {}
function E (sym, getMessage, Base) {
  errors[sym] = class NodeError extends Base {
    constructor () {
      super()

      Object.defineProperty(this, 'message', {
        value: getMessage.apply(this, arguments),
        writable: true,
        configurable: true
      })

      // Add the error code to the name to include it in the stack trace.
      this.name = `${this.name} [${sym}]`
      // Access the stack to generate the error message including the error code
      // from the name.
      this.stack // eslint-disable-line no-unused-expressions
      // Reset the name to the actual name.
      delete this.name
    }

    get code () {
      return sym
    }

    set code (value) {
      Object.defineProperty(this, 'code', {
        configurable: true,
        enumerable: true,
        value,
        writable: true
      })
    }

    toString () {
      return `${this.name} [${sym}]: ${this.message}`
    }
  }
}

E('ERR_BUFFER_OUT_OF_BOUNDS',
  function (name) {
    if (name) {
      return `${name} is outside of buffer bounds`
    }

    return 'Attempt to access memory outside buffer bounds'
  }, RangeError)
E('ERR_INVALID_ARG_TYPE',
  function (name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`
  }, TypeError)
E('ERR_OUT_OF_RANGE',
  function (str, range, input) {
    let msg = `The value of "${str}" is out of range.`
    let received = input
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) {
      received = addNumericalSeparator(String(input))
    } else if (typeof input === 'bigint') {
      received = String(input)
      if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) {
        received = addNumericalSeparator(received)
      }
      received += 'n'
    }
    msg += ` It must be ${range}. Received ${received}`
    return msg
  }, RangeError)

function addNumericalSeparator (val) {
  let res = ''
  let i = val.length
  const start = val[0] === '-' ? 1 : 0
  for (; i >= start + 4; i -= 3) {
    res = `_${val.slice(i - 3, i)}${res}`
  }
  return `${val.slice(0, i)}${res}`
}

// CHECK FUNCTIONS
// ===============

function checkBounds (buf, offset, byteLength) {
  validateNumber(offset, 'offset')
  if (buf[offset] === undefined || buf[offset + byteLength] === undefined) {
    boundsError(offset, buf.length - (byteLength + 1))
  }
}

function checkIntBI (value, min, max, buf, offset, byteLength) {
  if (value > max || value < min) {
    const n = typeof min === 'bigint' ? 'n' : ''
    let range
    if (byteLength > 3) {
      if (min === 0 || min === BigInt(0)) {
        range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`
      } else {
        range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` +
                `${(byteLength + 1) * 8 - 1}${n}`
      }
    } else {
      range = `>= ${min}${n} and <= ${max}${n}`
    }
    throw new errors.ERR_OUT_OF_RANGE('value', range, value)
  }
  checkBounds(buf, offset, byteLength)
}

function validateNumber (value, name) {
  if (typeof value !== 'number') {
    throw new errors.ERR_INVALID_ARG_TYPE(name, 'number', value)
  }
}

function boundsError (value, length, type) {
  if (Math.floor(value) !== value) {
    validateNumber(value, type)
    throw new errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value)
  }

  if (length < 0) {
    throw new errors.ERR_BUFFER_OUT_OF_BOUNDS()
  }

  throw new errors.ERR_OUT_OF_RANGE(type || 'offset',
                                    `>= ${type ? 1 : 0} and <= ${length}`,
                                    value)
}

// HELPER FUNCTIONS
// ================

const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  let codePoint
  const length = string.length
  let leadSurrogate = null
  const bytes = []

  for (let i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  const byteArray = []
  for (let i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  let c, hi, lo
  const byteArray = []
  for (let i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  let i
  for (i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const hexSliceLookupTable = (function () {
  const alphabet = '0123456789abcdef'
  const table = new Array(256)
  for (let i = 0; i < 16; ++i) {
    const i16 = i * 16
    for (let j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()

// Return not function with Error if BigInt not supported
function defineBigIntMethod (fn) {
  return typeof BigInt === 'undefined' ? BufferBigIntNotDefined : fn
}

function BufferBigIntNotDefined () {
  throw new Error('BigInt not supported')
}


/***/ }),

/***/ 5839:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(2097);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 4173:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 2097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(4173);
} else {}


/***/ }),

/***/ 8898:
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 9800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jc": function() { return /* reexport */ appWithTranslation; },
  "$G": function() { return /* reexport */ useTranslation; }
});

// UNUSED EXPORTS: I18nContext, Trans, Translation, i18n, withTranslation

;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}

;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}

;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}

;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/typeof.js
function typeof_typeof(o) {
  "@babel/helpers - typeof";

  return typeof_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, typeof_typeof(o);
}

;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function toPrimitive(t, r) {
  if ("object" != typeof_typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof_typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == typeof_typeof(i) ? i : i + "";
}

;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/defineProperty.js

function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/createClass.js

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}

;// CONCATENATED MODULE: ../node_modules/react-i18next/dist/es/unescape.js
var matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var htmlEntities = {
  '&amp;': '&',
  '&#38;': '&',
  '&lt;': '<',
  '&#60;': '<',
  '&gt;': '>',
  '&#62;': '>',
  '&apos;': "'",
  '&#39;': "'",
  '&quot;': '"',
  '&#34;': '"',
  '&nbsp;': ' ',
  '&#160;': ' ',
  '&copy;': '©',
  '&#169;': '©',
  '&reg;': '®',
  '&#174;': '®',
  '&hellip;': '…',
  '&#8230;': '…',
  '&#x2F;': '/',
  '&#47;': '/'
};

var unescapeHtmlEntity = function unescapeHtmlEntity(m) {
  return htmlEntities[m];
};

var unescape_unescape = function unescape(text) {
  return text.replace(matchHtmlEntity, unescapeHtmlEntity);
};
;// CONCATENATED MODULE: ../node_modules/react-i18next/dist/es/context.js




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



var defaultOptions = {
  bindI18n: 'languageChanged',
  bindI18nStore: '',
  transEmptyNodeValue: '',
  transSupportBasicHtmlNodes: true,
  transWrapTextNodes: '',
  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
  useSuspense: true,
  unescape: unescape_unescape
};
var i18nInstance;
var I18nContext = (0,react.createContext)();
function setDefaults() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  defaultOptions = _objectSpread(_objectSpread({}, defaultOptions), options);
}
function getDefaults() {
  return defaultOptions;
}
var ReportNamespaces = function () {
  function ReportNamespaces() {
    _classCallCheck(this, ReportNamespaces);

    this.usedNamespaces = {};
  }

  _createClass(ReportNamespaces, [{
    key: "addUsedNamespaces",
    value: function addUsedNamespaces(namespaces) {
      var _this = this;

      namespaces.forEach(function (ns) {
        if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function getUsedNamespaces() {
      return Object.keys(this.usedNamespaces);
    }
  }]);

  return ReportNamespaces;
}();
function setI18n(instance) {
  i18nInstance = instance;
}
function getI18n() {
  return i18nInstance;
}
var initReactI18next = {
  type: '3rdParty',
  init: function init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};
function composeInitialProps(ForComponent) {
  return function (ctx) {
    return new Promise(function (resolve) {
      var i18nInitialProps = getInitialProps();

      if (ForComponent.getInitialProps) {
        ForComponent.getInitialProps(ctx).then(function (componentsInitialProps) {
          resolve(_objectSpread(_objectSpread({}, componentsInitialProps), i18nInitialProps));
        });
      } else {
        resolve(i18nInitialProps);
      }
    });
  };
}
function getInitialProps() {
  var i18n = getI18n();
  var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
  var ret = {};
  var initialI18nStore = {};
  i18n.languages.forEach(function (l) {
    initialI18nStore[l] = {};
    namespaces.forEach(function (ns) {
      initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
    });
  });
  ret.initialI18nStore = initialI18nStore;
  ret.initialLanguage = i18n.language;
  return ret;
}
;// CONCATENATED MODULE: ../node_modules/react-i18next/dist/es/utils.js
function warn() {
  if (console && console.warn) {
    var _console;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);

    (_console = console).warn.apply(_console, args);
  }
}
var alreadyWarned = {};
function warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
  warn.apply(void 0, args);
}
function loadNamespaces(i18n, ns, cb) {
  i18n.loadNamespaces(ns, function () {
    if (i18n.isInitialized) {
      cb();
    } else {
      var initialized = function initialized() {
        setTimeout(function () {
          i18n.off('initialized', initialized);
        }, 0);
        cb();
      };

      i18n.on('initialized', initialized);
    }
  });
}

function oldI18nextHasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var lng = i18n.languages[0];
  var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  var lastLng = i18n.languages[i18n.languages.length - 1];
  if (lng.toLowerCase() === 'cimode') return true;

  var loadNotPending = function loadNotPending(l, n) {
    var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
    return loadState === -1 || loadState === 2;
  };

  if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
  if (i18n.hasResourceBundle(lng, ns)) return true;
  if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
  return false;
}

function hasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!i18n.languages || !i18n.languages.length) {
    warnOnce('i18n.languages were undefined or empty', i18n.languages);
    return true;
  }

  var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;

  if (!isNewerI18next) {
    return oldI18nextHasLoadedNamespace(ns, i18n, options);
  }

  return i18n.hasLoadedNamespace(ns, {
    precheck: function precheck(i18nInstance, loadNotPending) {
      if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
    }
  });
}
function getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}
;// CONCATENATED MODULE: ../node_modules/react-i18next/dist/es/useTranslation.js



function useTranslation_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function useTranslation_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { useTranslation_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { useTranslation_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var usePrevious = function usePrevious(value, ignore) {
  var ref = (0,react.useRef)();
  (0,react.useEffect)(function () {
    ref.current = ignore ? ref.current : value;
  }, [value, ignore]);
  return ref.current;
};

function useTranslation(ns) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var i18nFromProps = props.i18n;

  var _ref = (0,react.useContext)(I18nContext) || {},
      i18nFromContext = _ref.i18n,
      defaultNSFromContext = _ref.defaultNS;

  var i18n = i18nFromProps || i18nFromContext || getI18n();
  if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new ReportNamespaces();

  if (!i18n) {
    warnOnce('You will need to pass in an i18next instance by using initReactI18next');

    var notReadyT = function notReadyT(k) {
      return Array.isArray(k) ? k[k.length - 1] : k;
    };

    var retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }

  if (i18n.options.react && i18n.options.react.wait !== undefined) warnOnce('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');

  var i18nOptions = useTranslation_objectSpread(useTranslation_objectSpread(useTranslation_objectSpread({}, getDefaults()), i18n.options.react), props);

  var useSuspense = i18nOptions.useSuspense,
      keyPrefix = i18nOptions.keyPrefix;
  var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
  var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function (n) {
    return hasLoadedNamespace(n, i18n, i18nOptions);
  });

  function getT() {
    return i18n.getFixedT(null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
  }

  var _useState = (0,react.useState)(getT),
      _useState2 = _slicedToArray(_useState, 2),
      t = _useState2[0],
      setT = _useState2[1];

  var joinedNS = namespaces.join();
  var previousJoinedNS = usePrevious(joinedNS);
  var isMounted = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    var bindI18n = i18nOptions.bindI18n,
        bindI18nStore = i18nOptions.bindI18nStore;
    isMounted.current = true;

    if (!ready && !useSuspense) {
      loadNamespaces(i18n, namespaces, function () {
        if (isMounted.current) setT(getT);
      });
    }

    if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) {
      setT(getT);
    }

    function boundReset() {
      if (isMounted.current) setT(getT);
    }

    if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
    if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
    return function () {
      isMounted.current = false;
      if (bindI18n && i18n) bindI18n.split(' ').forEach(function (e) {
        return i18n.off(e, boundReset);
      });
      if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function (e) {
        return i18n.store.off(e, boundReset);
      });
    };
  }, [i18n, joinedNS]);
  var isInitial = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    if (isMounted.current && !isInitial.current) {
      setT(getT);
    }

    isInitial.current = false;
  }, [i18n, keyPrefix]);
  var ret = [t, i18n, ready];
  ret.t = t;
  ret.i18n = i18n;
  ret.ready = ready;
  if (ready) return ret;
  if (!ready && !useSuspense) return ret;
  throw new Promise(function (resolve) {
    loadNamespaces(i18n, namespaces, function () {
      resolve();
    });
  });
}
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

// EXTERNAL MODULE: ../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(5839);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ../node_modules/react-i18next/dist/es/I18nextProvider.js


function I18nextProvider(_ref) {
  var i18n = _ref.i18n,
      defaultNS = _ref.defaultNS,
      children = _ref.children;
  var value = (0,react.useMemo)(function () {
    return {
      i18n: i18n,
      defaultNS: defaultNS
    };
  }, [i18n, defaultNS]);
  return (0,react.createElement)(I18nContext.Provider, {
    value: value
  }, children);
}
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}

;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function toConsumableArray_toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}

;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}

;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}

;// CONCATENATED MODULE: ../node_modules/next-i18next/dist/esm/config/defaultConfig.js
var DEFAULT_LOCALE = 'en';
var LOCALES = ['en'];
var DEFAULT_NAMESPACE = 'common';
var LOCALE_PATH = './public/locales';
var LOCALE_STRUCTURE = '{{lng}}/{{ns}}';
var LOCALE_EXTENSION = 'json';
var defaultConfig = {
  defaultNS: DEFAULT_NAMESPACE,
  errorStackTraceLimit: 0,
  i18n: {
    defaultLocale: DEFAULT_LOCALE,
    locales: LOCALES
  },

  get initImmediate() {
    return  true && typeof window !== 'undefined';
  },

  interpolation: {
    escapeValue: false
  },
  load: 'currentOnly',
  localeExtension: LOCALE_EXTENSION,
  localePath: LOCALE_PATH,
  localeStructure: LOCALE_STRUCTURE,
  react: {
    useSuspense: false
  },
  reloadOnPrerender: false,
  serializeConfig: true,
  use: []
};
;// CONCATENATED MODULE: ../node_modules/next-i18next/dist/esm/utils.js


var getFallbackForLng = function getFallbackForLng(lng, fallbackLng) {
  if (typeof fallbackLng === 'string') {
    return [fallbackLng];
  }

  if (Array.isArray(fallbackLng)) {
    return fallbackLng;
  }

  if (_typeof(fallbackLng) === 'object') {
    var fallbackList = fallbackLng[lng];
    var fallbackDefault = fallbackLng["default"];
    return [].concat(_toConsumableArray(fallbackList !== null && fallbackList !== void 0 ? fallbackList : []), _toConsumableArray(fallbackDefault !== null && fallbackDefault !== void 0 ? fallbackDefault : []));
  }

  if (typeof fallbackLng === 'function') {
    return getFallbackForLng(lng, fallbackLng(lng));
  }

  return [];
};
var unique = function unique(list) {
  return Array.from(new Set(list));
};
;// CONCATENATED MODULE: ../node_modules/next-i18next/dist/esm/config/createConfig.js





var _excluded = ["i18n"],
    _excluded2 = ["i18n"];

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = createConfig_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function createConfig_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return createConfig_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return createConfig_arrayLikeToArray(o, minLen); }

function createConfig_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function createConfig_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function createConfig_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? createConfig_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : createConfig_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var deepMergeObjects = ['backend', 'detection'];
var createConfig = function createConfig(userConfig) {
  var _userConfig$use;

  if (typeof (userConfig === null || userConfig === void 0 ? void 0 : userConfig.lng) !== 'string') {
    throw new Error('config.lng was not passed into createConfig');
  } //
  // Initial merge of default and user-provided config
  //


  var userI18n = userConfig.i18n,
      userConfigStripped = _objectWithoutProperties(userConfig, _excluded);

  var defaultI18n = defaultConfig.i18n,
      defaultConfigStripped = _objectWithoutProperties(defaultConfig, _excluded2);

  var combinedConfig = createConfig_objectSpread(createConfig_objectSpread(createConfig_objectSpread(createConfig_objectSpread({}, defaultConfigStripped), userConfigStripped), defaultI18n), userI18n);

  var defaultNS = combinedConfig.defaultNS,
      lng = combinedConfig.lng,
      localeExtension = combinedConfig.localeExtension,
      localePath = combinedConfig.localePath,
      localeStructure = combinedConfig.localeStructure,
      nonExplicitSupportedLngs = combinedConfig.nonExplicitSupportedLngs;
  var locales = combinedConfig.locales.filter(function (l) {
    return l !== 'default';
  });
  /**
   * Skips translation file resolution while in cimode
   * https://github.com/i18next/next-i18next/pull/851#discussion_r503113620
  */

  if (lng === 'cimode') {
    return combinedConfig;
  }

  if (typeof combinedConfig.fallbackLng === 'undefined') {
    combinedConfig.fallbackLng = combinedConfig.defaultLocale;

    if (combinedConfig.fallbackLng === 'default') {
      var _locales = _slicedToArray(locales, 1);

      combinedConfig.fallbackLng = _locales[0];
    }
  }

  var fallbackLng = combinedConfig.fallbackLng;

  if (nonExplicitSupportedLngs) {
    var createFallbackObject = function createFallbackObject(acc, l) {
      var _l$split = l.split('-'),
          _l$split2 = _slicedToArray(_l$split, 1),
          locale = _l$split2[0];

      acc[l] = [locale];
      return acc;
    };

    if (typeof fallbackLng === 'string') {
      combinedConfig.fallbackLng = combinedConfig.locales.filter(function (l) {
        return l.includes('-');
      }).reduce(createFallbackObject, {
        "default": [fallbackLng]
      });
    } else if (Array.isArray(fallbackLng)) {
      combinedConfig.fallbackLng = combinedConfig.locales.filter(function (l) {
        return l.includes('-');
      }).reduce(createFallbackObject, {
        "default": fallbackLng
      });
    } else if (typeof_typeof(fallbackLng) === 'object') {
      combinedConfig.fallbackLng = Object.entries(combinedConfig.fallbackLng).reduce(function (acc, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            l = _ref2[0],
            f = _ref2[1];

        acc[l] = l.includes('-') ? unique([l.split('-')[0]].concat(toConsumableArray_toConsumableArray(f))) : f;
        return acc;
      }, fallbackLng);
    } else if (typeof fallbackLng === 'function') {
      throw new Error('If nonExplicitSupportedLngs is true, no functions are allowed for fallbackLng');
    }
  }

  var hasCustomBackend = userConfig === null || userConfig === void 0 ? void 0 : (_userConfig$use = userConfig.use) === null || _userConfig$use === void 0 ? void 0 : _userConfig$use.some(function (b) {
    return b.type === 'backend';
  });

  if (false) { var getNamespaces, _defaultFallbackNSExists, _fallback, _defaultNSExists, _defaultNSPath, defaultFallbackNSExists, fallback, defaultNSExists, defaultNSPath, defaultFile, defaultLocaleStructure, suffix, prefix, _userConfig$interpola, _userConfig$interpola2, _userConfig$interpola3, _userConfig$interpola4, path, fs; } else {
    //
    // Set client side backend, if there is no custom backend
    //
    if (!hasCustomBackend) {
      if (typeof localePath === 'string') {
        combinedConfig.backend = {
          addPath: "".concat(localePath, "/").concat(localeStructure, ".missing.").concat(localeExtension),
          loadPath: "".concat(localePath, "/").concat(localeStructure, ".").concat(localeExtension)
        };
      } else if (typeof localePath === 'function') {
        combinedConfig.backend = {
          addPath: function addPath(locale, namespace) {
            return localePath(locale, namespace, true);
          },
          loadPath: function loadPath(locale, namespace) {
            return localePath(locale, namespace, false);
          }
        };
      }
    }

    if (typeof combinedConfig.ns !== 'string' && !Array.isArray(combinedConfig.ns)) {
      combinedConfig.ns = [defaultNS];
    }
  } //
  // Deep merge with overwrite - goes last
  //


  deepMergeObjects.forEach(function (obj) {
    if (userConfig[obj]) {
      combinedConfig[obj] = createConfig_objectSpread(createConfig_objectSpread({}, combinedConfig[obj]), userConfig[obj]);
    }
  });
  return combinedConfig;
};
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}

;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js


function _possibleConstructorReturn(t, e) {
  if (e && ("object" == typeof_typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}

;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}

;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/toArray.js




function _toArray(r) {
  return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest();
}

;// CONCATENATED MODULE: ../node_modules/i18next/dist/esm/i18next.js










function i18next_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function i18next_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { i18next_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { i18next_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var consoleLogger = {
  type: 'logger',
  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    if (console && console[type]) console[type].apply(console, args);
  }
};

var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Logger);

    this.init(concreteLogger, options);
  }

  _createClass(Logger, [{
    key: "init",
    value: function init(concreteLogger) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.prefix = options.prefix || 'i18next:';
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.forward(args, 'log', '', true);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this.forward(args, 'warn', '', true);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this.forward(args, 'error', '');
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug) return null;
      if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create(moduleName) {
      return new Logger(this.logger, i18next_objectSpread(i18next_objectSpread({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }), this.options));
    }
  }, {
    key: "clone",
    value: function clone(options) {
      options = options || this.options;
      options.prefix = options.prefix || this.prefix;
      return new Logger(this.logger, options);
    }
  }]);

  return Logger;
}();

var baseLogger = new Logger();

var EventEmitter = function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);

    this.observers = {};
  }

  _createClass(EventEmitter, [{
    key: "on",
    value: function on(events, listener) {
      var _this = this;

      events.split(' ').forEach(function (event) {
        _this.observers[event] = _this.observers[event] || [];

        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      if (!this.observers[event]) return;

      if (!listener) {
        delete this.observers[event];
        return;
      }

      this.observers[event] = this.observers[event].filter(function (l) {
        return l !== listener;
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function (observer) {
          observer.apply(void 0, args);
        });
      }

      if (this.observers['*']) {
        var _cloned = [].concat(this.observers['*']);

        _cloned.forEach(function (observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);

  return EventEmitter;
}();

function defer() {
  var res;
  var rej;
  var promise = new Promise(function (resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  return '' + object;
}
function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');

  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();

    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
  var value = getPath(data, key);

  if (value !== undefined) {
    return value;
  }

  return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
  for (var prop in source) {
    if (prop !== '__proto__' && prop !== 'constructor') {
      if (prop in target) {
        if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
          if (overwrite) target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }

  return target;
}
function regexEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
function i18next_escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}
var isIE10 = typeof window !== 'undefined' && window.navigator && typeof window.navigator.userAgentData === 'undefined' && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;
var chars = [' ', ',', '?', '!', ';'];
function looksLikeObjectPath(key, nsSeparator, keySeparator) {
  nsSeparator = nsSeparator || '';
  keySeparator = keySeparator || '';
  var possibleChars = chars.filter(function (c) {
    return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
  });
  if (possibleChars.length === 0) return true;
  var r = new RegExp("(".concat(possibleChars.map(function (c) {
    return c === '?' ? '\\?' : c;
  }).join('|'), ")"));
  var matched = !r.test(key);

  if (!matched) {
    var ki = key.indexOf(keySeparator);

    if (ki > 0 && !r.test(key.substring(0, ki))) {
      matched = true;
    }
  }

  return matched;
}

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function deepFind(obj, path) {
  var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  if (!obj) return undefined;
  if (obj[path]) return obj[path];
  var paths = path.split(keySeparator);
  var current = obj;

  for (var i = 0; i < paths.length; ++i) {
    if (!current) return undefined;

    if (typeof current[paths[i]] === 'string' && i + 1 < paths.length) {
      return undefined;
    }

    if (current[paths[i]] === undefined) {
      var j = 2;
      var p = paths.slice(i, i + j).join(keySeparator);
      var mix = current[p];

      while (mix === undefined && paths.length > i + j) {
        j++;
        p = paths.slice(i, i + j).join(keySeparator);
        mix = current[p];
      }

      if (mix === undefined) return undefined;
      if (mix === null) return null;

      if (path.endsWith(p)) {
        if (typeof mix === 'string') return mix;
        if (p && typeof mix[p] === 'string') return mix[p];
      }

      var joinedPath = paths.slice(i + j).join(keySeparator);
      if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
      return undefined;
    }

    current = current[paths[i]];
  }

  return current;
}

var ResourceStore = function (_EventEmitter) {
  _inherits(ResourceStore, _EventEmitter);

  var _super = _createSuper(ResourceStore);

  function ResourceStore(data) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };

    _classCallCheck(this, ResourceStore);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    _this.data = data || {};
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    if (_this.options.ignoreJSONStructure === undefined) {
      _this.options.ignoreJSONStructure = true;
    }

    return _this;
  }

  _createClass(ResourceStore, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index = this.options.ns.indexOf(ns);

      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
      var path = [lng, ns];
      if (key && typeof key !== 'string') path = path.concat(key);
      if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
      }

      var result = getPath(this.data, path);
      if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
      return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        silent: false
      };
      var keySeparator = this.options.keySeparator;
      if (keySeparator === undefined) keySeparator = '.';
      var path = [lng, ns];
      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        value = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      setPath(this.data, path, value);
      if (!options.silent) this.emit('added', lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        silent: false
      };

      for (var m in resources) {
        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
          silent: true
        });
      }

      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
        silent: false
      };
      var path = [lng, ns];

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        deep = resources;
        resources = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      var pack = getPath(this.data, path) || {};

      if (deep) {
        deepExtend(pack, resources, overwrite);
      } else {
        pack = _objectSpread$1(_objectSpread$1({}, pack), resources);
      }

      setPath(this.data, path, pack);
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }

      this.removeNamespaces(ns);
      this.emit('removed', lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== undefined;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns) ns = this.options.defaultNS;
      if (this.options.compatibilityAPI === 'v1') return _objectSpread$1(_objectSpread$1({}, {}), this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "hasLanguageSomeTranslations",
    value: function hasLanguageSomeTranslations(lng) {
      var data = this.getDataByLanguage(lng);
      var n = data && Object.keys(data) || [];
      return !!n.find(function (v) {
        return data[v] && Object.keys(data[v]).length > 0;
      });
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);

  return ResourceStore;
}(EventEmitter);

var postProcessor = {
  processors: {},
  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var checkedLoadedFor = {};

var Translator = function (_EventEmitter) {
  _inherits(Translator, _EventEmitter);

  var _super = _createSuper$1(Translator);

  function Translator(services) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Translator);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, _assertThisInitialized(_this));
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    _this.logger = baseLogger.create('translator');
    return _this;
  }

  _createClass(Translator, [{
    key: "changeLanguage",
    value: function changeLanguage(lng) {
      if (lng) this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };

      if (key === undefined || key === null) {
        return false;
      }

      var resolved = this.resolve(key, options);
      return resolved && resolved.res !== undefined;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options) {
      var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
      if (nsSeparator === undefined) nsSeparator = ':';
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var namespaces = options.ns || this.options.defaultNS || [];
      var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
      var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);

      if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
        var m = key.match(this.interpolator.nestingRegexp);

        if (m && m.length > 0) {
          return {
            key: key,
            namespaces: namespaces
          };
        }

        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
        key = parts.join(keySeparator);
      }

      if (typeof namespaces === 'string') namespaces = [namespaces];
      return {
        key: key,
        namespaces: namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate(keys, options, lastKey) {
      var _this2 = this;

      if (typeof_typeof(options) !== 'object' && this.options.overloadTranslationOptionHandler) {
        options = this.options.overloadTranslationOptionHandler(arguments);
      }

      if (!options) options = {};
      if (keys === undefined || keys === null) return '';
      if (!Array.isArray(keys)) keys = [String(keys)];
      var returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;

      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
          key = _this$extractFromKey.key,
          namespaces = _this$extractFromKey.namespaces;

      var namespace = namespaces[namespaces.length - 1];
      var lng = options.lng || this.language;
      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;

      if (lng && lng.toLowerCase() === 'cimode') {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options.nsSeparator || this.options.nsSeparator;

          if (returnDetails) {
            resolved.res = "".concat(namespace).concat(nsSeparator).concat(key);
            return resolved;
          }

          return "".concat(namespace).concat(nsSeparator).concat(key);
        }

        if (returnDetails) {
          resolved.res = key;
          return resolved;
        }

        return key;
      }

      var resolved = this.resolve(keys, options);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
      var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';

      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
        if (!options.returnObjects && !this.options.returnObjects) {
          if (!this.options.returnedObjectHandler) {
            this.logger.warn('accessing an object - but returnObjects options is not enabled!');
          }

          var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, _objectSpread$2(_objectSpread$2({}, options), {}, {
            ns: namespaces
          })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");

          if (returnDetails) {
            resolved.res = r;
            return resolved;
          }

          return r;
        }

        if (keySeparator) {
          var resTypeIsArray = resType === '[object Array]';
          var copy = resTypeIsArray ? [] : {};
          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;

          for (var m in res) {
            if (Object.prototype.hasOwnProperty.call(res, m)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
              copy[m] = this.translate(deepKey, _objectSpread$2(_objectSpread$2({}, options), {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy[m] === deepKey) copy[m] = res[m];
            }
          }

          res = copy;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, keys, options, lastKey);
      } else {
        var usedDefault = false;
        var usedKey = false;
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var hasDefaultValue = Translator.hasDefaultValue(options);
        var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
        var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;

        if (!this.isValidLookup(res) && hasDefaultValue) {
          usedDefault = true;
          res = defaultValue;
        }

        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        }

        var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
        var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
        var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;

        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);

          if (keySeparator) {
            var fk = this.resolve(key, _objectSpread$2(_objectSpread$2({}, options), {}, {
              keySeparator: false
            }));
            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
          }

          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);

          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
            for (var i = 0; i < fallbackLngs.length; i++) {
              lngs.push(fallbackLngs[i]);
            }
          } else if (this.options.saveMissingTo === 'all') {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }

          var send = function send(l, k, specificDefaultValue) {
            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;

            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
            }

            _this2.emit('missingKey', l, namespace, k, res);
          };

          if (this.options.saveMissing) {
            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function (language) {
                _this2.pluralResolver.getSuffixes(language, options).forEach(function (suffix) {
                  send([language], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                });
              });
            } else {
              send(lngs, key, defaultValue);
            }
          }
        }

        res = this.extendTranslation(res, keys, options, resolved, lastKey);
        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);

        if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
          if (this.options.compatibilityAPI !== 'v1') {
            res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : undefined);
          } else {
            res = this.options.parseMissingKeyHandler(res);
          }
        }
      }

      if (returnDetails) {
        resolved.res = res;
        return resolved;
      }

      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options, resolved, lastKey) {
      var _this3 = this;

      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, _objectSpread$2(_objectSpread$2({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved: resolved
        });
      } else if (!options.skipInterpolation) {
        if (options.interpolation) this.interpolator.init(_objectSpread$2(_objectSpread$2({}, options), {
          interpolation: _objectSpread$2(_objectSpread$2({}, this.options.interpolation), options.interpolation)
        }));
        var skipOnVariables = typeof res === 'string' && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
        var nestBef;

        if (skipOnVariables) {
          var nb = res.match(this.interpolator.nestingRegexp);
          nestBef = nb && nb.length;
        }

        var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
        if (this.options.interpolation.defaultVariables) data = _objectSpread$2(_objectSpread$2({}, this.options.interpolation.defaultVariables), data);
        res = this.interpolator.interpolate(res, data, options.lng || this.language, options);

        if (skipOnVariables) {
          var na = res.match(this.interpolator.nestingRegexp);
          var nestAft = na && na.length;
          if (nestBef < nestAft) options.nest = false;
        }

        if (options.nest !== false) res = this.interpolator.nest(res, function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          if (lastKey && lastKey[0] === args[0] && !options.context) {
            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));

            return null;
          }

          return _this3.translate.apply(_this3, args.concat([key]));
        }, options);
        if (options.interpolation) this.interpolator.reset();
      }

      var postProcess = options.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread$2({
          i18nResolved: resolved
        }, options) : options, this);
      }

      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys) {
      var _this4 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var found;
      var usedKey;
      var exactUsedKey;
      var usedLng;
      var usedNS;
      if (typeof keys === 'string') keys = [keys];
      keys.forEach(function (k) {
        if (_this4.isValidLookup(found)) return;

        var extracted = _this4.extractFromKey(k, options);

        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';

        var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();

        var needsContextHandling = options.context !== undefined && (typeof options.context === 'string' || typeof options.context === 'number') && options.context !== '';
        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
        namespaces.forEach(function (ns) {
          if (_this4.isValidLookup(found)) return;
          usedNS = ns;

          if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;

            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
          }

          codes.forEach(function (code) {
            if (_this4.isValidLookup(found)) return;
            usedLng = code;
            var finalKeys = [key];

            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              var pluralSuffix;
              if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
              var zeroSuffix = "".concat(_this4.options.pluralSeparator, "zero");

              if (needsPluralHandling) {
                finalKeys.push(key + pluralSuffix);

                if (needsZeroSuffixLookup) {
                  finalKeys.push(key + zeroSuffix);
                }
              }

              if (needsContextHandling) {
                var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                finalKeys.push(contextKey);

                if (needsPluralHandling) {
                  finalKeys.push(contextKey + pluralSuffix);

                  if (needsZeroSuffixLookup) {
                    finalKeys.push(contextKey + zeroSuffix);
                  }
                }
              }
            }

            var possibleKey;

            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey: usedKey,
        exactUsedKey: exactUsedKey,
        usedLng: usedLng,
        usedNS: usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
  }], [{
    key: "hasDefaultValue",
    value: function hasDefaultValue(options) {
      var prefix = 'defaultValue';

      for (var option in options) {
        if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) {
          return true;
        }
      }

      return false;
    }
  }]);

  return Translator;
}(EventEmitter);

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtil = function () {
  function LanguageUtil(options) {
    _classCallCheck(this, LanguageUtil);

    this.options = options;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create('languageUtils');
  }

  _createClass(LanguageUtil, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return null;
      var p = code.split('-');
      if (p.length === 2) return null;
      p.pop();
      if (p[p.length - 1].toLowerCase() === 'x') return null;
      return this.formatLanguageCode(p.join('-'));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return code;
      var p = code.split('-');
      return this.formatLanguageCode(p[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
        var p = code.split('-');

        if (this.options.lowerCaseLng) {
          p = p.map(function (part) {
            return part.toLowerCase();
          });
        } else if (p.length === 2) {
          p[0] = p[0].toLowerCase();
          p[1] = p[1].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        } else if (p.length === 3) {
          p[0] = p[0].toLowerCase();
          if (p[1].length === 2) p[1] = p[1].toUpperCase();
          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
        }

        return p.join('-');
      }

      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isSupportedCode",
    value: function isSupportedCode(code) {
      if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
        code = this.getLanguagePartFromCode(code);
      }

      return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function getBestMatchFromCodes(codes) {
      var _this = this;

      if (!codes) return null;
      var found;
      codes.forEach(function (code) {
        if (found) return;

        var cleanedLng = _this.formatLanguageCode(code);

        if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
      });

      if (!found && this.options.supportedLngs) {
        codes.forEach(function (code) {
          if (found) return;

          var lngOnly = _this.getLanguagePartFromCode(code);

          if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
          found = _this.options.supportedLngs.find(function (supportedLng) {
            if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
          });
        });
      }

      if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
      return found;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks) return [];
      if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
      if (!code) return fallbacks["default"] || [];
      var found = fallbacks[code];
      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found) found = fallbacks[this.formatLanguageCode(code)];
      if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
      if (!found) found = fallbacks["default"];
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this2 = this;

      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];

      var addCode = function addCode(c) {
        if (!c) return;

        if (_this2.isSupportedCode(c)) {
          codes.push(c);
        } else {
          _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
        }
      };

      if (typeof code === 'string' && code.indexOf('-') > -1) {
        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === 'string') {
        addCode(this.formatLanguageCode(code));
      }

      fallbackCodes.forEach(function (fc) {
        if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
      });
      return codes;
    }
  }]);

  return LanguageUtil;
}();

var sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'tl', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kk', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'ht', 'id', 'ja', 'jbo', 'ka', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he', 'iw'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};
var deprecatedJsonVersions = ['v1', 'v2', 'v3'];
var suffixesOrder = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');

    if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === 'v4') && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
      this.options.compatibilityJSON = 'v3';
      this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
    }

    this.rules = createRules();
  }

  _createClass(PluralResolver, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.shouldUseIntlApi()) {
        try {
          return new Intl.PluralRules(code, {
            type: options.ordinal ? 'ordinal' : 'cardinal'
          });
        } catch (_unused) {
          return;
        }
      }

      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rule = this.getRule(code, options);

      if (this.shouldUseIntlApi()) {
        return rule && rule.resolvedOptions().pluralCategories.length > 1;
      }

      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.getSuffixes(code, options).map(function (suffix) {
        return "".concat(key).concat(suffix);
      });
    }
  }, {
    key: "getSuffixes",
    value: function getSuffixes(code) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rule = this.getRule(code, options);

      if (!rule) {
        return [];
      }

      if (this.shouldUseIntlApi()) {
        return rule.resolvedOptions().pluralCategories.sort(function (pluralCategory1, pluralCategory2) {
          return suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2];
        }).map(function (pluralCategory) {
          return "".concat(_this.options.prepend).concat(pluralCategory);
        });
      }

      return rule.numbers.map(function (number) {
        return _this.getSuffix(code, number, options);
      });
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var rule = this.getRule(code, options);

      if (rule) {
        if (this.shouldUseIntlApi()) {
          return "".concat(this.options.prepend).concat(rule.select(count));
        }

        return this.getSuffixRetroCompatible(rule, count);
      }

      this.logger.warn("no plural rule found for: ".concat(code));
      return '';
    }
  }, {
    key: "getSuffixRetroCompatible",
    value: function getSuffixRetroCompatible(rule, count) {
      var _this2 = this;

      var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
      var suffix = rule.numbers[idx];

      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        if (suffix === 2) {
          suffix = 'plural';
        } else if (suffix === 1) {
          suffix = '';
        }
      }

      var returnSuffix = function returnSuffix() {
        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
      };

      if (this.options.compatibilityJSON === 'v1') {
        if (suffix === 1) return '';
        if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
        return returnSuffix();
      } else if (this.options.compatibilityJSON === 'v2') {
        return returnSuffix();
      } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      }

      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
  }, {
    key: "shouldUseIntlApi",
    value: function shouldUseIntlApi() {
      return !deprecatedJsonVersions.includes(this.options.compatibilityJSON);
    }
  }]);

  return PluralResolver;
}();

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Interpolator);

    this.logger = baseLogger.create('interpolator');
    this.options = options;

    this.format = options.interpolation && options.interpolation.format || function (value) {
      return value;
    };

    this.init(options);
  }

  _createClass(Interpolator, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!options.interpolation) options.interpolation = {
        escapeValue: true
      };
      var iOpts = options.interpolation;
      this.escape = iOpts.escape !== undefined ? iOpts.escape : i18next_escape;
      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
      this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
      this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options) this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, 'g');
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, data, lng, options) {
      var _this = this;

      var match;
      var value;
      var replaces;
      var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};

      function regexSafe(val) {
        return val.replace(/\$/g, '$$$$');
      }

      var handleFormat = function handleFormat(key) {
        if (key.indexOf(_this.formatSeparator) < 0) {
          var path = getPathWithDefaults(data, defaultData, key);
          return _this.alwaysFormat ? _this.format(path, undefined, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
            interpolationkey: key
          })) : path;
        }

        var p = key.split(_this.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this.formatSeparator).trim();
        return _this.format(getPathWithDefaults(data, defaultData, k), f, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
          interpolationkey: k
        }));
      };

      this.resetRegExp();
      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
      var todos = [{
        regex: this.regexpUnescape,
        safeValue: function safeValue(val) {
          return regexSafe(val);
        }
      }, {
        regex: this.regexp,
        safeValue: function safeValue(val) {
          return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
        }
      }];
      todos.forEach(function (todo) {
        replaces = 0;

        while (match = todo.regex.exec(str)) {
          var matchedVar = match[1].trim();
          value = handleFormat(matchedVar);

          if (value === undefined) {
            if (typeof missingInterpolationHandler === 'function') {
              var temp = missingInterpolationHandler(str, match, options);
              value = typeof temp === 'string' ? temp : '';
            } else if (options && options.hasOwnProperty(matchedVar)) {
              value = '';
            } else if (skipOnVariables) {
              value = match[0];
              continue;
            } else {
              _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));

              value = '';
            }
          } else if (typeof value !== 'string' && !_this.useRawValueToEscape) {
            value = makeString(value);
          }

          var safeValue = todo.safeValue(value);
          str = str.replace(match[0], safeValue);

          if (skipOnVariables) {
            todo.regex.lastIndex += value.length;
            todo.regex.lastIndex -= match[0].length;
          } else {
            todo.regex.lastIndex = 0;
          }

          replaces++;

          if (replaces >= _this.maxReplaces) {
            break;
          }
        }
      });
      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc) {
      var _this2 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var match;
      var value;

      var clonedOptions = _objectSpread$3({}, options);

      clonedOptions.applyPostProcessor = false;
      delete clonedOptions.defaultValue;

      function handleHasOptions(key, inheritedOptions) {
        var sep = this.nestingOptionsSeparator;
        if (key.indexOf(sep) < 0) return key;
        var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
        var optionsString = "{".concat(c[1]);
        key = c[0];
        optionsString = this.interpolate(optionsString, clonedOptions);
        var matchedSingleQuotes = optionsString.match(/'/g);
        var matchedDoubleQuotes = optionsString.match(/"/g);

        if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) {
          optionsString = optionsString.replace(/'/g, '"');
        }

        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions) clonedOptions = _objectSpread$3(_objectSpread$3({}, inheritedOptions), clonedOptions);
        } catch (e) {
          this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
          return "".concat(key).concat(sep).concat(optionsString);
        }

        delete clonedOptions.defaultValue;
        return key;
      }

      while (match = this.nestingRegexp.exec(str)) {
        var formatters = [];
        var doReduce = false;

        if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
          var r = match[1].split(this.formatSeparator).map(function (elem) {
            return elem.trim();
          });
          match[1] = r.shift();
          formatters = r;
          doReduce = true;
        }

        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
        if (value && match[0] === str && typeof value !== 'string') return value;
        if (typeof value !== 'string') value = makeString(value);

        if (!value) {
          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
          value = '';
        }

        if (doReduce) {
          value = formatters.reduce(function (v, f) {
            return _this2.format(v, f, options.lng, _objectSpread$3(_objectSpread$3({}, options), {}, {
              interpolationkey: match[1].trim()
            }));
          }, value.trim());
        }

        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }

      return str;
    }
  }]);

  return Interpolator;
}();

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function parseFormatStr(formatStr) {
  var formatName = formatStr.toLowerCase().trim();
  var formatOptions = {};

  if (formatStr.indexOf('(') > -1) {
    var p = formatStr.split('(');
    formatName = p[0].toLowerCase().trim();
    var optStr = p[1].substring(0, p[1].length - 1);

    if (formatName === 'currency' && optStr.indexOf(':') < 0) {
      if (!formatOptions.currency) formatOptions.currency = optStr.trim();
    } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
      if (!formatOptions.range) formatOptions.range = optStr.trim();
    } else {
      var opts = optStr.split(';');
      opts.forEach(function (opt) {
        if (!opt) return;

        var _opt$split = opt.split(':'),
            _opt$split2 = _toArray(_opt$split),
            key = _opt$split2[0],
            rest = _opt$split2.slice(1);

        var val = rest.join(':').trim().replace(/^'+|'+$/g, '');
        if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
        if (val === 'false') formatOptions[key.trim()] = false;
        if (val === 'true') formatOptions[key.trim()] = true;
        if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
      });
    }
  }

  return {
    formatName: formatName,
    formatOptions: formatOptions
  };
}

function createCachedFormatter(fn) {
  var cache = {};
  return function invokeFormatter(val, lng, options) {
    var key = lng + JSON.stringify(options);
    var formatter = cache[key];

    if (!formatter) {
      formatter = fn(lng, options);
      cache[key] = formatter;
    }

    return formatter(val);
  };
}

var Formatter = function () {
  function Formatter() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Formatter);

    this.logger = baseLogger.create('formatter');
    this.options = options;
    this.formats = {
      number: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.NumberFormat(lng, options);
        return function (val) {
          return formatter.format(val);
        };
      }),
      currency: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.NumberFormat(lng, _objectSpread$4(_objectSpread$4({}, options), {}, {
          style: 'currency'
        }));
        return function (val) {
          return formatter.format(val);
        };
      }),
      datetime: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.DateTimeFormat(lng, _objectSpread$4({}, options));
        return function (val) {
          return formatter.format(val);
        };
      }),
      relativetime: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.RelativeTimeFormat(lng, _objectSpread$4({}, options));
        return function (val) {
          return formatter.format(val, options.range || 'day');
        };
      }),
      list: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.ListFormat(lng, _objectSpread$4({}, options));
        return function (val) {
          return formatter.format(val);
        };
      })
    };
    this.init(options);
  }

  _createClass(Formatter, [{
    key: "init",
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      var iOpts = options.interpolation;
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
    }
  }, {
    key: "add",
    value: function add(name, fc) {
      this.formats[name.toLowerCase().trim()] = fc;
    }
  }, {
    key: "addCached",
    value: function addCached(name, fc) {
      this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
    }
  }, {
    key: "format",
    value: function format(value, _format, lng, options) {
      var _this = this;

      var formats = _format.split(this.formatSeparator);

      var result = formats.reduce(function (mem, f) {
        var _parseFormatStr = parseFormatStr(f),
            formatName = _parseFormatStr.formatName,
            formatOptions = _parseFormatStr.formatOptions;

        if (_this.formats[formatName]) {
          var formatted = mem;

          try {
            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
            formatted = _this.formats[formatName](mem, l, _objectSpread$4(_objectSpread$4(_objectSpread$4({}, formatOptions), options), valOptions));
          } catch (error) {
            _this.logger.warn(error);
          }

          return formatted;
        } else {
          _this.logger.warn("there was no format function for ".concat(formatName));
        }

        return mem;
      }, value);
      return result;
    }
  }]);

  return Formatter;
}();

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function removePending(q, name) {
  if (q.pending[name] !== undefined) {
    delete q.pending[name];
    q.pendingCount--;
  }
}

var Connector = function (_EventEmitter) {
  _inherits(Connector, _EventEmitter);

  var _super = _createSuper$2(Connector);

  function Connector(backend, store, services) {
    var _this;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, Connector);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = baseLogger.create('backendConnector');
    _this.waitingReads = [];
    _this.maxParallelReads = options.maxParallelReads || 10;
    _this.readingCalls = 0;
    _this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
    _this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }

    return _this;
  }

  _createClass(Connector, [{
    key: "queueLoad",
    value: function queueLoad(languages, namespaces, options, callback) {
      var _this2 = this;

      var toLoad = {};
      var pending = {};
      var toLoadLanguages = {};
      var toLoadNamespaces = {};
      languages.forEach(function (lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function (ns) {
          var name = "".concat(lng, "|").concat(ns);

          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2;
          } else if (_this2.state[name] < 0) ; else if (_this2.state[name] === 1) {
            if (pending[name] === undefined) pending[name] = true;
          } else {
            _this2.state[name] = 1;
            hasAllNamespaces = false;
            if (pending[name] === undefined) pending[name] = true;
            if (toLoad[name] === undefined) toLoad[name] = true;
            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
          }
        });
        if (!hasAllNamespaces) toLoadLanguages[lng] = true;
      });

      if (Object.keys(toLoad).length || Object.keys(pending).length) {
        this.queue.push({
          pending: pending,
          pendingCount: Object.keys(pending).length,
          loaded: {},
          errors: [],
          callback: callback
        });
      }

      return {
        toLoad: Object.keys(toLoad),
        pending: Object.keys(pending),
        toLoadLanguages: Object.keys(toLoadLanguages),
        toLoadNamespaces: Object.keys(toLoadNamespaces)
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data) {
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      if (err) this.emit('failedLoading', lng, ns, err);

      if (data) {
        this.store.addResourceBundle(lng, ns, data);
      }

      this.state[name] = err ? -1 : 2;
      var loaded = {};
      this.queue.forEach(function (q) {
        pushPath(q.loaded, [lng], ns);
        removePending(q, name);
        if (err) q.errors.push(err);

        if (q.pendingCount === 0 && !q.done) {
          Object.keys(q.loaded).forEach(function (l) {
            if (!loaded[l]) loaded[l] = {};
            var loadedKeys = q.loaded[l];

            if (loadedKeys.length) {
              loadedKeys.forEach(function (ns) {
                if (loaded[l][ns] === undefined) loaded[l][ns] = true;
              });
            }
          });
          q.done = true;

          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      });
      this.emit('loaded', loaded);
      this.queue = this.queue.filter(function (q) {
        return !q.done;
      });
    }
  }, {
    key: "read",
    value: function read(lng, ns, fcName) {
      var _this3 = this;

      var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
      var callback = arguments.length > 5 ? arguments[5] : undefined;
      if (!lng.length) return callback(null, {});

      if (this.readingCalls >= this.maxParallelReads) {
        this.waitingReads.push({
          lng: lng,
          ns: ns,
          fcName: fcName,
          tried: tried,
          wait: wait,
          callback: callback
        });
        return;
      }

      this.readingCalls++;
      return this.backend[fcName](lng, ns, function (err, data) {
        _this3.readingCalls--;

        if (_this3.waitingReads.length > 0) {
          var next = _this3.waitingReads.shift();

          _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
        }

        if (err && data && tried < _this3.maxRetries) {
          setTimeout(function () {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }

        callback(err, data);
      });
    }
  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages, namespaces) {
      var _this4 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : undefined;

      if (!this.backend) {
        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
        return callback && callback();
      }

      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === 'string') namespaces = [namespaces];
      var toLoad = this.queueLoad(languages, namespaces, options, callback);

      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length) callback();
        return null;
      }

      toLoad.toLoad.forEach(function (name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;

      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      this.read(lng, ns, 'read', undefined, undefined, function (err, data) {
        if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);

        _this5.loaded(name, err, data);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
        this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        return;
      }

      if (key === undefined || key === null || key === '') return;

      if (this.backend && this.backend.create) {
        this.backend.create(languages, namespace, key, fallbackValue, null, _objectSpread$5(_objectSpread$5({}, options), {}, {
          isUpdate: isUpdate
        }));
      }

      if (!languages || !languages[0]) return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }]);

  return Connector;
}(EventEmitter);

function get() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    supportedLngs: false,
    nonExplicitSupportedLngs: false,
    load: 'all',
    preload: false,
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    saveMissing: false,
    updateMissing: false,
    saveMissingTo: 'fallback',
    saveMissingPlurals: true,
    missingKeyHandler: false,
    missingInterpolationHandler: false,
    postProcess: false,
    postProcessPassResolved: false,
    returnNull: true,
    returnEmptyString: true,
    returnObjects: false,
    joinArrays: false,
    returnedObjectHandler: false,
    parseMissingKeyHandler: false,
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if (typeof_typeof(args[1]) === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];

      if (typeof_typeof(args[2]) === 'object' || typeof_typeof(args[3]) === 'object') {
        var options = args[3] || args[2];
        Object.keys(options).forEach(function (key) {
          ret[key] = options[key];
        });
      }

      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng, options) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      nestingOptionsSeparator: ',',
      maxReplaces: 1000,
      skipOnVariables: true
    }
  };
}
function transformOptions(options) {
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];

  if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) {
    options.supportedLngs = options.supportedLngs.concat(['cimode']);
  }

  return options;
}

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function noop() {}

function bindMemberFunctions(inst) {
  var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
  mems.forEach(function (mem) {
    if (typeof inst[mem] === 'function') {
      inst[mem] = inst[mem].bind(inst);
    }
  });
}

var I18n = function (_EventEmitter) {
  _inherits(I18n, _EventEmitter);

  var _super = _createSuper$3(I18n);

  function I18n() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;

    _classCallCheck(this, I18n);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = baseLogger;
    _this.modules = {
      external: []
    };
    bindMemberFunctions(_assertThisInitialized(_this));

    if (callback && !_this.isInitialized && !options.isClone) {
      if (!_this.options.initImmediate) {
        _this.init(options, callback);

        return _possibleConstructorReturn(_this, _assertThisInitialized(_this));
      }

      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }

    return _this;
  }

  _createClass(I18n, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      if (!options.defaultNS && options.defaultNS !== false && options.ns) {
        if (typeof options.ns === 'string') {
          options.defaultNS = options.ns;
        } else if (options.ns.indexOf('translation') < 0) {
          options.defaultNS = options.ns[0];
        }
      }

      var defOpts = get();
      this.options = _objectSpread$6(_objectSpread$6(_objectSpread$6({}, defOpts), this.options), transformOptions(options));

      if (this.options.compatibilityAPI !== 'v1') {
        this.options.interpolation = _objectSpread$6(_objectSpread$6({}, defOpts.interpolation), this.options.interpolation);
      }

      if (options.keySeparator !== undefined) {
        this.options.userDefinedKeySeparator = options.keySeparator;
      }

      if (options.nsSeparator !== undefined) {
        this.options.userDefinedNsSeparator = options.nsSeparator;
      }

      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject) return null;
        if (typeof ClassOrObject === 'function') return new ClassOrObject();
        return ClassOrObject;
      }

      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }

        var formatter;

        if (this.modules.formatter) {
          formatter = this.modules.formatter;
        } else if (typeof Intl !== 'undefined') {
          formatter = Formatter;
        }

        var lu = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        var s = this.services;
        s.logger = baseLogger;
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });

        if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
          s.formatter = createClassOnDemand(formatter);
          s.formatter.init(s, this.options);
          this.options.interpolation.format = s.formatter.format.bind(s.formatter);
        }

        s.interpolator = new Interpolator(this.options);
        s.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        };
        s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
        s.backendConnector.on('*', function (event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });

        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          s.languageDetector.init(s, this.options.detection, this.options);
        }

        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init) s.i18nFormat.init(this);
        }

        this.translator = new Translator(this.services, this.options);
        this.translator.on('*', function (event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function (m) {
          if (m.init) m.init(_this2);
        });
      }

      this.format = this.options.interpolation.format;
      if (!callback) callback = noop;

      if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
      }

      if (!this.services.languageDetector && !this.options.lng) {
        this.logger.warn('init: no languageDetector is used and no lng is defined');
      }

      var storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
      storeApi.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store;

          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
      storeApiChained.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store2;

          (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);

          return _this2;
        };
      });
      var deferred = defer();

      var load = function load() {
        var finish = function finish(err, t) {
          if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn('init: i18next is already initialized. You should call init just once!');
          _this2.isInitialized = true;
          if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);

          _this2.emit('initialized', _this2.options);

          deferred.resolve(t);
          callback(err, t);
        };

        if (_this2.languages && _this2.options.compatibilityAPI !== 'v1' && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));

        _this2.changeLanguage(_this2.options.lng, finish);
      };

      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }

      return deferred;
    }
  }, {
    key: "loadResources",
    value: function loadResources(language) {
      var _this3 = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
      var usedCallback = callback;
      var usedLng = typeof language === 'string' ? language : this.language;
      if (typeof language === 'function') usedCallback = language;

      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
        var toLoad = [];

        var append = function append(lng) {
          if (!lng) return;

          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);

          lngs.forEach(function (l) {
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };

        if (!usedLng) {
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function (l) {
            return append(l);
          });
        } else {
          append(usedLng);
        }

        if (this.options.preload) {
          this.options.preload.forEach(function (l) {
            return append(l);
          });
        }

        this.services.backendConnector.load(toLoad, this.options.ns, function (e) {
          if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
          usedCallback(e);
        });
      } else {
        usedCallback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = defer();
      if (!lngs) lngs = this.languages;
      if (!ns) ns = this.options.ns;
      if (!callback) callback = noop;
      this.services.backendConnector.reload(lngs, ns, function (err) {
        deferred.resolve();
        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use(module) {
      if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
      if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');

      if (module.type === 'backend') {
        this.modules.backend = module;
      }

      if (module.type === 'logger' || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }

      if (module.type === 'languageDetector') {
        this.modules.languageDetector = module;
      }

      if (module.type === 'i18nFormat') {
        this.modules.i18nFormat = module;
      }

      if (module.type === 'postProcessor') {
        postProcessor.addPostProcessor(module);
      }

      if (module.type === 'formatter') {
        this.modules.formatter = module;
      }

      if (module.type === '3rdParty') {
        this.modules.external.push(module);
      }

      return this;
    }
  }, {
    key: "setResolvedLanguage",
    value: function setResolvedLanguage(l) {
      if (!l || !this.languages) return;
      if (['cimode', 'dev'].indexOf(l) > -1) return;

      for (var li = 0; li < this.languages.length; li++) {
        var lngInLngs = this.languages[li];
        if (['cimode', 'dev'].indexOf(lngInLngs) > -1) continue;

        if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
          this.resolvedLanguage = lngInLngs;
          break;
        }
      }
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this4 = this;

      this.isLanguageChangingTo = lng;
      var deferred = defer();
      this.emit('languageChanging', lng);

      var setLngProps = function setLngProps(l) {
        _this4.language = l;
        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
        _this4.resolvedLanguage = undefined;

        _this4.setResolvedLanguage(l);
      };

      var done = function done(err, l) {
        if (l) {
          setLngProps(l);

          _this4.translator.changeLanguage(l);

          _this4.isLanguageChangingTo = undefined;

          _this4.emit('languageChanged', l);

          _this4.logger.log('languageChanged', l);
        } else {
          _this4.isLanguageChangingTo = undefined;
        }

        deferred.resolve(function () {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback) callback(err, function () {
          return _this4.t.apply(_this4, arguments);
        });
      };

      var setLng = function setLng(lngs) {
        if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
        var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);

        if (l) {
          if (!_this4.language) {
            setLngProps(l);
          }

          if (!_this4.translator.language) _this4.translator.changeLanguage(l);
          if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
        }

        _this4.loadResources(l, function (err) {
          done(err, l);
        });
      };

      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        this.services.languageDetector.detect(setLng);
      } else {
        setLng(lng);
      }

      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns, keyPrefix) {
      var _this5 = this;

      var fixedT = function fixedT(key, opts) {
        var options;

        if (typeof_typeof(opts) !== 'object') {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }

          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        } else {
          options = _objectSpread$6({}, opts);
        }

        options.lng = options.lng || fixedT.lng;
        options.lngs = options.lngs || fixedT.lngs;
        options.ns = options.ns || fixedT.ns;
        options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
        var keySeparator = _this5.options.keySeparator || '.';
        var resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
        return _this5.t(resultKey, options);
      };

      if (typeof lng === 'string') {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }

      fixedT.ns = ns;
      fixedT.keyPrefix = keyPrefix;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t() {
      var _this$translator;

      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;

      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function hasLoadedNamespace(ns) {
      var _this6 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!this.isInitialized) {
        this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
        return false;
      }

      if (!this.languages || !this.languages.length) {
        this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
        return false;
      }

      var lng = this.resolvedLanguage || this.languages[0];
      var fallbackLng = this.options ? this.options.fallbackLng : false;
      var lastLng = this.languages[this.languages.length - 1];
      if (lng.toLowerCase() === 'cimode') return true;

      var loadNotPending = function loadNotPending(l, n) {
        var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];

        return loadState === -1 || loadState === 2;
      };

      if (options.precheck) {
        var preResult = options.precheck(this, loadNotPending);
        if (preResult !== undefined) return preResult;
      }

      if (this.hasResourceBundle(lng, ns)) return true;
      if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
      return false;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces(ns, callback) {
      var _this7 = this;

      var deferred = defer();

      if (!this.options.ns) {
        callback && callback();
        return Promise.resolve();
      }

      if (typeof ns === 'string') ns = [ns];
      ns.forEach(function (n) {
        if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
      });
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = defer();
      if (typeof lngs === 'string') lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function (lng) {
        return preloaded.indexOf(lng) < 0;
      });

      if (!newLngs.length) {
        if (callback) callback();
        return Promise.resolve();
      }

      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
      if (!lng) return 'rtl';
      var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam', 'ckb'];
      return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this8 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

      var mergedOptions = _objectSpread$6(_objectSpread$6(_objectSpread$6({}, this.options), options), {
        isClone: true
      });

      var clone = new I18n(mergedOptions);

      if (options.debug !== undefined || options.prefix !== undefined) {
        clone.logger = clone.logger.clone(options);
      }

      var membersToCopy = ['store', 'services', 'language'];
      membersToCopy.forEach(function (m) {
        clone[m] = _this8[m];
      });
      clone.services = _objectSpread$6({}, this.services);
      clone.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      clone.translator = new Translator(clone.services, clone.options);
      clone.translator.on('*', function (event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }

        clone.emit.apply(clone, [event].concat(args));
      });
      clone.init(mergedOptions, callback);
      clone.translator.options = clone.options;
      clone.translator.backendConnector.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      return clone;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        options: this.options,
        store: this.store,
        language: this.language,
        languages: this.languages,
        resolvedLanguage: this.resolvedLanguage
      };
    }
  }]);

  return I18n;
}(EventEmitter);

_defineProperty(I18n, "createInstance", function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var callback = arguments.length > 1 ? arguments[1] : undefined;
  return new I18n(options, callback);
});

var instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;

var createInstance = instance.createInstance;
var init = instance.init;
var loadResources = instance.loadResources;
var reloadResources = instance.reloadResources;
var use = instance.use;
var changeLanguage = instance.changeLanguage;
var getFixedT = instance.getFixedT;
var t = instance.t;
var exists = instance.exists;
var setDefaultNamespace = instance.setDefaultNamespace;
var i18next_hasLoadedNamespace = instance.hasLoadedNamespace;
var i18next_loadNamespaces = instance.loadNamespaces;
var loadLanguages = instance.loadLanguages;

/* harmony default export */ var i18next = (instance);


;// CONCATENATED MODULE: ../node_modules/next-i18next/dist/esm/createClient/browser.js

/* harmony default export */ var browser = (function (config) {
  if (config.ns === undefined) config.ns = [];
  var instance = i18next.createInstance(config);
  var initPromise;

  if (!instance.isInitialized) {
    var _config$use;

    config === null || config === void 0 ? void 0 : (_config$use = config.use) === null || _config$use === void 0 ? void 0 : _config$use.forEach(function (x) {
      return instance.use(x);
    });

    if (typeof config.onPreInitI18next === 'function') {
      config.onPreInitI18next(instance);
    }

    initPromise = instance.init(config);
  } else {
    initPromise = Promise.resolve(i18next.t);
  }

  return {
    i18n: instance,
    initPromise: initPromise
  };
});
;// CONCATENATED MODULE: ../node_modules/next-i18next/dist/esm/appWithTranslation.js


var __jsx = react.createElement;

function appWithTranslation_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function appWithTranslation_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? appWithTranslation_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : appWithTranslation_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var globalI18n = null;
var appWithTranslation = function appWithTranslation(WrappedComponent) {
  var configOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var AppWithTranslation = function AppWithTranslation(props) {
    var _nextI18Next$initialL, _props$router;

    var _ref = props.pageProps,
        _nextI18Next = _ref._nextI18Next;
    var locale = (_nextI18Next$initialL = _nextI18Next === null || _nextI18Next === void 0 ? void 0 : _nextI18Next.initialLocale) !== null && _nextI18Next$initialL !== void 0 ? _nextI18Next$initialL : props === null || props === void 0 ? void 0 : (_props$router = props.router) === null || _props$router === void 0 ? void 0 : _props$router.locale;
    var ns = _nextI18Next === null || _nextI18Next === void 0 ? void 0 : _nextI18Next.ns; // Memoize the instance and only re-initialize when either:
    // 1. The route changes (non-shallowly)
    // 2. Router locale changes
    // 3. UserConfig override changes

    var i18n = (0,react.useMemo)(function () {
      var _userConfig, _userConfig2, _userConfig2$i18n;

      if (!_nextI18Next && !configOverride) return null;
      var userConfig = configOverride !== null && configOverride !== void 0 ? configOverride : _nextI18Next === null || _nextI18Next === void 0 ? void 0 : _nextI18Next.userConfig;

      if (!userConfig && configOverride === null) {
        throw new Error('appWithTranslation was called without a next-i18next config');
      }

      if (configOverride !== null) {
        userConfig = configOverride;
      }

      if (!((_userConfig = userConfig) !== null && _userConfig !== void 0 && _userConfig.i18n)) {
        throw new Error('appWithTranslation was called without config.i18n');
      }

      if (!((_userConfig2 = userConfig) !== null && _userConfig2 !== void 0 && (_userConfig2$i18n = _userConfig2.i18n) !== null && _userConfig2$i18n !== void 0 && _userConfig2$i18n.defaultLocale)) {
        throw new Error('config.i18n does not include a defaultLocale property');
      }

      var _ref2 = _nextI18Next || {},
          initialI18nStore = _ref2.initialI18nStore;

      var resources = configOverride !== null && configOverride !== void 0 && configOverride.resources ? configOverride.resources : initialI18nStore;
      if (!locale) locale = userConfig.i18n.defaultLocale;
      var instance = browser(appWithTranslation_objectSpread(appWithTranslation_objectSpread({}, createConfig(appWithTranslation_objectSpread(appWithTranslation_objectSpread({}, userConfig), {}, {
        lng: locale
      }))), {}, {
        lng: locale,
        ns: ns,
        resources: resources
      })).i18n;
      globalI18n = instance;
      return instance;
    }, [_nextI18Next, locale, configOverride, ns]);
    return i18n !== null ? __jsx(I18nextProvider, {
      i18n: i18n
    }, __jsx(WrappedComponent, props)) : __jsx(WrappedComponent, _extends({
      key: locale
    }, props));
  };

  return hoist_non_react_statics_cjs_default()(AppWithTranslation, WrappedComponent);
};
;// CONCATENATED MODULE: ../node_modules/next-i18next/dist/esm/index.js



/***/ }),

/***/ 6321:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(2059);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8603:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _defineProperty = (__webpack_require__(5602)/* ["default"] */ .Z);
var _slicedToArray = (__webpack_require__(9854)/* ["default"] */ .Z);
var _toConsumableArray = (__webpack_require__(3957)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = Image;
var _extends = (__webpack_require__(6516)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(2619)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(6808)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(518)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(7378));
var _head = _interop_require_default(__webpack_require__(555));
var _imageBlurSvg = __webpack_require__(1721);
var _imageConfig = __webpack_require__(7893);
var _imageConfigContext = __webpack_require__(300);
var _utils = __webpack_require__(4915);
function Image(_param) {
    var src = _param.src, sizes = _param.sizes, _unoptimized = _param.unoptimized, unoptimized = _unoptimized === void 0 ? false : _unoptimized, _priority = _param.priority, priority = _priority === void 0 ? false : _priority, loading = _param.loading, className = _param.className, quality = _param.quality, width = _param.width, height = _param.height, fill = _param.fill, style = _param.style, onLoadingComplete = _param.onLoadingComplete, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? "empty" : _placeholder, blurDataURL = _param.blurDataURL, all = _object_without_properties_loose(_param, [
        "src",
        "sizes",
        "unoptimized",
        "priority",
        "loading",
        "className",
        "quality",
        "width",
        "height",
        "fill",
        "style",
        "onLoadingComplete",
        "placeholder",
        "blurDataURL"
    ]);
    var configContext = (0, _react).useContext(_imageConfigContext.ImageConfigContext);
    var config = (0, _react).useMemo(function() {
        var c = configEnv || configContext || _imageConfig.imageConfigDefault;
        var allSizes = _toConsumableArray(c.deviceSizes).concat(_toConsumableArray(c.imageSizes)).sort(function(a, b) {
            return a - b;
        });
        var deviceSizes = c.deviceSizes.sort(function(a, b) {
            return a - b;
        });
        return _extends({}, c, {
            allSizes: allSizes,
            deviceSizes: deviceSizes
        });
    }, [
        configContext
    ]);
    var rest = all;
    var loader = defaultLoader;
    if ("loader" in rest) {
        if (rest.loader) {
            var customImageLoader = rest.loader;
            var _tmp;
            _tmp = function(obj) {
                var _ = obj.config, opts = _object_without_properties_loose(obj, [
                    "config"
                ]);
                // The config object is internal only so we must
                // not pass it to the user-defined loader()
                return customImageLoader(opts);
            }, loader = _tmp, _tmp;
        }
        // Remove property so it's not spread on <img>
        delete rest.loader;
    }
    var staticSrc = "";
    var widthInt = getInt(width);
    var heightInt = getInt(height);
    var blurWidth;
    var blurHeight;
    if (isStaticImport(src)) {
        var staticImageData = isStaticRequire(src) ? src.default : src;
        if (!staticImageData.src) {
            throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received ".concat(JSON.stringify(staticImageData)));
        }
        if (!staticImageData.height || !staticImageData.width) {
            throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received ".concat(JSON.stringify(staticImageData)));
        }
        blurWidth = staticImageData.blurWidth;
        blurHeight = staticImageData.blurHeight;
        blurDataURL = blurDataURL || staticImageData.blurDataURL;
        staticSrc = staticImageData.src;
        if (!fill) {
            if (!widthInt && !heightInt) {
                widthInt = staticImageData.width;
                heightInt = staticImageData.height;
            } else if (widthInt && !heightInt) {
                var ratio = widthInt / staticImageData.width;
                heightInt = Math.round(staticImageData.height * ratio);
            } else if (!widthInt && heightInt) {
                var ratio1 = heightInt / staticImageData.height;
                widthInt = Math.round(staticImageData.width * ratio1);
            }
        }
    }
    src = typeof src === "string" ? src : staticSrc;
    var isLazy = !priority && (loading === "lazy" || typeof loading === "undefined");
    if (src.startsWith("data:") || src.startsWith("blob:")) {
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
        unoptimized = true;
        isLazy = false;
    }
    if (config.unoptimized) {
        unoptimized = true;
    }
    var ref = _slicedToArray((0, _react).useState(false), 2), blurComplete = ref[0], setBlurComplete = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(false), 2), showAltText = ref1[0], setShowAltText = ref1[1];
    var qualityInt = getInt(quality);
    if (false) { var url, urlStr, VALID_BLUR_EXT; }
    var imgStyle = Object.assign(fill ? {
        position: "absolute",
        height: "100%",
        width: "100%",
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
    } : {}, showAltText ? {} : {
        color: "transparent"
    }, style);
    var blurStyle = placeholder === "blur" && blurDataURL && !blurComplete ? {
        backgroundSize: imgStyle.objectFit || "cover",
        backgroundPosition: imgStyle.objectPosition || "50% 50%",
        backgroundRepeat: "no-repeat",
        backgroundImage: 'url("data:image/svg+xml;charset=utf-8,'.concat((0, _imageBlurSvg).getImageBlurSvg({
            widthInt: widthInt,
            heightInt: heightInt,
            blurWidth: blurWidth,
            blurHeight: blurHeight,
            blurDataURL: blurDataURL
        }), '")')
    } : {};
    if (false) {}
    var imgAttributes = generateImgAttrs({
        config: config,
        src: src,
        unoptimized: unoptimized,
        width: widthInt,
        quality: qualityInt,
        sizes: sizes,
        loader: loader
    });
    var srcString = src;
    if (false) { var fullUrl; }
    var imageSrcSetPropName = "imagesrcset";
    var imageSizesPropName = "imagesizes";
    if (true) {
        imageSrcSetPropName = "imageSrcSet";
        imageSizesPropName = "imageSizes";
    }
    var _obj;
    var linkProps = (_obj = {}, // Note: imagesrcset and imagesizes are not in the link element type with react 17.
    _defineProperty(_obj, imageSrcSetPropName, imgAttributes.srcSet), _defineProperty(_obj, imageSizesPropName, imgAttributes.sizes), _defineProperty(_obj, "crossOrigin", rest.crossOrigin), _obj);
    var onLoadingCompleteRef = (0, _react).useRef(onLoadingComplete);
    (0, _react).useEffect(function() {
        onLoadingCompleteRef.current = onLoadingComplete;
    }, [
        onLoadingComplete
    ]);
    var imgElementArgs = _extends({
        isLazy: isLazy,
        imgAttributes: imgAttributes,
        heightInt: heightInt,
        widthInt: widthInt,
        qualityInt: qualityInt,
        className: className,
        imgStyle: imgStyle,
        blurStyle: blurStyle,
        loading: loading,
        config: config,
        fill: fill,
        unoptimized: unoptimized,
        placeholder: placeholder,
        loader: loader,
        srcString: srcString,
        onLoadingCompleteRef: onLoadingCompleteRef,
        setBlurComplete: setBlurComplete,
        setShowAltText: setShowAltText
    }, rest);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement(ImageElement, Object.assign({}, imgElementArgs)), priority ? // for browsers that do not support `imagesrcset`, and in those cases
    // it would likely cause the incorrect image to be preloaded.
    //
    // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset
    /*#__PURE__*/ _react.default.createElement(_head.default, null, /*#__PURE__*/ _react.default.createElement("link", Object.assign({
        key: "__nimg-" + imgAttributes.src + imgAttributes.srcSet + imgAttributes.sizes,
        rel: "preload",
        as: "image",
        href: imgAttributes.srcSet ? undefined : imgAttributes.src
    }, linkProps))) : null);
}
"client";
var configEnv = {"deviceSizes":[600,900,1024,1440],"imageSizes":[600,900,1024,1440],"path":"/_next/image/","loader":"default","dangerouslyAllowSVG":false,"unoptimized":false};
var allImgs = new Map();
var perfObserver;
if (false) {}
var VALID_LOADING_VALUES = (/* unused pure expression or super */ null && ([
    "lazy",
    "eager",
    undefined
]));
function isStaticRequire(src) {
    return src.default !== undefined;
}
function isStaticImageData(src) {
    return src.src !== undefined;
}
function isStaticImport(src) {
    return typeof src === "object" && (isStaticRequire(src) || isStaticImageData(src));
}
function getWidths(param, width, sizes) {
    var deviceSizes = param.deviceSizes, allSizes = param.allSizes;
    if (sizes) {
        // Find all the "vw" percent sizes used in the sizes prop
        var viewportWidthRe = /(^|\s)(1?\d?\d)vw/g;
        var percentSizes = [];
        for(var match; match = viewportWidthRe.exec(sizes); match){
            percentSizes.push(parseInt(match[2]));
        }
        if (percentSizes.length) {
            var _Math;
            var smallestRatio = (_Math = Math).min.apply(_Math, _toConsumableArray(percentSizes)) * 0.01;
            return {
                widths: allSizes.filter(function(s) {
                    return s >= deviceSizes[0] * smallestRatio;
                }),
                kind: "w"
            };
        }
        return {
            widths: allSizes,
            kind: "w"
        };
    }
    if (typeof width !== "number") {
        return {
            widths: deviceSizes,
            kind: "w"
        };
    }
    var widths = _toConsumableArray(new Set(// > are actually 3x in the green color, but only 1.5x in the red and
    // > blue colors. Showing a 3x resolution image in the app vs a 2x
    // > resolution image will be visually the same, though the 3x image
    // > takes significantly more data. Even true 3x resolution screens are
    // > wasteful as the human eye cannot see that level of detail without
    // > something like a magnifying glass.
    // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
    [
        width,
        width * 2 /*, width * 3*/ 
    ].map(function(w) {
        return allSizes.find(function(p) {
            return p >= w;
        }) || allSizes[allSizes.length - 1];
    })));
    return {
        widths: widths,
        kind: "x"
    };
}
function generateImgAttrs(param) {
    var config = param.config, src = param.src, unoptimized = param.unoptimized, width = param.width, quality = param.quality, sizes = param.sizes, loader = param.loader;
    if (unoptimized) {
        return {
            src: src,
            srcSet: undefined,
            sizes: undefined
        };
    }
    var ref = getWidths(config, width, sizes), widths = ref.widths, kind = ref.kind;
    var last = widths.length - 1;
    return {
        sizes: !sizes && kind === "w" ? "100vw" : sizes,
        srcSet: widths.map(function(w, i) {
            return "".concat(loader({
                config: config,
                src: src,
                quality: quality,
                width: w
            }), " ").concat(kind === "w" ? w : i + 1).concat(kind);
        }).join(", "),
        // It's intended to keep `src` the last attribute because React updates
        // attributes in order. If we keep `src` the first one, Safari will
        // immediately start to fetch `src`, before `sizes` and `srcSet` are even
        // updated by React. That causes multiple unnecessary requests if `srcSet`
        // and `sizes` are defined.
        // This bug cannot be reproduced in Chrome or Firefox.
        src: loader({
            config: config,
            src: src,
            quality: quality,
            width: widths[last]
        })
    };
}
function getInt(x) {
    if (typeof x === "number" || typeof x === "undefined") {
        return x;
    }
    if (typeof x === "string" && /^[0-9]+$/.test(x)) {
        return parseInt(x, 10);
    }
    return NaN;
}
// See https://stackoverflow.com/q/39777833/266535 for why we use this ref
// handler instead of the img's onLoad attribute.
function handleLoading(img, src, placeholder, onLoadingCompleteRef, setBlurComplete) {
    if (!img || img["data-loaded-src"] === src) {
        return;
    }
    img["data-loaded-src"] = src;
    var p = "decode" in img ? img.decode() : Promise.resolve();
    p.catch(function() {}).then(function() {
        if (!img.parentNode) {
            // Exit early in case of race condition:
            // - onload() is called
            // - decode() is called but incomplete
            // - unmount is called
            // - decode() completes
            return;
        }
        if (placeholder === "blur") {
            setBlurComplete(true);
        }
        if (onLoadingCompleteRef == null ? void 0 : onLoadingCompleteRef.current) {
            onLoadingCompleteRef.current(img);
        }
        if (false) { var widthModified, heightModified, valid, position, widthViewportRatio; }
    });
}
var ImageElement = function(_param) {
    var imgAttributes = _param.imgAttributes, heightInt = _param.heightInt, widthInt = _param.widthInt, qualityInt = _param.qualityInt, className = _param.className, imgStyle = _param.imgStyle, blurStyle = _param.blurStyle, isLazy = _param.isLazy, fill = _param.fill, placeholder = _param.placeholder, loading = _param.loading, srcString = _param.srcString, config = _param.config, unoptimized = _param.unoptimized, loader = _param.loader, onLoadingCompleteRef = _param.onLoadingCompleteRef, setBlurComplete = _param.setBlurComplete, setShowAltText = _param.setShowAltText, onLoad = _param.onLoad, onError = _param.onError, rest = _object_without_properties_loose(_param, [
        "imgAttributes",
        "heightInt",
        "widthInt",
        "qualityInt",
        "className",
        "imgStyle",
        "blurStyle",
        "isLazy",
        "fill",
        "placeholder",
        "loading",
        "srcString",
        "config",
        "unoptimized",
        "loader",
        "onLoadingCompleteRef",
        "setBlurComplete",
        "setShowAltText",
        "onLoad",
        "onError"
    ]);
    loading = isLazy ? "lazy" : loading;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, imgAttributes, {
        width: widthInt,
        height: heightInt,
        decoding: "async",
        "data-nimg": "future".concat(fill ? "-fill" : ""),
        className: className,
        // @ts-ignore - TODO: upgrade to `@types/react@17`
        loading: loading,
        style: _extends({}, imgStyle, blurStyle),
        ref: (0, _react).useCallback(function(img) {
            if (!img) {
                return;
            }
            if (onError) {
                // If the image has an error before react hydrates, then the error is lost.
                // The workaround is to wait until the image is mounted which is after hydration,
                // then we set the src again to trigger the error handler (if there was an error).
                // eslint-disable-next-line no-self-assign
                img.src = img.src;
            }
            if (false) {}
            if (img.complete) {
                handleLoading(img, srcString, placeholder, onLoadingCompleteRef, setBlurComplete);
            }
        }, [
            srcString,
            placeholder,
            onLoadingCompleteRef,
            setBlurComplete,
            onError, 
        ]),
        onLoad: function(event) {
            var img = event.currentTarget;
            handleLoading(img, srcString, placeholder, onLoadingCompleteRef, setBlurComplete);
            if (onLoad) {
                onLoad(event);
            }
        },
        onError: function(event) {
            // if the real image fails to load, this will ensure "alt" is visible
            setShowAltText(true);
            if (placeholder === "blur") {
                // If the real image fails to load, this will still remove the placeholder.
                setBlurComplete(true);
            }
            if (onError) {
                onError(event);
            }
        }
    })));
};
function defaultLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    if (false) { var hasMatch, parsedSrc, missingValues; }
    if (src.endsWith(".svg") && !config.dangerouslyAllowSVG) {
        // Special case to make svg serve as-is to avoid proxying
        // through the built-in Image Optimization API.
        return src;
    }
    return "".concat(config.path, "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=image.js.map


/***/ }),

/***/ 1528:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath =  false || "";
function getDomainLocale(path, locale, locales, domainLocales) {
    if (true) {
        var normalizeLocalePath = (__webpack_require__(7964).normalizeLocalePath);
        var detectDomainLocale = (__webpack_require__(2019).detectDomainLocale);
        var target = locale || normalizeLocalePath(path, locales).detectedLocale;
        var domain = detectDomainLocale(domainLocales, undefined, target);
        if (domain) {
            var proto = "http".concat(domain.http ? "" : "s", "://");
            var finalLocale = target === domain.defaultLocale ? "" : "/".concat(target);
            return "".concat(proto).concat(domain.domain).concat(basePath).concat(finalLocale).concat(path);
        }
        return false;
    } else {}
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map


/***/ }),

/***/ 1453:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(9854)/* ["default"] */ .Z);
var _typeOf = (__webpack_require__(2271)["default"]);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _interop_require_default = (__webpack_require__(2619)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(518)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7378));
var _router = __webpack_require__(194);
var _addLocale = __webpack_require__(4087);
var _routerContext = __webpack_require__(9756);
var _appRouterContext = __webpack_require__(7868);
var _useIntersection = __webpack_require__(1842);
var _getDomainLocale = __webpack_require__(1528);
var _addBasePath = __webpack_require__(1470);
"client";
var prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    Promise.resolve(router.prefetch(href, as, options)).catch(function(err) {
        if (false) {}
    });
    var curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    var target = event.currentTarget.target;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
    var nodeName = e.currentTarget.nodeName;
    // anchors inside an svg have a lowercase nodeName
    var isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    var navigate = function() {
        // If the router is an NextRouter instance it will have `beforePopState`
        if ("beforePopState" in router) {
            router[replace ? "replace" : "push"](href, as, {
                shallow: shallow,
                locale: locale,
                scroll: scroll
            });
        } else {
            // If `beforePopState` doesn't exist on the router it's the AppRouter.
            var method = replace ? "replace" : "push";
            router[method](href, {
                forceOptimisticNavigation: !prefetchEnabled
            });
        }
    };
    if (isAppRouter) {
        // @ts-expect-error startTransition exists.
        _react.default.startTransition(navigate);
    } else {
        navigate();
    }
}
var Link = /*#__PURE__*/ _react.default.forwardRef(function LinkComponent(props, forwardedRef) {
    if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
    var children;
    var hrefProp = props.href, asProp = props.as, childrenProp = props.children, prefetchProp = props.prefetch, passHref = props.passHref, replace = props.replace, shallow = props.shallow, scroll = props.scroll, locale = props.locale, onClick = props.onClick, onMouseEnter = props.onMouseEnter, onTouchStart = props.onTouchStart, _legacyBehavior = props.legacyBehavior, legacyBehavior = _legacyBehavior === void 0 ? Boolean(true) !== true : _legacyBehavior, restProps = _object_without_properties_loose(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter",
        "onTouchStart",
        "legacyBehavior"
    ]);
    children = childrenProp;
    if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    var p = prefetchProp !== false;
    var router = _react.default.useContext(_routerContext.RouterContext);
    // TODO-APP: type error. Remove `as any`
    var appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
    if (appRouter) {
        router = appRouter;
    }
    var ref = _react.default.useMemo(function() {
        var ref = _slicedToArray((0, _router).resolveHref(router, hrefProp, true), 2), resolvedHref = ref[0], resolvedAs = ref[1];
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]), href = ref.href, as = ref.as;
    var previousHref = _react.default.useRef(href);
    var previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    var child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    }
    var childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootMargin: "200px"
    }), 3), setIntersectionRef = ref1[0], isVisible = ref1[1], resetVisible = ref1[2];
    var setRef = _react.default.useCallback(function(el) {
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(function() {
        var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        var isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    var childProps = {
        ref: setRef,
        onClick: function(e) {
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
            }
        },
        onMouseEnter: function(e) {
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        },
        onTouchStart: function(e) {
            if (!legacyBehavior && typeof onTouchStart === "function") {
                onTouchStart(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onTouchStart === "function") {
                child.props.onTouchStart(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
        childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 7964:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.normalizeLocalePath = void 0;
var normalizeLocalePath = function(pathname, locales) {
    if (true) {
        return (__webpack_require__(4331).normalizeLocalePath)(pathname, locales);
    }
    return {
        pathname: pathname,
        detectedLocale: undefined
    };
};
exports.normalizeLocalePath = normalizeLocalePath;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=normalize-locale-path.js.map


/***/ }),

/***/ 1842:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(9854)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(7378);
var _requestIdleCallback = __webpack_require__(2878);
var hasIntersectionObserver = typeof IntersectionObserver === "function";
var observers = new Map();
var idList = [];
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id: id,
        observer: observer,
        elements: elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(null), 2), element = ref1[0], setElement = ref1[1];
    (0, _react).useEffect(function() {
        if (hasIntersectionObserver) {
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                var unobserve = observe(element, function(isVisible) {
                    return isVisible && setVisible(isVisible);
                }, {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin: rootMargin
                });
                return unobserve;
            }
        } else {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    var resetVisible = (0, _react).useCallback(function() {
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 7868:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;
var _interop_require_default = (__webpack_require__(2619)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7378));
var AppRouterContext = _react.default.createContext(null);
exports.AppRouterContext = AppRouterContext;
var LayoutRouterContext = _react.default.createContext(null);
exports.LayoutRouterContext = LayoutRouterContext;
var GlobalLayoutRouterContext = _react.default.createContext(null);
exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;
var TemplateContext = _react.default.createContext(null);
exports.TemplateContext = TemplateContext;
if (false) {} //# sourceMappingURL=app-router-context.js.map


/***/ }),

/***/ 9906:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(3210)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(6516)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(2619)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7378));
var _loadable = _interop_require_default(__webpack_require__(2456));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if (false) {}
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 1721:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getImageBlurSvg = getImageBlurSvg;
function getImageBlurSvg(param) {
    var widthInt = param.widthInt, heightInt = param.heightInt, blurWidth = param.blurWidth, blurHeight = param.blurHeight, blurDataURL = param.blurDataURL;
    var std = blurWidth && blurHeight ? "1" : "20";
    var svgWidth = blurWidth || widthInt;
    var svgHeight = blurHeight || heightInt;
    var feComponentTransfer = blurDataURL.startsWith("data:image/jpeg") ? "%3CfeComponentTransfer%3E%3CfeFuncA type='discrete' tableValues='1 1'/%3E%3C/feComponentTransfer%3E%" : "";
    return "%3Csvg xmlns='http%3A//www.w3.org/2000/svg' viewBox='0 0 ".concat(svgWidth, " ").concat(svgHeight, "'%3E%3Cfilter id='b' color-interpolation-filters='sRGB'%3E%3CfeGaussianBlur stdDeviation='").concat(std, "'/%3E").concat(feComponentTransfer, "%3C/filter%3E%3Cimage filter='url(%23b)' x='0' y='0' height='100%25' width='100%25' href='").concat(blurDataURL, "'/%3E%3C/svg%3E");
} //# sourceMappingURL=image-blur-svg.js.map


/***/ }),

/***/ 7815:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(2619)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7378));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 2456:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(93)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(7758)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(6516)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(2619)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7378));
var _loadableContext = __webpack_require__(7815);
var useSyncExternalStore = ( true ? __webpack_require__(7378) : 0).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 8940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ HtmlParser; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
;// CONCATENATED MODULE: ../node_modules/markdown-to-jsx/dist/index.modern.js
function t(){return t=Object.assign?Object.assign.bind():function(n){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var e in r)({}).hasOwnProperty.call(r,e)&&(n[e]=r[e])}return n},t.apply(null,arguments)}const r=["strong","em","del","mark"],e=[["**",r[0]],["__",r[0]],["~~",r[2]],["==",r[3]],["*","em"],["_","em"]];function o(n,t){for(var r=1,e=t+1;e<n.length&&r>0;)"\\"!==n[e]?("["===n[e]&&r++,"]"===n[e]&&r--,e++):e+=2;if(0===r&&e<n.length&&("("===n[e]||"["===n[e])){var o="("===n[e]?")":"]",u=1;for(e++;e<n.length&&u>0;)"\\"!==n[e]?("("===n[e]&&")"===o&&u++,n[e]===o&&u--,e++):e+=2;if(0===u)return e}return-1}function u(n,t){if(!t||!t.inline&&!t.simple)return null;var r=n[0];if("*"!==r&&"_"!==r&&"~"!==r&&"="!==r)return null;for(var u="",a=0,c="",i=0;i<6;i++){var l=e[i][0];if(n.startsWith(l)&&n.length>=2*l.length){u=l,a=l.length,c=e[i][1];break}}if(!u)return null;for(var f=a,s=!1,_=!1,d="",p=0,y="",h=!1,m="";f<n.length;){var g=n[f];if(h)y+=g,h=!1,m=g,f++;else if("\\"!==g)if("`"!==g||0!==p){if("["===g&&!s&&0===p){var k=o(n,f);if(-1!==k){y+=n.slice(f,k),f=k,m=n[k-1];continue}}if(_)y+=g,d?g===d&&(d=""):'"'===g||"'"===g?d=g:">"===g&&(_=!1),m=g,f++;else if("<"!==g||s){if("\n"===g&&"\n"===m&&!s&&0===p)return null;if(!s&&0===p){for(var v=0;f+v<n.length&&n[f+v]===u[0];)v++;if(v>=a&&(1!==a||"*"!==u&&"_"!==u||n[f-1]!==u&&n[f+1]!==u)){var x=[n.slice(0,f+v),c,y+n.slice(f+a,f+v)];return x.index=0,x.input=n,x}}y+=g,m=g,f++}else{var q=n[f+1],b=n.indexOf(">",f);if(-1!==b){var S=n.slice(f,b+1).endsWith("/>");"/"===q?p=Math.max(0,p-1):S||p++}_=!0,y+=g,m=g,f++}}else s=!s,y+=g,m=g,f++;else y+=g,h=!0,m=g,f++}return null}const a=["children","options"],c={blockQuote:"0",breakLine:"1",breakThematic:"2",codeBlock:"3",codeFenced:"4",codeInline:"5",footnote:"6",footnoteReference:"7",gfmTask:"8",heading:"9",headingSetext:"10",htmlBlock:"11",htmlComment:"12",htmlSelfClosing:"13",image:"14",link:"15",linkAngleBraceStyleDetector:"16",linkBareUrlDetector:"17",linkMailtoDetector:"18",newlineCoalescer:"19",orderedList:"20",paragraph:"21",ref:"22",refImage:"23",refLink:"24",table:"25",tableSeparator:"26",text:"27",textEscaped:"28",textFormatted:"34",unorderedList:"30"},i=["allowFullScreen","allowTransparency","autoComplete","autoFocus","autoPlay","cellPadding","cellSpacing","charSet","classId","colSpan","contentEditable","contextMenu","crossOrigin","encType","formAction","formEncType","formMethod","formNoValidate","formTarget","frameBorder","hrefLang","inputMode","keyParams","keyType","marginHeight","marginWidth","maxLength","mediaGroup","minLength","noValidate","radioGroup","readOnly","rowSpan","spellCheck","srcDoc","srcLang","srcSet","tabIndex","useMap"].reduce((n,t)=>(n[t.toLowerCase()]=t,n),{class:"className",for:"htmlFor"}),l={amp:"&",apos:"'",gt:">",lt:"<",nbsp:" ",quot:"“"},f=["style","script","pre"],s=["src","href","data","formAction","srcDoc","action"],_=/([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi,d=/\n{2,}$/,p=/^(\s*>[\s\S]*?)(?=\n\n|$)/,y=/^ *> ?/gm,h=/^(?:\[!([^\]]*)\]\n)?([\s\S]*)/,m=/^ {2,}\n/,g=/^(?:([-*_])( *\1){2,}) *(?:\n *)+\n/,k=/^(?: {1,3})?(`{3,}|~{3,}) *(\S+)? *([^\n]*?)?\n([\s\S]*?)(?:\1\n?|$)/,v=/^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/,x=/^(`+)((?:\\`|(?!\1)`|[^`])+)\1/,q=/^(?:\n *)*\n/,b=/\r\n?/g,S=/^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/,$=/^\[\^([^\]]+)]/,z=/\f/g,A=/^---[ \t]*\n(.|\n)*\n---[ \t]*\n/,E=/^\[(x|\s)\]/,R=/^(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/,w=/^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/,L=/^([^\n]+)\n *(=|-)\2{2,} *\n/,B=/^<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>/i;function C(n){const t=B.exec(n);if(!t)return null;const r=t[1],e=r.toLowerCase(),o=e.length+1;let u=t[0].length;"\n"===n[u]&&u++;const a=u;let c=u,i=1;const l=n.length;for(;i>0;){const t=n.indexOf("<",u);if(-1===t)return null;let a=-1,f=-1;if("/"===n[t+1])f=t;else if(n[t+1]===e[0]||n[t+1]===r[0]){let u=!0;for(let o=0;o<e.length;o++){const a=n[t+1+o];if(a!==e[o]&&a!==r[o]){u=!1;break}}!u||" "!==n[t+o]&&">"!==n[t+o]||(a=t)}if(-1!==a||-1!==f)if(-1!==a&&(-1===f||a<f))u=a+o+1,i++;else{let t=f+2;for(;t<l;){const r=n[t];if(" "!==r&&"\t"!==r&&"\n"!==r&&"\r"!==r)break;t++}if(t+e.length>l)return null;let o=!0;for(let u=0;u<e.length;u++){const a=n[t+u];if(a!==e[u]&&a!==r[u]){o=!1;break}}if(!o){u=t;continue}for(t+=e.length;t<l;){const r=n[t];if(" "!==r&&"\t"!==r&&"\n"!==r&&"\r"!==r)break;t++}if(t>=l||">"!==n[t]){u=t;continue}c=f,u=t+1,i--}else u=t+1}let f=0;for(;u+f<l&&"\n"===n[u+f];)f++;return[n.slice(0,u+f),r,t[2],n.slice(a,c)]}const I=/&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi,M=/^<!--[\s\S]*?(?:-->)/,T=/^(data|aria|x)-[a-z_][a-z\d_.-]*$/,F=/^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i,O=/^\{.*\}$/,P=/^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,j=/^<([^ >]+[:@\/][^ >]+)>/,D=/-([a-z])?/gi,Z=/^(\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/,N=/^[^\n]+(?:  \n|\n{2,})/,G=/^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/,U=/^!\[([^\]]*)\] ?\[([^\]]*)\]/,V=/^\[([^\]]*)\] ?\[([^\]]*)\]/,H=/(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/,Q=/\t/g,W=/(^ *\||\| *$)/g,J=/^ *:-+: *$/,K=/^ *:-+ *$/,X=/^ *-+: *$/,Y=/^(:[a-zA-Z0-9-_]+:)/,nn=/^\\([^0-9A-Za-z\s])/,tn=/\\([^0-9A-Za-z\s])/g,rn=/^[\s\S](?:(?!  \n|[0-9]\.|http)[^=*_~\-\n:<`\\\[!])*/,en=/^\n+/,on=/^([ \t]*)/,un=/(?:^|\n)( *)$/,an="(?:\\d+\\.)",cn="(?:[*+-])";function ln(n){return"( *)("+(1===n?an:cn)+") +"}const fn=ln(1),sn=ln(2);function _n(n){return RegExp("^"+(1===n?fn:sn))}const dn=_n(1),pn=_n(2);function yn(n){return RegExp("^"+(1===n?fn:sn)+"[^\\n]*(?:\\n(?!\\1"+(1===n?an:cn)+" )[^\\n]*)*(\\n|$)","gm")}const hn=yn(1),mn=yn(2);function gn(n){const t=1===n?an:cn;return RegExp("^( *)("+t+") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1"+t+" (?!"+t+" ))\\n*|\\s*\\n*$)")}const kn=gn(1),vn=gn(2);function xn(n,t){const r=1===t,e=r?kn:vn,o=r?hn:mn,u=r?dn:pn;return{t:n=>u.test(n),o:In(function(n,t){const r=un.exec(t.prevCapture);return r&&(t.list||!t.inline&&!t.simple)?e.exec(n=r[1]+n):null}),u:1,i(n,t,e){const a=r?+n[2]:void 0,c=n[0].replace(d,"\n").match(o),i=u.exec(c[0]),l=RegExp("^ {1,"+(i?i[0].length:0)+"}","gm");let f=!1;return{items:c.map(function(n,r){const o=n.replace(l,"").replace(u,""),a=r===c.length-1,i=An(o,"\n\n")||a&&f;f=i;const s=e.inline,_=e.list;let d;e.list=!0,i?(e.inline=!1,d=$n(o)+"\n\n"):(e.inline=!0,d=$n(o));const p=t(d,e);return e.inline=s,e.list=_,p}),ordered:r,start:a}}}}const qn=RegExp("^\\[((?:\\[[^\\[\\]]*(?:\\[[^\\[\\]]*\\][^\\[\\]]*)*\\]|[^\\[\\]])*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"),bn=/^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/;function Sn(n){return"string"==typeof n}function $n(n){let t=n.length;for(;t>0&&n[t-1]<=" ";)t--;return n.slice(0,t)}function zn(n,t){return n.startsWith(t)}function An(n,t){return-1!==n.indexOf(t)}function En(n,t,r){if(Array.isArray(r)){for(let t=0;t<r.length;t++)if(zn(n,r[t]))return!0;return!1}return r(n,t)}function Rn(n){return n.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g,"a").replace(/[çÇ]/g,"c").replace(/[ðÐ]/g,"d").replace(/[ÈÉÊËéèêë]/g,"e").replace(/[ÏïÎîÍíÌì]/g,"i").replace(/[Ññ]/g,"n").replace(/[øØœŒÕõÔôÓóÒò]/g,"o").replace(/[ÜüÛûÚúÙù]/g,"u").replace(/[ŸÿÝý]/g,"y").replace(/[^a-z0-9- ]/gi,"").replace(/ /gi,"-").toLowerCase()}function wn(n){return X.test(n)?"right":J.test(n)?"center":K.test(n)?"left":null}function Ln(n,t,r,e){const o=r.inTable;r.inTable=!0;let u=[[]],a="";function c(){if(!a)return;const n=u[u.length-1];n.push.apply(n,t(a,r)),a=""}return n.trim().split(/(`[^`]*`|\\\||\|)/).filter(Boolean).forEach((n,t,r)=>{"|"===n.trim()&&(c(),e)?0!==t&&t!==r.length-1&&u.push([]):a+=n}),c(),r.inTable=o,u}function Bn(n,t,r){r.inline=!0;const e=n[2]?n[2].replace(W,"").split("|").map(wn):[],o=n[3]?function(n,t,r){return n.trim().split("\n").map(function(n){return Ln(n,t,r,!0)})}(n[3],t,r):[],u=Ln(n[1],t,r,!!o.length);return r.inline=!1,o.length?{align:e,cells:o,header:u,type:"25"}:{children:u,type:"21"}}function Cn(n,t){return null==n.align[t]?{}:{textAlign:n.align[t]}}function In(n){return n.inline=1,n}function Mn(n){return In(function(t,r){return r.inline?n.exec(t):null})}function Tn(n){return In(function(t,r){return r.inline||r.simple?n.exec(t):null})}function Fn(n){return function(t,r){return r.inline||r.simple?null:n.exec(t)}}function On(n){return In(function(t){return n.exec(t)})}const Pn=/(javascript|vbscript|data(?!:image)):/i;function jn(n){try{const t=decodeURIComponent(n).replace(/[^A-Za-z0-9/:]/g,"");if(Pn.test(t))return null}catch(n){return null}return n}function Dn(n){return n?n.replace(tn,"$1"):n}function Zn(n,t,r){const e=r.inline||!1,o=r.simple||!1;r.inline=!0,r.simple=!0;const u=n(t,r);return r.inline=e,r.simple=o,u}function Nn(n,t,r){const e=r.inline||!1,o=r.simple||!1;r.inline=!1,r.simple=!0;const u=n(t,r);return r.inline=e,r.simple=o,u}function Gn(n,t,r){const e=r.inline||!1;r.inline=!1;const o=n(t,r);return r.inline=e,o}const Un=(n,t,r)=>({children:Zn(t,n[2],r)});function Vn(){return{}}function Hn(...n){return n.filter(Boolean).join(" ")}function Qn(n,t,r){let e=n;const o=t.split(".");for(;o.length&&(e=e[o[0]],void 0!==e);)o.shift();return e||r}function Wn(n,t,r,e){if(!t||!t.trim())return null;const o=t.match(_);return o?o.reduce(function(t,o){const u=o.indexOf("=");if(-1!==u){const a=function(n){return-1!==n.indexOf("-")&&null===n.match(T)&&(n=n.replace(D,function(n,t){return t.toUpperCase()})),n}(o.slice(0,u)).trim(),c=i[a]||a;if("ref"===c)return t;const l=t[c]=function(n,t,r,e){return"style"===t?function(n){const t=[];if(!n)return t;let r="",e=0,o="";for(let u=0;u<n.length;u++){const a=n[u];if('"'===a||"'"===a)o?a===o&&(o="",e--):(o=a,e++);else if("("===a&&r.endsWith("url"))e++;else if(")"===a&&e>0)e--;else if(";"===a&&0===e){const n=r.indexOf(":");n>0&&t.push([r.slice(0,n).trim(),r.slice(n+1).trim()]),r="";continue}r+=a}const u=r.indexOf(":");return u>0&&t.push([r.slice(0,u).trim(),r.slice(u+1).trim()]),t}(r).reduce(function(t,[r,o]){return t[r.replace(/(-[a-z])/g,n=>n[1].toUpperCase())]=e(o,n,r),t},{}):-1!==s.indexOf(t)?e(Dn(r),n,t):(r.match(O)&&(r=Dn(r.slice(1,r.length-1))),"true"===r||"false"!==r&&r)}(n,a,function(n){const t=n[0];return('"'===t||"'"===t)&&n.length>=2&&n[n.length-1]===t?n.slice(1,-1):n}(o.slice(u+1).trim()),r);"string"==typeof l&&(B.test(l)||F.test(l))&&(t[c]=e(l.trim()))}else"style"!==o&&(t[i[o]||o]=!0);return t},{}):null}function Jn(n,t){for(let r=0;r<n.length;r++)if(n[r].test(t))return!0;return!1}function Kn(r="",e={}){e.overrides=e.overrides||{},e.namedCodesToUnicode=e.namedCodesToUnicode?t({},l,e.namedCodesToUnicode):l;const o=e.slugify||Rn,a=e.sanitizer||jn,c=e.createElement||react.createElement,i=[p,k,v,e.enforceAtxHeadings?w:R,L,Z,kn,vn],s=[...i,N,B,M,F];function _(n,r,...o){const u=Qn(e.overrides,n+".props",{});return c(function(n,t){const r=Qn(t,n);return r?"function"==typeof r||"object"==typeof r&&"render"in r?r:Qn(t,n+".component",n):n}(n,e.overrides),t({},r,u,{className:Hn(null==r?void 0:r.className,u.className)||void 0}),...o)}function d(n){n=n.replace(A,"");let r=!1;e.forceInline?r=!0:e.forceBlock||(r=!1===H.test(n));const u=W(r?n:$n(n).replace(en,"")+"\n\n",{inline:r});if(e.ast)return u;const a=J(u);for(;Sn(a[a.length-1])&&!a[a.length-1].trim();)a.pop();if(T.length&&a.push(_("footer",{key:"footer"},T.map(function(n){return _("div",{id:o(n.identifier,Rn),key:n.identifier},n.identifier,J(W(n.footnote,{inline:!0})))}))),null===e.wrapper)return a;const i=e.wrapper||(r?"span":"div");let l;if(a.length>1||e.forceWrapper)l=a;else{if(1===a.length)return l=a[0],"string"==typeof l?_("span",{key:"outer"},l):l;l=null}return c(i,t({key:"outer"},e.wrapperProps),l)}const T=[],O={},D={0:{t:[">"],o:Fn(p),u:1,i(n,t,r){const[,e,o]=n[0].replace(y,"").match(h);return{alert:e,children:t(o,r)}}},1:{t:["  "],o:Mn(m),u:1,i:Vn},2:{t:function(n,t){if(t.inline||t.simple)return!1;var r=n[0];return"-"===r||"*"===r||"_"===r},o:Fn(g),u:1,i:Vn},3:{t:["    "],o:Fn(v),u:0,i:n=>({lang:void 0,text:Dn($n(n[0].replace(/^ {4}/gm,"")))})},4:{t:["```","~~~"],o:Fn(k),u:0,i:n=>({attrs:Wn("code",n[3]||"",a,d),lang:n[2]||void 0,text:n[4],type:"3"})},5:{t:["`"],o:Tn(x),u:3,i:n=>({text:Dn(n[2])})},6:{t:["[^"],o:Fn(S),u:0,i:n=>(T.push({footnote:n[2],identifier:n[1]}),{})},7:{t:["[^"],o:Mn($),u:1,i:n=>({target:"#"+o(n[1],Rn),text:n[1]})},8:{t:["[ ]","[x]"],o:Mn(E),u:1,i:n=>({completed:"x"===n[1].toLowerCase()})},9:{t:["#"],o:Fn(e.enforceAtxHeadings?w:R),u:1,i:(n,t,r)=>({children:Zn(t,n[2],r),id:o(n[2],Rn),level:n[1].length})},10:{t:n=>{const t=n.indexOf("\n");return t>0&&t<n.length-1&&("="===n[t+1]||"-"===n[t+1])},o:Fn(L),u:1,i:(n,t,r)=>({children:Zn(t,n[1],r),level:"="===n[2]?1:2,type:"9"})},11:{t:["<"],o:In(C),u:1,i(n,t,r){const[,e]=n[3].match(on),o=RegExp("^"+e,"gm"),u=n[3].replace(o,""),c=Jn(s,u)?Gn:Zn,i=n[1].toLowerCase(),l=-1!==f.indexOf(i),_=(l?i:n[1]).trim(),p={attrs:Wn(_,n[2],a,d),noInnerParse:l,tag:_};if(r.inAnchor=r.inAnchor||"a"===i,l)p.text=n[3];else{const n=r.inHTML;r.inHTML=!0,p.children=c(t,u,r),r.inHTML=n}return r.inAnchor=!1,p}},13:{t:["<"],o:On(F),u:1,i(n){const t=n[1].trim();return{attrs:Wn(t,n[2]||"",a,d),tag:t}}},12:{t:["\x3c!--"],o:On(M),u:1,i:()=>({})},14:{t:["!["],o:Tn(bn),u:1,i:n=>({alt:Dn(n[1]),target:Dn(n[2]),title:Dn(n[3])})},15:{t:["["],o:Mn(qn),u:3,i:(n,t,r)=>({children:Nn(t,n[1],r),target:Dn(n[2]),title:Dn(n[3])})},16:{t:function(n,t){return!(!t.inline||t.inAnchor)&&"<"===n[0]&&(An(n,":")||An(n,"@")||An(n,"/"))},o:Mn(j),u:0,i(n){let t=n[1],r=!1;return An(t,"@")&&!An(t,"//")&&(r=!0,t=t.replace("mailto:","")),{children:[{text:t,type:"27"}],target:r?"mailto:"+t:t,type:"15"}}},17:{t:(n,t)=>!t.inAnchor&&!e.disableAutoLink&&zn(n,"http"),o:Mn(P),u:0,i:n=>({children:[{text:n[1],type:"27"}],target:n[1],title:void 0,type:"15"})},20:xn(0,1),30:xn(0,2),19:{t:["\n"],o:Fn(q),u:3,i:Vn},21:{t:function(n,t){return!t.inline&&!t.simple},o:In(function(n,t){if(t.inline||t.simple||t.inHTML&&!An(n,"\n\n")&&!An(t.prevCapture,"\n\n"))return null;let r="",e=0;for(;;){const t=n.indexOf("\n",e),o=n.slice(e,-1===t?void 0:t+1),u=n[e];if((">"===u||"#"===u||"|"===u||"`"===u||"~"===u||"*"===u||"-"===u||"_"===u||" "===u)&&Jn(i,o))break;if(r+=o,-1===t||!o.trim())break;e=t+1}const o=$n(r);return""===o?null:[r,,o]}),u:3,i:Un},22:{t:["["],o:Mn(G),u:0,i:n=>(O[n[1]]={target:n[2],title:n[4]},{})},23:{t:["!["],o:Tn(U),u:0,i:n=>({alt:n[1]?Dn(n[1]):void 0,ref:n[2]})},24:{t:n=>"["===n[0]&&!An(n,"]("),o:Mn(V),u:0,i:(n,t,r)=>({children:t(n[1],r),fallbackChildren:n[0],ref:n[2]})},25:{t:["|"],o:Fn(Z),u:1,i:Bn},27:{o:In(function(n,t){let r;return zn(n,":")&&(r=Y.exec(n)),r||rn.exec(n)}),u:4,i(n){const t=n[0];return{text:An(t,"&")?t.replace(I,(n,t)=>e.namedCodesToUnicode[t]||n):t}}},34:{t:["*","_","~","="],o:In(u),u:2,i:(n,t,r)=>({children:t(n[2],r),tag:n[1]})},28:{t:["\\"],o:Tn(nn),u:1,i:n=>({text:n[1],type:"27"})}};!0===e.disableParsingRawHTML&&(delete D[11],delete D[13]);const W=function(n){var t=Object.keys(n);function r(e,o){var u=[];if(o.prevCapture=o.prevCapture||"",e.trim())for(;e;)for(var a=0;a<t.length;){var c=t[a],i=n[c];if(!i.t||En(e,o,i.t)){var l=i.o(e,o);if(l&&l[0]){e=e.substring(l[0].length);var f=i.i(l,r,o);o.prevCapture+=l[0],f.type||(f.type=c),u.push(f);break}a++}else a++}return o.prevCapture="",u}return t.sort(function(t,r){return n[t].u-n[r].u||(t<r?-1:1)}),function(n,t){return r(function(n){return n.replace(b,"\n").replace(z,"").replace(Q,"    ")}(n),t)}}(D),J=function(n,r,e,o,u){function a(n){return Array.isArray(n)?n.map(n=>"text"in n?n.text:""):"text"in n?n.text:""}return function c(i,l={}){const f=(l.renderDepth||0)+1;if(f>2500)return a(i);l.renderDepth=f;try{if(Array.isArray(i)){const n=l.key,t=[];let r=!1;for(let n=0;n<i.length;n++){l.key=n;const e=c(i[n],l),o=Sn(e);o&&r?t[t.length-1]+=e:null!==e&&t.push(e),r=o}return l.key=n,l.renderDepth=f-1,t}const a=function(a,c,i){const l=()=>function(n,r,e,o,u,a,c){switch(n.type){case"0":{const t={key:e.key};return n.alert&&(t.className="markdown-alert-"+a(n.alert.toLowerCase(),Rn),n.children.unshift({attrs:{},children:[{type:"27",text:n.alert}],noInnerParse:!0,type:"11",tag:"header"})),o("blockquote",t,r(n.children,e))}case"1":return o("br",{key:e.key});case"2":return o("hr",{key:e.key});case"3":return o("pre",{key:e.key},o("code",t({},n.attrs,{className:n.lang?"lang-"+n.lang:""}),n.text));case"5":return o("code",{key:e.key},n.text);case"7":return o("a",{key:e.key,href:u(n.target,"a","href")},o("sup",{key:e.key},n.text));case"8":return o("input",{checked:n.completed,key:e.key,readOnly:!0,type:"checkbox"});case"9":return o("h"+n.level,{id:n.id,key:e.key},r(n.children,e));case"11":return o(n.tag,t({key:e.key},n.attrs),n.text||(n.children?r(n.children,e):""));case"13":return o(n.tag,t({},n.attrs,{key:e.key}));case"14":return o("img",{key:e.key,alt:n.alt||void 0,title:n.title||void 0,src:u(n.target,"img","src")});case"15":return o("a",{key:e.key,href:u(n.target,"a","href"),title:n.title},r(n.children,e));case"23":return c[n.ref]?o("img",{key:e.key,alt:n.alt,src:u(c[n.ref].target,"img","src"),title:c[n.ref].title}):null;case"24":return c[n.ref]?o("a",{key:e.key,href:u(c[n.ref].target,"a","href"),title:c[n.ref].title},r(n.children,e)):o("span",{key:e.key},n.fallbackChildren);case"25":{const t=n;return o("table",{key:e.key},o("thead",null,o("tr",null,t.header.map(function(n,u){return o("th",{key:u,style:Cn(t,u)},r(n,e))}))),o("tbody",null,t.cells.map(function(n,u){return o("tr",{key:u},n.map(function(n,u){return o("td",{key:u,style:Cn(t,u)},r(n,e))}))})))}case"27":return n.text;case"34":return o(n.tag,{key:e.key},r(n.children,e));case"20":case"30":return o(n.ordered?"ol":"ul",{key:e.key,start:"20"===n.type?n.start:void 0},n.items.map(function(n,t){return o("li",{key:t},r(n,e))}));case"19":return"\n";case"21":return o("p",{key:e.key},r(n.children,e));default:return null}}(a,c,i,r,e,o,u);return n?n(l,a,c,i):l()}(i,c,l);return l.renderDepth=f-1,a}catch(n){if(n instanceof RangeError&&n.message.includes("Maximum call stack"))return a(i);throw n}}}(e.renderRule,_,a,o,O);return d(r)}const Xn=n=>{let{children:r,options:e}=n,o=function(n,t){if(null==n)return{};var r={};for(var e in n)if({}.hasOwnProperty.call(n,e)){if(-1!==t.indexOf(e))continue;r[e]=n[e]}return r}(n,a);return Kn(null==r?"":r,t({},e,{wrapperProps:t({},null==e?void 0:e.wrapperProps,o)}))};
//# sourceMappingURL=index.modern.js.map

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Link-479ac100.mjs
var Link_479ac100 = __webpack_require__(965);
// EXTERNAL MODULE: ../node_modules/next/router.js
var router = __webpack_require__(6677);
// EXTERNAL MODULE: ./src/constants/magnolia.ts + 1 modules
var magnolia = __webpack_require__(5056);
;// CONCATENATED MODULE: ./src/components/HtmlParser/Anchor.tsx






var style = {
    color: "inherit"
};
function Anchor(param) {
    var href = param.href, id = param.id, children = param.children;
    var isPreview = (0,router.useRouter)().isPreview;
    if (!href) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link_479ac100.L, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        id: id,
        style: style
    }, formatLink(href, isPreview)), {
        children: children
    }));
}
/**
 * Richtext href internal and external link handler
 * @date 10/6/2022 - 9:35:36 AM
 *
 * @export
 * @param {string} link
 */ function formatLink(link) {
    var isPreview = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var decodedLink = decodeEncodedLink(link);
    //   Handle empty or root node links
    if (decodedLink === magnolia/* MGNL.AUTHOR_PATH */.m.AUTHOR_PATH + magnolia/* MGNL.ROOT_NODE */.m.ROOT_NODE || decodedLink === "") {
        return {
            href: "/"
        };
    }
    // Handle external links
    if (!decodedLink.startsWith("/")) return {
        href: decodedLink,
        target: "_blank"
    };
    var modifiedLink = decodedLink.replace(magnolia/* MGNL.AUTHOR_PATH */.m.AUTHOR_PATH, "").replace(magnolia/* MGNL.ROOT_NODE */.m.ROOT_NODE, "").replace("/fi", "").replace("/sv", "").replace(".html", "");
    // Prepend MGNL host to DAM links
    if (modifiedLink.startsWith("/dam")) {
        return {
            href: new URL(modifiedLink, magnolia/* MGNL.HOST */.m.HOST(isPreview)).toString(),
            target: "_blank"
        };
    }
    // Internal links
    return {
        href: modifiedLink
    };
}
/** Parse link if wrapped in an $ object. */ function decodeEncodedLink(link) {
    var decodedLink = decodeURI(link);
    if (decodedLink.startsWith("$")) {
        try {
            return decodedLink.split("path:{")[1].split("}")[0];
        } catch (e) {
            return "";
        }
    }
    return link;
}

;// CONCATENATED MODULE: ./src/components/HtmlParser/HtmlParser.tsx



var options = {
    overrides: {
        a: Anchor
    }
};
/**
 * Component to handle html tags inside richText string prop
 * and returns html tags as react instead of regular html.
 * This allows us to use UI components, styling etc.
 *
 * Can be extended to have more tags, currently have <p> and <a> tags
 *
 * @date 10/6/2022 - 9:53:50 AM
 */ function HtmlParser(param) {
    var html = param.html;
    if (!html) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Xn, {
        options: options,
        children: html.replaceAll("\xa0", "&nbsp;")
    });
}


/***/ }),

/***/ 5884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A_": function() { return /* binding */ META_TITLE_SUFFIX; },
/* harmony export */   "PX": function() { return /* binding */ __IS_PROD_ENV__; },
/* harmony export */   "aG": function() { return /* binding */ DeviceSizes; },
/* harmony export */   "ch": function() { return /* binding */ __IS_DEV_ENV__; },
/* harmony export */   "ip": function() { return /* binding */ headerHeightXs; },
/* harmony export */   "jT": function() { return /* binding */ __APP_HOST_PUBLIC__; },
/* harmony export */   "l_": function() { return /* binding */ Viewport; },
/* harmony export */   "tB": function() { return /* binding */ __IS_LIVE_SITE__; },
/* harmony export */   "z_": function() { return /* binding */ headerHeightSmAndAbove; }
/* harmony export */ });
/* unused harmony exports __IS_TEST_ENV__, __IS_BUILD_TEST__, __APP_HOST_AUTHOR__ */
/* provided dependency */ var process = __webpack_require__(7061);
// ---- Node environments
var __IS_DEV_ENV__ = "production" === "development";
var __IS_PROD_ENV__ = "production" === "production";
var __IS_TEST_ENV__ = (/* unused pure expression or super */ null && ("production" === "test"));
var __IS_BUILD_TEST__ = process.env.NEXT_PUBLIC_IS_BUILD_TEST === "true";
var __APP_HOST_PUBLIC__ = String("https://www.workinfinland.com" || 0);
var __APP_HOST_AUTHOR__ = String(process.env.NEXT_PUBLIC_APP_HOST_AUTHOR || __APP_HOST_PUBLIC__);
var __IS_LIVE_SITE__ = __APP_HOST_PUBLIC__.includes("workinfinland.com");
var Viewport;
(function(Viewport) {
    Viewport["xs"] = "xs";
    Viewport["sm"] = "sm";
    Viewport["md"] = "md";
    Viewport["lg"] = "lg";
    Viewport["xl"] = "xl";
})(Viewport || (Viewport = {}));
var DeviceSizes;
(function(DeviceSizes) {
    DeviceSizes[DeviceSizes["xs"] = 0] = "xs";
    DeviceSizes[DeviceSizes["sm"] = 600] = "sm";
    DeviceSizes[DeviceSizes["md"] = 900] = "md";
    DeviceSizes[DeviceSizes["lg"] = 1024] = "lg";
    DeviceSizes[DeviceSizes["xl"] = 1440] = "xl";
})(DeviceSizes || (DeviceSizes = {}));
var headerHeightXs = 75;
var headerHeightSmAndAbove = 104;
var META_TITLE_SUFFIX = " - Work in Finland";


/***/ }),

/***/ 3726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EW": function() { return /* binding */ ogLocaleMap; },
/* harmony export */   "HG": function() { return /* binding */ localesEmployers; },
/* harmony export */   "Vb": function() { return /* binding */ localesTalent; },
/* harmony export */   "al": function() { return /* binding */ defaultLocale; },
/* harmony export */   "go": function() { return /* binding */ Locale; }
/* harmony export */ });
/* unused harmony export locales */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7599);

var Locale;
(function(Locale) {
    Locale["Default"] = "default";
    Locale["English"] = "en";
    Locale["Suomi"] = "fi";
    Locale["Svenska"] = "sv";
})(Locale || (Locale = {}));
var defaultLocale = Locale.English;
var locales = [
    Locale.Suomi,
    Locale.English,
    Locale.Svenska, 
];
var localesTalent = [
    Locale.English
];
var localesEmployers = locales;
var _obj;
var ogLocaleMap = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, Locale.Suomi, "fi_FI"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, Locale.Svenska, "sv_SE"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, Locale.English, "en_GB"), _obj);


/***/ }),

/***/ 5056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* binding */ MGNL; },
  "w": function() { return /* binding */ MGNL_API; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(4364);
;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_create_class.mjs
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

;// CONCATENATED MODULE: ./src/constants/magnolia.ts
/* provided dependency */ var process = __webpack_require__(7061);
/* provided dependency */ var Buffer = __webpack_require__(816)["lW"];
/* eslint-disable max-len */ 

var MGNL = /*#__PURE__*/ function() {
    "use strict";
    function MGNL() {
        (0,_class_call_check/* default */.Z)(this, MGNL);
    }
    /**
   * URL for the current author or public deployment of Magnolia instance.
   * If `isPreview` is set to `true`, path for the author instance will be used,
   * else path for the public instance will be used.
   * @example "http://localhost:8080"
   */ MGNL.HOST = function HOST() {
        var isPreview = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return isPreview ? this.HOST_AUTHOR : this.HOST_PUBLIC;
    };
    /**
   * Used as base for all API endpoints
   * @example "http://localhost:8080/magnoliaAuthor"
   */ MGNL.BASE_URL = function BASE_URL() {
        var isPreview = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return this.HOST(isPreview) + this.AUTHOR_PATH;
    };
    /**
   * Used as base for all API endpoints
   * @example "http://localhost:8080/magnoliaAuthor"
   */ MGNL.DELIVERY_API = function DELIVERY_API() {
        var isPreview = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return this.BASE_URL(isPreview) + "/.rest/wif";
    };
    MGNL.BF_CUSTOM_API = function BF_CUSTOM_API() {
        var isPreview = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return this.BASE_URL(isPreview) + "/.rest/bf";
    };
    _createClass(MGNL, null, [
        {
            key: "HOST_PUBLIC",
            get: /**
   * URL for the current public deployment of Magnolia instance.
   * @example "http://localhost:8080"
   * @required
   */ function get() {
                var host = String("https://www.workinfinland.com" || 0);
                if (!host) {
                    throw new Error("Env var NEXT_PUBLIC_MGNL_HOST_PUBLIC is required.");
                }
                return host;
            }
        },
        {
            key: "HOST_AUTHOR",
            get: /**
   * URL for the current author deployment of Magnolia instance.
   * @example "http://localhost:8080"
   */ function get() {
                return String("https://mgnl-author.busfinland-prod.magnolia-platform.com" || 0);
            }
        },
        {
            key: "AUTHOR_PATH",
            get: /**
   * Subpath of Magnolia's author instance. Could be empty string.
   * @example "/magnoliaAuthor"
   * @default ""
   */ function get() {
                return String(process.env.NEXT_PUBLIC_MGNL_AUTHOR || "");
            }
        },
        {
            key: "ROOT_NODE",
            get: /**
   * Magnolia root node (parent page-node for all pages/content).
   * @default "/wif"
   */ function get() {
                return String("/wif" || 0);
            }
        },
        {
            key: "EMPLOYERS_NODE",
            get: /**
   * Magnolia root node for employers site .
   * @default "/wif/tyonantajat"
   */ function get() {
                return String(this.ROOT_NODE + "/tyonantajat");
            }
        },
        {
            key: "AUTH_TOKEN",
            get: function get() {
                // Bracket access so Next 12 does not inline this at image build
                // (same pattern as ASIAKASTIETO). ConfigMap value is used at runtime.
                return process.env["MGNL_AUTH_TOKEN"] || undefined;
            }
        },
        {
            key: "AUTH_HEADER",
            get: /** `Authorization` value. Accepts base64, `Basic …`, or `user:pass`. */ function get() {
                var ref;
                var token = (ref = this.AUTH_TOKEN) === null || ref === void 0 ? void 0 : ref.trim();
                if (!token) return undefined;
                var raw = token.startsWith("Basic ") ? token.slice(6).trim() : token;
                if (!raw) return undefined;
                var encoded = raw.includes(":") ? encodeBasicCredentials(raw) : raw;
                return "Basic ".concat(encoded);
            }
        }
    ]);
    return MGNL;
}();
function encodeBasicCredentials(userPass) {
    return typeof Buffer !== "undefined" ? Buffer.from(userPass, "utf8").toString("base64") : btoa(userPass);
}
var MGNL_API = /*#__PURE__*/ function() {
    "use strict";
    function MGNL_API() {
        (0,_class_call_check/* default */.Z)(this, MGNL_API);
    }
    /**
   * Get all companies.
   */ MGNL_API.COMPANIES = function COMPANIES() {
        var isPreview = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return MGNL.DELIVERY_API(isPreview) + "/companies";
    };
    /**
   * Get all content for the current page node to render page.
   */ MGNL_API.PAGE_CONTENT = function PAGE_CONTENT() {
        var isPreview = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return MGNL.DELIVERY_API(isPreview) + "/page-content";
    };
    /**
   * Get minimum data for all page-nodes that are required to build navigation.
   */ MGNL_API.NAVIGATION = function NAVIGATION() {
        var isPreview = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return MGNL.DELIVERY_API(isPreview) + "/navigation";
    };
    /**
   * Magnolia Navigation App endpoint (editor-managed navigation tree).
   * Uses the shared `/.rest/delivery/navigation` endpoint with the WIF app base.
   */ MGNL_API.NAVIGATION_APP = function NAVIGATION_APP() {
        var isPreview = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return MGNL.BASE_URL(isPreview) + "/.rest/delivery/navigation";
    };
    /**
   * Get minimum data for a list of page-nodes. Limit=100.
   */ MGNL_API.PAGES_100 = function PAGES_100() {
        var isPreview = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return MGNL.DELIVERY_API(isPreview) + "/pages/100";
    };
    /**
   * Get minimum data for a list of page-nodes. Limit=10.
   */ MGNL_API.PAGES_10 = function PAGES_10() {
        var isPreview = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return MGNL.DELIVERY_API(isPreview) + "/pages/10";
    };
    /**
   * Get minimum data for all page-nodes under ROOT_NODE
   * to statically generate pages during build-time (all languages).
   */ MGNL_API.PATHS = function PATHS() {
        var isPreview = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return MGNL.DELIVERY_API(isPreview) + "/paths";
    };
    /**
   * Get minimum data for all page-nodes under ROOT_NODE
   * to statically generate pages during build-time (all languages).
   */ MGNL_API.PATHS_VIDEOS = function PATHS_VIDEOS() {
        var isPreview = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return MGNL.DELIVERY_API(isPreview) + "/paths/videos";
    };
    /**
   * Get minimum data for all page-nodes under ROOT_NODE
   * to statically generate pages during build-time (all languages).
   */ MGNL_API.PATHS_IMAGES = function PATHS_IMAGES() {
        var isPreview = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return MGNL.DELIVERY_API(isPreview) + "/paths/images";
    };
    /**
   * Get all services.
   */ MGNL_API.SERVICES = function SERVICES() {
        var isPreview = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return MGNL.DELIVERY_API(isPreview) + "/services";
    };
    /**
   * Form module custom endpoint.
   */ MGNL_API.FORM_SUBMIT = function FORM_SUBMIT() {
        var isPreview = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return MGNL.BF_CUSTOM_API(isPreview) + "/form/submit";
    };
    /**
   * Get template annotations for current page during preview,
   * so the Magnolia editor can render toolbars.
   */ MGNL_API.TEMPLATE = function TEMPLATE() {
        return MGNL.BASE_URL(true) + "/.rest/template-annotations/v1";
    };
    /**
   * Magnolia Nodes API endpoint.
   * @see https://docs.magnolia-cms.com/product-docs/6.2/Developing/API/Nodes-and-properties-APIs/Nodes-API.html
   */ MGNL_API.NODES = function NODES(workspace) {
        var path = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "/", options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        var _isPreview = options.isPreview, isPreview = _isPreview === void 0 ? false : _isPreview, _depth = options.depth, depth = _depth === void 0 ? 0 : _depth, excludeNodeTypes = options.excludeNodeTypes, includeMetadata = options.includeMetadata;
        var url = MGNL.BASE_URL(isPreview) + "/.rest/nodes/v1/".concat(workspace).concat(path);
        if (!depth && !excludeNodeTypes && !includeMetadata) {
            return url;
        }
        var searchParams = new URLSearchParams();
        searchParams.set("depth", depth.toString());
        searchParams.set("excludeNodeTypes", (excludeNodeTypes === null || excludeNodeTypes === void 0 ? void 0 : excludeNodeTypes.join(",")) || "");
        searchParams.set("includeMetadata", String(Boolean(includeMetadata)));
        return "".concat(url, "?").concat(searchParams.toString());
    };
    return MGNL_API;
}();


/***/ }),

/***/ 981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ EmployerSiteContextProvider; },
/* harmony export */   "Z": function() { return /* binding */ useEmployerSite; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);

var EmployerSiteContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    isEmployerSite: false
});
var EmployerSiteContextProvider = EmployerSiteContext.Provider;
function useEmployerSite() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(EmployerSiteContext);
}


/***/ }),

/***/ 9366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ ViewportContextProvider; },
/* harmony export */   "Z": function() { return /* binding */ useViewport; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(169);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var _business_finland_wif_ui_lib__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(128);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);
/* harmony import */ var _util_viewport__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5625);






var initialViewport = {
    viewport: "xl",
    isMobile: false
};
var ViewportContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(initialViewport);
function ViewportContextProvider(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useTransition)(), startTransition = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initialViewport), viewport = ref1[0], setViewport = ref1[1];
    var checkIsMobile = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(viewport) {
        return viewport === "xs" || viewport === "sm" || viewport === undefined;
    }, []);
    var updateViewport = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var viewport = (0,_util_viewport__WEBPACK_IMPORTED_MODULE_2__/* .getViewportByWindowWidth */ .J)();
        setViewport(function(prev) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, prev), {
                viewport: viewport,
                isMobile: checkIsMobile(viewport)
            });
        });
    }, [
        checkIsMobile
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        return startTransition(updateViewport);
    }, [
        updateViewport
    ]);
    (0,_business_finland_wif_ui_lib__WEBPACK_IMPORTED_MODULE_5__/* .useEventListener */ .OR)("resize", function() {
        return startTransition(updateViewport);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ViewportContext.Provider, {
        value: viewport,
        children: children
    });
}
function useViewport() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(ViewportContext);
}


/***/ }),

/***/ 4847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useImageDataHandler; }
/* harmony export */ });
/* unused harmony export imageDataHandler */
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);
/* harmony import */ var _contexts_ViewportContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9366);
/* harmony import */ var _util_magnolia__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7581);
/* harmony import */ var _util_viewport__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5625);





/**
 * Hook to generate an image handler function.
 *
 * Options can be passed to handler function to optimise image size.
 * If the image does not to bigger than "sm" in any viewport, then
 * `maxViewport` option should be set to `Viewport.sm`.
 *
 * Image sizes (width) for each viewport size:
 * - xs: 600px
 * - sm: 800px
 * - md: 900px
 * - lg: 1024px
 * - xl: 1440px
 */ function useImageDataHandler() {
    var isPreview = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)().isPreview;
    var viewport = (0,_contexts_ViewportContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().viewport;
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(image, options) {
        return imageDataHandler(image, viewport, isPreview, options);
    }, [
        isPreview,
        viewport
    ]);
}
/**
 * Get image information from MGNL (MGNL = Magnolia)
 * @param image - Image object from MGNL
 * @param viewport - Viewport from store
 * @returns Object containing "imageSrc" (image url), "imageLoader" (loader to handle next/image)
 *  and boolean "fallback", to show a fallback image if current image is not published in MGNL
 */ function imageDataHandler(image, viewport) {
    var isPreview = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, options = arguments.length > 3 ? arguments[3] : void 0;
    if (typeof image === "string" || !image) return {
        src: "",
        width: 0,
        height: 0,
        imageLoader: undefined,
        imageSrc: ""
    };
    var _metadata = image.metadata, width = _metadata.width, height = _metadata.height;
    var src = (0,_util_magnolia__WEBPACK_IMPORTED_MODULE_3__/* .formatAssetLink */ .Qz)(image["@link"], isPreview).toString();
    var optimisedViewport = (0,_util_viewport__WEBPACK_IMPORTED_MODULE_4__/* .optimiseViewport */ .s)(viewport, options);
    var imageLoader = function() {
        var ref;
        return optimisedViewport && ((ref = image.renditions) === null || ref === void 0 ? void 0 : ref[optimisedViewport].link) ? (0,_util_magnolia__WEBPACK_IMPORTED_MODULE_3__/* .formatAssetLink */ .Qz)(image.renditions[optimisedViewport].link, isPreview) : src;
    };
    return {
        src: src,
        width: width,
        height: height,
        imageLoader: imageLoader,
        imageSrc: src
    };
}


/***/ }),

/***/ 9647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "gM": function() { return /* binding */ MagnoliaTemplate; },
  "rX": function() { return /* binding */ getComponentForMagnoliaTemplate; },
  "iL": function() { return /* binding */ magnoliaEditablePageConfig; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(7599);
// EXTERNAL MODULE: ../node_modules/next/dynamic.js
var dynamic = __webpack_require__(5218);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../wif-ui-lib/dist/app-a75c1d35.mjs
var app_a75c1d35 = __webpack_require__(3406);
// EXTERNAL MODULE: ../wif-ui-lib/dist/swiper.min-13551361.mjs
var swiper_min_13551361 = __webpack_require__(5038);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Image-d6406817.mjs
var Image_d6406817 = __webpack_require__(5905);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Link-479ac100.mjs
var Link_479ac100 = __webpack_require__(965);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Button-c598cb52.mjs
var Button_c598cb52 = __webpack_require__(7977);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Block-9b78bd10.mjs
var Block_9b78bd10 = __webpack_require__(4877);
;// CONCATENATED MODULE: ../wif-ui-lib/dist/Testimonials.js












function ne({
  swiper: e,
  extendParams: r,
  on: a,
  emit: o
}) {
  let d;
  e.autoplay = {
    running: !1,
    paused: !1
  }, r({
    autoplay: {
      enabled: !1,
      delay: 3e3,
      waitForTransition: !0,
      disableOnInteraction: !0,
      stopOnLastSlide: !1,
      reverseDirection: !1,
      pauseOnMouseEnter: !1
    }
  });
  function i() {
    if (!e.size) {
      e.autoplay.running = !1, e.autoplay.paused = !1;
      return;
    }
    const m = e.slides.eq(e.activeIndex);
    let u = e.params.autoplay.delay;
    m.attr("data-swiper-autoplay") && (u = m.attr("data-swiper-autoplay") || e.params.autoplay.delay), clearTimeout(d), d = (0,swiper_min_13551361.n)(() => {
      let p;
      e.params.autoplay.reverseDirection ? e.params.loop ? (e.loopFix(), p = e.slidePrev(e.params.speed, !0, !0), o("autoplay")) : e.isBeginning ? e.params.autoplay.stopOnLastSlide ? l() : (p = e.slideTo(e.slides.length - 1, e.params.speed, !0, !0), o("autoplay")) : (p = e.slidePrev(e.params.speed, !0, !0), o("autoplay")) : e.params.loop ? (e.loopFix(), p = e.slideNext(e.params.speed, !0, !0), o("autoplay")) : e.isEnd ? e.params.autoplay.stopOnLastSlide ? l() : (p = e.slideTo(0, e.params.speed, !0, !0), o("autoplay")) : (p = e.slideNext(e.params.speed, !0, !0), o("autoplay")), (e.params.cssMode && e.autoplay.running || p === !1) && i();
    }, u);
  }
  function c() {
    return typeof d < "u" || e.autoplay.running ? !1 : (e.autoplay.running = !0, o("autoplayStart"), i(), !0);
  }
  function l() {
    return !e.autoplay.running || typeof d > "u" ? !1 : (d && (clearTimeout(d), d = void 0), e.autoplay.running = !1, o("autoplayStop"), !0);
  }
  function C(m) {
    e.autoplay.running && (e.autoplay.paused || (d && clearTimeout(d), e.autoplay.paused = !0, m === 0 || !e.params.autoplay.waitForTransition ? (e.autoplay.paused = !1, i()) : ["transitionend", "webkitTransitionEnd"].forEach((u) => {
      e.$wrapperEl[0].addEventListener(u, g);
    })));
  }
  function _() {
    const m = (0,swiper_min_13551361.g)();
    m.visibilityState === "hidden" && e.autoplay.running && C(), m.visibilityState === "visible" && e.autoplay.paused && (i(), e.autoplay.paused = !1);
  }
  function g(m) {
    !e || e.destroyed || !e.$wrapperEl || m.target === e.$wrapperEl[0] && (["transitionend", "webkitTransitionEnd"].forEach((u) => {
      e.$wrapperEl[0].removeEventListener(u, g);
    }), e.autoplay.paused = !1, e.autoplay.running ? i() : l());
  }
  function E() {
    e.params.autoplay.disableOnInteraction ? l() : (o("autoplayPause"), C()), ["transitionend", "webkitTransitionEnd"].forEach((m) => {
      e.$wrapperEl[0].removeEventListener(m, g);
    });
  }
  function T() {
    e.params.autoplay.disableOnInteraction || (e.autoplay.paused = !1, o("autoplayResume"), i());
  }
  function S() {
    e.params.autoplay.pauseOnMouseEnter && (e.$el.on("mouseenter", E), e.$el.on("mouseleave", T));
  }
  function k() {
    e.$el.off("mouseenter", E), e.$el.off("mouseleave", T);
  }
  a("init", () => {
    e.params.autoplay.enabled && (c(), (0,swiper_min_13551361.g)().addEventListener("visibilitychange", _), S());
  }), a("beforeTransitionStart", (m, u, p) => {
    e.autoplay.running && (p || !e.params.autoplay.disableOnInteraction ? e.autoplay.pause(u) : l());
  }), a("sliderFirstMove", () => {
    e.autoplay.running && (e.params.autoplay.disableOnInteraction ? l() : C());
  }), a("touchEnd", () => {
    e.params.cssMode && e.autoplay.paused && !e.params.autoplay.disableOnInteraction && i();
  }), a("destroy", () => {
    k(), e.autoplay.running && l(), (0,swiper_min_13551361.g)().removeEventListener("visibilitychange", _);
  }), Object.assign(e.autoplay, {
    pause: C,
    run: i,
    start: c,
    stop: l
  });
}
function A(e, r = {}) {
  typeof window > "u" || !Array.isArray(window.dataLayer) || window.dataLayer.push({
    event: e,
    event_category: "testimonials",
    ...r
  });
}
const ie = "testimonial-card", se = "testimonial-card--featured", oe = "testimonial-card__image-container", le = "desktop", re = "testimonial-card__content-overlay", de = "testimonial-card__content", me = "mobile", ue = "testimonial-card__title", ce = "testimonial-card__title--featured", fe = "testimonial-card__numbering", pe = "testimonial-card__featured-body", ye = "testimonial-card__body", Ce = "testimonial-card__cta", ge = "testimonial-card__cta-button", ve = "testimonial-card__testimonial-section", he = "testimonial-card__quote-container", Ee = "testimonial-card__quote-mark", _e = "testimonial-card__testimonial-content", be = "testimonial-card__testimonial-text", Ne = "testimonial-card__author-info", Te = "testimonial-card__person-name", Be = "testimonial-card__company-name", s = {
  testimonialCard: ie,
  testimonialCardFeatured: se,
  testimonialCardImageContainer: oe,
  desktop: le,
  testimonialCardContentOverlay: re,
  testimonialCardContent: de,
  mobile: me,
  testimonialCardTitle: ue,
  testimonialCardTitleFeatured: ce,
  testimonialCardNumbering: fe,
  testimonialCardFeaturedBody: pe,
  testimonialCardBody: ye,
  testimonialCardCta: Ce,
  testimonialCardCtaButton: ge,
  testimonialCardTestimonialSection: ve,
  testimonialCardQuoteContainer: he,
  testimonialCardQuoteMark: Ee,
  testimonialCardTestimonialContent: _e,
  testimonialCardTestimonialText: be,
  testimonialCardAuthorInfo: Ne,
  testimonialCardPersonName: Te,
  testimonialCardCompanyName: Be
}, V = ({
  title: e,
  testimonialText: r,
  personName: a,
  companyName: o,
  image: d,
  variant: i = "quote",
  body: c,
  cta: l,
  index: C,
  total: _
}) => {
  const g = i === "featured", E = g && C && _ ? `${C}/${_}` : void 0, T = () => {
    A("testimonials_cta_click", {
      variant: i,
      card_title: e,
      card_index: C,
      card_total: _,
      cta_href: l?.href
    });
  };
  return /* @__PURE__ */ react.createElement(
    "div",
    {
      className: (0,app_a75c1d35.c)(
        s.testimonialCard,
        g && s.testimonialCardFeatured
      ),
      "data-testid": "testimonial-card",
      "data-variant": i
    },
    /* @__PURE__ */ react.createElement("div", { className: s.testimonialCardImageContainer }, d && /* @__PURE__ */ react.createElement(
      Image_d6406817.I,
      {
        ...d,
        styling: Image_d6406817.a.CARD
      }
    )),
    /* @__PURE__ */ react.createElement("div", { className: s.testimonialCardContentOverlay }, /* @__PURE__ */ react.createElement("div", { className: s.testimonialCardContent }, E && /* @__PURE__ */ react.createElement(
      "p",
      {
        className: s.testimonialCardNumbering,
        "data-testid": "testimonial-card-numbering"
      },
      E
    ), /* @__PURE__ */ react.createElement(
      "h3",
      {
        className: (0,app_a75c1d35.c)(
          s.testimonialCardTitle,
          g && s.testimonialCardTitleFeatured
        )
      },
      e
    ), g ? /* @__PURE__ */ react.createElement("div", { className: s.testimonialCardFeaturedBody }, typeof c == "string" && c && /* @__PURE__ */ react.createElement(
      "div",
      {
        className: (0,app_a75c1d35.c)(
          app_a75c1d35.t.richText,
          app_a75c1d35.t.textsBodyText,
          s.testimonialCardBody
        ),
        "data-testid": "testimonial-card-body",
        dangerouslySetInnerHTML: { __html: c }
      }
    ), c && typeof c != "string" && /* @__PURE__ */ react.createElement(
      "div",
      {
        className: (0,app_a75c1d35.c)(
          app_a75c1d35.t.richText,
          app_a75c1d35.t.textsBodyText,
          s.testimonialCardBody
        ),
        "data-testid": "testimonial-card-body"
      },
      c
    ), l?.href && l.text && /* @__PURE__ */ react.createElement(
      Link_479ac100.L,
      {
        className: (0,app_a75c1d35.c)(
          Button_c598cb52.B.PrimaryFocusStyleInLink,
          s.testimonialCardCta
        ),
        href: l.href,
        target: l.isExternalLink ? "_blank" : void 0,
        disableLinkTextStyle: !0,
        onClick: T,
        "data-analytics-click": "testimonials-cta",
        "data-analytics-label": e
      },
      /* @__PURE__ */ react.createElement(
        Button_c598cb52.B.Primary,
        {
          text: l.text,
          asDiv: !0,
          className: s.testimonialCardCtaButton
        }
      )
    )) : /* @__PURE__ */ react.createElement("div", { className: s.testimonialCardTestimonialSection }, /* @__PURE__ */ react.createElement("div", { className: s.testimonialCardQuoteContainer }, /* @__PURE__ */ react.createElement("span", { className: s.testimonialCardQuoteMark }, "“"), /* @__PURE__ */ react.createElement("div", { className: s.testimonialCardTestimonialContent }, r && /* @__PURE__ */ react.createElement(
      "p",
      {
        className: (0,app_a75c1d35.c)(
          app_a75c1d35.t.textsBodyText,
          s.testimonialCardTestimonialText
        )
      },
      r
    ), (a || o) && /* @__PURE__ */ react.createElement("div", { className: s.testimonialCardAuthorInfo }, a && /* @__PURE__ */ react.createElement("span", { className: s.testimonialCardPersonName }, a), o && /* @__PURE__ */ react.createElement(
      "span",
      {
        className: (0,app_a75c1d35.c)(
          app_a75c1d35.t.textsBodyText,
          s.testimonialCardCompanyName
        )
      },
      o
    )))))))
  );
}, xe = "testimonials", Se = "testimonials--light-blue", Le = "testimonials--white", Oe = "testimonials--gray", ke = "testimonials--featured", Me = "testimonials__header", Pe = "desktop", Fe = "testimonials__title", Ie = "mobile", Ae = "testimonials__navigation", $e = "testimonials__carousel", De = "testimonials__carousel--featured", Re = "testimonials__mobile-list", Ge = "testimonials__mobile-card", We = "testimonials__load-more-container", f = {
  testimonials: xe,
  testimonialsLightBlue: Se,
  testimonialsWhite: Le,
  testimonialsGray: Oe,
  testimonialsFeatured: ke,
  testimonialsHeader: Me,
  desktop: Pe,
  testimonialsTitle: Fe,
  mobile: Ie,
  testimonialsNavigation: Ae,
  testimonialsCarousel: $e,
  testimonialsCarouselFeatured: De,
  testimonialsMobileList: Re,
  testimonialsMobileCard: Ge,
  testimonialsLoadMoreContainer: We
}, ze = 1216;
function Ve(e) {
  return window.addEventListener("resize", e), () => window.removeEventListener("resize", e);
}
function Qe() {
  return window.innerWidth;
}
function at({
  id: e,
  title: r,
  testimonials: a,
  loadMoreText: o,
  backgroundColor: d = "lightBlue",
  variant: i = "quote",
  autoplay: c = !1
}) {
  const l = (0,react.useRef)(null), [C, _] = (0,react.useState)(!1), [g, E] = (0,react.useState)(!0), [T, S] = (0,react.useState)(!1), [k, m] = (0,react.useState)(2), u = (0,react.useSyncExternalStore)(
    Ve,
    Qe,
    () => 0
  ), p = (0,react.useMemo)(() => u > app_a75c1d35.D.xl, [u]), B = (0,react.useMemo)(() => u < app_a75c1d35.D.md, [u]), v = i === "featured", P = v || !B;
  (0,react.useEffect)(() => {
    const n = l.current;
    if (!n)
      return;
    const y = () => {
      if (v)
        n.params.slidesOffsetBefore = 0, n.params.slidesOffsetAfter = 0;
      else if (p) {
        const W = (u - ze) / 2;
        n.params.slidesOffsetBefore = W, n.params.slidesOffsetAfter = W;
      }
      n.update();
      const G = !!c && (a?.length || 0) > 1;
      E(!G && n.isBeginning), S(
        !G && (!n.allowSlideNext || n.isEnd)
      );
    };
    if (y(), !n.el || typeof ResizeObserver > "u")
      return;
    const R = new ResizeObserver(y);
    return R.observe(n.el), () => R.disconnect();
  }, [
    C,
    u,
    p,
    c,
    v,
    a?.length
  ]), (0,react.useEffect)(() => {
    m(B ? 2 : a?.length || 0);
  }, [B, a?.length]);
  const Q = (0,react.useCallback)((n) => {
    if (n.params.loop) {
      E(!1), S(!1);
      return;
    }
    E(n.isBeginning), S(n.isEnd);
  }, []), $ = (n) => {
    const y = l.current;
    y && (n === "previous" ? y?.slidePrev() : y?.slideNext(), A("testimonials_navigate", {
      variant: i,
      direction: n,
      title: r
    }));
  }, q = () => {
    m(
      (n) => Math.min(n + 2, a?.length || 0)
    );
  }, b = a || [], H = B ? b.slice(0, k) : b, j = !P && B && k < b.length, X = !!(a && (v ? a.length > 1 : !B && a.length > 2)), D = c && P && b.length > 1;
  return (0,react.useEffect)(() => {
    A("testimonials_impression", {
      variant: i,
      title: r,
      item_count: b.length
    });
  }, [r, i, b.length]), !a || a.length === 0 ? null : /* @__PURE__ */ react.createElement(
    Block_9b78bd10.B,
    {
      id: e,
      "data-testid": "testimonials-block",
      "data-variant": i,
      topPadding: Block_9b78bd10.B.Padding.SMALL,
      bottomPadding: Block_9b78bd10.B.Padding.LARGE,
      className: (0,app_a75c1d35.c)(
        f.testimonials,
        d === "lightBlue" && f.testimonialsLightBlue,
        d === "white" && f.testimonialsWhite,
        d === "gray" && f.testimonialsGray,
        v && f.testimonialsFeatured
      )
    },
    /* @__PURE__ */ react.createElement(Block_9b78bd10.B.Content, { "data-testid": "testimonials-content" }, /* @__PURE__ */ react.createElement("div", { className: f.testimonialsHeader }, /* @__PURE__ */ react.createElement("h2", { className: (0,app_a75c1d35.c)(f.testimonialsTitle) }, r), X && /* @__PURE__ */ react.createElement("div", { className: f.testimonialsNavigation }, /* @__PURE__ */ react.createElement(
      Button_c598cb52.B.Arrow,
      {
        arrowDirection: "left",
        "aria-label": "Previous slide",
        "data-testid": "testimonials-prev",
        disabled: g,
        onClick: () => $("previous")
      }
    ), /* @__PURE__ */ react.createElement(
      Button_c598cb52.B.Arrow,
      {
        arrowDirection: "right",
        "aria-label": "Next slide",
        "data-testid": "testimonials-next",
        disabled: T,
        onClick: () => $("next")
      }
    )))),
    /* @__PURE__ */ react.createElement(Block_9b78bd10.B.Content, { limitedWidth: v }, /* @__PURE__ */ react.createElement(
      "div",
      {
        className: (0,app_a75c1d35.c)(
          f.testimonialsCarousel,
          v && f.testimonialsCarouselFeatured
        ),
        "data-testid": "testimonials-container"
      },
      /* @__PURE__ */ react.createElement(
        swiper_min_13551361.S,
        {
          modules: D ? [ne] : [],
          slidesPerView: v ? 1 : "auto",
          spaceBetween: 20,
          slidesPerGroup: 1,
          centeredSlides: !1,
          speed: 500,
          loop: !1,
          autoplay: D ? {
            delay: 6e3,
            disableOnInteraction: !0,
            pauseOnMouseEnter: !0
          } : !1,
          watchOverflow: !0,
          preventClicks: !1,
          preventClicksPropagation: !1,
          touchStartPreventDefault: !1,
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0,
          onSlideChange: Q,
          onSwiper: (n) => {
            l.current = n, _(!0);
          },
          enabled: v,
          breakpoints: v ? {
            [app_a75c1d35.D.sm]: {
              slidesPerView: 2,
              slidesPerGroup: 2,
              spaceBetween: 20
            },
            [app_a75c1d35.D.lg]: {
              slidesPerView: 2,
              slidesPerGroup: 2,
              spaceBetween: 32
            }
          } : {
            [app_a75c1d35.D.md]: {
              enabled: !0,
              slidesPerView: "auto",
              slidesPerGroup: 2,
              spaceBetween: 20,
              slidesOffsetBefore: 64,
              slidesOffsetAfter: 64
            },
            [app_a75c1d35.D.lg]: {
              enabled: !0,
              slidesPerView: "auto",
              slidesPerGroup: 2,
              spaceBetween: 32,
              slidesOffsetBefore: 80,
              slidesOffsetAfter: 80
            },
            [app_a75c1d35.D.xl]: {
              enabled: !0,
              slidesPerView: "auto",
              slidesPerGroup: 2,
              spaceBetween: 32,
              slidesOffsetBefore: 80,
              slidesOffsetAfter: 80
            }
          }
        },
        P ? /* @__PURE__ */ react.createElement(react.Fragment, null, a.map((n, y) => /* @__PURE__ */ react.createElement(swiper_min_13551361.a, { key: y, "data-testid": "testimonial-slide" }, /* @__PURE__ */ react.createElement(
          V,
          {
            ...n,
            variant: i,
            index: y + 1,
            total: a.length
          }
        )))) : /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("div", { className: f.testimonialsMobileList }, H.map((n, y) => /* @__PURE__ */ react.createElement("div", { key: y, className: f.testimonialsMobileCard }, /* @__PURE__ */ react.createElement(
          V,
          {
            ...n,
            variant: i,
            index: y + 1,
            total: b.length
          }
        )))), j && /* @__PURE__ */ react.createElement("div", { className: f.testimonialsLoadMoreContainer }, /* @__PURE__ */ react.createElement(
          Button_c598cb52.B.Primary,
          {
            text: o || "Load more",
            onClick: q,
            "data-testid": "testimonials-load-more"
          }
        )))
      )
    ))
  );
}
function nt(e) {
  const r = [...e];
  for (let a = r.length - 1; a > 0; a -= 1) {
    const o = Math.floor(Math.random() * (a + 1)), d = r[a];
    r[a] = r[o], r[o] = d;
  }
  return r;
}

//# sourceMappingURL=Testimonials.js.map

// EXTERNAL MODULE: ../node_modules/next-i18next/dist/esm/index.js + 36 modules
var esm = __webpack_require__(9800);
// EXTERNAL MODULE: ../node_modules/next/router.js
var router = __webpack_require__(6677);
// EXTERNAL MODULE: ./src/components/HtmlParser/HtmlParser.tsx + 2 modules
var HtmlParser = __webpack_require__(8940);
// EXTERNAL MODULE: ./src/constants/app.ts
var app = __webpack_require__(5884);
// EXTERNAL MODULE: ./src/contexts/EmployerSiteContext.tsx
var EmployerSiteContext = __webpack_require__(981);
// EXTERNAL MODULE: ./src/hooks/useImageDataHandler.ts
var useImageDataHandler = __webpack_require__(4847);
// EXTERNAL MODULE: ./src/util/cms-background-color.ts
var cms_background_color = __webpack_require__(4770);
// EXTERNAL MODULE: ./src/util/magnolia.ts + 1 modules
var magnolia = __webpack_require__(7581);
;// CONCATENATED MODULE: ./src/magnolia/components/Testimonials/Testimonials.tsx











function resolveTestimonialsVariant(variant) {
    var value = typeof variant === "string" ? variant : variant === null || variant === void 0 ? void 0 : variant.field;
    return value === "featured" ? "featured" : "quote";
}
function isCmsFlagEnabled(value) {
    var defaultValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (value === undefined) return defaultValue;
    return value === true || value === "true";
}
function mapTestimonialImage(item, imageDataHandler) {
    var ref, ref1;
    var imageData = item.image ? imageDataHandler(item.image, {
        maxViewport: app/* Viewport.lg */.l_.lg
    }) : null;
    var ref2;
    var credits = typeof item.image === "string" ? "" : (ref2 = (ref = item.image) === null || ref === void 0 ? void 0 : (ref1 = ref.metadata) === null || ref1 === void 0 ? void 0 : ref1.rights) !== null && ref2 !== void 0 ? ref2 : "";
    if (!imageData) {
        return null;
    }
    return {
        src: imageData.src,
        width: imageData.width,
        height: imageData.height,
        altText: item.imageAltText || "",
        imageLoader: imageData.imageLoader,
        credits: credits
    };
}
function mapTestimonialCards(testimonials, variant, imageDataHandler, isPreview) {
    if (!testimonials) {
        return [];
    }
    return (0,magnolia/* jcrMultiFieldToArray */.FE)(testimonials).map(function(item) {
        var image = mapTestimonialImage(item, imageDataHandler);
        if (variant === "featured") {
            var resolvedLink = (0,magnolia/* resolveLinkSwitchableField */.cJ)(item.ctaLink, isPreview);
            var fallbackBullets = item.bullets ? (0,magnolia/* jcrMultiFieldToArray */.FE)(item.bullets).map(function(bullet) {
                return bullet.text;
            }).filter(function(text) {
                return Boolean(text);
            }) : [];
            var bodyHtml = item.body || (fallbackBullets.length ? "<ul>".concat(fallbackBullets.map(function(text) {
                return "<li>".concat(text, "</li>");
            }).join(""), "</ul>") : undefined);
            var cta = item.ctaText && resolvedLink.linkHref ? {
                text: item.ctaText,
                href: resolvedLink.linkHref,
                isExternalLink: resolvedLink.isExternalLink
            } : undefined;
            return {
                title: item.title,
                image: image,
                body: bodyHtml ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlParser/* HtmlParser */._, {
                    html: bodyHtml
                }) : undefined,
                cta: cta
            };
        }
        return {
            title: item.title,
            testimonialText: item.testimonialText,
            personName: item.personName,
            companyName: item.companyName,
            image: image
        };
    });
}
function Testimonials(param) {
    var title = param.title, anchorTag = param.anchorTag, backgroundColor = param.backgroundColor, variant = param.variant, shuffle = param.shuffle, autoplay = param.autoplay, testimonials = param.testimonials;
    var imageDataHandler = (0,useImageDataHandler/* default */.Z)();
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var isEmployerSite = (0,EmployerSiteContext/* default */.Z)().isEmployerSite;
    var isPreview = (0,router.useRouter)().isPreview;
    var resolvedVariant = resolveTestimonialsVariant(variant);
    var shouldShuffle = isCmsFlagEnabled(shuffle, resolvedVariant === "featured");
    var orderedCards = (0,react.useMemo)(function() {
        var cards = mapTestimonialCards(testimonials, resolvedVariant, imageDataHandler, isPreview);
        return shouldShuffle ? nt(cards) : cards;
    }, [
        testimonials,
        resolvedVariant,
        imageDataHandler,
        isPreview,
        shouldShuffle, 
    ]);
    if (!orderedCards.length) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(at, {
        id: anchorTag,
        title: title,
        testimonials: orderedCards,
        loadMoreText: t("pagination.loadMore"),
        backgroundColor: (0,cms_background_color/* resolveCmsBackgroundColor */.A)(backgroundColor, isEmployerSite, "lightBlue"),
        variant: resolvedVariant,
        autoplay: isCmsFlagEnabled(autoplay)
    });
}

;// CONCATENATED MODULE: ./src/magnolia.config.ts
/* istanbul ignore file */ 


// Templates
var Page = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1682).then(__webpack_require__.bind(__webpack_require__, 1682));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1682)
            ];
        }
    }
});
var EventsPage = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8822).then(__webpack_require__.bind(__webpack_require__, 8822));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8822)
            ];
        }
    }
});
var OpenJobsPage = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(808), __webpack_require__.e(6105), __webpack_require__.e(2146), __webpack_require__.e(9821)]).then(__webpack_require__.bind(__webpack_require__, 9821));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9821)
            ];
        }
    }
});
var JobsPage = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(808), __webpack_require__.e(6105), __webpack_require__.e(2146), __webpack_require__.e(7215)]).then(__webpack_require__.bind(__webpack_require__, 7215));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7215)
            ];
        }
    }
});
var EventsCalendarPage = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6667).then(__webpack_require__.bind(__webpack_require__, 6667));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6667)
            ];
        }
    }
});
var ArticlesFiltersPage = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(808), __webpack_require__.e(7553), __webpack_require__.e(2872)]).then(__webpack_require__.bind(__webpack_require__, 2872));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2872)
            ];
        }
    }
});
var ServicesFiltersPage = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(808), __webpack_require__.e(7553), __webpack_require__.e(9573)]).then(__webpack_require__.bind(__webpack_require__, 9573));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9573)
            ];
        }
    }
});
var ServicePage = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4871).then(__webpack_require__.bind(__webpack_require__, 4871));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4871)
            ];
        }
    }
});
// Components
var ArticleChart = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6875).then(__webpack_require__.bind(__webpack_require__, 6875));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6875)
            ];
        }
    }
});
var ArticleFooterSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 318).then(__webpack_require__.bind(__webpack_require__, 318));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(318)
            ];
        }
    }
});
var ArticleImageGallery = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8622).then(__webpack_require__.bind(__webpack_require__, 8622));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8622)
            ];
        }
    }
});
var ArticlePageHero = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3883).then(__webpack_require__.bind(__webpack_require__, 3883));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3883)
            ];
        }
    }
});
var ArticleQuote = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7666).then(__webpack_require__.bind(__webpack_require__, 7666));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7666)
            ];
        }
    }
});
var ArticleSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6191).then(__webpack_require__.bind(__webpack_require__, 6191));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6191)
            ];
        }
    }
});
var CompanyList = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(808), __webpack_require__.e(7512)]).then(__webpack_require__.bind(__webpack_require__, 9615));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9615)
            ];
        }
    }
});
var CompanyForm = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(808), __webpack_require__.e(8386)]).then(__webpack_require__.bind(__webpack_require__, 5130));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5130)
            ];
        }
    }
});
var ContactCard = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3260).then(__webpack_require__.bind(__webpack_require__, 3260));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3260)
            ];
        }
    }
});
var CTABanner = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 93).then(__webpack_require__.bind(__webpack_require__, 1460));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1460)
            ];
        }
    }
});
var Hero = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4349).then(__webpack_require__.bind(__webpack_require__, 4349));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4349)
            ];
        }
    }
});
var LinkPreview = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1176).then(__webpack_require__.bind(__webpack_require__, 6333));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6333)
            ];
        }
    }
});
var LogoGallery = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8190).then(__webpack_require__.bind(__webpack_require__, 8190));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8190)
            ];
        }
    }
});
var MapBox = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3707).then(__webpack_require__.bind(__webpack_require__, 3707));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3707)
            ];
        }
    }
});
var Masonry = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3467).then(__webpack_require__.bind(__webpack_require__, 3467));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3467)
            ];
        }
    }
});
var MigriWidget = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9642).then(__webpack_require__.bind(__webpack_require__, 9642));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9642)
            ];
        }
    }
});
var OpenJobsHighlight = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(808), __webpack_require__.e(6105), __webpack_require__.e(7404)]).then(__webpack_require__.bind(__webpack_require__, 7404));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7404)
            ];
        }
    }
});
var PageHeader = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6758).then(__webpack_require__.bind(__webpack_require__, 6758));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6758)
            ];
        }
    }
});
var PromotionBanner = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9781).then(__webpack_require__.bind(__webpack_require__, 9781));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9781)
            ];
        }
    }
});
var Quotes = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 859).then(__webpack_require__.bind(__webpack_require__, 859));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(859)
            ];
        }
    }
});
var Recommendations = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3987).then(__webpack_require__.bind(__webpack_require__, 3987));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3987)
            ];
        }
    }
});
var SectionHeader = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2885).then(__webpack_require__.bind(__webpack_require__, 2885));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2885)
            ];
        }
    }
});
var Tabs = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9569).then(__webpack_require__.bind(__webpack_require__, 9569));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9569)
            ];
        }
    }
});
var Video = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7650), __webpack_require__.e(9907)]).then(__webpack_require__.bind(__webpack_require__, 9907));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9907)
            ];
        }
    }
});
var Quiz = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8866).then(__webpack_require__.bind(__webpack_require__, 8866));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8866)
            ];
        }
    }
});
var Form = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8039), __webpack_require__.e(4378)]).then(__webpack_require__.bind(__webpack_require__, 4378));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4378)
            ];
        }
    }
});
var FormGroupFields = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9176).then(__webpack_require__.bind(__webpack_require__, 9176));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9176)
            ];
        }
    }
});
var FormEdit = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8039), __webpack_require__.e(8668)]).then(__webpack_require__.bind(__webpack_require__, 8668));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8668)
            ];
        }
    }
});
var FormSelection = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8039), __webpack_require__.e(9930)]).then(__webpack_require__.bind(__webpack_require__, 9930));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9930)
            ];
        }
    }
});
var FormHoneypot = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2627).then(__webpack_require__.bind(__webpack_require__, 2190));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2190)
            ];
        }
    }
});
var FormFile = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8039), __webpack_require__.e(5514)]).then(__webpack_require__.bind(__webpack_require__, 5514));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5514)
            ];
        }
    }
});
var FormSubmit = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8039), __webpack_require__.e(439)]).then(__webpack_require__.bind(__webpack_require__, 439));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(439)
            ];
        }
    }
});
var HtmlCode = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 731).then(__webpack_require__.bind(__webpack_require__, 731));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(731)
            ];
        }
    }
});
var FaqAccordion = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 961).then(__webpack_require__.bind(__webpack_require__, 961));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(961)
            ];
        }
    }
});
var ItemList = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5761).then(__webpack_require__.bind(__webpack_require__, 5761));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5761)
            ];
        }
    }
});
var JobsModule = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(808), __webpack_require__.e(6105), __webpack_require__.e(2146), __webpack_require__.e(9258)]).then(__webpack_require__.bind(__webpack_require__, 9258));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9258)
            ];
        }
    }
});
var MagnoliaTemplate;
(function(MagnoliaTemplate) {
    MagnoliaTemplate[// Pages
    "Page"] = "wif-lm:pages/page";
    MagnoliaTemplate["PageArticle"] = "wif-lm:pages/article";
    MagnoliaTemplate["PageArticleFilter"] = "wif-lm:pages/articleFilter";
    MagnoliaTemplate["PageService"] = "wif-lm:pages/service";
    MagnoliaTemplate["PageServicesFilter"] = "wif-lm:pages/servicesFilter";
    MagnoliaTemplate["PageDeleted"] = "pages-app:deleted";
    MagnoliaTemplate["PageEmployer"] = "wif-lm:pages/employer";
    MagnoliaTemplate["PageEvent"] = "wif-lm:pages/event";
    MagnoliaTemplate["PageEventCalendar"] = "wif-lm:pages/eventCalendar";
    MagnoliaTemplate["PageOpenJobs"] = "wif-lm:pages/openJobsPage";
    MagnoliaTemplate["PageJobs"] = "wif-lm:pages/jobsPage";
    MagnoliaTemplate["PageRedirect"] = "wif-lm:pages/redirect";
    MagnoliaTemplate["PagePlainText"] = "bf-common:pages/plain-text";
    MagnoliaTemplate[// Components
    "ArticleChart"] = "wif-lm:components/articleChart";
    MagnoliaTemplate["ArticleFooterSection"] = "wif-lm:components/footerSection";
    MagnoliaTemplate["ArticleImageGallery"] = "wif-lm:components/articleImageGallery";
    MagnoliaTemplate["ArticlePageHero"] = "wif-lm:components/articlePageHero";
    MagnoliaTemplate["ArticleQuote"] = "wif-lm:components/articleQuote";
    MagnoliaTemplate["ArticleSection"] = "wif-lm:components/articleSection";
    MagnoliaTemplate["CompanyList"] = "wif-lm:components/companyList";
    MagnoliaTemplate["CompanyForm"] = "wif-lm:components/companyForm";
    MagnoliaTemplate["ContactCard"] = "wif-lm:components/contactCard";
    MagnoliaTemplate["CTABanner"] = "wif-lm:components/ctaBanner";
    MagnoliaTemplate["Hero"] = "wif-lm:components/hero";
    MagnoliaTemplate["LinkPreview"] = "wif-lm:components/linkPreview";
    MagnoliaTemplate["LogoGallery"] = "wif-lm:components/logoGallery";
    MagnoliaTemplate["Map"] = "wif-lm:components/mapBox";
    MagnoliaTemplate["Masonry"] = "wif-lm:components/masonry";
    MagnoliaTemplate["MigriWidget"] = "wif-lm:components/migriWidget";
    MagnoliaTemplate["OpenJobsHighlight"] = "wif-lm:components/openJobsHighlight";
    MagnoliaTemplate["PageHeader"] = "wif-lm:components/pageHeader";
    MagnoliaTemplate["PromotionBanner"] = "wif-lm:components/promotionBanner";
    MagnoliaTemplate["Quotes"] = "wif-lm:components/quotes";
    MagnoliaTemplate["Recommendations"] = "wif-lm:components/recommendations";
    MagnoliaTemplate["SectionHeader"] = "wif-lm:components/sectionHeader";
    MagnoliaTemplate["Tabs"] = "wif-lm:components/tabs";
    MagnoliaTemplate["Video"] = "wif-lm:components/articleVideo";
    MagnoliaTemplate["Quiz"] = "wif-lm:components/quiz";
    MagnoliaTemplate["Form"] = "form:components/form";
    MagnoliaTemplate["FormGroupFields"] = "form:components/formGroupFields";
    MagnoliaTemplate["FormEdit"] = "form:components/formEdit";
    MagnoliaTemplate["FormNumber"] = "form:components/formNumber";
    MagnoliaTemplate["FormSubmit"] = "form:components/formSubmit";
    MagnoliaTemplate["FormSelection"] = "form:components/formSelection";
    MagnoliaTemplate["FormHoneypot"] = "form:components/formHoneypot";
    MagnoliaTemplate["FormFile"] = "form:components/formFile";
    MagnoliaTemplate["HtmlCode"] = "wif-lm:components/htmlCode";
    MagnoliaTemplate["Testimonials"] = "wif-lm:components/testimonials";
    MagnoliaTemplate["FaqAccordion"] = "wif-lm:components/faqAccordion";
    MagnoliaTemplate["ItemList"] = "wif-lm:components/itemList";
    MagnoliaTemplate["JobsModule"] = "wif-lm:components/jobsModule";
})(MagnoliaTemplate || (MagnoliaTemplate = {}));
var _obj;
var magnoliaEditablePageConfig = {
    componentMappings: (_obj = {}, // Pages
    (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.Page, Page), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.PageArticle, Page), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.PageArticleFilter, ArticlesFiltersPage), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.PageService, ServicePage), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.PageServicesFilter, ServicesFiltersPage), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.PageEmployer, Page), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.PageEvent, EventsPage), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.PageEventCalendar, EventsCalendarPage), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.PageOpenJobs, OpenJobsPage), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.PageJobs, JobsPage), // Components
    (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.ArticleChart, ArticleChart), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.ArticleFooterSection, ArticleFooterSection), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.ArticleImageGallery, ArticleImageGallery), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.ArticlePageHero, ArticlePageHero), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.ArticleQuote, ArticleQuote), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.ArticleSection, ArticleSection), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.CompanyList, CompanyList), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.CompanyForm, CompanyForm), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.ContactCard, ContactCard), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.CTABanner, CTABanner), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.LinkPreview, LinkPreview), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.LogoGallery, LogoGallery), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.Hero, Hero), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.Map, MapBox), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.Masonry, Masonry), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.MigriWidget, MigriWidget), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.OpenJobsHighlight, OpenJobsHighlight), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.PageHeader, PageHeader), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.PromotionBanner, PromotionBanner), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.Quotes, Quotes), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.Recommendations, Recommendations), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.SectionHeader, SectionHeader), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.Tabs, Tabs), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.Video, Video), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.Quiz, Quiz), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.Form, Form), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.FormGroupFields, FormGroupFields), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.FormEdit, FormEdit), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.FormNumber, FormEdit), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.FormSelection, FormSelection), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.FormHoneypot, FormHoneypot), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.FormFile, FormFile), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.FormSubmit, FormSubmit), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.HtmlCode, HtmlCode), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.Testimonials, Testimonials), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.FaqAccordion, FaqAccordion), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.ItemList, ItemList), (0,_define_property/* default */.Z)(_obj, MagnoliaTemplate.JobsModule, JobsModule), _obj)
};
/**
 * The helper function finds and returns the Component associated
 * with the provided MGNL template from the componentMappings.
 * If component is not found, `undefined` is returned.
 */ function getComponentForMagnoliaTemplate(template) {
    if (!template) {
        return undefined;
    }
    var validTemplate = Object.keys(magnoliaEditablePageConfig.componentMappings).find(function(t) {
        return t === template;
    });
    if (!validTemplate) {
        return undefined;
    }
    return magnoliaEditablePageConfig.componentMappings[validTemplate];
}


/***/ }),

/***/ 2059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/next-i18next/dist/esm/index.js + 36 modules
var esm = __webpack_require__(9800);
// EXTERNAL MODULE: ../wif-ui-lib/dist/style.css
var style = __webpack_require__(1584);
// EXTERNAL MODULE: ./src/styles/theme.css
var theme = __webpack_require__(477);
// EXTERNAL MODULE: ./src/constants/magnolia.ts + 1 modules
var magnolia = __webpack_require__(5056);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
// EXTERNAL MODULE: ../node_modules/next/head.js
var head = __webpack_require__(8038);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(6677);
// EXTERNAL MODULE: ../node_modules/next/link.js
var next_link = __webpack_require__(9894);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../node_modules/next/future/image.js
var future_image = __webpack_require__(1723);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
;// CONCATENATED MODULE: ../node_modules/next-themes/dist/index.mjs
"use client";var M=(e,i,s,u,m,a,l,h)=>{let d=document.documentElement,w=["light","dark"];function p(n){(Array.isArray(e)?e:[e]).forEach(y=>{let k=y==="class",S=k&&a?m.map(f=>a[f]||f):m;k?(d.classList.remove(...S),d.classList.add(a&&a[n]?a[n]:n)):d.setAttribute(y,n)}),R(n)}function R(n){h&&w.includes(n)&&(d.style.colorScheme=n)}function c(){return window.matchMedia("(prefers-color-scheme: dark)").matches?"dark":"light"}if(u)p(u);else try{let n=localStorage.getItem(i)||s,y=l&&n==="system"?c():n;p(y)}catch(n){}};var b=["light","dark"],I="(prefers-color-scheme: dark)",O=typeof window=="undefined",x=react.createContext(void 0),U={setTheme:e=>{},themes:[]},z=()=>{var e;return(e=t.useContext(x))!=null?e:U},J=e=>react.useContext(x)?react.createElement(react.Fragment,null,e.children):react.createElement(V,{...e}),N=["light","dark"],V=({forcedTheme:e,disableTransitionOnChange:i=!1,enableSystem:s=!0,enableColorScheme:u=!0,storageKey:m="theme",themes:a=N,defaultTheme:l=s?"system":"light",attribute:h="data-theme",value:d,children:w,nonce:p,scriptProps:R})=>{let[c,n]=react.useState(()=>H(m,l)),[T,y]=react.useState(()=>c==="system"?E():c),k=d?Object.values(d):a,S=react.useCallback(o=>{let r=o;if(!r)return;o==="system"&&s&&(r=E());let v=d?d[r]:r,C=i?W(p):null,P=document.documentElement,L=g=>{g==="class"?(P.classList.remove(...k),v&&P.classList.add(v)):g.startsWith("data-")&&(v?P.setAttribute(g,v):P.removeAttribute(g))};if(Array.isArray(h)?h.forEach(L):L(h),u){let g=b.includes(l)?l:null,D=b.includes(r)?r:g;P.style.colorScheme=D}C==null||C()},[p]),f=react.useCallback(o=>{let r=typeof o=="function"?o(c):o;n(r);try{localStorage.setItem(m,r)}catch(v){}},[c]),A=react.useCallback(o=>{let r=E(o);y(r),c==="system"&&s&&!e&&S("system")},[c,e]);react.useEffect(()=>{let o=window.matchMedia(I);return o.addListener(A),A(o),()=>o.removeListener(A)},[A]),react.useEffect(()=>{let o=r=>{r.key===m&&(r.newValue?n(r.newValue):f(l))};return window.addEventListener("storage",o),()=>window.removeEventListener("storage",o)},[f]),react.useEffect(()=>{S(e!=null?e:c)},[e,c]);let Q=react.useMemo(()=>({theme:c,setTheme:f,forcedTheme:e,resolvedTheme:c==="system"?T:c,themes:s?[...a,"system"]:a,systemTheme:s?T:void 0}),[c,f,e,T,s,a]);return react.createElement(x.Provider,{value:Q},react.createElement(_,{forcedTheme:e,storageKey:m,attribute:h,enableSystem:s,enableColorScheme:u,defaultTheme:l,value:d,themes:a,nonce:p,scriptProps:R}),w)},_=react.memo(({forcedTheme:e,storageKey:i,attribute:s,enableSystem:u,enableColorScheme:m,defaultTheme:a,value:l,themes:h,nonce:d,scriptProps:w})=>{let p=JSON.stringify([s,i,a,e,h,l,u,m]).slice(1,-1);return react.createElement("script",{...w,suppressHydrationWarning:!0,nonce:typeof window=="undefined"?d:"",dangerouslySetInnerHTML:{__html:`(${M.toString()})(${p})`}})}),H=(e,i)=>{if(O)return;let s;try{s=localStorage.getItem(e)||void 0}catch(u){}return s||i},W=e=>{let i=document.createElement("style");return e&&i.setAttribute("nonce",e),i.appendChild(document.createTextNode("*,*::before,*::after{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}")),document.head.appendChild(i),()=>{window.getComputedStyle(document.body),setTimeout(()=>{document.head.removeChild(i)},1)}},E=e=>(e||(e=window.matchMedia(I)),e.matches?"dark":"light");

// EXTERNAL MODULE: ../wif-ui-lib/dist/useClickOutside-726e7c36.mjs
var useClickOutside_726e7c36 = __webpack_require__(8643);
// EXTERNAL MODULE: ../wif-ui-lib/dist/ImageContext-57256dc1.mjs
var ImageContext_57256dc1 = __webpack_require__(2355);
// EXTERNAL MODULE: ../wif-ui-lib/dist/LinkContext-0c83848a.mjs
var LinkContext_0c83848a = __webpack_require__(2659);
;// CONCATENATED MODULE: ../wif-ui-lib/dist/context.js







function s({
  children: r,
  LinkComponent: t,
  ImageComponent: o,
  isEmployerSite: m = !1
}) {
  return /* @__PURE__ */ react.createElement(useClickOutside_726e7c36.E.Provider, { value: m }, /* @__PURE__ */ react.createElement(LinkContext_0c83848a.L.Provider, { value: t }, /* @__PURE__ */ react.createElement(ImageContext_57256dc1.I.Provider, { value: o }, r)));
}

//# sourceMappingURL=context.js.map

// EXTERNAL MODULE: ./src/constants/app.ts
var app = __webpack_require__(5884);
// EXTERNAL MODULE: ./src/constants/locale.ts
var constants_locale = __webpack_require__(3726);
// EXTERNAL MODULE: ./src/contexts/EmployerSiteContext.tsx
var EmployerSiteContext = __webpack_require__(981);
;// CONCATENATED MODULE: ./src/contexts/PageContentContext.tsx

var PageContentContext = /*#__PURE__*/ (0,react.createContext)(null);
var PageContentContextProvider = PageContentContext.Provider;
function usePageContent() {
    var context = useContext(PageContentContext);
    if (!context) {
        throw new Error("The page content is not available on this route.");
    }
    return context;
}

// EXTERNAL MODULE: ./src/contexts/ViewportContext.tsx
var ViewportContext = __webpack_require__(9366);
// EXTERNAL MODULE: ./src/magnolia.config.ts + 2 modules
var magnolia_config = __webpack_require__(9647);
// EXTERNAL MODULE: ./src/util/magnolia.ts + 1 modules
var util_magnolia = __webpack_require__(7581);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3444);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Icon-3122c134.mjs
var Icon_3122c134 = __webpack_require__(3355);
// EXTERNAL MODULE: ../wif-ui-lib/dist/app-a75c1d35.mjs
var app_a75c1d35 = __webpack_require__(3406);
;// CONCATENATED MODULE: ../wif-ui-lib/dist/Logo-f02d52de.mjs


const i = [
  "a[href]",
  "button",
  "textarea",
  'input[type="text"]',
  'input[type="radio"]',
  'input[type="checkbox"]',
  'input[type="file"]',
  'input[type="search"]',
  "select"
];
function g(r) {
  const o = (0,react.useRef)(null);
  function n(e) {
    const t = o.current;
    if (!t)
      return;
    const H = t.querySelectorAll(
      i.join(", ")
    ), c = H[0], a = H[H.length - 1];
    if (e.key === "Tab") {
      if (e.shiftKey)
        return document.activeElement === c ? (e.preventDefault(), e.stopPropagation(), a.focus()) : void 0;
      if (document.activeElement === a)
        return e.preventDefault(), c.focus();
    }
  }
  return (0,react.useEffect)(() => {
    const e = o.current;
    if (!(!e || r))
      return e?.addEventListener("keydown", n), () => e?.removeEventListener("keydown", n);
  }, [r]), o;
}
function Logo_f02d52de_E(r, o, n = "Component") {
  const e = (t) => {
    throw new Error(
      `${n} can only have ${o} as children. ${t ? `Found '${t}'.` : ""}`
    );
  };
  react.Children.forEach(r, (t) => {
    t && typeof t == "object" ? "type" in t && t.type !== o && e(t.type) : e();
  });
}
const f = "logo", p = "logo--primary", y = "logo--secondary", Logo_f02d52de_s = {
  logo: f,
  logoPrimary: p,
  logoSecondary: y
};
function d({
  color: r = "primary",
  style: o
}) {
  const n = r === "primary" ? Logo_f02d52de_s.logoPrimary : Logo_f02d52de_s.logoSecondary;
  return /* @__PURE__ */ react.createElement("div", { className: (0,app_a75c1d35.c)(Logo_f02d52de_s.logo, n), style: o }, /* @__PURE__ */ react.createElement("svg", { viewBox: "0 0 83 38" }, /* @__PURE__ */ react.createElement("path", { d: "M0.979858 22.2666H10.3483V25.3168H4.46579V28.367H9.97791V31.4171H4.46579V37.5175H0.979858V22.2666ZM11.9883 34.6852H13.9927V25.0989H11.9883V22.2666H19.4612V25.0989H17.4568V34.6852H19.4612V37.5175H11.9883V34.6852ZM21.9745 22.2666H24.8068L29.5782 30.6328C29.6218 30.7054 29.6799 30.7417 29.7525 30.7417C29.8107 30.7417 29.8542 30.72 29.8832 30.6764C29.9268 30.6182 29.9414 30.5603 29.9268 30.5021L29.6 28.5848V22.2666H32.868V37.5175H30.0357L25.2862 29.1513C25.2572 29.0787 25.199 29.0424 25.1119 29.0424C25.0539 29.0424 25.0029 29.0713 24.9593 29.1295C24.9304 29.1731 24.9232 29.2238 24.9376 29.282L25.2426 31.1993V37.5175H21.9745V22.2666ZM35.8017 22.2666H39.2876V34.4673H43.5143V37.5175H35.8017V22.2666ZM52.498 33.988H48.707L47.9663 37.5175H44.5021L47.5087 25.0989H45.9183V22.2666H52.9991L56.7029 37.5175H53.2387L52.498 33.988ZM51.8879 31.1557L50.9511 26.6894L50.7986 25.3168C50.7986 25.2586 50.7768 25.215 50.7332 25.186C50.6896 25.1425 50.6461 25.1207 50.6025 25.1207C50.5007 25.1207 50.4354 25.186 50.4064 25.3168L50.2539 26.6894L49.3171 31.1557H51.8879ZM58.5624 22.2666H61.3947L66.1661 30.6328C66.2096 30.7054 66.2678 30.7417 66.3404 30.7417C66.3986 30.7417 66.4421 30.72 66.4711 30.6764C66.5147 30.6182 66.5293 30.5603 66.5147 30.5021L66.1879 28.5848V22.2666H69.4559V37.5175H66.6236L61.874 29.1513C61.8451 29.0787 61.7869 29.0424 61.6997 29.0424C61.6416 29.0424 61.5908 29.0713 61.5472 29.1295C61.5182 29.1731 61.5108 29.2238 61.5254 29.282L61.8305 31.1993V37.5175H58.5624V22.2666ZM72.3895 22.2666H76.8341C78.6932 22.2666 80.1311 22.7095 81.1479 23.5956C82.1791 24.4817 82.7602 25.7089 82.8909 27.2776C82.9635 28.1491 82.9998 29.0206 82.9998 29.8921C82.9998 30.7635 82.9635 31.635 82.8909 32.5065C82.7746 34.0752 82.2009 35.3024 81.1697 36.1885C80.1383 37.0746 78.6932 37.5175 76.8341 37.5175H72.3895V22.2666ZM76.8341 34.6852C77.72 34.6852 78.3954 34.4455 78.8603 33.9662C79.325 33.4869 79.6011 32.8479 79.6882 32.049C79.7462 31.4679 79.7754 30.7489 79.7754 29.8921C79.7754 29.0495 79.7462 28.3306 79.6882 27.7351C79.6154 26.9362 79.3396 26.2972 78.8603 25.8179C78.3954 25.3386 77.72 25.0989 76.8341 25.0989H75.8755V34.6852H76.8341Z" }), /* @__PURE__ */ react.createElement("path", { d: "M0 0.261445H1.59045L3.35521 11.1768L3.39878 12.2879C3.39878 12.4332 3.44961 12.5058 3.55129 12.5058C3.63844 12.5058 3.68927 12.4477 3.7038 12.3315L5.53391 4.61886H6.77577L8.60589 12.3315C8.62042 12.4477 8.67125 12.5058 8.7584 12.5058C8.86007 12.5058 8.9109 12.4332 8.9109 12.2879L8.95448 11.1768L10.741 0.261445H12.3097L9.91311 15.5124H8.10478L6.38361 8.78018C6.34003 8.60589 6.26742 8.51874 6.16574 8.51874C6.06406 8.51874 5.99144 8.60589 5.94787 8.78018L4.2049 15.5124H2.39658L0 0.261445ZM19.352 15.7738C17.7833 15.7738 16.556 15.3163 15.67 14.4012C15.1471 13.8784 14.7477 13.1376 14.4717 12.179C14.1957 11.2203 14.0577 9.78964 14.0577 7.88691C14.0577 5.98419 14.1957 4.55349 14.4717 3.59486C14.7477 2.63623 15.1471 1.89547 15.67 1.37258C16.556 0.457528 17.7833 0 19.352 0C20.9207 0 22.1481 0.457528 23.0339 1.37258C23.5568 1.89547 23.9564 2.63623 24.2322 3.59486C24.5083 4.55349 24.6462 5.98419 24.6462 7.88691C24.6462 9.78964 24.5083 11.2203 24.2322 12.179C23.9564 13.1376 23.5568 13.8784 23.0339 14.4012C22.1481 15.3163 20.9207 15.7738 19.352 15.7738ZM19.352 14.0744C20.4123 14.0744 21.2257 13.7912 21.7921 13.2247C22.3585 12.6583 22.671 11.8667 22.7289 10.85C22.8161 9.5863 22.8596 8.59863 22.8596 7.88691C22.8596 7.1752 22.8161 6.18752 22.7289 4.92387C22.671 3.90714 22.3585 3.11555 21.7921 2.54909C21.2257 1.98262 20.4123 1.69939 19.352 1.69939C18.2917 1.69939 17.4783 1.98262 16.9118 2.54909C16.3454 3.11555 16.0331 3.90714 15.975 4.92387C15.8879 6.18752 15.8443 7.1752 15.8443 7.88691C15.8443 8.59863 15.8879 9.5863 15.975 10.85C16.0331 11.8667 16.3454 12.6583 16.9118 13.2247C17.4783 13.7912 18.2917 14.0744 19.352 14.0744ZM27.8151 0.261445H32.7825C34.1915 0.261445 35.2881 0.63908 36.0724 1.39437C36.8567 2.14966 37.2489 3.21723 37.2489 4.59707C37.2489 5.59927 36.9946 6.44897 36.4863 7.14615C35.978 7.82881 35.2809 8.29361 34.3948 8.54053C34.2787 8.56957 34.2205 8.62767 34.2205 8.71482C34.2205 8.7584 34.2495 8.83829 34.3076 8.95448L34.9395 10.0003L36.9439 15.5124H35.0048L32.5429 8.73661H29.5581V15.5124H27.8151V0.261445ZM32.7825 7.14615C33.625 7.14615 34.2787 6.92828 34.7434 6.49254C35.2227 6.04227 35.4623 5.41045 35.4623 4.59707C35.4623 3.69654 35.2227 3.00661 34.7434 2.5273C34.2787 2.03345 33.625 1.78654 32.7825 1.78654H29.5581V7.14615H32.7825ZM39.9827 0.261445H41.7693V7.05901H43.4033L47.0853 0.261445H49.0461L44.8848 7.75619L49.0897 15.5124H47.1289L43.4033 8.69304H41.7693V15.5124H39.9827V0.261445ZM56.2762 13.8566H58.8906V1.91726H56.2762V0.261445H63.3134V1.91726H60.6989V13.8566H63.3134V15.5124H56.2762V13.8566ZM66.2514 0.261445H67.7329L74.1165 12.179C74.1601 12.2516 74.2037 12.2879 74.2472 12.2879C74.2908 12.2879 74.3272 12.2661 74.3562 12.2225C74.3997 12.179 74.4143 12.1281 74.3997 12.07L74.1601 10.6103V0.261445H75.903V15.5124H74.1601L68.0815 4.24848C68.0233 4.1468 67.958 4.09597 67.8854 4.09597C67.8564 4.09597 67.8272 4.11775 67.7983 4.16133C67.7693 4.2049 67.7619 4.25573 67.7765 4.31384L67.9943 5.73V15.5124H66.2514V0.261445Z" })));
}

//# sourceMappingURL=Logo-f02d52de.mjs.map

// EXTERNAL MODULE: ../wif-ui-lib/dist/CallToAction-d24a74ed.mjs
var CallToAction_d24a74ed = __webpack_require__(1416);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Block-9b78bd10.mjs
var Block_9b78bd10 = __webpack_require__(4877);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Link-479ac100.mjs
var Link_479ac100 = __webpack_require__(965);
;// CONCATENATED MODULE: ../wif-ui-lib/dist/Footer.js






const Footer_ = "footer", u = "footer__logo", T = "desktop", h = "footer__button-to-top", C = "footer__button-to-top__btn-text", L = "footer__content_list", Footer_x = "footer__content_list--item", Footer_g = "footer__content_list__link", Footer_E = "footer__icon-content", Footer_y = "footer__icon-content__header", B = "footer__icon-content__list", Footer_I = "footer__copyright", Footer_b = "footer__copyright--text", Footer_N = "mobile--text", o = {
  footer: Footer_,
  footerLogo: u,
  desktop: T,
  footerButtonToTop: h,
  footerButtonToTopBtnText: C,
  footerContentList: L,
  footerContentListItem: Footer_x,
  footerContentListLink: Footer_g,
  footerIconContent: Footer_E,
  footerIconContentHeader: Footer_y,
  footerIconContentList: B,
  footerCopyright: Footer_I,
  footerCopyrightText: Footer_b,
  mobileText: Footer_N
};
function m({
  logo: n,
  ctaExternalLink: r,
  children: e,
  backToTopLabel: a
}) {
  return /* @__PURE__ */ react.createElement(Block_9b78bd10.B, { as: "footer", className: o.footer, "data-testid": "footer-block" }, /* @__PURE__ */ react.createElement(Block_9b78bd10.B.Content, { "data-testid": "footer-block-content" }, /* @__PURE__ */ react.createElement(
    "div",
    {
      role: "presentation",
      className: o.footerLogo,
      "data-testid": "footer-logo"
    },
    n
  ), /* @__PURE__ */ react.createElement(
    F,
    {
      "data-testid": "footer-to-top-button",
      backToTopLabel: a
    }
  ), e, /* @__PURE__ */ react.createElement("div", { className: o.footerCopyright, "data-testid": "footer-copy-right" }, r, /* @__PURE__ */ react.createElement(
    "div",
    {
      className: (0,app_a75c1d35.c)(
        app_a75c1d35.t.textsBodyText,
        o.footerCopyrightText
      )
    },
    /* @__PURE__ */ react.createElement("span", { "data-testid": "copyright-text" }, "© WorkInFinland.com ", (/* @__PURE__ */ new Date()).getFullYear())
  ))));
}
m.LinkList = k;
m.IconList = v;
function k({
  links: n,
  boldText: r = !1
}) {
  return !n || n.length === 0 ? null : /* @__PURE__ */ react.createElement(
    "ul",
    {
      className: o.footerContentList,
      "data-testid": "footer-list-container",
      itemScope: !0,
      itemType: "https://schema.org/ItemList"
    },
    n.map((e, a) => {
      if (!e.href)
        return null;
      const p = e.href.includes("://");
      return e.href ? /* @__PURE__ */ react.createElement(
        "li",
        {
          className: o.footerContentListItem,
          key: e.id,
          "data-testid": `footer-link-${e.id}`,
          itemProp: "itemListElement",
          itemScope: !0,
          itemType: "https://schema.org/ListItem"
        },
        /* @__PURE__ */ react.createElement("meta", { itemProp: "position", content: String(a + 1) }),
        /* @__PURE__ */ react.createElement(
          Link_479ac100.L,
          {
            href: e.href,
            target: p ? "_blank" : void 0,
            locale: e.locale,
            className: (0,app_a75c1d35.c)(
              r ? app_a75c1d35.t.textsBodyTextBold : app_a75c1d35.t.textsBodyText,
              o.footerContentListLink
            ),
            itemProp: "item"
          },
          e.title
        )
      ) : null;
    })
  );
}
function v({
  iconLinks: n,
  followUsLabel: r = "Follow us"
}) {
  return !n || n.length === 0 ? null : /* @__PURE__ */ react.createElement("div", { className: o.footerIconContent }, /* @__PURE__ */ react.createElement("div", { className: o.footerIconContentHeader }, /* @__PURE__ */ react.createElement("span", { className: app_a75c1d35.t.textsBodyTextBold }, r)), /* @__PURE__ */ react.createElement(
    "div",
    {
      className: o.footerIconContentList,
      "data-testid": "footer-list-container"
    },
    n.map((e, a) => /* @__PURE__ */ react.createElement(
      Link_479ac100.L,
      {
        "data-testid": `footer-icon-${a}`,
        key: e.url,
        href: e.url,
        target: "_blank",
        rel: "noreferrer noopener",
        "aria-label": e.label
      },
      /* @__PURE__ */ react.createElement(Icon_3122c134.I, { ...e })
    ))
  ));
}
function F({
  backToTopLabel: n = "Back to Top"
}) {
  const r = () => window.scrollTo({ top: 0, behavior: "smooth" });
  return /* @__PURE__ */ react.createElement(
    "button",
    {
      className: (0,app_a75c1d35.c)(app_a75c1d35.t.textsBodyText, o.footerButtonToTop),
      onClick: r
    },
    /* @__PURE__ */ react.createElement("div", { className: o.footerButtonToTopBtnText }, /* @__PURE__ */ react.createElement("span", null, n)),
    /* @__PURE__ */ react.createElement(Icon_3122c134.I, { icon: Icon_3122c134.W.CHEVRON_UP, size: 16, color: "white" })
  );
}

//# sourceMappingURL=Footer.js.map

;// CONCATENATED MODULE: ./src/components/Footer/Footer.tsx










function Footer(param) {
    var primary = param.primary, secondary = param.secondary, switchLink = param.switch;
    var t = (0,esm/* useTranslation */.$G)().t;
    var isEmployerSite = (0,EmployerSiteContext/* default */.Z)().isEmployerSite;
    var ctaLink = useCtaLink();
    var ctaProps = (0,react.useMemo)(function() {
        return {
            text: t("footer.ctaExternalLink"),
            to: ctaLink,
            isBlueBackground: true
        };
    }, [
        t,
        ctaLink
    ]);
    var socialIconLinks = (0,react.useMemo)(function() {
        return [
            {
                icon: Icon_3122c134.W.SO_ME_YOUTUBE,
                color: "white",
                url: "https://www.youtube.com/channel/UCmZLixtub8rzI1Gxkr5w5jg",
                label: "Youtube",
                width: 35.75,
                height: 25.19,
                viewBox: "8 7.2 16 17"
            },
            {
                icon: Icon_3122c134.W.SO_ME_LINKEDIN,
                color: "white",
                url: isEmployerSite ? "https://www.linkedin.com/company/work-in-finland-kansainvalisen-rekrytoinnin-tyonantajaneuvonta/" : "https://linkedin.com/showcase/finland-works/",
                label: "Linkedin",
                size: 35
            }, 
        ];
    }, [
        isEmployerSite
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(m, {
        logo: /*#__PURE__*/ (0,jsx_runtime.jsx)(d, {
            color: "secondary"
        }),
        ctaExternalLink: /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToAction_d24a74ed.C, (0,_object_spread/* default */.Z)({}, ctaProps)),
        backToTopLabel: t("footer.backToTop"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(m.LinkList, {
                links: (0,_to_consumable_array/* default */.Z)(primary).concat([
                    switchLink
                ]),
                boldText: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(m.LinkList, {
                links: secondary
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(m.IconList, {
                iconLinks: socialIconLinks,
                followUsLabel: t("footer.followUs")
            })
        ]
    });
}
function useCtaLink() {
    var locale = (0,next_router.useRouter)().locale;
    if (locale === constants_locale/* Locale.Suomi */.go.Suomi) return "https://tem.fi/talent-boost";
    if (locale === constants_locale/* Locale.Svenska */.go.Svenska) return "https://tem.fi/sv/tillvaxt-genom-internationella-talanger";
    return "https://tem.fi/en/talent-boost-en";
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(2050);
// EXTERNAL MODULE: ../node_modules/next/dynamic.js
var dynamic = __webpack_require__(5218);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../node_modules/react-dom/index.js
var react_dom = __webpack_require__(1542);
// EXTERNAL MODULE: ../wif-ui-lib/dist/index-099c513a.mjs
var index_099c513a = __webpack_require__(3011);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Image-d6406817.mjs
var Image_d6406817 = __webpack_require__(5905);
// EXTERNAL MODULE: ../wif-ui-lib/dist/useModal-4683a76a.mjs
var useModal_4683a76a = __webpack_require__(6230);
;// CONCATENATED MODULE: ../wif-ui-lib/dist/Navigation.js















function Pn(e) {
  const n = (0,react.useRef)(0), t = (0,react.useRef)("init"), a = (0,react.useCallback)(() => {
    const r = e?.current?.clientHeight ?? 104, s = window.scrollY - n.current;
    if (n.current = window.scrollY, window.scrollY <= r)
      return t.current = "init";
    if (s === 0)
      return t.current;
    const c = s < 0 ? "up" : "down";
    return t.current = c;
  }, [e]);
  return (0,react.useSyncExternalStore)(
    In,
    a,
    () => "init"
  );
}
function In(e) {
  return window.addEventListener("scroll", e), () => window.removeEventListener("scroll", e);
}
const Tn = "rich-text", Rn = "hero__text", On = "mobile", Hn = "tablet", An = "desktop", Un = "button__text-primary", Fn = "button__title", Bn = "button__title__map", Vn = "button__heroTitle", $n = "heading__page", jn = "heading__section", Kn = "heading__menu", zn = "texts__component_title", Wn = "navigation__language-picker--dropdown__link", Gn = "texts__component_title--bold", Yn = "texts__lead_text", Xn = "page__lead_text", qn = "texts__lead_text--bold", Jn = "texts__paragraph_subtitle", Qn = "texts__paragraph_subtitle--bold", Zn = "texts__body_text", et = "texts__body_text--bold", nt = "texts__link", tt = "texts__caption", ot = "texts__caption--bold", it = "page__heading", at = "navigation__language-picker", rt = "navigation__language-picker__button", st = "navigation__language-picker--dropdown", ct = "navigation__language-picker--dropdown__heading", lt = "navigation__language-picker--dropdown__list", Navigation_J = {
  richText: Tn,
  heroText: Rn,
  mobile: On,
  tablet: Hn,
  desktop: An,
  buttonTextPrimary: Un,
  buttonTitle: Fn,
  buttonTitleMap: Bn,
  buttonHeroTitle: Vn,
  headingPage: $n,
  headingSection: jn,
  headingMenu: Kn,
  textsComponentTitle: zn,
  navigationLanguagePickerDropdownLink: Wn,
  textsComponentTitleBold: Gn,
  textsLeadText: Yn,
  pageLeadText: Xn,
  textsLeadTextBold: qn,
  textsParagraphSubtitle: Jn,
  textsParagraphSubtitleBold: Qn,
  textsBodyText: Zn,
  textsBodyTextBold: et,
  textsLink: nt,
  textsCaption: tt,
  textsCaptionBold: ot,
  pageHeading: it,
  navigationLanguagePicker: at,
  navigationLanguagePickerButton: rt,
  navigationLanguagePickerDropdown: st,
  navigationLanguagePickerDropdownHeading: ct,
  navigationLanguagePickerDropdownList: lt
};
function dt({
  currentLanguage: e,
  availableLanguages: n,
  currentUrlPath: t,
  isNavigationHidden: a,
  i18n: i
}) {
  const r = (0,react.useId)(), s = `language-picker-${r}`, c = `language-picker-button-${r}`, u = `language-picker-dropdown-${r}`, { selectLanguageLabel: g = "Select language" } = i || {}, {
    isDropdownOpen: l,
    closeDropdown: p,
    toggleDropdownOpen: v,
    buttonRef: m,
    dropdownRef: f
  } = gt(a);
  return n.length < 2 ? null : /* @__PURE__ */ react.createElement("div", { id: s, className: Navigation_J.navigationLanguagePicker }, /* @__PURE__ */ react.createElement(
    "button",
    {
      id: c,
      className: (0,app_a75c1d35.c)(
        Navigation_J.navigationLanguagePickerButton
        // isDropdownOpen
        //   ? typography.textsLeadTextBold
        //   : typography.textsLeadText
      ),
      "aria-expanded": l,
      "aria-controls": u,
      onClick: v,
      type: "button",
      ref: m
    },
    /* @__PURE__ */ react.createElement("span", null, e.toUpperCase()),
    /* @__PURE__ */ react.createElement(Icon_3122c134.I, { icon: Icon_3122c134.W.GLOBE, size: 24 })
  ), /* @__PURE__ */ react.createElement(
    "div",
    {
      id: u,
      className: Navigation_J.navigationLanguagePickerDropdown,
      "data-open": l,
      role: "listbox",
      "aria-activedescendant": `${u}-${e}`,
      ref: f
    },
    /* @__PURE__ */ react.createElement(
      "div",
      {
        className: (0,app_a75c1d35.c)(
          app_a75c1d35.t.headingSection,
          Navigation_J.navigationLanguagePickerDropdownHeading
        )
      },
      g
    ),
    /* @__PURE__ */ react.createElement("ul", { className: Navigation_J.navigationLanguagePickerDropdownList }, n.map((k) => /* @__PURE__ */ react.createElement(
      ut,
      {
        key: k.code,
        ...k,
        closeDropdown: p,
        currentLanguage: e,
        currentUrlPath: t,
        dropdownId: u
      }
    )))
  ));
}
function ut({
  code: e,
  label: n,
  currentLanguage: t,
  currentUrlPath: a,
  closeDropdown: i,
  dropdownId: r
}) {
  const s = `${r}-${e}`, c = e === t;
  return /* @__PURE__ */ react.createElement(
    Link_479ac100.L,
    {
      key: e,
      id: s,
      className: Navigation_J.navigationLanguagePickerDropdownLink,
      "aria-selected": c,
      locale: e,
      href: a,
      disableLinkTextStyle: !0,
      role: "listitem",
      onClick: i
    },
    e.toUpperCase(),
    " - ",
    n
  );
}
function gt(e) {
  const [n, t] = (0,react.useState)(!1), a = (0,react.useCallback)(
    () => t((c) => !c),
    []
  ), i = (0,react.useCallback)(() => t(!1), []), r = (0,react.useRef)(null), s = (0,react.useRef)(null);
  return (0,react.useEffect)(() => {
    e && i();
  }, [e, i]), (0,useClickOutside_726e7c36.b)([r, s], i), {
    isDropdownOpen: n,
    toggleDropdownOpen: a,
    closeDropdown: i,
    buttonRef: r,
    dropdownRef: s
  };
}
function Fe(e) {
  const n = react.useRef(e);
  return react.useEffect(() => {
    n.current = e;
  }), react.useMemo(() => (...t) => n.current?.(...t), []);
}
function vt(e) {
  const n = react.useRef(e);
  return react.useEffect(() => {
    n.current = e;
  }), react.useMemo(() => (...t) => n.current?.(...t), []);
}
function _t(e, n = globalThis?.document) {
  const t = vt(e);
  react.useEffect(() => {
    const a = (i) => {
      i.key === "Escape" && t(i);
    };
    return n.addEventListener("keydown", a, { capture: !0 }), () => n.removeEventListener("keydown", a, { capture: !0 });
  }, [t, n]);
}
var mt = "DismissableLayer", ue = "dismissableLayer.update", pt = "dismissableLayer.pointerDownOutside", ft = "dismissableLayer.focusOutside", xe, Be = react.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Ve = react.forwardRef(
  (e, n) => {
    const {
      disableOutsidePointerEvents: t = !1,
      onEscapeKeyDown: a,
      onPointerDownOutside: i,
      onFocusOutside: r,
      onInteractOutside: s,
      onDismiss: c,
      ...u
    } = e, g = react.useContext(Be), [l, p] = react.useState(null), v = l?.ownerDocument ?? globalThis?.document, [, m] = react.useState({}), f = (0,index_099c513a.u)(n, (w) => p(w)), k = Array.from(g.layers), [C] = [...g.layersWithOutsidePointerEventsDisabled].slice(-1), M = k.indexOf(C), I = l ? k.indexOf(l) : -1, h = g.layersWithOutsidePointerEventsDisabled.size > 0, L = I >= M, E = Lt((w) => {
      const F = w.target, b = [...g.branches].some((B) => B.contains(F));
      !L || b || (i?.(w), s?.(w), w.defaultPrevented || c?.());
    }, v), S = Et((w) => {
      const F = w.target;
      [...g.branches].some((B) => B.contains(F)) || (r?.(w), s?.(w), w.defaultPrevented || c?.());
    }, v);
    return _t((w) => {
      I === g.layers.size - 1 && (a?.(w), !w.defaultPrevented && c && (w.preventDefault(), c()));
    }, v), react.useEffect(() => {
      if (l)
        return t && (g.layersWithOutsidePointerEventsDisabled.size === 0 && (xe = v.body.style.pointerEvents, v.body.style.pointerEvents = "none"), g.layersWithOutsidePointerEventsDisabled.add(l)), g.layers.add(l), Ne(), () => {
          t && g.layersWithOutsidePointerEventsDisabled.size === 1 && (v.body.style.pointerEvents = xe);
        };
    }, [l, v, t, g]), react.useEffect(() => () => {
      l && (g.layers.delete(l), g.layersWithOutsidePointerEventsDisabled.delete(l), Ne());
    }, [l, g]), react.useEffect(() => {
      const w = () => m({});
      return document.addEventListener(ue, w), () => document.removeEventListener(ue, w);
    }, []), /* @__PURE__ */ index_099c513a.j.jsx(
      index_099c513a.P.div,
      {
        ...u,
        ref: f,
        style: {
          pointerEvents: h ? L ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: (0,index_099c513a.c)(e.onFocusCapture, S.onFocusCapture),
        onBlurCapture: (0,index_099c513a.c)(e.onBlurCapture, S.onBlurCapture),
        onPointerDownCapture: (0,index_099c513a.c)(
          e.onPointerDownCapture,
          E.onPointerDownCapture
        )
      }
    );
  }
);
Ve.displayName = mt;
var kt = "DismissableLayerBranch", ht = react.forwardRef((e, n) => {
  const t = react.useContext(Be), a = react.useRef(null), i = (0,index_099c513a.u)(n, a);
  return react.useEffect(() => {
    const r = a.current;
    if (r)
      return t.branches.add(r), () => {
        t.branches.delete(r);
      };
  }, [t.branches]), /* @__PURE__ */ index_099c513a.j.jsx(index_099c513a.P.div, { ...e, ref: i });
});
ht.displayName = kt;
function Lt(e, n = globalThis?.document) {
  const t = Fe(e), a = react.useRef(!1), i = react.useRef(() => {
  });
  return react.useEffect(() => {
    const r = (c) => {
      if (c.target && !a.current) {
        let u = function() {
          $e(
            pt,
            t,
            g,
            { discrete: !0 }
          );
        };
        const g = { originalEvent: c };
        c.pointerType === "touch" ? (n.removeEventListener("click", i.current), i.current = u, n.addEventListener("click", i.current, { once: !0 })) : u();
      } else
        n.removeEventListener("click", i.current);
      a.current = !1;
    }, s = window.setTimeout(() => {
      n.addEventListener("pointerdown", r);
    }, 0);
    return () => {
      window.clearTimeout(s), n.removeEventListener("pointerdown", r), n.removeEventListener("click", i.current);
    };
  }, [n, t]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => a.current = !0
  };
}
function Et(e, n = globalThis?.document) {
  const t = Fe(e), a = react.useRef(!1);
  return react.useEffect(() => {
    const i = (r) => {
      r.target && !a.current && $e(ft, t, { originalEvent: r }, {
        discrete: !1
      });
    };
    return n.addEventListener("focusin", i), () => n.removeEventListener("focusin", i);
  }, [n, t]), {
    onFocusCapture: () => a.current = !0,
    onBlurCapture: () => a.current = !1
  };
}
function Ne() {
  const e = new CustomEvent(ue);
  document.dispatchEvent(e);
}
function $e(e, n, t, { discrete: a }) {
  const i = t.originalEvent.target, r = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: t });
  n && i.addEventListener(e, n, { once: !0 }), a ? (0,index_099c513a.d)(i, r) : i.dispatchEvent(r);
}
function wt(e) {
  const n = react.useRef({ value: e, previous: e });
  return react.useMemo(() => (n.current.value !== e && (n.current.previous = n.current.value, n.current.value = e), n.current.previous), [e]);
}
function Navigation_W(e) {
  const n = react.useRef(e);
  return react.useEffect(() => {
    n.current = e;
  }), react.useMemo(() => (...t) => n.current?.(...t), []);
}
var St = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), yt = "VisuallyHidden", je = react.forwardRef(
  (e, n) => /* @__PURE__ */ index_099c513a.j.jsx(
    index_099c513a.P.span,
    {
      ...e,
      ref: n,
      style: { ...St, ...e.style }
    }
  )
);
je.displayName = yt;
var Ct = je, q = "NavigationMenu", [Le, Ke, bt] = (0,index_099c513a.a)(q), [ge, Mt, xt] = (0,index_099c513a.a)(q), [Ee, Da] = (0,index_099c513a.b)(
  q,
  [bt, xt]
), [Nt, Navigation_V] = Ee(q), [Dt, Pt] = Ee(q), ze = react.forwardRef(
  (e, n) => {
    const {
      __scopeNavigationMenu: t,
      value: a,
      onValueChange: i,
      defaultValue: r,
      delayDuration: s = 200,
      skipDelayDuration: c = 300,
      orientation: u = "horizontal",
      dir: g,
      ...l
    } = e, [p, v] = react.useState(null), m = (0,index_099c513a.u)(n, (b) => v(b)), f = (0,index_099c513a.e)(g), k = react.useRef(0), C = react.useRef(0), M = react.useRef(0), [I, h] = react.useState(!0), [L, E] = (0,index_099c513a.f)({
      prop: a,
      onChange: (b) => {
        const B = b !== "", re = c > 0;
        B ? (window.clearTimeout(M.current), re && h(!1)) : (window.clearTimeout(M.current), M.current = window.setTimeout(
          () => h(!0),
          c
        )), i?.(b);
      },
      defaultProp: r ?? "",
      caller: q
    }), S = react.useCallback(() => {
      window.clearTimeout(C.current), C.current = window.setTimeout(() => E(""), 150);
    }, [E]), w = react.useCallback(
      (b) => {
        window.clearTimeout(C.current), E(b);
      },
      [E]
    ), F = react.useCallback(
      (b) => {
        L === b ? window.clearTimeout(C.current) : k.current = window.setTimeout(() => {
          window.clearTimeout(C.current), E(b);
        }, s);
      },
      [L, E, s]
    );
    return react.useEffect(() => () => {
      window.clearTimeout(k.current), window.clearTimeout(C.current), window.clearTimeout(M.current);
    }, []), /* @__PURE__ */ index_099c513a.j.jsx(
      We,
      {
        scope: t,
        isRootMenu: !0,
        value: L,
        dir: f,
        orientation: u,
        rootNavigationMenu: p,
        onTriggerEnter: (b) => {
          window.clearTimeout(k.current), I ? F(b) : w(b);
        },
        onTriggerLeave: () => {
          window.clearTimeout(k.current), S();
        },
        onContentEnter: () => window.clearTimeout(C.current),
        onContentLeave: S,
        onItemSelect: (b) => {
          E((B) => B === b ? "" : b);
        },
        onItemDismiss: () => E(""),
        children: /* @__PURE__ */ index_099c513a.j.jsx(
          index_099c513a.P.nav,
          {
            "aria-label": "Main",
            "data-orientation": u,
            dir: f,
            ...l,
            ref: m
          }
        )
      }
    );
  }
);
ze.displayName = q;
var ve = "NavigationMenuSub", It = react.forwardRef(
  (e, n) => {
    const {
      __scopeNavigationMenu: t,
      value: a,
      onValueChange: i,
      defaultValue: r,
      orientation: s = "horizontal",
      ...c
    } = e, u = Navigation_V(ve, t), [g, l] = (0,index_099c513a.f)({
      prop: a,
      onChange: i,
      defaultProp: r ?? "",
      caller: ve
    });
    return /* @__PURE__ */ index_099c513a.j.jsx(
      We,
      {
        scope: t,
        isRootMenu: !1,
        value: g,
        dir: u.dir,
        orientation: s,
        rootNavigationMenu: u.rootNavigationMenu,
        onTriggerEnter: (p) => l(p),
        onItemSelect: (p) => l(p),
        onItemDismiss: () => l(""),
        children: /* @__PURE__ */ index_099c513a.j.jsx(index_099c513a.P.div, { "data-orientation": s, ...c, ref: n })
      }
    );
  }
);
It.displayName = ve;
var We = (e) => {
  const {
    scope: n,
    isRootMenu: t,
    rootNavigationMenu: a,
    dir: i,
    orientation: r,
    children: s,
    value: c,
    onItemSelect: u,
    onItemDismiss: g,
    onTriggerEnter: l,
    onTriggerLeave: p,
    onContentEnter: v,
    onContentLeave: m
  } = e, [f, k] = react.useState(null), [C, M] = react.useState(/* @__PURE__ */ new Map()), [I, h] = react.useState(null);
  return /* @__PURE__ */ index_099c513a.j.jsx(
    Nt,
    {
      scope: n,
      isRootMenu: t,
      rootNavigationMenu: a,
      value: c,
      previousValue: wt(c),
      baseId: (0,index_099c513a.g)(),
      dir: i,
      orientation: r,
      viewport: f,
      onViewportChange: k,
      indicatorTrack: I,
      onIndicatorTrackChange: h,
      onTriggerEnter: Navigation_W(l),
      onTriggerLeave: Navigation_W(p),
      onContentEnter: Navigation_W(v),
      onContentLeave: Navigation_W(m),
      onItemSelect: Navigation_W(u),
      onItemDismiss: Navigation_W(g),
      onViewportContentChange: react.useCallback((L, E) => {
        M((S) => (S.set(L, E), new Map(S)));
      }, []),
      onViewportContentRemove: react.useCallback((L) => {
        M((E) => E.has(L) ? (E.delete(L), new Map(E)) : E);
      }, []),
      children: /* @__PURE__ */ index_099c513a.j.jsx(Le.Provider, { scope: n, children: /* @__PURE__ */ index_099c513a.j.jsx(Dt, { scope: n, items: C, children: s }) })
    }
  );
}, Ge = "NavigationMenuList", Ye = react.forwardRef(
  (e, n) => {
    const { __scopeNavigationMenu: t, ...a } = e, i = Navigation_V(Ge, t), r = /* @__PURE__ */ index_099c513a.j.jsx(index_099c513a.P.ul, { "data-orientation": i.orientation, ...a, ref: n });
    return /* @__PURE__ */ index_099c513a.j.jsx(index_099c513a.P.div, { style: { position: "relative" }, ref: i.onIndicatorTrackChange, children: /* @__PURE__ */ index_099c513a.j.jsx(Le.Slot, { scope: t, children: i.isRootMenu ? /* @__PURE__ */ index_099c513a.j.jsx(tn, { asChild: !0, children: r }) : r }) });
  }
);
Ye.displayName = Ge;
var Xe = "NavigationMenuItem", [Tt, qe] = Ee(Xe), Je = react.forwardRef(
  (e, n) => {
    const { __scopeNavigationMenu: t, value: a, ...i } = e, r = (0,index_099c513a.g)(), s = a || r || "LEGACY_REACT_AUTO_VALUE", c = react.useRef(null), u = react.useRef(null), g = react.useRef(null), l = react.useRef(() => {
    }), p = react.useRef(!1), v = react.useCallback((f = "start") => {
      if (c.current) {
        l.current();
        const k = me(c.current);
        k.length && ye(f === "start" ? k : k.reverse());
      }
    }, []), m = react.useCallback(() => {
      if (c.current) {
        const f = me(c.current);
        f.length && (l.current = $t(f));
      }
    }, []);
    return /* @__PURE__ */ index_099c513a.j.jsx(
      Tt,
      {
        scope: t,
        value: s,
        triggerRef: u,
        contentRef: c,
        focusProxyRef: g,
        wasEscapeCloseRef: p,
        onEntryKeyDown: v,
        onFocusProxyEnter: v,
        onRootContentClose: m,
        onContentFocusOutside: m,
        children: /* @__PURE__ */ index_099c513a.j.jsx(index_099c513a.P.li, { ...i, ref: n })
      }
    );
  }
);
Je.displayName = Xe;
var _e = "NavigationMenuTrigger", Qe = react.forwardRef((e, n) => {
  const { __scopeNavigationMenu: t, disabled: a, ...i } = e, r = Navigation_V(_e, e.__scopeNavigationMenu), s = qe(_e, e.__scopeNavigationMenu), c = react.useRef(null), u = (0,index_099c513a.u)(c, s.triggerRef, n), g = an(r.baseId, s.value), l = rn(r.baseId, s.value), p = react.useRef(!1), v = react.useRef(!1), m = s.value === r.value;
  return /* @__PURE__ */ index_099c513a.j.jsxs(index_099c513a.j.Fragment, { children: [
    /* @__PURE__ */ index_099c513a.j.jsx(Le.ItemSlot, { scope: t, value: s.value, children: /* @__PURE__ */ index_099c513a.j.jsx(on, { asChild: !0, children: /* @__PURE__ */ index_099c513a.j.jsx(
      index_099c513a.P.button,
      {
        id: g,
        disabled: a,
        "data-disabled": a ? "" : void 0,
        "data-state": Ce(m),
        "aria-expanded": m,
        "aria-controls": l,
        ...i,
        ref: u,
        onPointerEnter: (0,index_099c513a.c)(e.onPointerEnter, () => {
          v.current = !1, s.wasEscapeCloseRef.current = !1;
        }),
        onPointerMove: (0,index_099c513a.c)(
          e.onPointerMove,
          ie(() => {
            a || v.current || s.wasEscapeCloseRef.current || p.current || (r.onTriggerEnter(s.value), p.current = !0);
          })
        ),
        onPointerLeave: (0,index_099c513a.c)(
          e.onPointerLeave,
          ie(() => {
            a || (r.onTriggerLeave(), p.current = !1);
          })
        ),
        onClick: (0,index_099c513a.c)(e.onClick, () => {
          r.onItemSelect(s.value), v.current = m;
        }),
        onKeyDown: (0,index_099c513a.c)(e.onKeyDown, (f) => {
          const C = { horizontal: "ArrowDown", vertical: r.dir === "rtl" ? "ArrowLeft" : "ArrowRight" }[r.orientation];
          m && f.key === C && (s.onEntryKeyDown(), f.preventDefault());
        })
      }
    ) }) }),
    m && /* @__PURE__ */ index_099c513a.j.jsxs(index_099c513a.j.Fragment, { children: [
      /* @__PURE__ */ index_099c513a.j.jsx(
        Ct,
        {
          "aria-hidden": !0,
          tabIndex: 0,
          ref: s.focusProxyRef,
          onFocus: (f) => {
            const k = s.contentRef.current, C = f.relatedTarget, M = C === c.current, I = k?.contains(C);
            (M || !I) && s.onFocusProxyEnter(M ? "start" : "end");
          }
        }
      ),
      r.viewport && /* @__PURE__ */ index_099c513a.j.jsx("span", { "aria-owns": l })
    ] })
  ] });
});
Qe.displayName = _e;
var Rt = "NavigationMenuLink", De = "navigationMenu.linkSelect", Ze = react.forwardRef(
  (e, n) => {
    const { __scopeNavigationMenu: t, active: a, onSelect: i, ...r } = e;
    return /* @__PURE__ */ index_099c513a.j.jsx(on, { asChild: !0, children: /* @__PURE__ */ index_099c513a.j.jsx(
      index_099c513a.P.a,
      {
        "data-active": a ? "" : void 0,
        "aria-current": a ? "page" : void 0,
        ...r,
        ref: n,
        onClick: (0,index_099c513a.c)(
          e.onClick,
          (s) => {
            const c = s.target, u = new CustomEvent(De, {
              bubbles: !0,
              cancelable: !0
            });
            if (c.addEventListener(De, (g) => i?.(g), { once: !0 }), (0,index_099c513a.d)(c, u), !u.defaultPrevented && !s.metaKey) {
              const g = new CustomEvent(oe, {
                bubbles: !0,
                cancelable: !0
              });
              (0,index_099c513a.d)(c, g);
            }
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Ze.displayName = Rt;
var we = "NavigationMenuIndicator", Ot = react.forwardRef((e, n) => {
  const { forceMount: t, ...a } = e, i = Navigation_V(we, e.__scopeNavigationMenu), r = !!i.value;
  return i.indicatorTrack ? react_dom.createPortal(
    /* @__PURE__ */ index_099c513a.j.jsx(index_099c513a.h, { present: t || r, children: /* @__PURE__ */ index_099c513a.j.jsx(Ht, { ...a, ref: n }) }),
    i.indicatorTrack
  ) : null;
});
Ot.displayName = we;
var Ht = react.forwardRef((e, n) => {
  const { __scopeNavigationMenu: t, ...a } = e, i = Navigation_V(we, t), r = Ke(t), [s, c] = react.useState(
    null
  ), [u, g] = react.useState(null), l = i.orientation === "horizontal", p = !!i.value;
  react.useEffect(() => {
    const f = r().find((k) => k.value === i.value)?.ref.current;
    f && c(f);
  }, [r, i.value]);
  const v = () => {
    s && g({
      size: l ? s.offsetWidth : s.offsetHeight,
      offset: l ? s.offsetLeft : s.offsetTop
    });
  };
  return pe(s, v), pe(i.indicatorTrack, v), u ? /* @__PURE__ */ index_099c513a.j.jsx(
    index_099c513a.P.div,
    {
      "aria-hidden": !0,
      "data-state": p ? "visible" : "hidden",
      "data-orientation": i.orientation,
      ...a,
      ref: n,
      style: {
        position: "absolute",
        ...l ? {
          left: 0,
          width: u.size + "px",
          transform: `translateX(${u.offset}px)`
        } : {
          top: 0,
          height: u.size + "px",
          transform: `translateY(${u.offset}px)`
        },
        ...a.style
      }
    }
  ) : null;
}), Z = "NavigationMenuContent", en = react.forwardRef((e, n) => {
  const { forceMount: t, ...a } = e, i = Navigation_V(Z, e.__scopeNavigationMenu), r = qe(Z, e.__scopeNavigationMenu), s = (0,index_099c513a.u)(r.contentRef, n), c = r.value === i.value, u = {
    value: r.value,
    triggerRef: r.triggerRef,
    focusProxyRef: r.focusProxyRef,
    wasEscapeCloseRef: r.wasEscapeCloseRef,
    onContentFocusOutside: r.onContentFocusOutside,
    onRootContentClose: r.onRootContentClose,
    ...a
  };
  return i.viewport ? /* @__PURE__ */ index_099c513a.j.jsx(At, { forceMount: t, ...u, ref: s }) : /* @__PURE__ */ index_099c513a.j.jsx(index_099c513a.h, { present: t || c, children: /* @__PURE__ */ index_099c513a.j.jsx(
    nn,
    {
      "data-state": Ce(c),
      ...u,
      ref: s,
      onPointerEnter: (0,index_099c513a.c)(e.onPointerEnter, i.onContentEnter),
      onPointerLeave: (0,index_099c513a.c)(
        e.onPointerLeave,
        ie(i.onContentLeave)
      ),
      style: {
        // Prevent interaction when animating out
        pointerEvents: !c && i.isRootMenu ? "none" : void 0,
        ...u.style
      }
    }
  ) });
});
en.displayName = Z;
var At = react.forwardRef((e, n) => {
  const t = Navigation_V(Z, e.__scopeNavigationMenu), { onViewportContentChange: a, onViewportContentRemove: i } = t;
  return (0,index_099c513a.i)(() => {
    a(e.value, {
      ref: n,
      ...e
    });
  }, [e, n, a]), (0,index_099c513a.i)(() => () => i(e.value), [e.value, i]), null;
}), oe = "navigationMenu.rootContentDismiss", nn = react.forwardRef((e, n) => {
  const {
    __scopeNavigationMenu: t,
    value: a,
    triggerRef: i,
    focusProxyRef: r,
    wasEscapeCloseRef: s,
    onRootContentClose: c,
    onContentFocusOutside: u,
    ...g
  } = e, l = Navigation_V(Z, t), p = react.useRef(null), v = (0,index_099c513a.u)(p, n), m = an(l.baseId, a), f = rn(l.baseId, a), k = Ke(t), C = react.useRef(null), { onItemDismiss: M } = l;
  react.useEffect(() => {
    const h = p.current;
    if (l.isRootMenu && h) {
      const L = () => {
        M(), c(), h.contains(document.activeElement) && i.current?.focus();
      };
      return h.addEventListener(oe, L), () => h.removeEventListener(oe, L);
    }
  }, [l.isRootMenu, e.value, i, M, c]);
  const I = react.useMemo(() => {
    const L = k().map((B) => B.value);
    l.dir === "rtl" && L.reverse();
    const E = L.indexOf(l.value), S = L.indexOf(l.previousValue), w = a === l.value, F = S === L.indexOf(a);
    if (!w && !F)
      return C.current;
    const b = (() => {
      if (E !== S) {
        if (w && S !== -1)
          return E > S ? "from-end" : "from-start";
        if (F && E !== -1)
          return E > S ? "to-start" : "to-end";
      }
      return null;
    })();
    return C.current = b, b;
  }, [l.previousValue, l.value, l.dir, k, a]);
  return /* @__PURE__ */ index_099c513a.j.jsx(tn, { asChild: !0, children: /* @__PURE__ */ index_099c513a.j.jsx(
    Ve,
    {
      id: f,
      "aria-labelledby": m,
      "data-motion": I,
      "data-orientation": l.orientation,
      ...g,
      ref: v,
      disableOutsidePointerEvents: !1,
      onDismiss: () => {
        const h = new Event(oe, {
          bubbles: !0,
          cancelable: !0
        });
        p.current?.dispatchEvent(h);
      },
      onFocusOutside: (0,index_099c513a.c)(e.onFocusOutside, (h) => {
        u();
        const L = h.target;
        l.rootNavigationMenu?.contains(L) && h.preventDefault();
      }),
      onPointerDownOutside: (0,index_099c513a.c)(e.onPointerDownOutside, (h) => {
        const L = h.target, E = k().some((w) => w.ref.current?.contains(L)), S = l.isRootMenu && l.viewport?.contains(L);
        (E || S || !l.isRootMenu) && h.preventDefault();
      }),
      onKeyDown: (0,index_099c513a.c)(e.onKeyDown, (h) => {
        const L = h.altKey || h.ctrlKey || h.metaKey;
        if (h.key === "Tab" && !L) {
          const S = me(h.currentTarget), w = document.activeElement, F = S.findIndex((re) => re === w), B = h.shiftKey ? S.slice(0, F).reverse() : S.slice(F + 1, S.length);
          ye(B) ? h.preventDefault() : r.current?.focus();
        }
      }),
      onEscapeKeyDown: (0,index_099c513a.c)(e.onEscapeKeyDown, (h) => {
        s.current = !0;
      })
    }
  ) });
}), Se = "NavigationMenuViewport", Ut = react.forwardRef((e, n) => {
  const { forceMount: t, ...a } = e, r = !!Navigation_V(Se, e.__scopeNavigationMenu).value;
  return /* @__PURE__ */ index_099c513a.j.jsx(index_099c513a.h, { present: t || r, children: /* @__PURE__ */ index_099c513a.j.jsx(Ft, { ...a, ref: n }) });
});
Ut.displayName = Se;
var Ft = react.forwardRef((e, n) => {
  const { __scopeNavigationMenu: t, children: a, ...i } = e, r = Navigation_V(Se, t), s = (0,index_099c513a.u)(n, r.onViewportChange), c = Pt(
    Z,
    e.__scopeNavigationMenu
  ), [u, g] = react.useState(null), [l, p] = react.useState(null), v = u ? u?.width + "px" : void 0, m = u ? u?.height + "px" : void 0, f = !!r.value, k = f ? r.value : r.previousValue;
  return pe(l, () => {
    l && g({ width: l.offsetWidth, height: l.offsetHeight });
  }), /* @__PURE__ */ index_099c513a.j.jsx(
    index_099c513a.P.div,
    {
      "data-state": Ce(f),
      "data-orientation": r.orientation,
      ...i,
      ref: s,
      style: {
        // Prevent interaction when animating out
        pointerEvents: !f && r.isRootMenu ? "none" : void 0,
        "--radix-navigation-menu-viewport-width": v,
        "--radix-navigation-menu-viewport-height": m,
        ...i.style
      },
      onPointerEnter: (0,index_099c513a.c)(e.onPointerEnter, r.onContentEnter),
      onPointerLeave: (0,index_099c513a.c)(e.onPointerLeave, ie(r.onContentLeave)),
      children: Array.from(c.items).map(([M, { ref: I, forceMount: h, ...L }]) => {
        const E = k === M;
        return /* @__PURE__ */ index_099c513a.j.jsx(index_099c513a.h, { present: h || E, children: /* @__PURE__ */ index_099c513a.j.jsx(
          nn,
          {
            ...L,
            ref: (0,index_099c513a.k)(I, (S) => {
              E && S && p(S);
            })
          }
        ) }, M);
      })
    }
  );
}), Bt = "FocusGroup", tn = react.forwardRef(
  (e, n) => {
    const { __scopeNavigationMenu: t, ...a } = e, i = Navigation_V(Bt, t);
    return /* @__PURE__ */ index_099c513a.j.jsx(ge.Provider, { scope: t, children: /* @__PURE__ */ index_099c513a.j.jsx(ge.Slot, { scope: t, children: /* @__PURE__ */ index_099c513a.j.jsx(index_099c513a.P.div, { dir: i.dir, ...a, ref: n }) }) });
  }
), Pe = ["ArrowRight", "ArrowLeft", "ArrowUp", "ArrowDown"], Vt = "FocusGroupItem", on = react.forwardRef(
  (e, n) => {
    const { __scopeNavigationMenu: t, ...a } = e, i = Mt(t), r = Navigation_V(Vt, t);
    return /* @__PURE__ */ index_099c513a.j.jsx(ge.ItemSlot, { scope: t, children: /* @__PURE__ */ index_099c513a.j.jsx(
      index_099c513a.P.button,
      {
        ...a,
        ref: n,
        onKeyDown: (0,index_099c513a.c)(e.onKeyDown, (s) => {
          if (["Home", "End", ...Pe].includes(s.key)) {
            let u = i().map((p) => p.ref.current);
            if ([r.dir === "rtl" ? "ArrowRight" : "ArrowLeft", "ArrowUp", "End"].includes(s.key) && u.reverse(), Pe.includes(s.key)) {
              const p = u.indexOf(s.currentTarget);
              u = u.slice(p + 1);
            }
            setTimeout(() => ye(u)), s.preventDefault();
          }
        })
      }
    ) });
  }
);
function me(e) {
  const n = [], t = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (a) => {
      const i = a.tagName === "INPUT" && a.type === "hidden";
      return a.disabled || a.hidden || i ? NodeFilter.FILTER_SKIP : a.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; t.nextNode(); )
    n.push(t.currentNode);
  return n;
}
function ye(e) {
  const n = document.activeElement;
  return e.some((t) => t === n ? !0 : (t.focus(), document.activeElement !== n));
}
function $t(e) {
  return e.forEach((n) => {
    n.dataset.tabindex = n.getAttribute("tabindex") || "", n.setAttribute("tabindex", "-1");
  }), () => {
    e.forEach((n) => {
      const t = n.dataset.tabindex;
      n.setAttribute("tabindex", t);
    });
  };
}
function pe(e, n) {
  const t = Navigation_W(n);
  (0,index_099c513a.i)(() => {
    let a = 0;
    if (e) {
      const i = new ResizeObserver(() => {
        cancelAnimationFrame(a), a = window.requestAnimationFrame(t);
      });
      return i.observe(e), () => {
        window.cancelAnimationFrame(a), i.unobserve(e);
      };
    }
  }, [e, t]);
}
function Ce(e) {
  return e ? "open" : "closed";
}
function an(e, n) {
  return `${e}-trigger-${n}`;
}
function rn(e, n) {
  return `${e}-content-${n}`;
}
function ie(e) {
  return (n) => n.pointerType === "mouse" ? e(n) : void 0;
}
var sn = ze, cn = Ye, ln = Je, dn = Qe, j = Ze, un = en;
const jt = "navigation__links", Kt = "desktop", zt = "navigation__links__list", Wt = "navigation__links__item", Gt = "navigation__links__link", Yt = "navigation__links__trigger", Xt = "navigation__links__link--selected", qt = "navigation__links__trigger--selected", Jt = "navigation__links__trigger__arrow", Qt = "navigation__links__content", Zt = "navigation__links__dropdown", eo = "navigation__links__dropdown__header", no = "navigation__links__dropdown__header__link", to = "navigation__links__dropdown__header__separator", oo = "navigation__links__dropdown__body", io = "navigation__links__dropdown__section", ao = "navigation__links__dropdown__section__link", ro = "navigation__links__dropdown__list", so = "navigation__links__dropdown__list__item", co = "navigation__links__dropdown__sub_link", lo = "slideDown", Navigation_x = {
  navigationLinks: jt,
  desktop: Kt,
  navigationLinksList: zt,
  navigationLinksItem: Wt,
  navigationLinksLink: Gt,
  navigationLinksTrigger: Yt,
  navigationLinksLinkSelected: Xt,
  navigationLinksTriggerSelected: qt,
  navigationLinksTriggerArrow: Jt,
  navigationLinksContent: Qt,
  navigationLinksDropdown: Zt,
  navigationLinksDropdownHeader: eo,
  navigationLinksDropdownHeaderLink: no,
  navigationLinksDropdownHeaderSeparator: to,
  navigationLinksDropdownBody: oo,
  navigationLinksDropdownSection: io,
  navigationLinksDropdownSectionLink: ao,
  navigationLinksDropdownList: ro,
  navigationLinksDropdownListItem: so,
  navigationLinksDropdownSubLink: co,
  slideDown: lo
};
function uo({
  links: e,
  isNavigationHidden: n,
  currentPageId: t
}) {
  const [a, i] = (0,react.useState)(""), r = (0,react.useCallback)((s) => {
    i(s);
  }, []);
  return n ? /* @__PURE__ */ react.createElement(
    "nav",
    {
      className: Navigation_x.navigationLinks,
      "data-testid": "navigation-links"
    }
  ) : /* @__PURE__ */ react.createElement(
    sn,
    {
      className: Navigation_x.navigationLinks,
      "data-testid": "navigation-links",
      value: a,
      onValueChange: r
    },
    /* @__PURE__ */ react.createElement(cn, { className: Navigation_x.navigationLinksList }, e.map((s) => /* @__PURE__ */ react.createElement(
      ln,
      {
        key: s.id,
        value: s.id,
        className: Navigation_x.navigationLinksItem
      },
      s.subPages && s.subPages.length > 0 ? /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(
        dn,
        {
          className: (0,app_a75c1d35.c)(
            Navigation_x.navigationLinksTrigger,
            (t === s.id || a === s.id) && Navigation_x.navigationLinksTriggerSelected
          ),
          onPointerMove: (c) => c.preventDefault(),
          onPointerLeave: (c) => c.preventDefault()
        },
        s.title,
        /* @__PURE__ */ react.createElement(
          Icon_3122c134.I,
          {
            className: Navigation_x.navigationLinksTriggerArrow,
            icon: Icon_3122c134.W.CHEVRON_DOWN,
            size: 16
          }
        )
      ), /* @__PURE__ */ react.createElement(
        un,
        {
          className: Navigation_x.navigationLinksContent,
          onPointerLeave: (c) => c.preventDefault()
        },
        /* @__PURE__ */ react.createElement(go, { link: s })
      )) : /* @__PURE__ */ react.createElement(j, { asChild: !0 }, /* @__PURE__ */ react.createElement(
        Link_479ac100.L,
        {
          href: s.href,
          locale: s.locale,
          target: s.target,
          className: (0,app_a75c1d35.c)(
            Navigation_x.navigationLinksLink,
            t === s.id && Navigation_x.navigationLinksLinkSelected
          ),
          disableLinkTextStyle: !0
        },
        s.title
      ))
    )))
  );
}
function go({ link: e }) {
  return /* @__PURE__ */ react.createElement("div", { className: Navigation_x.navigationLinksDropdown }, /* @__PURE__ */ react.createElement("div", { className: Navigation_x.navigationLinksDropdownHeader }, /* @__PURE__ */ react.createElement(j, { asChild: !0 }, /* @__PURE__ */ react.createElement(
    Link_479ac100.L,
    {
      href: e.href,
      locale: e.locale,
      target: e.target,
      className: Navigation_x.navigationLinksDropdownHeaderLink,
      disableLinkTextStyle: !0
    },
    /* @__PURE__ */ react.createElement("span", null, e.title),
    /* @__PURE__ */ react.createElement(Icon_3122c134.I, { icon: Icon_3122c134.W.ARROW_RIGHT, size: 40 })
  )), /* @__PURE__ */ react.createElement("div", { className: Navigation_x.navigationLinksDropdownHeaderSeparator })), /* @__PURE__ */ react.createElement("div", { className: Navigation_x.navigationLinksDropdownBody }, e.subPages?.map((n) => /* @__PURE__ */ react.createElement(
    "div",
    {
      key: n.id,
      className: Navigation_x.navigationLinksDropdownSection
    },
    /* @__PURE__ */ react.createElement(j, { asChild: !0 }, /* @__PURE__ */ react.createElement(
      Link_479ac100.L,
      {
        href: n.href,
        locale: n.locale,
        target: n.target,
        className: Navigation_x.navigationLinksDropdownSectionLink,
        disableLinkTextStyle: !0
      },
      /* @__PURE__ */ react.createElement("span", null, n.title),
      /* @__PURE__ */ react.createElement(Icon_3122c134.I, { icon: Icon_3122c134.W.ARROW_RIGHT, size: 20 })
    )),
    n.subPages && n.subPages.length > 0 && /* @__PURE__ */ react.createElement("ul", { className: Navigation_x.navigationLinksDropdownList }, n.subPages.map((t) => /* @__PURE__ */ react.createElement(
      "li",
      {
        key: t.id,
        className: Navigation_x.navigationLinksDropdownListItem
      },
      /* @__PURE__ */ react.createElement(j, { asChild: !0 }, /* @__PURE__ */ react.createElement(
        Link_479ac100.L,
        {
          href: t.href,
          locale: t.locale,
          target: t.target,
          className: Navigation_x.navigationLinksDropdownSubLink,
          disableLinkTextStyle: !0
        },
        /* @__PURE__ */ react.createElement("span", null, t.title),
        /* @__PURE__ */ react.createElement(Icon_3122c134.I, { icon: Icon_3122c134.W.ARROW_RIGHT, size: 20 })
      ))
    )))
  ))));
}
const vo = "navigation__header", _o = "navigation__header--modal-open", mo = "desktop", po = "navigation__header--visible", fo = "navigation__header--show", ko = "animateShow", ho = "navigation__header--hide", Lo = "animateHide", Eo = "navigation__header--employers", wo = "navigation__header__content", So = "navigation__header__logo", yo = "navigation__header__actions", Co = "navigation__header__search", bo = "navigation__header__menu", Mo = "navigation__header__search--employers", xo = "navigation__header__menu--employers", No = "navigation__header__saved_items_link", Do = "navigation__header__saved_items_link__with-dot", A = {
  navigationHeader: vo,
  navigationHeaderModalOpen: _o,
  desktop: mo,
  navigationHeaderVisible: po,
  navigationHeaderShow: fo,
  animateShow: ko,
  navigationHeaderHide: ho,
  animateHide: Lo,
  navigationHeaderEmployers: Eo,
  navigationHeaderContent: wo,
  navigationHeaderLogo: So,
  navigationHeaderActions: yo,
  navigationHeaderSearch: Co,
  navigationHeaderMenu: bo,
  navigationHeaderSearchEmployers: Mo,
  navigationHeaderMenuEmployers: xo,
  navigationHeaderSavedItemsLink: No,
  navigationHeaderSavedItemsLinkWithDot: Do
}, fe = "Contact-us", Po = "contact__us", Io = "contact__us__list", To = "contact__us__trigger", Ro = "contact__us__link", Oo = "contact__us__trigger--selected", Ho = "contact__us__link--selected", Ao = "contact__us__content", Uo = "contact__us__dropdown", Fo = "desktop", Bo = "contact__us__dropdown__header", Vo = "contact__us__dropdown__header__link", $o = "contact__us__dropdown__header__separator", jo = "contact__us__dropdown__body", Ko = "contact__us__dropdown__section", zo = "contact__us__dropdown__section__link", Wo = "contact__us__dropdown__featured", Go = "contact__us__dropdown__featured__image", Yo = "contact__us__dropdown__featured__link", D = {
  contactUs: Po,
  contactUsList: Io,
  contactUsTrigger: To,
  contactUsLink: Ro,
  contactUsTriggerSelected: Oo,
  contactUsLinkSelected: Ho,
  contactUsContent: Ao,
  contactUsDropdown: Uo,
  desktop: Fo,
  contactUsDropdownHeader: Bo,
  contactUsDropdownHeaderLink: Vo,
  contactUsDropdownHeaderSeparator: $o,
  contactUsDropdownBody: jo,
  contactUsDropdownSection: Ko,
  contactUsDropdownSectionLink: zo,
  contactUsDropdownFeatured: Wo,
  contactUsDropdownFeaturedImage: Go,
  contactUsDropdownFeaturedLink: Yo
}, Ie = "contact";
function Xo({
  links: e,
  isContactUsHidden: n,
  i18n: t,
  currentPageId: a
}) {
  const [i, r] = (0,react.useState)(""), s = (0,react.useCallback)((l) => {
    r(l);
  }, []), c = e[0], u = c?.subPages != null && c.subPages.length > 0, g = i === Ie || a === c?.id;
  return n ? /* @__PURE__ */ react.createElement("div", { className: D.contactUs }) : /* @__PURE__ */ react.createElement(
    sn,
    {
      className: D.contactUs,
      value: i,
      onValueChange: s,
      "aria-label": `${c?.title || "Contact us"} menu`
    },
    /* @__PURE__ */ react.createElement(cn, { className: D.contactUsList }, /* @__PURE__ */ react.createElement(ln, { value: Ie }, u ? /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(
      dn,
      {
        className: (0,app_a75c1d35.c)(
          D.contactUsTrigger,
          g && D.contactUsTriggerSelected
        ),
        "aria-label": c?.title || "Contact us",
        onPointerMove: (l) => l.preventDefault(),
        onPointerLeave: (l) => l.preventDefault()
      },
      /* @__PURE__ */ react.createElement(Icon_3122c134.I, { icon: Icon_3122c134.W.CONTACT, size: 24 })
    ), /* @__PURE__ */ react.createElement(
      un,
      {
        className: D.contactUsContent,
        onPointerLeave: (l) => l.preventDefault()
      },
      /* @__PURE__ */ react.createElement(
        qo,
        {
          link: c,
          featured: c.featured,
          i18n: t
        }
      )
    )) : /* @__PURE__ */ react.createElement(j, { asChild: !0 }, /* @__PURE__ */ react.createElement(
      Link_479ac100.L,
      {
        href: c?.href,
        locale: c?.locale,
        target: c?.target,
        className: (0,app_a75c1d35.c)(
          D.contactUsLink,
          g && D.contactUsLinkSelected
        ),
        disableLinkTextStyle: !0,
        title: c?.title,
        "aria-label": c?.title || "Contact us"
      },
      /* @__PURE__ */ react.createElement(Icon_3122c134.I, { icon: Icon_3122c134.W.CONTACT, size: 24 })
    ))))
  );
}
function qo({
  link: e,
  featured: n,
  i18n: t
}) {
  const a = (0,useClickOutside_726e7c36.u)();
  return /* @__PURE__ */ react.createElement(
    "div",
    {
      className: (0,app_a75c1d35.c)(
        D.contactUsDropdown,
        a && D.contactUsDropdownEmployer
      )
    },
    /* @__PURE__ */ react.createElement("div", { className: D.contactUsDropdownHeader }, /* @__PURE__ */ react.createElement(j, { asChild: !0 }, /* @__PURE__ */ react.createElement(
      Link_479ac100.L,
      {
        href: e.href,
        locale: e.locale,
        target: e.target,
        className: D.contactUsDropdownHeaderLink,
        disableLinkTextStyle: !0
      },
      /* @__PURE__ */ react.createElement("span", null, e.title),
      /* @__PURE__ */ react.createElement(Icon_3122c134.I, { icon: Icon_3122c134.W.ARROW_RIGHT, size: 40 })
    )), /* @__PURE__ */ react.createElement("div", { className: D.contactUsDropdownHeaderSeparator })),
    /* @__PURE__ */ react.createElement("div", { className: D.contactUsDropdownBody }, e.subPages?.map((i) => /* @__PURE__ */ react.createElement("div", { key: i.id, className: D.contactUsDropdownSection }, /* @__PURE__ */ react.createElement(j, { asChild: !0 }, /* @__PURE__ */ react.createElement(
      Link_479ac100.L,
      {
        href: i.href,
        locale: i.locale,
        target: i.target,
        className: D.contactUsDropdownSectionLink,
        disableLinkTextStyle: !0
      },
      /* @__PURE__ */ react.createElement("span", null, i.title),
      /* @__PURE__ */ react.createElement(Icon_3122c134.I, { icon: Icon_3122c134.W.ARROW_RIGHT, size: 20 })
    )))), n ? /* @__PURE__ */ react.createElement(Jo, { ...n, i18n: t }) : null)
  );
}
function Jo({
  image: e,
  linkUrl: n,
  title: t,
  i18n: a
}) {
  const { featureArticleText: i = "Feature article", readMoreText: r = "Read more" } = a ?? {};
  return /* @__PURE__ */ react.createElement("div", { className: D.contactUsDropdownFeatured }, /* @__PURE__ */ react.createElement(
    Image_d6406817.I,
    {
      ...e,
      className: D.contactUsDropdownFeaturedImage
    }
  ), /* @__PURE__ */ react.createElement("span", null, i, ": ", t), /* @__PURE__ */ react.createElement(j, { asChild: !0 }, /* @__PURE__ */ react.createElement(
    Link_479ac100.L,
    {
      href: n,
      className: D.contactUsDropdownFeaturedLink
    },
    r
  )));
}
const Qo = "top-bar", Zo = "top-bar__switchLinks", ei = "top-bar__link", ni = "top-bar__link--active", te = {
  topBar: Qo,
  topBarSwitchLinks: Zo,
  topBarLink: ei,
  topBarLinkActive: ni
}, ti = (e) => {
  const { switchLinks: n } = e;
  return /* @__PURE__ */ react.createElement("section", { className: te.topBar }, /* @__PURE__ */ react.createElement("nav", { className: te.topBarSwitchLinks }, n.map((t, a) => /* @__PURE__ */ react.createElement(
    Link_479ac100.L,
    {
      key: t.id,
      href: t.href,
      locale: t.locale,
      className: (0,app_a75c1d35.c)(
        te.topBarLink,
        t.isActive && te.topBarLinkActive
      ),
      disabled: t.isActive,
      disableLinkTextStyle: !0
    },
    a === 0 ? /* @__PURE__ */ react.createElement(Icon_3122c134.I, { icon: Icon_3122c134.W.EMPLOYEE }) : /* @__PURE__ */ react.createElement(Icon_3122c134.I, { icon: Icon_3122c134.W.EMPLOYER }),
    /* @__PURE__ */ react.createElement("span", null, t.title)
  ))));
};
function oi(e) {
  const {
    isSearchDisabled: n,
    links: t,
    logoHref: a,
    onLogoClick: i,
    languagePickerOptions: r,
    isSearchOpen: s,
    onSearchClick: c,
    isMenuOpen: u,
    onMenuClick: g,
    i18n: l,
    switchLinks: p,
    currentPageId: v
  } = e, { headerRef: m, headerClassName: f, isHeaderHidden: k } = si(), C = (0,useClickOutside_726e7c36.u)(), M = t?.filter((I) => I?.id === fe) || [];
  return /* @__PURE__ */ react.createElement(
    Block_9b78bd10.B,
    {
      as: "header",
      blockRef: m,
      className: (0,app_a75c1d35.c)(
        f,
        (u || s) && A.navigationHeaderModalOpen
      ),
      "data-testid": "navigation",
      topPadding: Block_9b78bd10.B.Padding.NONE,
      bottomPadding: Block_9b78bd10.B.Padding.NONE
    },
    /* @__PURE__ */ react.createElement(ti, { switchLinks: p }),
    /* @__PURE__ */ react.createElement(Block_9b78bd10.B.Content, { className: A.navigationHeaderContent }, /* @__PURE__ */ react.createElement(ii, { onClick: i, href: a }), /* @__PURE__ */ react.createElement(
      uo,
      {
        links: t?.filter((I) => I?.id !== fe),
        isNavigationHidden: k,
        currentPageId: v
      }
    ), /* @__PURE__ */ react.createElement("div", { className: A.navigationHeaderActions }, C && M.length > 0 && /* @__PURE__ */ react.createElement(
      Xo,
      {
        links: M,
        isContactUsHidden: k,
        i18n: l,
        currentPageId: v
      }
    ), r ? /* @__PURE__ */ react.createElement(
      dt,
      {
        ...r,
        isNavigationHidden: k,
        i18n: l
      }
    ) : null, n ? null : /* @__PURE__ */ react.createElement(
      ai,
      {
        isSearchOpen: s,
        onSearchClick: c,
        label: l?.searchLabel,
        closeLabel: l?.closeSearchLabel
      }
    ), /* @__PURE__ */ react.createElement(ri, { isMenuOpen: u, onMenuClick: g })))
  );
}
function ii({
  href: e,
  onClick: n
}) {
  const t = (0,useClickOutside_726e7c36.u)();
  return /* @__PURE__ */ react.createElement(
    Link_479ac100.L,
    {
      href: e,
      className: A.navigationHeaderLogo,
      disableLinkTextStyle: !0,
      "data-testid": "navigation-logo",
      title: "Work in Finland logo",
      onClick: n
    },
    /* @__PURE__ */ react.createElement(d, { color: t ? "secondary" : "primary" })
  );
}
function ai({
  isSearchOpen: e,
  onSearchClick: n,
  label: t = "Search",
  closeLabel: a = "Close search"
}) {
  const i = (0,useClickOutside_726e7c36.u)(), r = e ? a : t;
  return /* @__PURE__ */ react.createElement(
    "button",
    {
      type: "button",
      title: r,
      "aria-label": r,
      className: (0,app_a75c1d35.c)(
        A.navigationHeaderSearch,
        i && A.navigationHeaderSearchEmployers
      ),
      onClick: n
    },
    /* @__PURE__ */ react.createElement(Icon_3122c134.I, { icon: e ? Icon_3122c134.W.CLOSE : Icon_3122c134.W.SEARCH, size: 24 })
  );
}
function ri({
  isMenuOpen: e,
  onMenuClick: n
}) {
  const t = (0,useClickOutside_726e7c36.u)();
  return /* @__PURE__ */ react.createElement(
    "button",
    {
      type: "button",
      title: "Menu",
      className: (0,app_a75c1d35.c)(
        A.navigationHeaderMenu,
        t && A.navigationHeaderMenuEmployers
      ),
      onClick: n
    },
    /* @__PURE__ */ react.createElement(Icon_3122c134.I, { icon: e ? Icon_3122c134.W.CLOSE : Icon_3122c134.W.HAMBURGER, size: 20 })
  );
}
function si() {
  const e = (0,react.useRef)(null), n = Pn(e), t = (0,useClickOutside_726e7c36.u)(), a = n === "init", i = n === "down", r = n === "up", s = (0,app_a75c1d35.c)(
    A.navigationHeader,
    app_a75c1d35.t.textsLeadText,
    t && A.navigationHeaderEmployers,
    a && A.navigationHeaderVisible,
    r && A.navigationHeaderShow,
    i && A.navigationHeaderHide
  );
  return { headerRef: e, headerClassName: s, isHeaderHidden: i };
}
const ci = "accordion", li = "accordion__item", di = "accordion__item__heading", ui = "active", gi = "accordion__item__content", vi = "accordion__item__content--expanded", ne = {
  accordion: ci,
  accordionItem: li,
  accordionItemHeading: di,
  active: ui,
  accordionItemContent: gi,
  accordionItemContentExpanded: vi
}, gn = (0,react.createContext)(void 0);
function _i(e = {}, n) {
  const { collapsible: t = !1, multiple: a = !1, defaultActiveId: i } = e, [r, s] = (0,react.useState)(
    () => se(e)
  ), c = (0,react.useMemo)(() => (react.Children.map(n, (m) => {
    if ((0,react.isValidElement)(m))
      return m.props.id;
  }) || []).filter(Boolean), [n]), u = (0,react.useCallback)(
    (v) => {
      s((m) => a ? m.includes(v) ? !t && m.length === 1 ? m : m.filter((f) => f !== v) : [...m, v] : t ? m.includes(v) ? [] : [v] : [v]);
    },
    [t, a]
  ), g = (0,react.useCallback)(() => {
    s(se({ defaultActiveId: i, collapsible: t }));
  }, [i, t]), l = (0,react.useCallback)(
    () => s(
      t ? [] : se({ defaultActiveId: i, collapsible: t })
    ),
    [i, t]
  ), p = (0,react.useCallback)(() => {
    a && s(c);
  }, [a, c]);
  return { activeIds: r, toggleId: u, resetIds: g, collapseAll: l, expandAll: p };
}
function se({
  defaultActiveId: e,
  collapsible: n,
  allIds: t = []
} = {}) {
  if (e)
    return [e];
  if (n)
    return [];
  const a = t[0];
  return a ? [a] : [];
}
function vn({
  id: e,
  heading: n,
  children: t,
  className: a,
  disabled: i
}) {
  const r = (0,react.useContext)(gn);
  if (!r)
    throw new Error("Accordion.Item must be used within Accordion");
  const { activeIds: s, toggleId: c, id: u } = r, g = s.includes(e), l = {
    expanded: g,
    toggleItem: () => c(e)
  }, p = u + "-item-" + e, v = u + "-item-" + e + "-label", m = u + "-item-" + e + "-content";
  return /* @__PURE__ */ react.createElement(
    "div",
    {
      id: p,
      "aria-expanded": g,
      className: (0,app_a75c1d35.c)(ne.accordionItem),
      "data-testid": "accordion-item"
    },
    /* @__PURE__ */ react.createElement(
      "button",
      {
        id: v,
        className: (0,app_a75c1d35.c)(
          ne.accordionItemHeading,
          g && "active",
          i && "disabled"
        ),
        onClick: () => c(e),
        disabled: i,
        "aria-controls": m,
        "aria-expanded": g,
        "data-testid": "accordion-toggler"
      },
      typeof n != "string" ? (0,react.createElement)(n, l) : n
    ),
    /* @__PURE__ */ react.createElement(
      "div",
      {
        id: m,
        className: (0,app_a75c1d35.c)(
          ne.accordionItemContent,
          g && ne.accordionItemContentExpanded,
          a
        ),
        role: "region",
        "aria-labelledby": v,
        "data-testid": "accordion-item-content-expanded"
      },
      t
    )
  );
}
function ke({
  className: e,
  children: n,
  collapsible: t,
  multiple: a,
  defaultActiveId: i,
  ...r
}) {
  Logo_f02d52de_E(n, vn, "Accordion");
  const s = (0,react.useId)(), c = _i(
    {
      collapsible: t,
      multiple: a,
      defaultActiveId: i
    },
    n
  );
  return /* @__PURE__ */ react.createElement(
    "div",
    {
      className: (0,app_a75c1d35.c)(ne.accordion, e),
      ...r,
      "data-testid": "accordion"
    },
    /* @__PURE__ */ react.createElement(
      gn.Provider,
      {
        value: { ...c, id: r.id || s }
      },
      n
    )
  );
}
ke.Item = vn;
const mi = "navigation__switch_link", pi = "navigation__links_section", fi = "navigation__links_section--mobile-only", ki = "desktop", hi = "navigation__links_section__link", Li = "navigation__links_section__link--primary", Ei = "navigation__links_section__link--secondary", wi = "navigation__links_section__link--mobile-only", Si = "navigation__modal", Q = {
  navigationSwitchLink: mi,
  navigationLinksSection: pi,
  navigationLinksSectionMobileOnly: fi,
  desktop: ki,
  navigationLinksSectionLink: hi,
  navigationLinksSectionLinkPrimary: Li,
  navigationLinksSectionLinkSecondary: Ei,
  navigationLinksSectionLinkMobileOnly: wi,
  navigationModal: Si
};
function yi(e) {
  return /* @__PURE__ */ react.createElement(
    "nav",
    {
      key: e.id,
      className: (0,app_a75c1d35.c)(
        Q.navigationLinksSection,
        e.isMobileOnly && Q.navigationLinksSectionMobileOnly
      )
    },
    /* @__PURE__ */ react.createElement(Te, { key: `${e.id}-primary`, ...e, isPrimary: !0 }),
    _n(e).map((n) => /* @__PURE__ */ react.createElement(
      Te,
      {
        key: n.id,
        ...n,
        closeMenu: e.closeMenu
      }
    ))
  );
}
function Te({
  id: e,
  href: n,
  locale: t,
  title: a,
  isPrimary: i,
  isMobileOnly: r,
  closeMenu: s
}) {
  const c = (0,app_a75c1d35.c)(
    Q.navigationLinksSectionLink,
    i ? Q.navigationLinksSectionLinkPrimary : Q.navigationLinksSectionLinkSecondary,
    i ? app_a75c1d35.t.textsLeadTextBold : app_a75c1d35.t.textsLeadText,
    r && Q.navigationLinksSectionLinkMobileOnly
  );
  return /* @__PURE__ */ react.createElement(
    Link_479ac100.L,
    {
      key: e,
      href: n,
      locale: t,
      itemProp: "url",
      className: c,
      disableLinkTextStyle: !0,
      onClick: s
    },
    /* @__PURE__ */ react.createElement("span", { itemProp: "name" }, a),
    /* @__PURE__ */ react.createElement(Icon_3122c134.I, { icon: Icon_3122c134.W.ARROW_RIGHT, size: 20 })
  );
}
function _n(e) {
  return e.subPages?.flatMap((n) => [
    n,
    ..._n(n)
  ]) || [];
}
const Ci = "navigation__switch_link", bi = "navigation__links_section", Mi = "navigation__links_section--mobile-only", xi = "desktop", Ni = "navigation__links_section__link", Di = "navigation__links_section__link--primary", Pi = "navigation__links_section__link--secondary", Ii = "navigation__links_section__link--mobile-only", Ti = "navigation__modal", Ri = "navigation__menu", Oi = "navigation__menu__switchLinks", Hi = "navigation__menu__switchLinks__content", Ai = "navigation__menu__switchLinks__link", Ui = "navigation__menu__switchLinks__link--active", Fi = "navigation__menu__accordion", Bi = "navigation__menu__accordion__heading", Vi = "navigation__menu__accordion__heading__container", $i = "navigation__menu__accordion__heading__link", ji = "navigation__menu__accordion__heading__icon", Ki = "navigation__menu__accordion__content", zi = "navigation__menu__accordion__content--employers", Wi = "navigation__menu__accordion__content__container", Gi = "navigation__menu__footer", Navigation_U = {
  navigationSwitchLink: Ci,
  navigationLinksSection: bi,
  navigationLinksSectionMobileOnly: Mi,
  desktop: xi,
  navigationLinksSectionLink: Ni,
  navigationLinksSectionLinkPrimary: Di,
  navigationLinksSectionLinkSecondary: Pi,
  navigationLinksSectionLinkMobileOnly: Ii,
  navigationModal: Ti,
  navigationMenu: Ri,
  navigationMenuSwitchLinks: Oi,
  navigationMenuSwitchLinksContent: Hi,
  navigationMenuSwitchLinksLink: Ai,
  navigationMenuSwitchLinksLinkActive: Ui,
  navigationMenuAccordion: Fi,
  navigationMenuAccordionHeading: Bi,
  navigationMenuAccordionHeadingContainer: Vi,
  navigationMenuAccordionHeadingLink: $i,
  navigationMenuAccordionHeadingIcon: ji,
  navigationMenuAccordionContent: Ki,
  navigationMenuAccordionContentEmployers: zi,
  navigationMenuAccordionContentContainer: Wi,
  navigationMenuFooter: Gi
};
function Yi(e) {
  const { links: n = [], closeMenu: t, switchLinks: a, currentPageId: i } = e, r = g(), s = (0,useClickOutside_726e7c36.u)();
  return /* @__PURE__ */ react.createElement(
    useModal_4683a76a.M,
    {
      className: Navigation_U.navigationMenu,
      "data-testid": "menu-mobile",
      modalRef: r,
      closeModal: t
    },
    /* @__PURE__ */ react.createElement(Xi, { switchLinks: a, closeMenu: t }),
    /* @__PURE__ */ react.createElement(
      ke,
      {
        className: Navigation_U.navigationMenuAccordion,
        defaultActiveId: i || n?.[0]?.id,
        collapsible: !0,
        "data-testid": "menu-mobile-accordion"
      },
      n?.filter((c) => c?.id !== fe)?.map(({ id: c, title: u, href: g, locale: l, subPages: p = [] }) => {
        const v = p.length === 0;
        return /* @__PURE__ */ react.createElement(
          ke.Item,
          {
            key: c,
            id: c,
            disabled: v,
            heading: ({ expanded: m }) => /* @__PURE__ */ react.createElement(
              qi,
              {
                expanded: m,
                href: g,
                locale: l,
                closeMenu: t,
                hideIcon: v
              },
              u
            )
          },
          v ? null : /* @__PURE__ */ react.createElement(
            Block_9b78bd10.B,
            {
              className: (0,app_a75c1d35.c)(
                Navigation_U.navigationMenuAccordionContent,
                s && Navigation_U.navigationMenuAccordionContentEmployers
              ),
              topPadding: Block_9b78bd10.B.Padding.NONE,
              bottomPadding: Block_9b78bd10.B.Padding.NONE
            },
            /* @__PURE__ */ react.createElement(
              Block_9b78bd10.B.Content,
              {
                className: Navigation_U.navigationMenuAccordionContentContainer
              },
              p.map((m) => /* @__PURE__ */ react.createElement(
                yi,
                {
                  key: m.id,
                  ...m,
                  closeMenu: t
                }
              ))
            )
          )
        );
      })
    )
  );
}
const Xi = ({
  switchLinks: e,
  closeMenu: n
}) => /* @__PURE__ */ react.createElement(
  Block_9b78bd10.B,
  {
    topPadding: Block_9b78bd10.B.Padding.NONE,
    bottomPadding: Block_9b78bd10.B.Padding.NONE,
    className: Navigation_U.navigationMenuSwitchLinks
  },
  /* @__PURE__ */ react.createElement(Block_9b78bd10.B.Content, { flex: !0, className: Navigation_U.navigationMenuSwitchLinksContent }, e.map((t) => /* @__PURE__ */ react.createElement(
    Link_479ac100.L,
    {
      key: t.id,
      href: t.href,
      onClick: t.isActive ? void 0 : n,
      className: (0,app_a75c1d35.c)(
        Navigation_U.navigationMenuSwitchLinksLink,
        t.isActive && Navigation_U.navigationMenuSwitchLinksLinkActive
      ),
      disabled: t.isActive,
      disableLinkTextStyle: !0,
      itemProp: "url"
    },
    /* @__PURE__ */ react.createElement("span", { itemProp: "name" }, t.title)
  )))
);
function qi({
  expanded: e,
  children: n,
  href: t,
  locale: a,
  closeMenu: i,
  hideIcon: r
}) {
  return /* @__PURE__ */ react.createElement(Block_9b78bd10.B, { className: Navigation_U.navigationMenuAccordionHeading }, /* @__PURE__ */ react.createElement(
    Block_9b78bd10.B.Content,
    {
      flex: !0,
      className: Navigation_U.navigationMenuAccordionHeadingContainer
    },
    /* @__PURE__ */ react.createElement(
      Link_479ac100.L,
      {
        href: t,
        onClick: i,
        locale: a,
        title: n,
        disableLinkTextStyle: !0,
        className: (0,app_a75c1d35.c)(
          Navigation_U.navigationMenuAccordionHeadingLink,
          e ? app_a75c1d35.t.headingSection : app_a75c1d35.t.headingMenu
        ),
        itemProp: "url"
      },
      /* @__PURE__ */ react.createElement("span", { itemProp: "name" }, n)
    ),
    r ? null : /* @__PURE__ */ react.createElement(
      Icon_3122c134.I,
      {
        className: Navigation_U.navigationMenuAccordionHeadingIcon,
        icon: e ? Icon_3122c134.W.CHEVRON_UP : Icon_3122c134.W.CHEVRON_DOWN,
        size: 16
      }
    )
  ));
}
const Ji = "navigation__switch_link", Qi = "navigation__links_section", Zi = "navigation__links_section--mobile-only", ea = "desktop", na = "navigation__links_section__link", ta = "navigation__links_section__link--primary", oa = "navigation__links_section__link--secondary", ia = "navigation__links_section__link--mobile-only", aa = "navigation__modal", ra = "navigation__search", sa = "navigation__search__content", ca = "navigation__search__input", la = "navigation__search__input__label", da = "navigation__search__input__row", ua = "navigation__search__input__button", ga = "navigation__search__input__field", G = {
  navigationSwitchLink: Ji,
  navigationLinksSection: Qi,
  navigationLinksSectionMobileOnly: Zi,
  desktop: ea,
  navigationLinksSectionLink: na,
  navigationLinksSectionLinkPrimary: ta,
  navigationLinksSectionLinkSecondary: oa,
  navigationLinksSectionLinkMobileOnly: ia,
  navigationModal: aa,
  navigationSearch: ra,
  navigationSearchContent: sa,
  navigationSearchInput: ca,
  navigationSearchInputLabel: la,
  navigationSearchInputRow: da,
  navigationSearchInputButton: ua,
  navigationSearchInputField: ga
};
function va({
  defaultKeyword: e = "",
  closeSearch: n,
  renderContent: t,
  label: a,
  placeholder: i,
  clearLabel: r
}) {
  const s = g(), [c, u] = (0,react.useState)(e);
  return /* @__PURE__ */ react.createElement(
    useModal_4683a76a.M,
    {
      className: G.navigationSearch,
      "data-testid": "search",
      modalRef: s,
      closeModal: n
    },
    /* @__PURE__ */ react.createElement(Block_9b78bd10.B, { topPadding: Block_9b78bd10.a.NONE, bottomPadding: Block_9b78bd10.a.NONE }, /* @__PURE__ */ react.createElement(Block_9b78bd10.B.Content, { className: G.navigationSearchContent }, /* @__PURE__ */ react.createElement(
      _a,
      {
        onChange: u,
        defaultValue: e,
        label: a,
        placeholder: i,
        clearLabel: r
      }
    ))),
    t({ keyword: c, closeModal: n })
  );
}
function _a({
  onChange: e,
  defaultValue: n,
  placeholder: t = "For example: residence permit, housing, jobs",
  label: a = "Search the Work in Finland website",
  clearLabel: i = "Clear search"
}) {
  const r = (0,react.useId)(), [s, c] = (0,react.useState)(n), [, u] = (0,react.useTransition)(), g = (0,react.useRef)(null), l = s.length > 0, p = (0,react.useCallback)(() => {
    c(""), g.current?.focus();
  }, []);
  return (0,react.useEffect)(() => {
    u(() => e(s));
  }, [e, s]), (0,react.useEffect)(() => {
    g.current?.focus();
  }, []), /* @__PURE__ */ react.createElement(
    "div",
    {
      className: (0,app_a75c1d35.c)(G.navigationSearchInput),
      "data-testid": "search-input"
    },
    /* @__PURE__ */ react.createElement(
      "label",
      {
        htmlFor: r,
        className: (0,app_a75c1d35.c)(
          G.navigationSearchInputLabel,
          app_a75c1d35.t.textsCaption
        )
      },
      a
    ),
    /* @__PURE__ */ react.createElement("div", { className: G.navigationSearchInputRow }, /* @__PURE__ */ react.createElement(
      "button",
      {
        type: "button",
        title: l ? i : a,
        "aria-label": l ? i : a,
        onClick: p,
        "data-testid": "search-input-button",
        className: G.navigationSearchInputButton
      },
      /* @__PURE__ */ react.createElement(Icon_3122c134.I, { icon: l ? Icon_3122c134.W.CLOSE : Icon_3122c134.W.SEARCH, size: 24 })
    ), /* @__PURE__ */ react.createElement(
      "input",
      {
        id: r,
        type: "text",
        ref: g,
        value: s,
        onChange: (v) => c(v.target.value),
        placeholder: t,
        "data-testid": "search-input-field",
        className: (0,app_a75c1d35.c)(
          G.navigationSearchInputField,
          app_a75c1d35.t.textsComponentTitle
        )
      }
    ))
  );
}
function Pa(e) {
  const {
    isMenuOpen: n,
    isSearchOpen: t,
    toggleMenuOpen: a,
    toggleSearchOpen: i,
    closeMenu: r,
    closeSearch: s,
    closeAllModals: c
  } = ma();
  return /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(
    oi,
    {
      ...e,
      isMenuOpen: n,
      onMenuClick: a,
      isSearchOpen: t,
      onSearchClick: i,
      onLogoClick: c
    }
  ), n ? /* @__PURE__ */ react.createElement(
    Yi,
    {
      links: e.links,
      switchLinks: e.switchLinks,
      closeMenu: r,
      currentPageId: e.currentPageId
    }
  ) : null, t ? /* @__PURE__ */ react.createElement(
    va,
    {
      closeSearch: s,
      renderContent: e.searchContent,
      defaultKeyword: e.defaultSearchKeyword,
      label: e.i18n?.searchLabel,
      placeholder: e.i18n?.searchPlaceholder,
      clearLabel: e.i18n?.clearSearchLabel
    }
  ) : null);
}
function ma() {
  const e = (0,react.useRef)(void 0), n = (0,react.useRef)(void 0), {
    isModalOpen: t,
    toggleModalOpen: a,
    closeModal: i
  } = (0,useModal_4683a76a.u)({ onOpen: e.current }), {
    isModalOpen: r,
    toggleModalOpen: s,
    closeModal: c
  } = (0,useModal_4683a76a.u)({ onOpen: n.current });
  n.current = i, e.current = c;
  const u = (0,react.useCallback)(() => {
    i(), c();
  }, [i, c]);
  return {
    isMenuOpen: t,
    isSearchOpen: r,
    toggleMenuOpen: a,
    toggleSearchOpen: s,
    closeMenu: i,
    closeSearch: c,
    closeAllModals: u
  };
}

//# sourceMappingURL=Navigation.js.map

;// CONCATENATED MODULE: ./src/components/Navigation/Navigation.tsx













var SearchContent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9501), __webpack_require__.e(8634), __webpack_require__.e(808), __webpack_require__.e(4587)]).then(__webpack_require__.bind(__webpack_require__, 4587));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4587)
            ];
        }
    },
    ssr: false
});
function Navigation(param) {
    var links = param.links, switchLinks = param.switchLinks;
    var t = (0,esm/* useTranslation */.$G)().t;
    var isMobile = (0,ViewportContext/* default */.Z)().isMobile;
    var i18n = (0,react.useMemo)(function() {
        return {
            featureArticleText: t("navigation.featureArticle"),
            readMoreText: t("navigation.readMore"),
            selectLanguageLabel: t("navigation.selectLanguage"),
            searchLabel: t("search.label"),
            searchPlaceholder: t("search.placeholder"),
            clearSearchLabel: t("search.clear"),
            closeSearchLabel: t("search.close")
        };
    }, [
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Pa, {
        logoHref: useLogoHref(),
        links: links,
        switchLinks: switchLinks,
        languagePickerOptions: useLanguagePicker(),
        currentPageId: useCurrentPageId(links),
        searchContent: renderSearchContent,
        i18n: i18n,
        isSearchDisabled: false,
        isMobile: isMobile
    });
}
function renderSearchContent(args) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
        fallback: null,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchContent, (0,_object_spread/* default */.Z)({}, args))
    });
}
function useLogoHref() {
    var isEmployerSite = (0,EmployerSiteContext/* default */.Z)().isEmployerSite;
    return (0,util_magnolia/* formatPageLink */.Jd)(isEmployerSite ? magnolia/* MGNL.EMPLOYERS_NODE */.m.EMPLOYERS_NODE : magnolia/* MGNL.ROOT_NODE */.m.ROOT_NODE);
}
function useCurrentPageId(links) {
    var asPath = (0,next_router.useRouter)().asPath;
    var page = (0,react.useMemo)(function() {
        return links === null || links === void 0 ? void 0 : links.find(function(param) {
            var href = param.href;
            return asPath.startsWith(href);
        });
    }, [
        asPath,
        links
    ]);
    return page === null || page === void 0 ? void 0 : page.id;
}
function useLanguagePicker() {
    var isEmployerSite = (0,EmployerSiteContext/* default */.Z)().isEmployerSite;
    var ref = (0,next_router.useRouter)(), _locale = ref.locale, locale = _locale === void 0 ? constants_locale/* defaultLocale */.al : _locale, _locales = ref.locales, locales = _locales === void 0 ? [] : _locales, asPath = ref.asPath;
    var ref1;
    var getLocaleName = (0,react.useCallback)(function(code) {
        var ref;
        return (ref1 = (ref = Object.entries(constants_locale/* Locale */.go).find(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
            return value === code;
        })) === null || ref === void 0 ? void 0 : ref[0]) !== null && ref1 !== void 0 ? ref1 : code;
    }, []);
    var languagePicker = (0,react.useMemo)(function() {
        var availableLanguages = locales.filter(function(l) {
            return l !== "default";
        }).map(function(code) {
            return {
                code: code,
                label: getLocaleName(code)
            };
        });
        return {
            currentLanguage: locale,
            availableLanguages: availableLanguages,
            currentUrlPath: asPath
        };
    }, [
        asPath,
        locale,
        locales,
        getLocaleName
    ]);
    return isEmployerSite ? languagePicker : null;
}

;// CONCATENATED MODULE: ./src/components/Layout/RouteProgressBar.tsx
/* istanbul ignore file */ 



function RouteProgressBar() {
    var elementRef = useProgressElement();
    var isEmployerSite = (0,EmployerSiteContext/* default */.Z)().isEmployerSite;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "progress-bar-container",
        role: "none",
        style: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            zIndex: 1000,
            display: "flex",
            height: "2px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: elementRef,
            id: "progress-bar",
            role: "none",
            style: {
                background: isEmployerSite ? "var(--color-white)" : "var(--color-primary-700)",
                transition: "width 300ms ease-out"
            }
        })
    });
}
function useProgressElement() {
    var ref = (0,react.useTransition)(), startTransition = ref[1];
    var elementRef = (0,react.useRef)(null);
    var timeout = (0,react.useRef)();
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    (0,react.useEffect)(function() {
        var startLoading = function() {
            return startTransition(function() {
                return setIsLoading(true);
            });
        };
        var stopLoading = function() {
            return startTransition(function() {
                return setIsLoading(false);
            });
        };
        router.events.on("routeChangeStart", startLoading);
        router.events.on("routeChangeComplete", stopLoading);
        router.events.on("routeChangeError", stopLoading);
        return function() {
            router.events.off("routeChangeStart", startLoading);
            router.events.off("routeChangeComplete", stopLoading);
            router.events.off("routeChangeError", stopLoading);
        };
    }, [
        router
    ]);
    var setElementWidth = (0,react.useCallback)(function(width) {
        var element = elementRef.current;
        if (!element) return;
        element.style.width = width.toString();
        element.dataset.value = width.toString();
    }, []);
    var updateWidth = (0,react.useCallback)(function(ms) {
        var element = elementRef.current;
        if (!element) return;
        timeout.current = setTimeout(function() {
            var width = parseFloat(element.style.width);
            var percent = !isNaN(width) ? 10 + 0.9 * width : 0;
            setElementWidth("".concat(percent, "%"));
            updateWidth(100);
        }, ms);
    }, [
        setElementWidth
    ]);
    (0,react.useEffect)(function() {
        if (!isLoading || !elementRef.current) return;
        if (timeout.current) clearTimeout(timeout.current);
        var element = elementRef.current;
        setElementWidth("0%");
        updateWidth(300);
        return function() {
            if (timeout.current) clearTimeout(timeout.current);
            if (element.style.width === "0%") return;
            setElementWidth("100%");
            timeout.current = setTimeout(function() {
                if ((element === null || element === void 0 ? void 0 : element.style.width) !== "100%") return;
                setElementWidth("");
            }, 200);
        };
    }, [
        isLoading,
        updateWidth,
        setElementWidth
    ]);
    return elementRef;
}

// EXTERNAL MODULE: ./src/components/Layout/Layout.module.scss
var Layout_module = __webpack_require__(4375);
var Layout_module_default = /*#__PURE__*/__webpack_require__.n(Layout_module);
;// CONCATENATED MODULE: ./src/components/Layout/Layout.tsx






















function Layout(props) {
    var links = props.links, children = props.children, _isEmployerSite = props.isEmployerSite, isEmployerSite = _isEmployerSite === void 0 ? false : _isEmployerSite, page = props.page;
    var themeProviderConfig = (0,react.useMemo)(function() {
        return {
            themes: [
                "default",
                "employer"
            ],
            defaultTheme: isEmployerSite ? "employer" : "default",
            forcedTheme: isEmployerSite ? "employer" : "default",
            enableSystem: false,
            disableTransitionOnChange: true
        };
    }, [
        isEmployerSite
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadTags, (0,_object_spread/* default */.Z)({}, props)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmployerSiteContext/* EmployerSiteContextProvider */.N, {
                value: {
                    isEmployerSite: isEmployerSite
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewportContext/* ViewportContextProvider */.L, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageContentContextProvider, {
                        value: page,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(s, {
                            LinkComponent: (link_default()),
                            ImageComponent: (image_default()),
                            isEmployerSite: isEmployerSite,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(J, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, themeProviderConfig), {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RouteProgressBar, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation, {
                                        links: links.primary,
                                        switchLinks: links.switchLinks
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                                        className: (Layout_module_default()).layout,
                                        children: children
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, (0,_object_spread/* default */.Z)({}, links))
                                ]
                            }))
                        })
                    })
                })
            })
        ]
    });
}
function HeadTags(param) {
    var title = param.title, isEmployerSite = param.isEmployerSite, page = param.page, isHomepage = param.isHomepage, schemaJsonLd = param.schemaJsonLd, _metaNoIndex = param.metaNoIndex, metaNoIndex = _metaNoIndex === void 0 ? false : _metaNoIndex, _metaNoFollow = param.metaNoFollow, metaNoFollow = _metaNoFollow === void 0 ? false : _metaNoFollow;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,next_router.useRouter)(), locale = ref5.locale, asPath = ref5.asPath, isPreview = ref5.isPreview;
    var metaTitle = isHomepage ? title : "".concat(title).concat(app/* META_TITLE_SUFFIX */.A_);
    var description = (page === null || page === void 0 ? void 0 : page.metaDescription) || (page === null || page === void 0 ? void 0 : page.description);
    var canonicalUrl = "".concat(app/* __APP_HOST_PUBLIC__ */.jT, "/").concat(locale).concat(asPath);
    var ogLocale = locale ? constants_locale/* ogLocaleMap */.EW[locale] : undefined;
    var alternateLocales = (isEmployerSite ? constants_locale/* localesEmployers */.HG : constants_locale/* localesTalent */.Vb).filter(function(l) {
        return l !== locale;
    });
    var ogImage = (page === null || page === void 0 ? void 0 : (ref = page.introductionImage) === null || ref === void 0 ? void 0 : (ref1 = ref.renditions) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.xs) === null || ref2 === void 0 ? void 0 : ref2.link) || (page === null || page === void 0 ? void 0 : (ref3 = page.introductionImage) === null || ref3 === void 0 ? void 0 : ref3["@link"]);
    var ogType = (page === null || page === void 0 ? void 0 : page["mgnl:template"]) === magnolia_config/* MagnoliaTemplate.PageArticle */.gM.PageArticle || (page === null || page === void 0 ? void 0 : page["mgnl:template"]) === magnolia_config/* MagnoliaTemplate.PageEvent */.gM.PageEvent ? "article" : "website";
    var mgnlPageEditorStylesheet = isPreview // only needed in Mgnl Editor
     ? "".concat(magnolia/* MGNL.BASE_URL */.m.BASE_URL(isPreview), "/VAADIN/themes/pages-app/page-editor.css") : undefined;
    var follow = app/* __IS_LIVE_SITE__ */.tB && !metaNoFollow ? "follow" : "nofollow";
    var index = app/* __IS_LIVE_SITE__ */.tB && !metaNoIndex ? "index" : "noindex";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: metaTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preconnect",
                href: magnolia/* MGNL.HOST */.m.HOST(isPreview)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "keywords",
                content: page === null || page === void 0 ? void 0 : (ref4 = page.keywords) === null || ref4 === void 0 ? void 0 : ref4.join(", ")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "msvalidate.01",
                content: "74D640CD1F31D68F74FEE432FDD5A501"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "robots",
                content: "".concat(index, ", ").concat(follow)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "googlebot",
                content: "".concat(index, ", ").concat(follow)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "AddSearchBot",
                content: "".concat(index, ", ").concat(follow)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:site_name",
                content: app/* META_TITLE_SUFFIX.replace */.A_.replace("-", "").trim()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:url",
                content: canonicalUrl
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:locale",
                content: ogLocale
            }),
            alternateLocales.map(function(l) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    property: "og:locale:alternate",
                    content: constants_locale/* ogLocaleMap */.EW[l]
                }, l);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:type",
                content: ogType
            }),
            ogImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: (0,util_magnolia/* formatAssetLink */.Qz)(ogImage, isPreview)
            }),
            mgnlPageEditorStylesheet && /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "stylesheet",
                href: mgnlPageEditorStylesheet
            }),
            schemaJsonLd && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                nonce: "5274deac-df2c-4405-9816-123c1b001d19",
                dangerouslySetInnerHTML: {
                    __html: schemaJsonLd
                }
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/pages/_app.tsx







function MyApp(param) {
    var Component = param.Component, pageProps = param.pageProps;
    var page = pageProps.page, title = pageProps.title, _isEmployerSite = pageProps.isEmployerSite, isEmployerSite = _isEmployerSite === void 0 ? false : _isEmployerSite, navLinks = pageProps.navLinks, schemaJsonLd = pageProps.schemaJsonLd;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
        title: title,
        links: navLinks,
        page: page,
        isHomepage: (page === null || page === void 0 ? void 0 : page["@path"]) === magnolia/* MGNL.ROOT_NODE */.m.ROOT_NODE,
        isEmployerSite: isEmployerSite,
        schemaJsonLd: schemaJsonLd,
        metaNoIndex: !!(page === null || page === void 0 ? void 0 : page.noindex),
        metaNoFollow: !!(page === null || page === void 0 ? void 0 : page.nofollow),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, pageProps))
    });
}
/* harmony default export */ var _app = ((0,esm/* appWithTranslation */.Jc)(MyApp));


/***/ }),

/***/ 4770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ resolveCmsBackgroundColor; },
/* harmony export */   "I_": function() { return /* binding */ uiBackgroundColorHex; },
/* harmony export */   "Kk": function() { return /* binding */ resolveJobsPageBackgroundColor; }
/* harmony export */ });
var UI_BACKGROUND_HEX = {
    white: "#ffffff",
    lightBlue: "#f1f8ff",
    gray: "#f5f5f5"
};
function resolveCmsBackgroundColor(backgroundColor, isEmployerSite) {
    var missing = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : undefined;
    if (backgroundColor === "white") return "white";
    if (backgroundColor === "color") {
        return isEmployerSite ? "gray" : "lightBlue";
    }
    return missing;
}
/** Jobs pages: CMS "color" is Light blue for header + list, never gray. */ function resolveJobsPageBackgroundColor(backgroundColor) {
    if (backgroundColor === "white") return "white";
    if (backgroundColor === "color") return "lightBlue";
    return undefined;
}
function uiBackgroundColorHex(color, fallback) {
    return color ? UI_BACKGROUND_HEX[color] : fallback;
}


/***/ }),

/***/ 7581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "lJ": function() { return /* binding */ filterUniqueMgnlNodesPredicate; },
  "Qz": function() { return /* binding */ formatAssetLink; },
  "Jd": function() { return /* binding */ formatPageLink; },
  "dA": function() { return /* binding */ generateErrorResult; },
  "K3": function() { return /* binding */ getAssetPath; },
  "FE": function() { return /* binding */ jcrMultiFieldToArray; },
  "cJ": function() { return /* binding */ resolveLinkSwitchableField; },
  "gA": function() { return /* binding */ setURLSearchParams; }
});

// UNUSED EXPORTS: extractLocaleDataFromNode, extractUuidListFromMgnlNodeTree, findNodeFromMgnlNodeWithUUID, formatMgnlNodePath, generateCompanyServiceLabel, generateMgnlSystemNodeProperties, generateMgnlSystemNodeProperty, isValidMgnlUUID, removeMetadataPropertiesFromMgnlNode, removePropertiesFromMgnlNode, transformMgnlServiceNodesToWifServices, traverseMgnlNodeTree

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var src_sliced_to_array = __webpack_require__(2050);
// EXTERNAL MODULE: ./src/constants/magnolia.ts + 1 modules
var magnolia = __webpack_require__(5056);
;// CONCATENATED MODULE: ./src/types/wif-next.ts
var LinkSwitchableType;
(function(LinkSwitchableType) {
    LinkSwitchableType["Magnolia"] = "magnolia";
    LinkSwitchableType["External"] = "external";
})(LinkSwitchableType || (LinkSwitchableType = {}));

;// CONCATENATED MODULE: ./src/util/magnolia.ts








function jcrMultiFieldToArray(jcrMultiField) {
    return ((jcrMultiField === null || jcrMultiField === void 0 ? void 0 : jcrMultiField["@nodes"]) || []).map(function(n) {
        return jcrMultiField[n];
    }).filter(Boolean);
}
function formatAssetLink(url) {
    var isPreview = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return magnolia/* MGNL.HOST */.m.HOST(isPreview) + url;
}
/**
 * @param url string
 * @param isPreview boolean
 * @returns string
 */ function formatPageLink(url, isPreview, anchorTag) {
    var hash = anchorTag ? "#".concat(anchorTag) : "";
    if (!url) return hash;
    if (!isPreview) {
        if (url === magnolia/* MGNL.ROOT_NODE */.m.ROOT_NODE) {
            return "/" + hash;
        } else {
            return url.replace(magnolia/* MGNL.ROOT_NODE */.m.ROOT_NODE, "") + hash;
        }
    }
    return url + hash;
}
function setURLSearchParams(uri, params) {
    var url = new URL(uri);
    Object.entries(params).forEach(function(param) {
        var _param = (0,src_sliced_to_array/* default */.Z)(param, 2), name = _param[0], value = _param[1];
        if (value) url.searchParams.set(name, value);
    });
    return url.toString();
}
function getAssetPath(asset) {
    var isPreview = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (asset && asset["@link"]) {
        return magnolia/* MGNL.HOST */.m.HOST(isPreview) + asset["@link"];
    }
    return "";
}
/**
 * Traverse a Magnolia node till the last subnode.
 * @param node The Mgnl.Node to traverse.
 * @param predicate The callback function with receives current node, parentNode and depth.
 *
 * @example
 * ```ts
 * const pageNode: Wif.Mgnl.Page = {...};
 * traverseMgnlNodeTree(pageNode, (node, parentNode) => {...})
 * ```
 */ function traverseMgnlNodeTree(node, predicate, parentNode) {
    return _traverseMgnlNodeTree.apply(this, arguments);
}
function _traverseMgnlNodeTree() {
    _traverseMgnlNodeTree = _async_to_generator(function(node, predicate, parentNode) {
        var currentDepth, previousResult, result, nodeList;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    currentDepth = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : 0, previousResult = _arguments.length > 4 ? _arguments[4] : void 0;
                    return [
                        4,
                        predicate(node, parentNode, currentDepth, previousResult)
                    ];
                case 1:
                    result = _state.sent();
                    if (result === null) return [
                        2
                    ];
                    nodeList = (node === null || node === void 0 ? void 0 : node["@nodes"]) || [];
                    if (!(nodeList && Array.isArray(nodeList))) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        Promise.all(nodeList.map(function(nodeName) {
                            return traverseMgnlNodeTree(node[nodeName], predicate, node, currentDepth + 1, result);
                        }))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _traverseMgnlNodeTree.apply(this, arguments);
}
/**
 * Extract a list of uuid in the provided Mgnl node
 * @param node Mgnl Node/Page/NavPage
 * @param matchPredicate Filter nodes that should be tested. Leave undefined for all nodes.
 * @param fields List of fields to test in a node. Default ["@id"];
 * @param existingUuidList List of existing uuid list. These uuid are ignored from returned list.
 * @returns A list of UUID.
 *
 * @example
 * ```ts
 * const uuidList = extractUuidListFromMgnlNodeTree(
 *  pageNode,
 *  (node) => node["@nodes"].length > 0,
 *  ["page", "field"],
 *  ["e3ea7c3b-2ef1-463a-9895-9ef53e28401", "e3ea7c3b-2ef1-463a-9895-9ef53e28439"]
 * )
 * ```
 */ function extractUuidListFromMgnlNodeTree(node, matchPredicate) {
    return _extractUuidListFromMgnlNodeTree.apply(this, arguments);
}
function _extractUuidListFromMgnlNodeTree() {
    _extractUuidListFromMgnlNodeTree = _async_to_generator(function(node, matchPredicate) {
        var fields, existingUuidList, uuidList;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    fields = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : [
                        "@id"
                    ], existingUuidList = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : [];
                    if (fields.length === 0) return [
                        2,
                        []
                    ];
                    uuidList = new Set();
                    return [
                        4,
                        traverseMgnlNodeTree(node, function(node, parentNode, depth) {
                            if (typeof node !== "object") return;
                            if (!matchPredicate || matchPredicate(node, parentNode, depth)) {
                                fields.forEach(function(field) {
                                    if (field in node) {
                                        var uuid = node[field];
                                        if (isValidMgnlUUID(uuid) && !existingUuidList.includes(uuid)) {
                                            uuidList.add(uuid);
                                        }
                                    }
                                });
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        _to_consumable_array(uuidList)
                    ];
            }
        });
    });
    return _extractUuidListFromMgnlNodeTree.apply(this, arguments);
}
function isValidMgnlUUID(uuid) {
    // e3ea7c3b-2ef1-463a-9895-9ef53e28439
    // e3ea7c3b-2ef1-463a-9895-9ef53e284395
    return Boolean(typeof uuid === "string" && uuid.split("-").length === 5);
}
function filterUniqueMgnlNodesPredicate(node, index, nodes) {
    return index === nodes.findIndex(function(n) {
        return n["@id"] === node["@id"];
    });
}
function removeMetadataPropertiesFromMgnlNode(node) {
    for(var _len = arguments.length, metaProperties = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        metaProperties[_key - 1] = arguments[_key];
    }
    Object.values(node).forEach(function(property) {
        if (property && typeof property === "object" && "metadata" in property) {
            metaProperties.forEach(function(metaProperty) {
                if (metaProperty in property.metadata) {
                    delete property.metadata[metaProperty];
                }
            });
        }
    });
}
function removePropertiesFromMgnlNode(node) {
    for(var _len = arguments.length, properties = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        properties[_key - 1] = arguments[_key];
    }
    return traverseObjectProperties(node, properties, function(_, obj, prop) {
        delete obj[prop];
    }, false);
}
/**
 * Format path based on target language and parent node's path.
 */ function formatMgnlNodePath(node, parentPath) {
    var targetLang = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultLocale, rootNodePath = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : MGNL.ROOT_NODE;
    var ref;
    if (targetLang === defaultLocale) return ((ref = node["@path"]) === null || ref === void 0 ? void 0 : ref.replace(rootNodePath, "")) || "/";
    if (!parentPath) return "/";
    var slug = node["slug_".concat(targetLang)] || node["@name"];
    return "".concat(parentPath, "/").concat(slug).replace("//", "/").replace(MGNL.ROOT_NODE, "");
}
function findNodeFromMgnlNodeWithUUID(mgnlNode, uuid) {
    return _findNodeFromMgnlNodeWithUUID.apply(this, arguments);
}
function _findNodeFromMgnlNodeWithUUID() {
    _findNodeFromMgnlNodeWithUUID = _async_to_generator(function(mgnlNode, uuid) {
        var matchingNode;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        traverseMgnlNodeTree(mgnlNode, function(node) {
                            if (node["@id"] === uuid) {
                                matchingNode = node;
                                return null;
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        matchingNode
                    ];
            }
        });
    });
    return _findNodeFromMgnlNodeWithUUID.apply(this, arguments);
}
/** Generate property that can be attached to MgnlSystemNode */ function generateMgnlSystemNodeProperty(name, value) {
    var type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "String";
    var multiple = Array.isArray(value);
    var values = multiple ? value : [
        value
    ];
    return {
        name: name,
        values: values,
        type: type,
        multiple: multiple
    };
}
function generateMgnlSystemNodeProperties(entries) {
    var properties = [];
    Object.entries(entries).forEach(function(param) {
        var _param = _sliced_to_array(param, 2), name = _param[0], entry = _param[1];
        if (!entry) return;
        if (typeof entry === "object" && "value" in entry) {
            return properties.push(generateMgnlSystemNodeProperty(name, entry.value, entry.type));
        }
        return properties.push(generateMgnlSystemNodeProperty(name, entry));
    });
    return properties;
}
function transformMgnlServiceNodesToWifServices(services, lang) {
    return (services || []).filter(function(node) {
        return node && typeof node === "object" && node["@id"];
    }).map(function(serviceNode) {
        return {
            value: serviceNode["@id"],
            label: generateCompanyServiceLabel(serviceNode, lang)
        };
    });
}
function generateCompanyServiceLabel(service, lang) {
    var fallback = service.name || service["@name"] || "";
    if (lang === Locale.Suomi) return service.nameFi || fallback;
    if (lang === Locale.Svenska) return service.nameSv || fallback;
    return fallback;
}
function extractLocaleDataFromNode(node, lang, property) {
    var defaultValue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    var fallback = node["".concat(property, "-fi")] || defaultValue;
    if (lang === Locale.English) return node["".concat(property, "-en")] || fallback;
    if (lang === Locale.Svenska) return node["".concat(property, "-sv")] || fallback;
    return fallback;
}
function generateErrorResult() {
    return {
        limit: 0,
        offset: 0,
        total: 0,
        results: []
    };
}
function resolveLinkSwitchableField(link, isPreview) {
    var fallback = {
        isExternalLink: true,
        linkHref: ""
    };
    if (link) {
        if (link.field === LinkSwitchableType.Magnolia && link.wifLinkMagnoliaPage) {
            var page = link.wifLinkMagnoliaPage;
            // Unpublished pages stay as plain UUID strings in the delivery API
            if (!page || typeof page !== "object") {
                return fallback;
            }
            var pagePath = normaliseMagnoliaPagePath(page["@path"]);
            if (!pagePath || page["mgnl:activationStatus"] === false || page["mgnl:template"] === "pages-app:deleted") {
                return fallback;
            }
            var href = formatPageLink(pagePath, isPreview, link.wifLinkAnchorTag);
            return {
                isExternalLink: false,
                linkHref: href
            };
        }
        if (link.field === LinkSwitchableType.External && link.wifLinkExternalUrl) {
            var _wifLinkExternalUrl;
            return {
                isExternalLink: true,
                linkHref: formatPageLink((_wifLinkExternalUrl = link.wifLinkExternalUrl) !== null && _wifLinkExternalUrl !== void 0 ? _wifLinkExternalUrl : "", isPreview)
            };
        }
    }
    return fallback;
}
function normaliseMagnoliaPagePath(path) {
    if (!path) return "";
    return path.split("/variants/")[0];
}


/***/ }),

/***/ 5625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ getViewportByWindowWidth; },
/* harmony export */   "s": function() { return /* binding */ optimiseViewport; }
/* harmony export */ });
/* harmony import */ var _constants_app__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5884);

var getViewportByWindowWidth = function() {
    if (window.innerWidth >= _constants_app__WEBPACK_IMPORTED_MODULE_0__/* .DeviceSizes.xl */ .aG.xl) return _constants_app__WEBPACK_IMPORTED_MODULE_0__/* .Viewport.xl */ .l_.xl;
    if (window.innerWidth >= _constants_app__WEBPACK_IMPORTED_MODULE_0__/* .DeviceSizes.lg */ .aG.lg) return _constants_app__WEBPACK_IMPORTED_MODULE_0__/* .Viewport.lg */ .l_.lg;
    if (window.innerWidth >= _constants_app__WEBPACK_IMPORTED_MODULE_0__/* .DeviceSizes.md */ .aG.md) return _constants_app__WEBPACK_IMPORTED_MODULE_0__/* .Viewport.md */ .l_.md;
    if (window.innerWidth >= _constants_app__WEBPACK_IMPORTED_MODULE_0__/* .DeviceSizes.sm */ .aG.sm) return _constants_app__WEBPACK_IMPORTED_MODULE_0__/* .Viewport.sm */ .l_.sm;
    return _constants_app__WEBPACK_IMPORTED_MODULE_0__/* .Viewport.xs */ .l_.xs;
};
/**
 * Get the optimised version of viewport.
 * Formula = min(maxViewport, max(minViewport ,Viewport))
 */ function optimiseViewport(viewport) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _maxViewport = options.maxViewport, maxViewport = _maxViewport === void 0 ? _constants_app__WEBPACK_IMPORTED_MODULE_0__/* .Viewport.xl */ .l_.xl : _maxViewport, _minViewport = options.minViewport, minViewport = _minViewport === void 0 ? _constants_app__WEBPACK_IMPORTED_MODULE_0__/* .Viewport.xs */ .l_.xs : _minViewport;
    // If viewport is limited to single option.
    if (maxViewport === minViewport) {
        return maxViewport;
    }
    // If viewport is limited to all options
    if (maxViewport === _constants_app__WEBPACK_IMPORTED_MODULE_0__/* .Viewport.xl */ .l_.xl && minViewport === _constants_app__WEBPACK_IMPORTED_MODULE_0__/* .Viewport.xs */ .l_.xs) {
        return viewport;
    }
    var minDeviceSize = _constants_app__WEBPACK_IMPORTED_MODULE_0__/* .DeviceSizes */ .aG[minViewport];
    var maxDeviceSize = _constants_app__WEBPACK_IMPORTED_MODULE_0__/* .DeviceSizes */ .aG[maxViewport];
    // Incorrect bounds
    if (minDeviceSize > maxDeviceSize) {
        return undefined;
    }
    // Else find the sweet spot
    var deviceSize = _constants_app__WEBPACK_IMPORTED_MODULE_0__/* .DeviceSizes */ .aG[viewport];
    var optimalDeviceSize = Math.min(Math.max(deviceSize, minDeviceSize), maxDeviceSize);
    var optimalViewport = _constants_app__WEBPACK_IMPORTED_MODULE_0__/* .DeviceSizes */ .aG[optimalDeviceSize];
    return optimalViewport;
}


/***/ }),

/***/ 4375:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__vMu_3"};

/***/ }),

/***/ 477:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 1584:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 5218:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(9906)


/***/ }),

/***/ 1723:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(8603)


/***/ }),

/***/ 8038:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(555)


/***/ }),

/***/ 9894:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(1453)


/***/ }),

/***/ 6677:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5817)


/***/ }),

/***/ 7061:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AJ": function() { return /* binding */ nt; },
/* harmony export */   "N4": function() { return /* binding */ ee; },
/* harmony export */   "OR": function() { return /* binding */ Qr; },
/* harmony export */   "R": function() { return /* binding */ ot; },
/* harmony export */   "XZ": function() { return /* binding */ et; },
/* harmony export */   "Y8": function() { return /* binding */ ct; },
/* harmony export */   "Yz": function() { return /* binding */ Xr; },
/* harmony export */   "gx": function() { return /* binding */ it; },
/* harmony export */   "ko": function() { return /* binding */ at; },
/* harmony export */   "oi": function() { return /* binding */ st; },
/* harmony export */   "pz": function() { return /* binding */ rt; },
/* harmony export */   "qL": function() { return /* binding */ tt; }
/* harmony export */ });
/* unused harmony exports MIME_TYPE_MAP, createIntervalWithCleanup, eventListenerWithCleanup */
/* harmony import */ var _useClickOutside_726e7c36_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8643);
/* harmony import */ var _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4877);
/* harmony import */ var _Button_c598cb52_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7977);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3406);
/* harmony import */ var _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3355);
/* harmony import */ var _Dropdown_cd8b285a_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8501);
/* harmony import */ var _VideoIcon_87fb4a33_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4659);
/* harmony import */ var _index_615eb227_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8517);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1542);





























function ee(r = {}) {
  const { disableFocusEvent: t = !1, disableHoverEvent: o = !1 } = r, n = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), [a, c] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const i = n.current;
    if (!i)
      return;
    const s = () => c(!0), u = () => c(!1);
    return o || (i.addEventListener("mouseenter", s), i.addEventListener("mouseleave", u)), t || (i.addEventListener("focus", s), i.addEventListener("blur", u)), () => {
      u(), o || (i.removeEventListener("mouseenter", s), i.removeEventListener("mouseleave", u)), t || (i.removeEventListener("focus", s), i.removeEventListener("blur", u));
    };
  }, [t, o]), { ref: n, isHovering: a, setIsHovering: c };
}
function Qr(r, t, o, n) {
  const a = (0,_index_615eb227_mjs__WEBPACK_IMPORTED_MODULE_2__.a)(t);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => j(n || window, r, a, o), [r, a, n, o]);
}
function j(r, t, o, n) {
  return n ? () => {
  } : (r.addEventListener(t, o), () => r.removeEventListener(t, o));
}
function Xr(r, t, o = {}) {
  const n = (0,_index_615eb227_mjs__WEBPACK_IMPORTED_MODULE_2__.a)(r);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(
    () => de(n, t, {
      disabled: o.disabled,
      maxDuration: o.maxDuration,
      executeImmediately: o.executeImmediately
    }),
    [
      n,
      t,
      o.disabled,
      o.maxDuration,
      o.executeImmediately
    ]
  );
}
function de(r, t, o = {}) {
  const { disabled: n, maxDuration: a, executeImmediately: c } = o;
  if (n || t <= 0)
    return () => {
    };
  let i = 0;
  c && r(i);
  const s = window.setInterval(() => {
    i += t, a && i >= a && window.clearInterval(s), r(i) && window.clearInterval(s);
  }, t);
  return () => window.clearInterval(s);
}
const ue = "checkbox", pe = "no-padding", me = "checkbox__icon", be = "checkbox__icon--dark-bg", ge = "checkbox__icon--error", _e = "checkbox__input", U = {
  checkbox: ue,
  noPadding: pe,
  checkboxIcon: me,
  checkboxIconDarkBg: be,
  checkboxIconError: ge,
  checkboxInput: _e
};
function et({
  label: r,
  name: t,
  checked: o,
  onChange: n,
  disabled: a,
  error: c,
  onDarkBackground: i,
  required: s,
  noPadding: u
}) {
  const { isHovering: d, ref: g } = ee(), p = (0,_useClickOutside_726e7c36_mjs__WEBPACK_IMPORTED_MODULE_3__.u)();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "label",
    {
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(U.checkbox, u && U.noPadding),
      ref: g,
      "data-hover": d,
      "aria-disabled": a
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "div",
      {
        className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
          U.checkboxIcon,
          c && U.checkboxIconError,
          (i === !0 || p) && U.checkboxIconDarkBg
        ),
        "aria-checked": o
      },
      o && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_5__.I, { icon: _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_5__.W.CHECK, size: 16 }),
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        "input",
        {
          className: U.checkboxInput,
          type: "checkbox",
          checked: o,
          onChange: (y) => n?.(y.target.checked),
          name: t,
          required: s
        }
      )
    ),
    r
  );
}
const ye = "curtain", xe = "curtain--show", Z = {
  curtain: ye,
  curtainShow: xe
};
function rt({ show: r = !1 }) {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(Z.curtain, r && Z.curtainShow) });
}
const Ee = "error-handler", he = "desktop", Ie = "error-handler--heading", fe = "error-handler--description", Be = "error-handler--icon", F = {
  errorHandler: Ee,
  desktop: he,
  errorHandlerHeading: Ie,
  errorHandlerDescription: fe,
  errorHandlerIcon: Be
};
function tt({
  title: r,
  description: t,
  videoSrc: o,
  fallbackSrc: n
}) {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_6__.B, { topPadding: _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_6__.a.NONE, bottomPadding: _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_6__.a.NONE }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_6__.B.Content, { flex: !0, className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(F.errorHandler) }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(F.errorHandlerIcon) }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_VideoIcon_87fb4a33_mjs__WEBPACK_IMPORTED_MODULE_7__.V, { src: o, fallbackImgSrc: n })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "p",
    {
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
        F.errorHandlerHeading,
        _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.t.headingSection
      )
    },
    r
  ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "p",
    {
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
        F.errorHandlerDescription,
        _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.t.textsBodyText
      )
    },
    t
  )));
}
const Ce = "media-upload", Ae = "media-upload__help-text", ve = "media-upload__area", Ne = "desktop", Se = "media-upload__area__content", ke = "media-upload__area__icon", Ue = "media-upload__area__texts", Le = "media-upload__area__texts__subheading", Pe = "media-upload__area__button", we = "media-upload__area__input", Te = "media-upload__banner", De = "media-upload__banner--error", Fe = "media-upload__banner__file-icon", He = "media-upload__banner__file-icon--error", Ge = "media-upload__banner__content", $e = "media-upload__banner__content__fileSize", Re = "media-upload__banner__content__fileSize--error", We = "media-upload__banner__clear-button", Me = "media-upload__errorMessage", m = {
  mediaUpload: Ce,
  mediaUploadHelpText: Ae,
  mediaUploadArea: ve,
  desktop: Ne,
  mediaUploadAreaContent: Se,
  mediaUploadAreaIcon: ke,
  mediaUploadAreaTexts: Ue,
  mediaUploadAreaTextsSubheading: Le,
  mediaUploadAreaButton: Pe,
  mediaUploadAreaInput: we,
  mediaUploadBanner: Te,
  mediaUploadBannerError: De,
  mediaUploadBannerFileIcon: Fe,
  mediaUploadBannerFileIconError: He,
  mediaUploadBannerContent: Ge,
  mediaUploadBannerContentFileSize: $e,
  mediaUploadBannerContentFileSizeError: Re,
  mediaUploadBannerClearButton: We,
  mediaUploadErrorMessage: Me
}, G = 1024, w = G * G, Y = w * w, ze = {
  IMAGES: ["image/jpeg", "image/webp", "image/png"],
  VIDEOS: ["video/mp4", "video/mpeg"],
  AUDIOS: ["audio/mpeg", "audio/wav", "audio/ogg", "audio/webm", "audio/mp3"]
};
function ot({
  label: r,
  caption: t,
  onChange: o,
  disabled: n,
  required: a,
  supportedMimeTypes: c = ze.IMAGES,
  maxFileSize: i = w,
  fileIcon: s = _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_5__.W.SIGHTSEEING,
  name: u,
  value: d,
  errorMessage: g,
  i18n: p = {}
}) {
  const {
    maximumSizeLabel: y = "Maximum size",
    optionalLabel: h = "Optional",
    unsupportedFileTypeError: x = "File type not supported",
    browseFilesLabel: A = "Browse files",
    removeFileLabel: B = "Remove file"
  } = p, E = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), k = !!(d && c.includes(d.type)), R = (d?.size || 0) > i, I = c.map((oe) => oe.split("/")[1]).join(", "), v = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    o(void 0), E.current?.value && (E.current.value = "");
  }, [o]), D = `media-upload-${u || "input"}`, q = `${D}-label`, W = g ? `${D}-error` : void 0;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      className: m.mediaUpload,
      role: "group",
      "aria-labelledby": q,
      "aria-describedby": W
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "div",
      {
        className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(m.mediaUploadHelpText, _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.t.textsCaption)
      },
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", { id: q, htmlFor: D }, r, " ", a ? null : h ? `(${h})` : null),
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, y, " ", J(i))
    ),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      Oe,
      {
        disabled: n,
        heading: t,
        subheading: I,
        onChange: o,
        supportedMimeTypes: c,
        buttonLabel: A,
        name: u,
        inputId: D,
        required: a,
        ariaInvalid: !!g,
        ariaDescribedBy: W,
        forwardedInputRef: E
      }
    ),
    d ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      qe,
      {
        disabled: n,
        fileName: d.name,
        fileIcon: s,
        resetFile: v,
        removeFileLabel: B,
        errorMessage: R ? J(d.size) : k ? void 0 : x
      }
    ) : null,
    !!g && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "div",
      {
        id: W,
        role: "alert",
        className: _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.t.textsCaption && m.mediaUploadErrorMessage
      },
      g
    )
  );
}
function Oe({
  heading: r = "Upload",
  subheading: t,
  onChange: o,
  supportedMimeTypes: n,
  buttonLabel: a,
  name: c,
  disabled: i,
  forwardedInputRef: s,
  inputId: u,
  required: d,
  ariaInvalid: g,
  ariaDescribedBy: p
}) {
  const y = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), [h, x] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), A = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (I) => {
      i || (I.preventDefault(), I.stopPropagation(), x(!0));
    },
    [i]
  ), B = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => x(!1), []), E = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => y.current?.click(), []), k = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (I) => {
      if (I.preventDefault(), i)
        return;
      x(!1);
      const v = I.dataTransfer.files?.[0];
      v && o(v);
    },
    [i, o]
  ), R = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (I) => {
      const v = I.target.files?.[0];
      v && o(v);
    },
    [o]
  );
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "button",
    {
      type: "button",
      className: m.mediaUploadArea,
      onClick: E,
      onDragOver: A,
      onDragLeave: B,
      onDrop: k,
      "data-dragover": h
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: m.mediaUploadAreaContent }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: m.mediaUploadAreaIcon, role: "none" }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_5__.I, { icon: _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_5__.W.SHARE, size: 24 })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: m.mediaUploadAreaTexts }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.t.textsLeadTextBold }, r), t && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "span",
      {
        className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
          m.mediaUploadAreaTextsSubheading,
          _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.t.textsLeadText
        )
      },
      t
    )), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      _Button_c598cb52_mjs__WEBPACK_IMPORTED_MODULE_8__.B.Primary,
      {
        asDiv: !0,
        text: a,
        className: m.mediaUploadAreaButton
      }
    )),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "input",
      {
        type: "file",
        id: u,
        name: c,
        disabled: i,
        required: d,
        "aria-required": d || void 0,
        "aria-invalid": g || void 0,
        "aria-describedby": p,
        ref: (0,_index_615eb227_mjs__WEBPACK_IMPORTED_MODULE_2__.m)(y, s),
        onChange: R,
        className: m.mediaUploadAreaInput,
        accept: n.join(", ")
      }
    )
  );
}
function qe({
  fileName: r,
  errorMessage: t,
  resetFile: o,
  disabled: n,
  fileIcon: a,
  removeFileLabel: c = "Remove file"
}) {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "output",
    {
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
        m.mediaUploadBanner,
        t && m.mediaUploadBannerError
      )
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "div",
      {
        className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
          m.mediaUploadBannerFileIcon,
          t && m.mediaUploadBannerFileIconError
        ),
        role: "none"
      },
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_5__.I, { icon: a, size: 20 })
    ),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "div",
      {
        className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
          m.mediaUploadBannerContent,
          _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.t.textsLeadText
        )
      },
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, r),
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        "span",
        {
          className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
            m.mediaUploadBannerContentFileSize,
            t && m.mediaUploadBannerContentFileSizeError
          )
        },
        typeof t == "string" ? t : null
      )
    ),
    !n && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "button",
      {
        type: "button",
        onClick: o,
        "aria-label": c,
        title: c,
        className: m.mediaUploadBannerClearButton
      },
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_5__.I, { icon: _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_5__.W.CLOSE, size: 20 })
    )
  );
}
function J(r) {
  return r >= Y ? `${(r / Y).toFixed(2)} GB` : r >= w ? `${(r / w).toFixed(2)} MB` : r >= G ? `${(r / G).toFixed(2)} KB` : `${r} Bytes`;
}
const Ke = "phone-number-input", Ve = "phone-number-input__label", je = "phone-number-input__label--error", Ze = "phone-number-input__errorMessage", Ye = "phone-number-input__container", Je = "phone-number-input__container--large", Qe = "phone-number-input__container--error", Xe = "phone-number-input__dropdown", er = "phone-number-input__dropdown__button", rr = "phone-number-input__dropdown__list", tr = "phone-number-input__dropdown__flag", or = "phone-number-input__divider", nr = "phone-number-input__country-code", ar = "phone-number-input__country-code--error", cr = "phone-number-input__input-field", _ = {
  phoneNumberInput: Ke,
  phoneNumberInputLabel: Ve,
  phoneNumberInputLabelError: je,
  phoneNumberInputErrorMessage: Ze,
  phoneNumberInputContainer: Ye,
  phoneNumberInputContainerLarge: Je,
  phoneNumberInputContainerError: Qe,
  phoneNumberInputDropdown: Xe,
  phoneNumberInputDropdownButton: er,
  phoneNumberInputDropdownList: rr,
  phoneNumberInputDropdownFlag: tr,
  phoneNumberInputDivider: or,
  phoneNumberInputCountryCode: nr,
  phoneNumberInputCountryCodeError: ar,
  phoneNumberInputInputField: cr
};
function ir(r, t) {
  const o = 10 ** Math.round(t);
  return Math.round(r * o) / o;
}
function sr(r) {
  const t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    () => dr(r),
    [r]
  );
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useSyncExternalStore)(lr, t, () => 0);
}
function lr(r) {
  return r(), window.addEventListener("resize", r, { passive: !0 }), () => window.removeEventListener("resize", r);
}
function dr(r, t = 0) {
  return ir(
    r.current?.getBoundingClientRect().width || t,
    0
  );
}
const $ = [
  {
    flagUrl: "/flags/fi.svg",
    name: "Soumi",
    code: "+358"
  },
  {
    flagUrl: "/flags/sv.svg",
    name: "Sverige",
    code: "+46"
  }
], ur = $.map(re), nt = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function({
  errorMessage: t,
  dataTestid: o,
  label: n,
  onValueChange: a,
  onChange: c,
  height: i = "normal",
  ...s
}, u) {
  const d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), g = sr(d), [p, y] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)($[0]), h = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
    _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.t.textsCaption,
    _.phoneNumberInputLabel,
    t && _.phoneNumberInputLabelError
  ), x = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (E) => {
      const k = E.target.value;
      c?.(E), a?.(k ? p.code + k : "");
    },
    [p.code, a, c]
  ), A = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((E) => {
    y(te(E[0]));
  }, []), B = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => [re(p)],
    [p]
  );
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: _.phoneNumberInput }, n && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", { className: h }, n, s.required ? " *" : null), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      ref: d,
      "aria-disabled": s.disabled,
      "data-testid": o,
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
        _.phoneNumberInputContainer,
        _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.t.textsLeadText,
        t && _.phoneNumberInputContainerError,
        i === "large" && _.phoneNumberInputContainerLarge
      ),
      style: {
        "--phone-input-container-width": g.toFixed(0) + "px"
      }
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      _Dropdown_cd8b285a_mjs__WEBPACK_IMPORTED_MODULE_9__.D,
      {
        name: `${s.name}-cc`,
        items: ur,
        isMulti: !1,
        label: pr,
        selectedItems: B,
        onSelectedItemsChange: A,
        className: _.phoneNumberInputDropdown,
        buttonClassName: _.phoneNumberInputDropdownButton,
        listClassName: _.phoneNumberInputDropdownList,
        disabled: s.disabled
      }
    ),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: _.phoneNumberInputDivider, role: "none" }),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "span",
      {
        className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
          _.phoneNumberInputCountryCode,
          t && _.phoneNumberInputCountryCodeError
        )
      },
      p.code
    ),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "input",
      {
        ...s,
        type: "tel",
        className: _.phoneNumberInputInputField,
        onChange: x,
        ref: u,
        inputMode: "numeric"
      }
    )
  ), t && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "span",
    {
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
        _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.t.textsCaption,
        _.phoneNumberInputErrorMessage
      )
    },
    t
  ));
});
function pr({ selectedItems: r }) {
  const t = te(r[0]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "img",
    {
      src: t.flagUrl,
      alt: "",
      "aria-hidden": "true",
      className: _.phoneNumberInputDropdownFlag
    }
  );
}
function mr({ flagUrl: r, name: t, code: o }) {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { style: { display: "flex", alignItems: "center", gap: "1rem" } }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "img",
    {
      src: r,
      alt: "",
      "aria-hidden": "true",
      className: _.phoneNumberInputDropdownFlag
    }
  ), " ", t, " ", /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: _.phoneNumberInputCountryCode }, o));
}
function re(r) {
  return {
    label: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(mr, { ...r }),
    value: r.code
  };
}
function te(r) {
  return $.find((t) => t.code === r?.value) || $[0];
}
const br = "progressBar", gr = "progressBar__container", _r = "progressBar__wrapper", yr = "progressBar__fill", H = {
  progressBar: br,
  progressBarContainer: gr,
  progressBarWrapper: _r,
  progressBarFill: yr
};
function at({
  totalSteps: r,
  currentStep: t,
  stepLabel: o = "Step",
  ofLabel: n = "of"
}) {
  const a = Math.min(r, Math.max(0, t)), c = Math.min(
    100,
    Math.max(0, Math.round(a / r * 100))
  );
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: H.progressBar }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: H.progressBarContainer }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", null, o, " ", a, " ", /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, n, " ", r))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: H.progressBarWrapper }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      className: H.progressBarFill,
      style: {
        width: `${c}%`
      }
    }
  )));
}
const xr = "radio", Er = "radio__icon", hr = "radio__icon--dark-bg", Ir = "radio__icon--error", fr = "radio__input", P = {
  radio: xr,
  radioIcon: Er,
  radioIconDarkBg: hr,
  radioIconError: Ir,
  radioInput: fr
};
function ct({
  label: r,
  name: t,
  checked: o,
  onChange: n,
  disabled: a,
  error: c,
  onDarkBackground: i,
  required: s
}) {
  const { isHovering: u, ref: d } = ee(), g = (0,_useClickOutside_726e7c36_mjs__WEBPACK_IMPORTED_MODULE_3__.u)();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "label",
    {
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(P.radio),
      ref: d,
      "data-hover": u,
      "aria-disabled": a
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "div",
      {
        className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
          P.radioIcon,
          c && P.radioIconError,
          (i === !0 || g) && P.radioIconDarkBg
        ),
        "aria-checked": o
      },
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        "input",
        {
          className: P.radioInput,
          type: "radio",
          checked: o,
          onChange: (p) => n?.(p.target.checked),
          name: t,
          required: s
        }
      )
    ),
    r
  );
}
const Br = "textarea", Cr = "textarea__label", Ar = "textarea__input", vr = "textarea__input--error", Nr = "textarea__footer", Sr = "textarea__errorMessage", L = {
  textarea: Br,
  textareaLabel: Cr,
  textareaInput: Ar,
  textareaInputError: vr,
  textareaFooter: Nr,
  textareaErrorMessage: Sr
};
function kr({
  label: r,
  errorMessage: t,
  onChange: o,
  onValueChange: n,
  maxLength: a = 500,
  ...c
}, i) {
  const s = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), u = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
    _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.t.textsCaption,
    t && L.textareaLabelError
  ), d = (p) => {
    o?.(p);
    const y = p.target.value || "";
    n?.(y), s.current && (s.current.innerText = y.length.toString());
  }, g = t && c.id ? `${c.id}-error` : void 0;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: L.textarea }, r && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", { htmlFor: c.id, className: u }, c.required ? `${r} *` : r), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "textarea",
    {
      ref: i,
      maxLength: a,
      rows: a / 100,
      ...c,
      "aria-required": c.required || void 0,
      "aria-invalid": t ? !0 : void 0,
      "aria-describedby": g,
      onChange: d,
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
        L.textareaInput,
        _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.t.textsLeadText,
        t && L.textareaInputError
      )
    }
  ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: L.textareaFooter }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      id: g,
      role: t ? "alert" : void 0,
      className: _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.t.textsCaption && L.textareaErrorMessage
    },
    t
  ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.t.textsCaption }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { ref: s }, c.value?.length || 0), "/", a)));
}
const it = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(kr), Ur = "text-input", Lr = "text-input__container", Pr = "text-input__container__input_field", wr = "text-input__container__input_field--error", Tr = "text-input__container__icon_button", Dr = "text-input__container__icon_button--error", Fr = "text-input__container--error", Hr = "text-input__errorMessage", C = {
  textInput: Ur,
  textInputContainer: Lr,
  textInputContainerInputField: Pr,
  textInputContainerInputFieldError: wr,
  textInputContainerIconButton: Tr,
  textInputContainerIconButtonError: Dr,
  textInputContainerError: Fr,
  textInputErrorMessage: Hr
};
function Gr({
  label: r,
  dataTestid: t,
  buttonTargetId: o,
  iconState: n,
  errorMessage: a,
  onValueChange: c,
  onIconClick: i,
  buttonContent: s,
  helpText: u,
  ...d
}, g) {
  const p = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
    _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.t.textsCaption
    // errorMessage && styles.textInputLabelError
  ), y = `input-${d.name}`, h = u ? `${y}-help` : void 0, x = a ? `${y}-error` : void 0, A = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(h, x) || void 0;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: C.textInput }, r && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", { className: p, htmlFor: y }, d.required ? `${r} *` : r), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
        _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.t.textsLeadText,
        C.textInputContainer,
        a && C.textInputContainerError
      ),
      "data-testid": t
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "input",
      {
        ...d,
        id: y,
        "aria-required": d.required || void 0,
        "aria-invalid": a ? !0 : void 0,
        "aria-describedby": A,
        className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
          C.textInputContainerInputField,
          a && C.textInputContainerInputFieldError
        ),
        onChange: (B) => {
          c?.(B.target.value), d.onChange?.(B);
        },
        ref: g
      }
    ),
    n && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "button",
      {
        type: "button",
        className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
          C.textInputContainerIconButton,
          a && C.textInputContainerIconButtonError
        ),
        onClick: i,
        "data-testid": o,
        title: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
          n === "SEARCH" && "Search",
          n === "CLEAR" && "Clear",
          n === "CHECK" && "Check"
        )
      },
      s,
      n === "SEARCH" && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_5__.I, { icon: _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_5__.W.SEARCH, size: 20 }),
      n === "CLEAR" && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_5__.I, { icon: _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_5__.W.CLOSE, size: 20 }),
      n === "CHECK" && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_5__.I, { icon: _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_5__.W.CHECK, size: 20 })
    )
  ), u && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { id: h, className: _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.t.textsCaption }, u), a && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      id: x,
      role: "alert",
      className: _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_4__.t.textsCaption && C.textInputErrorMessage
    },
    a
  ));
}
const st = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Gr);

//# sourceMappingURL=main.js.map


/***/ }),

/***/ 719:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 4364:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 7599:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 2126:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 5034:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7599);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 169:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 2050:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(2126);
;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(2164);
;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ }),

/***/ 3444:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(719);
;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(2126);
;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(2164);
;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 2164:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(719);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ }),

/***/ 4877:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ p; },
/* harmony export */   "a": function() { return /* binding */ g; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3406);


const m = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
  isInsideBlock: !1
}), N = "block__content", S = "block__content--flex", B = "block__content--grid", _ = "block__content--limited-width", x = "desktop", A = "desktop--limited-width", T = "debug", e = {
  blockContent: N,
  blockContentFlex: S,
  blockContentGrid: B,
  blockContentLimitedWidth: _,
  desktop: x,
  desktopLimitedWidth: A,
  debug: T
}, G = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(n, l) {
  const {
    children: d,
    limitedWidth: c = !0,
    className: i,
    style: s,
    id: a,
    debug: r,
    itemScope: u = !1,
    itemType: L,
    flex: C
  } = n;
  if (!(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(m).isInsideBlock)
    throw new Error("Content should be only used inside the Block.");
  const f = r && "production" === "development" ? 0 : "";
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      ref: l,
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
        i,
        e.blockContent,
        f,
        c && e.blockContentLimitedWidth,
        C ? e.blockContentFlex : e.blockContentGrid
      ),
      style: s,
      id: a,
      itemScope: u,
      itemType: L
    },
    d
  );
}), R = "block", v = "block--padding-top-large", W = "desktop", w = "block--padding-top-small", y = "block--padding-top-small--disabled", M = "block--padding-bottom-large", D = "block--padding-bottom-small", o = {
  block: R,
  blockPaddingTopLarge: v,
  desktop: W,
  blockPaddingTopSmall: w,
  blockPaddingTopSmallDisabled: y,
  blockPaddingBottomLarge: M,
  blockPaddingBottomSmall: D
};
var g = /* @__PURE__ */ ((t) => (t.NONE = "NONE", t.SMALL = "SMALL", t.LARGE = "LARGE", t))(g || {});
function p(t) {
  const {
    children: n,
    className: l,
    topPadding: d = "LARGE",
    bottomPadding: c = "LARGE",
    as: i,
    blockRef: s,
    ...a
  } = t, r = i || "div";
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    r,
    {
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
        o.block,
        F(d),
        I(c),
        l
      ),
      ...a,
      ref: s
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(m.Provider, { value: { isInsideBlock: !0 } }, n)
  );
}
p.Content = G;
p.Padding = g;
function F(t) {
  return t === "LARGE" ? o.blockPaddingTopLarge : t === "SMALL" ? o.blockPaddingTopSmall : "";
}
function I(t) {
  return t === "LARGE" ? o.blockPaddingBottomLarge : t === "SMALL" ? o.blockPaddingBottomSmall : "";
}

//# sourceMappingURL=Block-9b78bd10.mjs.map


/***/ }),

/***/ 7977:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ lt; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3406);
/* harmony import */ var _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3355);
/* harmony import */ var _useClickOutside_726e7c36_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8643);




const f = "button", C = "button__default-focus-style-in-link", S = "button__primary-focus-style-in-link", z = "button__map", k = "button__primary", L = "button__menu-talent", H = "button__arrows", I = "button__secondary", x = "button__quiz", T = "button__menu-employer", Q = "employer", M = "desktop", D = "button__hero", P = "button__hero-talents", B = "button__hero-employer", w = "button__save-container", R = "button__save", F = "button__menu", A = "button__icon", h = "button__icon__container", q = "button__link", g = "button__quiz__label", O = "mobile", V = "button__quiz__divider", U = "button__quiz__text", W = "button__quiz__correct", G = "button__quiz__incorrect", e = {
  button: f,
  buttonDefaultFocusStyleInLink: C,
  buttonPrimaryFocusStyleInLink: S,
  buttonMap: z,
  buttonPrimary: k,
  buttonMenuTalent: L,
  buttonArrows: H,
  buttonSecondary: I,
  buttonQuiz: x,
  buttonMenuEmployer: T,
  employer: Q,
  desktop: M,
  buttonHero: D,
  buttonHeroTalents: P,
  buttonHeroEmployer: B,
  buttonSaveContainer: w,
  buttonSave: R,
  buttonMenu: F,
  buttonIcon: A,
  buttonIconContainer: h,
  buttonLink: q,
  buttonQuizLabel: g,
  mobile: O,
  buttonQuizDivider: V,
  buttonQuizText: U,
  buttonQuizCorrect: W,
  buttonQuizIncorrect: G
}, lt = {
  Default: (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(j),
  HeroTalents: (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)($),
  HeroEmployer: (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(tt),
  Primary: (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(J),
  Secondary: (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(K),
  Save: (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(X),
  Arrow: (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Z),
  Menu: (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(et),
  IconLabel: (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(nt),
  DefaultFocusStyleInLink: e.buttonDefaultFocusStyleInLink,
  PrimaryFocusStyleInLink: e.buttonPrimaryFocusStyleInLink,
  Quiz: (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(ot),
  Link: (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(ut)
};
function j({ asDiv: u, ...o }, n) {
  const a = u ? "div" : "button";
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    a,
    {
      ...o,
      ref: n,
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(e.button, o.className)
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.buttonTextPrimary) }, o.text),
    o.icon ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_2__.I, { icon: o.icon, size: 14 }) : null
  );
}
function J(u, o) {
  const { icon: n, text: a, onClick: c, asDiv: r, preventEmployerStyle: l, ...m } = u, y = (0,_useClickOutside_726e7c36_mjs__WEBPACK_IMPORTED_MODULE_3__.u)(), E = r ? "div" : "button";
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    E,
    {
      type: "button",
      ...m,
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
        e.button,
        e.buttonPrimary,
        y && !l && e.employer,
        u.className
      ),
      onClick: c,
      ref: o
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: e.buttonMap }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.buttonTextPrimary) }, a), n ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_2__.I, { icon: n, size: 12 }) : null)
  );
}
function K(u, o) {
  const {
    icon: n,
    text: a,
    onClick: c,
    asDiv: r,
    preventEmployerStyle: l,
    iconPosition: m,
    ...y
  } = u, E = (0,_useClickOutside_726e7c36_mjs__WEBPACK_IMPORTED_MODULE_3__.u)(), v = r ? "div" : "button";
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    v,
    {
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
        e.button,
        e.buttonSecondary,
        E && !l && e.employer,
        u.className
      ),
      onClick: c,
      type: "button",
      ...y,
      ref: o
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: e.buttonMap }, n && m === "left" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_2__.I, { icon: n, size: 12 }) : null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.buttonTextPrimary) }, a), n && m !== "left" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_2__.I, { icon: n, size: 12 }) : null)
  );
}
function X({ iconFilled: u, className: o, containerClassName: n, ...a }, c) {
  const r = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
    e.buttonSaveContainer,
    n ?? ""
  );
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: r }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "button",
    {
      type: "button",
      ...a,
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(e.button, e.buttonSave, o),
      ref: c,
      "aria-label": "save"
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_2__.I,
      {
        icon: u ? _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_2__.W.HEART_FILLED : _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_2__.W.HEART,
        size: 20
      }
    )
  ));
}
const Y = {
  left: "Previous",
  right: "Next",
  up: "Up",
  down: "Down"
};
function Z({
  arrowDirection: u,
  className: o,
  "aria-label": n,
  ...a
}, c) {
  const r = (l) => {
    switch (l) {
      case "up":
        return _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_2__.W.CHEVRON_UP;
      case "down":
        return _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_2__.W.CHEVRON_DOWN;
      case "left":
        return _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_2__.W.CHEVRON_LEFT;
      case "right":
      default:
        return _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_2__.W.CHEVRON_RIGHT;
    }
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "button",
    {
      type: "button",
      ...a,
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(e.button, e.buttonArrows, o),
      ref: c,
      "aria-label": n || Y[u]
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_2__.I,
      {
        size: 20,
        icon: r(u),
        "aria-hidden": !0,
        focusable: "false"
      }
    )
  );
}
function $({ asDiv: u, ...o }, n) {
  const a = u ? "div" : "button";
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    a,
    {
      type: "button",
      ...o,
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(e.button, e.buttonHeroTalents, o.className),
      ref: n
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.buttonHeroTitle) }, o.text)
  );
}
function tt({ asDiv: u, ...o }, n) {
  const a = u ? "div" : "button";
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    a,
    {
      type: "button",
      ...o,
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
        e.button,
        e.buttonHeroEmployer,
        o.className
      ),
      ref: n
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.buttonHeroTitle) }, o.text)
  );
}
function et({ asDiv: u, isMenuOpen: o, ...n }, a) {
  const c = u ? "div" : "button", l = (0,_useClickOutside_726e7c36_mjs__WEBPACK_IMPORTED_MODULE_3__.u)() ? e.buttonMenuEmployer : e.buttonMenuTalent;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    c,
    {
      type: "button",
      ...n,
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
        e.button,
        e.buttonMenu,
        l,
        n.className
      ),
      ref: a,
      "aria-label": o ? "Close" : "Menu"
    },
    o ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_2__.I, { icon: _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_2__.W.CLOSE }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_2__.I, { icon: _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_2__.W.SEARCH }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_2__.I, { icon: _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_2__.W.HAMBURGER }))
  );
}
function nt(u, o) {
  const { icon: n, text: a, textClassName: c, onClick: r, buttonClassName: l, ...m } = u, y = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)("button " + e.buttonIcon, l), E = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsLeadText, c);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "button",
    {
      className: y,
      onClick: r,
      type: "button",
      ...m,
      ref: o
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: e.buttonIconContainer }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: E }, a), n && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_2__.I,
      {
        icon: n.type,
        size: n.size,
        className: n.className,
        color: n.color
      }
    ))
  );
}
function ot(u, o) {
  const {
    icon: n,
    text: a,
    onClick: c,
    asDiv: r,
    preventEmployerStyle: l,
    label: m,
    customClass: y,
    ...E
  } = u, v = (0,_useClickOutside_726e7c36_mjs__WEBPACK_IMPORTED_MODULE_3__.u)(), d = r ? "div" : "button";
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    d,
    {
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
        e.button,
        e.buttonQuiz,
        v && !l && e.employer,
        y
      ),
      onClick: c,
      ...E,
      ref: o
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: e.buttonMap }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: e.buttonQuizLabel }, m), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: e.buttonQuizDivider }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: e.buttonQuizText }, a), n ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_2__.I, { icon: n, size: 29 }) : null)
  );
}
function ut(u, o) {
  const { onClick: n, asDiv: a, preventEmployerStyle: c, label: r, customClass: l, ...m } = u, y = (0,_useClickOutside_726e7c36_mjs__WEBPACK_IMPORTED_MODULE_3__.u)(), E = a ? "div" : "button";
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    E,
    {
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
        e.button,
        e.buttonLink,
        y && !c && e.employer,
        l
      ),
      onClick: n,
      type: "button",
      ...m,
      ref: o
    },
    r
  );
}

//# sourceMappingURL=Button-c598cb52.mjs.map


/***/ }),

/***/ 1416:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ T; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3406);
/* harmony import */ var _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3355);



const B = "cta-container", D = "cta-content", k = "text", h = "text--white-color", p = "text__disabled-default", N = "text__disabled-default__svg", W = "text__svg-blue-background__svg", I = "text__svg-white-background__svg", t = {
  ctaContainer: B,
  ctaContent: D,
  text: k,
  textWhiteColor: h,
  textDisabledDefault: p,
  textDisabledDefaultSvg: N,
  textSvgBlueBackgroundSvg: W,
  textSvgWhiteBackgroundSvg: I
};
function T(i) {
  const {
    text: r = "Call to Action",
    isDisabled: e,
    showCTAIcon: g = !0,
    isBlueBackground: a,
    containerClassName: x,
    textClassName: u,
    to: n,
    as: d = "a",
    ...v
  } = i;
  let c;
  n && (c = {
    href: n,
    target: "_blank"
  });
  let l = d;
  e && (l = "div");
  const m = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
    t.ctaContainer,
    x ?? ""
  ), C = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.buttonTitle, t.text, {
    textClassName: u,
    [t.textWhiteColor]: a,
    [t.textDisabledDefault]: e,
    [t.textSvgBlueBackgroundSvg]: a
  }), _ = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)({
    [t.textDisabledDefaultSvg]: e,
    [t.textSvgBlueBackgroundSvg]: a && !e,
    [t.textSvgWhiteBackgroundSvg]: !a && !e
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    l,
    {
      className: m,
      "aria-disabled": e,
      ...c,
      ...v
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: t.ctaContent }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: C }, r), g && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_2__.I,
      {
        className: _,
        icon: _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_2__.W.ARROW_UP_RIGHT,
        size: 12
      }
    ))
  );
}

//# sourceMappingURL=CallToAction-d24a74ed.mjs.map


/***/ }),

/***/ 8501:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ Me; }
/* harmony export */ });
/* unused harmony export u */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3406);
/* harmony import */ var _useClickOutside_726e7c36_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8643);
/* harmony import */ var _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3355);
/* harmony import */ var _index_615eb227_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8517);





const ee = "dropdown", te = "dropdown__button", oe = "dropdown__count-badge", ne = "dropdown__button--large", se = "dropdown__button--disabled", re = "dropdown__filter", ae = "mobile", de = "dropdown__list", le = "desktop", ce = "dropdown__list-item", ue = "dropdown__list-empty-message", ie = "dropdown__checkbox", pe = "dropdown__label-content", me = "dropdown__button--open", f = {
  dropdown: ee,
  dropdownButton: te,
  dropdownCountBadge: oe,
  dropdownButtonLarge: ne,
  dropdownButtonDisabled: se,
  dropdownFilter: re,
  mobile: ae,
  dropdownList: de,
  desktop: le,
  dropdownListItem: ce,
  dropdownListEmptyMessage: ue,
  dropdownCheckbox: ie,
  dropdownLabelContent: pe,
  dropdownButtonOpen: me
}, we = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function({
  isOpen: e,
  selectedItems: t,
  label: n,
  onClick: s,
  isLarge: d,
  isMulti: i,
  className: l,
  ...u
}, p) {
  const k = t.length, m = (0,_index_615eb227_mjs__WEBPACK_IMPORTED_MODULE_1__.a)(
    (b) => {
      b.stopPropagation(), s?.(b);
    }
  ), { disabled: x } = { ...u }, h = typeof n == "string" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "label",
    {
      className: e ? _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.t.textsLeadTextBold : _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.t.textsLeadText
    },
    i ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: f.dropdownLabelContent }, n, k > 0 ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(W, { count: k }) : null) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, t[0]?.label || n)
  ) : (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(n, { isOpen: e, selectedItems: t, isMulti: i });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "button",
    {
      "data-testid": "dropdown-button",
      "aria-label": n.toString(),
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
        f.dropdownButton,
        d && f.dropdownButtonLarge,
        x && f.dropdownButtonDisabled,
        e && f.dropdownButtonOpen,
        l
      ),
      type: "button",
      ...u,
      onClick: m,
      ref: p
    },
    h,
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_3__.I,
      {
        icon: e ? _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_3__.W.CHEVRON_UP : _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_3__.W.CHEVRON_DOWN,
        size: 16
      }
    )
  );
}), fe = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function({
  isOpen: e,
  getItemProps: t,
  checkSelected: n,
  items: s,
  highlightedIndex: d,
  emptyMessage: i,
  isMulti: l,
  className: u,
  name: p,
  showFilterInput: k = !1,
  ...m
}, x) {
  const [h, b] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""), _ = h ? s?.filter((r) => {
    if (r && r.label)
      return r.label.toLowerCase().startsWith(h.toLowerCase());
  }) : s, E = (r) => {
    const c = r.target.value, I = c.charAt(0).toUpperCase() + c.slice(1);
    b(I);
  };
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    e || b("");
  }, [e]), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, e && k && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "input",
    {
      type: "text",
      value: h,
      onChange: E,
      tabIndex: e ? 0 : -1,
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(f.dropdownFilter, _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.t.textsLeadTextBold),
      autoFocus: e
    }
  ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "ul",
    {
      ...m,
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(f.dropdownList, u),
      ref: x,
      "data-testid": "dropdown-list",
      hidden: !e
    },
    _.length > 0 ? _.map((r, c) => {
      const I = n(r.value);
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        "li",
        {
          className: f.dropdownListItem,
          "data-highlighted": d === c,
          key: `${r.value}${c}`,
          "aria-selected": I,
          ...t({ item: r.value, index: c }),
          "data-testid": "dropdown-list-item-" + c,
          tabIndex: 0
        },
        l ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ge, { checked: I }) : null,
        /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
          "label",
          {
            className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
              _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.t.textsLeadText,
              f.dropdownLabelContent
            )
          },
          r.label,
          r.count ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(W, { count: r.count }) : null
        )
      );
    }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", { className: f.dropdownListEmptyMessage }, i)
  ), p ? s.map((r) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "input",
    {
      hidden: !0,
      key: r.value,
      name: p,
      checked: n(r.value),
      value: r.value,
      type: l ? "checkbox" : "radio",
      onChange: he
    }
  )) : null);
});
function ge({ checked: o = !1 }) {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: f.dropdownCheckbox, "aria-checked": o }, o && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_3__.I, { icon: _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_3__.W.CHECK }));
}
function W({ count: o }) {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: f.dropdownCountBadge, "aria-hidden": "true" }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.t.textsCaption }, o));
}
function he() {
}
function z(o, e) {
  const t = e?.replace(/\s/g, "-").replace(/[^\w]/gi, "");
  return `dropdown-${o}-list-item-${t}`;
}
function be(o, e, t, n) {
  const s = () => t(0), d = () => t(e - 1), i = () => t((u) => Math.min(u + 1, e - 1)), l = () => t((u) => Math.max(0, u - 1));
  if (o.key === "Tab") {
    o.preventDefault(), o.shiftKey ? l() : i();
    return;
  }
  if (o.key === "ArrowDown") {
    o.preventDefault(), o.metaKey ? d() : i();
    return;
  }
  if (o.key === "ArrowUp") {
    o.preventDefault(), o.metaKey ? s() : l();
    return;
  }
  if (o.key === "Enter" || o.key === " ")
    return o.preventDefault(), n();
}
function Ie(o, e) {
  const [t, n] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), s = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    () => e[t],
    [e, t]
  ), d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => z(o, s()?.value),
    [o, s]
  );
  return {
    highlightedIndex: t,
    highlightedItemId: d,
    setHighlightedIndex: n,
    getItemFromHighlightedIndex: s
  };
}
function Ee(o, e, t, n) {
  const [s, d] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), i = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (p = 0) => {
      d(!0), n?.(!0), e.current?.focus(), t(p);
    },
    [e, n, t]
  ), l = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (p = !1) => {
      d(!1), n?.(!1), p && o.current?.focus();
    },
    [o, n]
  ), u = (0,_index_615eb227_mjs__WEBPACK_IMPORTED_MODULE_1__.a)(
    () => s ? l(!0) : i(0)
  );
  return { isOpen: s, openMenu: i, closeMenu: l, toggleMenu: u };
}
function Ce(o, e) {
  const t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(
    () => new Set(
      (e || o || []).map(
        (s) => s.value
      )
    )
  ), n = t[1];
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    e && n((s) => (s.clear(), e.forEach((d) => s.add(d.value)), s));
  }, [e, n]), t;
}
function ye(o, e, t) {
  const n = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (t)
      return;
    const s = e.current?.querySelector("#" + o);
    n.current && s?.scrollIntoView({
      block: "nearest",
      inline: "nearest",
      behavior: "smooth"
    });
  }, [t, o, e]), n;
}
function ke(o) {
  const {
    id: e,
    items: t = [],
    initialSelectedItems: n,
    selectedItems: s,
    enableCloseOnSelect: d = !1,
    onOpenStateChange: i,
    onSelectedItemsChange: l,
    isMulti: u = !0,
    disabled: p
  } = o, k = (0,react__WEBPACK_IMPORTED_MODULE_0__.useId)(), m = (e || k).replace(/:/g, ""), x = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), h = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), {
    highlightedIndex: b,
    highlightedItemId: _,
    setHighlightedIndex: E,
    getItemFromHighlightedIndex: r
  } = Ie(m, t), { isOpen: c, closeMenu: I, openMenu: B, toggleMenu: F } = Ee(
    x,
    h,
    E,
    i
  ), D = ye(
    _,
    h,
    !c
  ), [g, N] = Ce(n, s), C = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (w) => g.has(w),
    [g]
  ), K = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (w) => {
      const y = w || r().value;
      if (u) {
        C(y) ? g.delete(y) : g.add(y), N(g);
        const M = t.filter(
          (V) => g.has(V.value)
        );
        l?.(M), d && I(!0);
      } else
        C(y) ? (N(/* @__PURE__ */ new Set()), l?.([])) : (N(/* @__PURE__ */ new Set([y])), l?.(
          t.filter((M) => M.value === y)
        )), I(!0);
    },
    [
      r,
      C,
      g,
      N,
      t,
      l,
      d,
      I,
      u
    ]
  ), q = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => ({
    id: `dropdown-${m}-button`,
    ref: x,
    "aria-expanded": c,
    "aria-haspopup": "listbox",
    onClick: F,
    onKeyUp: () => {
      D.current = !1;
    },
    onKeyDown: (w) => {
      if (D.current = !0, w.key === "ArrowDown")
        return w.preventDefault(), B();
    },
    disabled: p
  }), [m, c, F, p, D, B]), j = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => ({
    id: `dropdown-${m}-list`,
    ref: h,
    tabIndex: -1,
    role: "listbox",
    "aria-activedescendant": _,
    "data-open": c,
    onKeyUp: () => {
      D.current = !1;
    },
    onKeyDown: (w) => (D.current = !0, be(
      w,
      t.length,
      E,
      K
    ))
  }), [
    m,
    _,
    c,
    D,
    t.length,
    E,
    K
  ]), G = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    ({ item: w, index: y }) => {
      const M = b === y, V = C(w);
      return {
        id: z(m, w),
        role: "option",
        "aria-selected": V,
        "aria-current": M,
        onClick: () => K(w),
        onMouseEnter: () => E(y),
        onTouchStart: () => E(y)
      };
    },
    [
      b,
      C,
      m,
      K,
      E
    ]
  ), J = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => t.filter((w) => g.has(w.value)),
    [t, g]
  );
  return {
    uuid: m,
    isOpen: c,
    highlightedIndex: b,
    selectedItemsValues: g,
    selectedItems: J,
    checkSelected: C,
    openMenu: B,
    closeMenu: I,
    getMenuProps: j,
    getMenuItemProps: G,
    getUpdatedToggleButtonProps: q
  };
}
const Me = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(e, t) {
  const n = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), {
    label: s,
    name: d,
    items: i = [],
    emptyMessage: l = "No items available",
    size: u = "normal",
    isMulti: p = !0,
    className: k,
    buttonClassName: m,
    listClassName: x,
    autoFocus: h = !1,
    showFilterInput: b = !1,
    disabled: _
  } = e, {
    uuid: E,
    isOpen: r,
    highlightedIndex: c,
    selectedItems: I,
    getMenuProps: B,
    getMenuItemProps: F,
    checkSelected: D,
    getUpdatedToggleButtonProps: g,
    openMenu: N,
    closeMenu: C
  } = ke(e);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useImperativeHandle)(
    t,
    () => ({
      open: N,
      close: C,
      isOpen: r
    }),
    [N, C, r]
  ), (0,_useClickOutside_726e7c36_mjs__WEBPACK_IMPORTED_MODULE_4__.b)([n], C, { disabled: !r }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      id: `dropdown-${E}`,
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(f.dropdown, k),
      "data-testid": "dropdown",
      ref: n
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      we,
      {
        isOpen: r,
        label: s,
        selectedItems: e.selectedItems || I,
        isLarge: u === "large",
        isMulti: p,
        className: m,
        ...g(),
        autoFocus: h
      }
    ),
    !_ && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      fe,
      {
        isOpen: r,
        items: i,
        getItemProps: F,
        checkSelected: D,
        highlightedIndex: c,
        emptyMessage: l,
        isMulti: p,
        className: x,
        name: d,
        ...B(),
        showFilterInput: b
      }
    )
  );
});
function ve() {
  return S(null);
}

//# sourceMappingURL=Dropdown-cd8b285a.mjs.map


/***/ }),

/***/ 3355:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ G0; },
/* harmony export */   "W": function() { return /* binding */ U0; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);

const g = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M4 4H2v16h2v-4h16v4h2v-6H4z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M7.5 13c1.4 0 2.5-1.1 2.5-2.5S8.9 8 7.5 8 5 9.1 5 10.5 6.1 13 7.5 13zm0-3.3c.4 0 .8.4.8.8s-.4.8-.8.8-.8-.4-.8-.8.4-.8.8-.8zM19.4 7.8H11V13h1.9V9.7h6.5c.4 0 .7.3.7.8V13H22v-2.6c0-1.4-1.2-2.6-2.6-2.6z" })
), p = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(g), d = p, M = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M5.3 17H2.1v1.9h3.3c1.3 0 2.5-.5 3.4-1.3l-1.3-1.3c-.7.4-1.4.7-2.2.7zM10.2 7.3 7.5 10l-.2.2c-.9 1.1-.9 2.7.1 3.7l3.6 3.6c.6.6.9 1.4.9 2.2V22h1.9v-2.3c0-1.3-.5-2.6-1.5-3.5l-3.6-3.6c-.3-.3-.3-.8 0-1.1l2.8-2.8c.5-.5 1.3-.5 1.7 0 .2.2.4.5.4.9s-.1.6-.4.9l-2 2 1.3 1.3 2-2c.6-.6.9-1.4.9-2.2s-.3-1.6-.9-2.2c-1-1.3-3.1-1.3-4.3-.1zM17.5 2C16.1 2 15 3.1 15 4.5S16.1 7 17.5 7 20 5.9 20 4.5 18.9 2 17.5 2zm0 3.3c-.4 0-.8-.4-.8-.8s.4-.8.8-.8.8.4.8.8-.4.8-.8.8z" })
), i = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(M), S = i, z = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M11 3v15l-4.5-4.5-1.4 1.4 5.5 5.5c.4.4.9.6 1.4.6s1-.2 1.4-.6l5.5-5.5-1.4-1.4L13 18V3h-2z" })
), x = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(z), H = x, R = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M21 11H6l4.5-4.5-1.4-1.4-5.5 5.5c-.4.4-.6.9-.6 1.4 0 .5.2 1 .6 1.4l5.5 5.5 1.4-1.4L6 13h15v-2z" })
), C = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(R), L = C, O = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M3 13h15l-4.5 4.5 1.4 1.4 5.5-5.5c.4-.4.6-.9.6-1.4s-.2-1-.6-1.4l-5.5-5.5-1.4 1.4L18 11H3v2z" })
), A = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(O), B = A, T = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M13 21V6l4.5 4.5 1.4-1.4-5.5-5.5C13 3.2 12.5 3 12 3s-1 .2-1.4.6L5.1 9.1l1.4 1.4L11 6v15h2z" })
), V = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(T), F = V, _ = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "m12.379 1.045-.07-.07-.071.07L.929 12.354l-.07.07.07.071.571.571.071.071.07-.07 11.31-11.309.07-.07-.07-.071-.572-.572Z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M13 12.812h.1V.9H1.19v1.008h10.903V12.81H13Z" })
), f = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(_), N = f, $ = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M18.5 2 7.8 12.6l3.5 3.5L22 5.5 18.5 2zm-7.8 10.6 7.8-7.8.7.7-7.8 7.8-.7-.7zM6.4 14.5c-1.8 0-2.7 1.5-3.2 3.1L2 22l4.4-1.2c1.6-.5 3.1-1.4 3.1-3.1 0-1.8-1.4-3.2-3.1-3.2zm-.5 4.4-1.1.3.3-1.1c.3-1.2.8-1.7 1.3-1.8.7 0 1.2.5 1.2 1.3 0 .7-1.1 1.2-1.7 1.3z" })
), u = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)($), y = u, U = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M20 10.5c0-.6-.1-1.2-.2-1.7.8-.8 1-2 .4-3-.5-.8-1.3-1.3-2.2-1.3-.2 0-.5 0-.7.1-.8-.8-1.8-1.3-2.9-1.7C14.2 1.8 13.2 1 12 1s-2.2.8-2.4 1.9c-1.1.4-2.1.9-3 1.7-.2-.1-.4-.1-.7-.1-.8 0-1.7.5-2.1 1.3-.6 1-.4 2.3.4 3-.1.5-.2 1.1-.2 1.7 0 .6.1 1.2.2 1.7-.8.8-1 2-.4 3 .5.8 1.3 1.3 2.2 1.3.2 0 .5 0 .7-.1.7.6 1.5 1.1 2.3 1.5l-.6 2.2H4V22h16v-1.9h-4.3l-.6-2.2c.9-.4 1.6-.9 2.3-1.5.2.1.4.1.7.1.9 0 1.7-.4 2.2-1.3.6-1 .4-2.3-.4-3 0-.5.1-1.1.1-1.7zM18.1 6c.4 0 .7.2.9.5.2.5 0 1.1-.4 1.4-.2.1-.4.1-.5.1-.4 0-.7-.2-.9-.5-.3-.5-.1-1.1.4-1.4.1 0 .3-.1.5-.1zM12 2.5c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1zm-6.9 4c.1-.3.5-.5.8-.5.2 0 .3 0 .5.1.5.3.7.9.4 1.4-.2.3-.5.5-.9.5-.1 0-.3 0-.5-.1-.4-.3-.6-.9-.3-1.4zm0 8c-.3-.5-.1-1.1.3-1.4.2 0 .4-.1.5-.1.4 0 .7.2.9.5.3.5.1 1.1-.4 1.4-.1.1-.3.1-.5.1-.3 0-.7-.2-.8-.5zm8.6 5.6h-3.5l.5-1.7c.4.1.8.1 1.3.1s.8 0 1.3-.1l.4 1.7zm-2.4-3.5L12 14l.7 2.6h-1.4zm1.6-6.4c-.1-.4-.5-.7-.9-.7s-.8.3-.9.7L9.4 16c-.5-.2-.9-.5-1.3-.8.4-.7.4-1.7 0-2.4-.5-.8-1.3-1.3-2.1-1.3-.1-.3-.1-.7-.1-1 0-.3 0-.7.1-1 .8 0 1.7-.5 2.1-1.2.4-.8.4-1.7 0-2.4.5-.4 1.1-.8 1.7-1 .5.6 1.3 1.1 2.2 1.1.9 0 1.7-.5 2.1-1.2.6.2 1.2.6 1.7 1-.4.7-.4 1.7 0 2.4.5.8 1.4 1.3 2.2 1.3.1.3.1.7.1 1 0 .3 0 .7-.1 1-.8 0-1.7.5-2.1 1.2-.5.8-.4 1.7 0 2.4-.4.3-.8.6-1.3.8l-1.7-5.7zm6 4.3c-.2.3-.5.5-.9.5-.2 0-.3 0-.5-.1-.5-.3-.6-.9-.4-1.4.2-.3.5-.5.9-.5.2 0 .3 0 .5.1.5.3.7.9.4 1.4z" })
), P = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(U), Z = P, D = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M17.9 10.8c.1-.9 0-1.8-.2-2.8-.5-2.6-.8-6-.8-6H7s-.3 3.4-.8 6C6 9 5.9 9.9 6 10.8c.3 2.7 2.5 4.7 5 5.1V20H7v2h10v-2h-4v-4.1c2.4-.4 4.6-2.3 4.9-5.1zM12 4h3.2c.1.9.2 1.9.4 3H8.4c.2-1.1.3-2.1.4-3H12zm-4 6.6c-.1-.5 0-1 0-1.6h7.8c.1.6.1 1.1 0 1.6-.2 2-1.9 3.1-3.4 3.4h-1.1c-1.4-.3-3-1.4-3.3-3.4z" })
), G = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(D), I = G, k = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M5 4h5v1.9H5zM17.6 12c-.1 0-.1 0 0 0l-1.1-5.4c-.1-.2 0-.4.1-.5.1-.1.2-.2.4-.2h3V4h-3c-.8 0-1.5.4-2 1s-.6 1.4-.5 2l.2 1H7.2l-.7 4C4 12 2 14 2 16.5S4 21 6.5 21s4.5-2 4.5-4.5c0-1.8-1.1-3.4-2.7-4.1l.5-2.5h6.3l.5 2.6c-1.5.7-2.6 2.3-2.6 4 0 2.5 2 4.5 4.5 4.5s4.5-2 4.5-4.5-1.9-4.5-4.4-4.5zm-8.4 4.5c0 1.5-1.2 2.7-2.7 2.7S3.8 18 3.8 16.5c0-1.4 1-2.5 2.3-2.7l-.5 3h1.9l.5-2.5c.7.4 1.2 1.3 1.2 2.2zm8.4 2.7c-1.5 0-2.7-1.2-2.7-2.7 0-.9.4-1.7 1.1-2.2l.5 2.5h1.9l-.6-3c1.4.1 2.4 1.3 2.4 2.7.1 1.5-1.1 2.7-2.6 2.7z" })
), b = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(k), Y = b, K = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M5.6 6.2c.9 0 1.6-.7 1.6-1.6S6.5 3 5.6 3C4.7 3 4 3.7 4 4.6s.7 1.6 1.6 1.6zM9.9 6.2c.9 0 1.6-.7 1.6-1.6S10.8 3 9.9 3c-.9 0-1.6.7-1.6 1.6S9 6.2 9.9 6.2zM14.1 6.2c.9 0 1.6-.7 1.6-1.6S15 3 14.1 3s-1.6.7-1.6 1.6.7 1.6 1.6 1.6z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 18.4, cy: 4.6, r: 1.6 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M5.6 17.8c-.9 0-1.6.7-1.6 1.6 0 .9.7 1.6 1.6 1.6.9 0 1.6-.7 1.6-1.6 0-.9-.7-1.6-1.6-1.6zM9.9 17.8c-.9 0-1.6.7-1.6 1.6 0 .9.7 1.6 1.6 1.6.9 0 1.6-.7 1.6-1.6 0-.9-.7-1.6-1.6-1.6zM14.1 17.8c-.9 0-1.6.7-1.6 1.6 0 .9.7 1.6 1.6 1.6s1.6-.7 1.6-1.6c0-.9-.7-1.6-1.6-1.6zM18.4 17.8c-.9 0-1.6.7-1.6 1.6 0 .9.7 1.6 1.6 1.6s1.6-.7 1.6-1.6c0-.9-.7-1.6-1.6-1.6zM20 16V8H4v8h16zm-1.8-6.2v4.4H5.8V9.8h12.4z" })
), j = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(K), q = j, J = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 770 392",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      clipRule: "evenodd",
      d: "M404.975-198.944c-32.127 19.292-75.9 55.64-82.19 125.216-5.483 60.644 37.02 117.455 86.545 137.757C238.619 22.203 6.016 116.129.26 294.745c-3.277 47.683 27.406 87.822 54.99 123.907l.032.041c1.284 1.68 2.56 3.35 3.827 5.012 70.754 76.44 184.136 108.056 284.054 79.144 32.211-9.572 63.408-23.482 92.266-41.175-17.978 14.924-32.22 33.263-40.903 54.955-17.468 38.168-2.08 82.524 28.645 108.472 4.454 4.232 9.2 7.987 14.158 11.391-15.295-6.014-29.823-10.147-41.347-12.795-29.737-6.864-75.745-11.284-121.181 12.48-45.436 23.764-51.727 95.056-46.684 129.844 5.043 34.788 39.146 68.224 90.873 84.084 51.726 15.86 107.3 17.16 145.146 0 37.846-17.16 84.582-59.436 68.154-124.124-7.364-28.999-27.286-50.662-50.718-66.587 6.269 2.784 12.523 5.573 18.643 8.555 4.797 2.348 10.518 5.471 16.827 8.914l.002.001.001.001c16.045 8.757 35.893 19.591 54.027 25.04 46.207 12.328 96.077-11.716 138.134-31.992 2.469-1.19 4.912-2.368 7.325-3.524 27.916-14.56 43.304-45.292 50.323-75.296 31.241-169.17-182.454-214.889-303.092-148.579 13.247-9.854 25.831-20.565 37.596-32.069 61.76-58.812 90.457-173.42 70.338-214.552a203.27 203.27 0 0 0-12.581-26.495 89.667 89.667 0 0 1 1.508 2.419c2.406 3.99 4.469 8.179 6.531 12.369l.001.001c2.749 5.586 5.499 11.172 9.064 16.282a45.394 45.394 0 0 0 4.939 6.032 51.623 51.623 0 0 0 16.583 11.492c2.652 1.144 5.355 2.132 8.058 3.12.431.159.86.318 1.288.478 2.106.783 4.194 1.561 6.354 2.122 2.252.58 4.523 1.059 6.79 1.538 1.397.295 2.792.589 4.179.906a168.297 168.297 0 0 0 38.158 4.212c6.603 0 13.205-.416 19.755-1.248a105.529 105.529 0 0 0 9.826-1.872c.179-.039.36-.078.542-.115l.356-.073c1.129-.23 2.276-.463 3.261-.956 1.039-.572 2.131-.988 3.275-1.352a96.568 96.568 0 0 0 16.843-6.76c4.055-2.08 7.954-4.368 11.749-6.968a100.253 100.253 0 0 0 23.498-21.944c1.716-2.236 3.275-4.576 4.731-6.968 6.706-11.284 10.605-23.972 11.437-37.076.52-7.852.104-16.068-2.131-23.608a185.086 185.086 0 0 0-2.496-7.592 133.319 133.319 0 0 0-4.782-11.284 98.832 98.832 0 0 0-1.664-3.328c-4.939-9.464-11.073-18.252-18.195-26.208a123.18 123.18 0 0 0-24.174-20.8c-4.471-2.912-9.098-5.564-13.932-7.852-1.43-.682-2.844-1.395-4.259-2.108-3.113-1.57-6.229-3.14-9.518-4.392-5.926-2.236-12.009-3.9-18.299-4.94-3.015-.468-6.03-.832-9.046-1.04-1.403-.156-2.755-.208-4.159-.104-.332.024-.654.091-.969.157h-.001c-.375.079-.742.155-1.109.155-1.04-.052-2.132-.156-3.171-.364-4.419-.416-8.89 0-13.205 1.248a49.597 49.597 0 0 0-5.683 1.901 135.417 135.417 0 0 0 7.919-6.113c53.13-44.304 35.403-144.196 15.18-177.112s-96.903-84.76-155.96-75.92c-59.057 8.84-72.521 12.896-93.212 25.324Zm136.406 342.201c-27.576-34.362-65.609-58.24-108.845-72.566 49.006 8.31 124.229 4.145 178.334-23.595-1.293.973-2.579 1.956-3.865 2.939-5.762 4.404-11.521 8.807-17.894 12.27-4.745 2.582-9.749 4.58-14.743 6.573l-.004.002h-.001c-2.444.976-4.886 1.95-7.294 2.992-7.33 3.172-14.66 7.02-20.171 12.844-6.966 7.384-11.073 17.68-11.853 27.768a39.72 39.72 0 0 0 .208 8.944c.052.572.104 1.144.104 1.716.052 1.3.156 2.6.312 3.9.208 1.768.572 3.484 1.04 5.2.52 1.612 1.092 3.224 1.82 4.784a59.694 59.694 0 0 0 2.852 6.229Z"
    }
  )
), Q = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(J), X = Q, W = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 7, cy: 15, r: 1 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 17, cy: 15, r: 1 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M6 18.1h12v1.8H6z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M18 2H6C3.8 2 2 3.8 2 6v16h2v-8c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2v8h2V6c0-2.2-1.8-4-4-4zm0 8H6c-.7 0-1.4.2-2 .6V6c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2v4.6c-.6-.4-1.3-.6-2-.6z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M9.5 5.2h5V7h-5z" })
), e1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(W), t1 = e1, c1 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 7, cy: 15, r: 1 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 17, cy: 15, r: 1 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M6 18.1h12v1.8H6z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "m19.9 10.5-.6-4.1c-.3-2-2-3.4-4-3.4H8.6c-2 0-3.7 1.5-4 3.4L4 10.5c-1.2.7-2 2-2 3.5v8h2v-8c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2v8h2v-8c0-1.5-.8-2.8-2.1-3.5zM8.6 5h6.8c1 0 1.8.7 2 1.7l.5 3.3H6.2l.5-3.3c.1-1 .9-1.7 1.9-1.7z" })
), r1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(c1), l1 = r1, n1 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      className: "Check_svg__st0",
      d: "M10 18c-.2 0-.5-.1-.7-.3l-6-5.4 1.3-1.5 5.3 4.8 10.4-9.4 1.3 1.5-11 10c-.2.2-.4.3-.6.3z"
    }
  )
), h1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(n1), a1 = h1, s1 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M19.7 9.7 12 17.4 4.3 9.7l1.4-1.4 6.3 6.3 6.3-6.3z" })
), m1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(s1), o1 = m1, v1 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M14.3 19.7 6.6 12l7.7-7.7 1.4 1.4L9.4 12l6.3 6.3z" })
), w1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(v1), E1 = w1, g1 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "m9.7 4.3 7.7 7.7-7.7 7.7-1.4-1.4 6.3-6.3-6.3-6.3z" })
), p1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(g1), d1 = p1, M1 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M4.3 14.3 12 6.6l7.7 7.7-1.4 1.4L12 9.4l-6.3 6.3z" })
), i1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(M1), S1 = i1, z1 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M10.3 8.4c0-.9-.8-1.6-1.6-1.6-.9 0-1.6.8-1.6 1.6 0 .9.7 1.6 1.6 1.6.9 0 1.6-.7 1.6-1.6zM2 3h9v2H2zM5.9 8.4c0-.9-.7-1.6-1.6-1.6s-1.6.7-1.6 1.6.7 1.6 1.6 1.6 1.6-.8 1.6-1.6zM21.3 8.4c0-.9-.8-1.6-1.6-1.6-.9 0-1.6.8-1.6 1.6 0 .9.7 1.6 1.6 1.6.9 0 1.6-.7 1.6-1.6zM13 3h9v2h-9zM16.9 8.4c0-.9-.8-1.6-1.6-1.6s-1.6.8-1.6 1.6c0 .9.7 1.6 1.6 1.6.9 0 1.6-.7 1.6-1.6zM8.7 17.8c-.9 0-1.6.7-1.6 1.6 0 .9.7 1.6 1.6 1.6s1.6-.7 1.6-1.6c0-.9-.7-1.6-1.6-1.6zM2 14h9v2H2zM4.3 17.8c-.9 0-1.6.7-1.6 1.6 0 .9.7 1.6 1.6 1.6s1.6-.7 1.6-1.6c0-.9-.7-1.6-1.6-1.6zM19.7 17.8c-.9 0-1.6.7-1.6 1.6 0 .9.7 1.6 1.6 1.6s1.6-.7 1.6-1.6c0-.9-.7-1.6-1.6-1.6zM13 14h9v2h-9zM15.3 17.8c-.9 0-1.6.7-1.6 1.6 0 .9.7 1.6 1.6 1.6s1.6-.7 1.6-1.6c0-.9-.7-1.6-1.6-1.6z" })
), x1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(z1), H1 = x1, R1 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M13 6h-2v7h6v-2h-4z" })
), C1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(R1), L1 = C1, O1 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M21 4.4 19.6 3 12 10.6 4.4 3 3 4.4l7.6 7.6L3 19.6 4.4 21l7.6-7.6 7.6 7.6 1.4-1.4-7.6-7.6z" })
), A1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(O1), B1 = A1, T1 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M10.3 7c1.8 0 3.5 1.1 3.9 3.2h2.5c1.8 0 3.4 1.5 3.4 3.4S18.6 17 16.7 17H6.5C5.2 17 4 15.8 4 14.2c0-1.2 1.1-2.5 2.5-2.6C6.1 8.5 8.1 7 10.3 7m0-2c-1.8 0-3.4.7-4.5 1.9-.6.7-1.2 1.7-1.4 3.3C3 11 2 12.6 2 14.2 2 16.8 4 19 6.5 19h10.2c3 0 5.4-2.4 5.4-5.4s-2.4-5.4-5.4-5.4h-1c-1.1-2-3.1-3.2-5.4-3.2z" })
), V1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(T1), F1 = V1, _1 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M3 18h6.3v2H3z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M21 15.6V4H3v11.7h8V20h10v-2h-8v-2.4h8zm-3.4-9.7-3.9 3.5c-.9.8-2.4.8-3.3 0l-4-3.5h11.2zM4.9 7l4.3 3.7c.8.7 1.8 1 2.8 1s2.1-.3 2.8-1L19.1 7v6.8H4.9V7z" })
), f1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(_1), N1 = f1, $1 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M24 0v24H0V0" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M19.5 2h-10C8.7 2 8 2.7 8 3.5V7H4.5C3.7 7 3 7.7 3 8.5v12c0 .8.7 1.5 1.5 1.5h10c.8 0 1.5-.7 1.5-1.5V17h3.5c.8 0 1.5-.7 1.5-1.5v-12c0-.8-.7-1.5-1.5-1.5zM14 20H5V9h9v11zm5-5h-3V8.5c0-.8-.7-1.5-1.5-1.5H10V4h9v11z" })
), u1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)($1), y1 = u1, U1 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M20 9v8c0 1.7-1.3 3-3 3H7c-1.7 0-3-1.3-3-3V9H2v8c0 2.8 2.2 5 5 5h10c2.8 0 5-2.2 5-5V9h-2z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "m16.7 11.7-1.4-1.4-2.3 2.4V2h-2v10.7l-2.3-2.4-1.4 1.4 4.7 4.6z" })
), P1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(U1), Z1 = P1, D1 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 18",
    xmlSpace: "preserve",
    ref: c,
    ...t,
    fill: "none"
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M21.6471 11.7391L9.54924 11.7391M0.647064 11.7391H3.15793", stroke: "currentColor" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: "6.58184", cy: "3.52174", r: "2.23913", stroke: "currentColor" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: "16.1688", cy: "3.52174", r: "2.23913", stroke: "currentColor" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M19.3645 10.3696L19.8636 10.3402C19.8642 10.35 19.8645 10.3598 19.8645 10.3696L19.3645 10.3696ZM18.8653 10.3989C18.7694 8.76773 17.5494 7.96774 16.3128 7.97109C15.6918 7.97278 15.0946 8.18101 14.659 8.57219C14.232 8.95555 13.9297 9.54104 13.9297 10.3696L12.9297 10.3696C12.9297 9.27368 13.3407 8.41192 13.9908 7.82813C14.6323 7.25217 15.476 6.97336 16.3101 6.9711C17.9839 6.96655 19.7313 8.09097 19.8636 10.3402L18.8653 10.3989ZM19.8645 10.3696L19.8645 11.0544L18.8645 11.0544L18.8645 10.3696L19.8645 10.3696ZM13.9297 10.3696L13.9297 11.0543L12.9297 11.0543L12.9297 10.3696L13.9297 10.3696Z", fill: "currentColor" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M9.77749 10.3695L10.2766 10.3402C10.2772 10.35 10.2775 10.3597 10.2775 10.3695L9.77749 10.3695ZM9.27836 10.3989C9.1824 8.7677 7.96244 7.9677 6.72586 7.97106C6.10478 7.97275 5.50764 8.18097 5.07198 8.57216C4.64503 8.95552 4.34271 9.54101 4.34271 10.3695L3.34271 10.3695C3.34271 9.27365 3.7537 8.41189 4.40387 7.8281C5.04531 7.25214 5.88907 6.97333 6.72315 6.97107C8.3969 6.96652 10.1443 8.09094 10.2766 10.3402L9.27836 10.3989ZM10.2775 10.3695L10.2775 17.2174L9.27749 17.2174L9.27749 10.3695L10.2775 10.3695ZM4.34271 10.3695L4.34271 17.2174L3.34271 17.2174L3.34271 10.3695L4.34271 10.3695Z", fill: "currentColor" })
), G1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(D1), I1 = G1, k1 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 16",
    xmlSpace: "preserve",
    ref: c,
    ...t,
    fill: "none"
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M2.82352 16L2.82352 11.2737L2.82352 10.8235", stroke: "currentColor" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M18.8235 16L18.8235 11.2737L18.8235 10.8235", stroke: "currentColor" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M13.6471 8L14.1462 7.97064C14.1468 7.98041 14.1471 7.99021 14.1471 8L13.6471 8ZM13.1479 8.02936C13.0485 6.33838 11.7828 5.50874 10.5014 5.51222C9.85786 5.51396 9.23852 5.72969 8.78627 6.13578C8.34273 6.53403 8.02942 7.14183 8.02942 8L7.02942 8C7.02942 6.87446 7.4514 5.9904 8.11816 5.39171C8.7762 4.80086 9.64215 4.51455 10.4986 4.51222C12.2172 4.50755 14.0104 5.66162 14.1462 7.97064L13.1479 8.02936ZM14.1471 8L14.1471 8.70588L13.1471 8.70588L13.1471 8L14.1471 8ZM8.02942 8L8.02942 8.70588L7.02942 8.70588L7.02942 8L8.02942 8Z", fill: "currentColor" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: "3.76469", cy: "2.82353", r: "2.32353", stroke: "currentColor" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M0.941162 8.70588L0.941162 8C0.941162 5.97741 2.46997 4.90551 3.99999 4.94118", stroke: "currentColor" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: "2.82353", cy: "2.82353", r: "2.32353", transform: "matrix(-1 0 0 1 20.2353 0)", stroke: "currentColor" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M20.2353 8.70588L20.2353 8C20.2353 5.97741 18.7065 4.90551 17.1765 4.94118", stroke: "currentColor" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M21.6471 10.3529L1.88236 10.3529H5.30481e-06", stroke: "currentColor" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: "10.3529", cy: "2.82353", r: "2.32353", stroke: "currentColor" })
), b1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(k1), Y1 = b1, K1 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M12.1 15.2c-1 0-1.9-.5-2.2-1.4h2.9v-1.4H7.7c0 2.9 1.7 4.6 4.4 4.6 2.3 0 3.9-1.5 4.2-3.8l-2.1-.2c-.1 1.3-.9 2.2-2.1 2.2zM12.1 7c-2.6 0-4.3 1.8-4.4 4.6h5.2v-1.4h-3c.3-.8 1.2-1.4 2.2-1.4 1.2 0 2 .8 2.1 2.1l2.1-.2C16 8.4 14.3 7 12.1 7z" })
), j1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(K1), q1 = j1, J1 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M16.6 4V2h-1.9v2H9V2H7v2H2v18h20V4h-5.4zM20 20H4V6h3v2h2V6h5.7v2h1.9V6H20v14z" })
), Q1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(J1), X1 = Q1, W1 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      style: {
        fill: "none"
      },
      d: "M0 0h24v24H0z"
    }
  ),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M21.3 10c-1-1.3-2.3-2.4-3.7-3.3C16 5.7 14 5 11.9 5c-2 0-3.9.7-5.5 1.8-1.4.9-2.7 2-3.7 3.2-.5.6-.7 1.3-.7 2s.2 1.4.7 2c1.1 1.4 2.4 2.5 3.9 3.5 1.6 1 3.5 1.6 5.4 1.6s3.8-.5 5.4-1.6c1.5-.9 2.8-2.1 3.9-3.5.5-.6.7-1.2.7-2 0-.7-.3-1.4-.7-2zm-1.6 2.7c-.9 1.2-2.1 2.2-3.4 3-1.3.9-2.8 1.3-4.3 1.3s-3-.4-4.3-1.3c-1.3-.8-2.5-1.8-3.4-3-.2-.2-.3-.4-.3-.7 0-.2.1-.5.3-.7.9-1.1 2-2.1 3.2-2.9C8.8 7.5 10.3 7 11.9 7c1.6 0 3.3.5 4.6 1.4 1.2.8 2.3 1.7 3.2 2.9.2.2.3.4.3.7s-.1.5-.3.7z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M12 8.8c-1.8 0-3.2 1.5-3.2 3.2s1.5 3.2 3.2 3.2 3.2-1.5 3.2-3.2-1.4-3.2-3.2-3.2zm0 4.6c-.8 0-1.4-.6-1.4-1.4 0-.8.6-1.4 1.4-1.4.8 0 1.4.6 1.4 1.4 0 .8-.6 1.4-1.4 1.4z" })
), e2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(W1), t2 = e2, c2 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M6.5 10.6C7.9 10.6 9 9.5 9 8.1S7.9 5.6 6.5 5.6 4 6.7 4 8.1s1.1 2.5 2.5 2.5zm0-3.3c.4 0 .8.4.8.8s-.4.8-.8.8-.8-.4-.8-.8.4-.8.8-.8zM17.5 7C18.9 7 20 5.9 20 4.5S18.9 2 17.5 2 15 3.1 15 4.5 16.1 7 17.5 7zm0-3.3c.4 0 .8.4.8.8s-.4.8-.8.8-.8-.4-.8-.8.4-.8.8-.8zM22 11.7c0-2.1-1.8-3.8-3.9-3.8h-1.2c-2.2 0-3.9 1.8-3.9 3.9V14c0 .6-.4 1-1 1-.5 0-.7-.2-1.2-1.1-.2-.3-.3-.6-.5-.8-.7-1-1.9-1.6-3.1-1.6H5.9c-2.2 0-3.9 1.8-3.9 3.9V22h2v-6.6c0-1.1.9-1.9 1.9-1.9h1.2c.6 0 1.2.3 1.5.8.2.2.3.4.4.7.5.9 1.2 2 3 2 1.7 0 3-1.3 3-3v-2.2c0-1.1.9-1.9 1.9-1.9h1.2c1 0 1.9.8 1.9 1.8V22h2V11.7z" })
), r2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(c2), l2 = r2, n2 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M22 11h-3V7.5C19 5.6 17.4 4 15.5 4H13V2h-2v2H8.5C6.6 4 5 5.6 5 7.5V11H2l3 9H2v2h20v-2h-3l3-9zM7 7.5C7 6.7 7.7 6 8.5 6h7c.8 0 1.5.7 1.5 1.5V11H7V7.5zM7.1 20l-2.3-7h14.4l-2.3 7H7.1z" })
), h2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(n2), a2 = h2, s2 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M10.8 4C10.4 2.8 9.3 2 8 2s-2.4.8-2.8 2H2v2h3.2C5.6 7.2 6.7 8 8 8s2.4-.8 2.8-2H22V4H10.8zM8 6.2c-.7 0-1.2-.5-1.2-1.2S7.3 3.8 8 3.8s1.2.5 1.2 1.2S8.7 6.2 8 6.2zM8 16c-1.3 0-2.4.8-2.8 2H2v2h3.2c.4 1.2 1.5 2 2.8 2s2.4-.8 2.8-2H22v-2H10.8c-.4-1.2-1.5-2-2.8-2zm0 4.2c-.7 0-1.2-.5-1.2-1.2s.5-1.2 1.2-1.2 1.2.5 1.2 1.2-.5 1.2-1.2 1.2zM16 9c-1.3 0-2.4.8-2.8 2H2v2h11.2c.4 1.2 1.5 2 2.8 2s2.4-.8 2.8-2H22v-2h-3.2c-.4-1.2-1.5-2-2.8-2zm0 4.2c-.7 0-1.2-.5-1.2-1.2s.5-1.2 1.2-1.2 1.2.5 1.2 1.2-.5 1.2-1.2 1.2z" })
), m2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(s2), o2 = m2, v2 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M10 6.8c0 1.7-.7 2.1-1.6 2.2V2h-2v7C5.6 8.9 5 8.5 5 6.8V2H3v4.8c0 3.5 2.1 4.1 3.5 4.2v11h2V11c1.4 0 3.5-.7 3.5-4.2V2h-2v4.8zM16.7 2H15v20h2V4c1.3.1 2 .9 2 2.3v9.2h2V6.3C21 3.7 19.3 2 16.7 2z" })
), w2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(v2), E2 = w2, g2 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm6.9 6h-3.3c-.2-1.4-.6-2.6-1-3.6 1.8.7 3.4 2 4.3 3.6zM14 12c0 .7 0 1.4-.1 2h-3.8c-.1-.6-.1-1.3-.1-2s0-1.4.1-2h3.8c.1.6.1 1.3.1 2zm-3.6 4h3.2c-.4 2.2-1.2 3.6-1.6 3.9-.4-.3-1.2-1.7-1.6-3.9zm0-8c.4-2.2 1.2-3.6 1.6-4 .4.3 1.2 1.7 1.6 4h-3.2zm-1-3.6c-.4 1-.8 2.2-1 3.6H5.1C6 6.4 7.6 5.1 9.4 4.4zM4.3 10h3.8c-.1.6-.1 1.3-.1 2s0 1.4.1 2H4.3c-.2-.6-.3-1.3-.3-2s.1-1.4.3-2zm.8 6h3.3c.2 1.4.6 2.6 1 3.6-1.8-.7-3.4-2-4.3-3.6zm9.5 3.6c.4-1 .8-2.2 1-3.6h3.3c-.9 1.6-2.5 2.9-4.3 3.6zm5.1-5.6h-3.8c.1-.6.1-1.3.1-2s0-1.4-.1-2h3.8c.2.6.3 1.3.3 2s-.1 1.4-.3 2z" })
), p2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(g2), d2 = p2, M2 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M18.1 12.8h-.5c.4.6.7 1.3.8 2 .9.1 1.6.9 1.6 1.9V20h2v-3.3c0-2.1-1.8-3.9-3.9-3.9zM2 16.7V20h2v-3.3c0-.9.7-1.7 1.6-1.9.1-.7.4-1.4.8-2h-.5c-2.1 0-3.9 1.8-3.9 3.9zM16.9 15.8c0-2.4-1.7-3.9-3.8-3.9H11c-2.2 0-3.9 1.8-3.9 3.9V20h2v-4.2c0-1.1.9-1.9 1.9-1.9h2c1 0 1.9.8 1.9 1.9V20h2v-4.2zM12 10c1.7 0 3-1.3 3-3s-1.3-3-3-3-3 1.3-3 3 1.3 3 3 3zm0-4.3c.7 0 1.3.6 1.3 1.3s-.6 1.3-1.3 1.3-1.3-.6-1.3-1.3.6-1.3 1.3-1.3zM18.5 11.7c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5S16 7.8 16 9.2s1.1 2.5 2.5 2.5zm0-3.3c.4 0 .8.4.8.8s-.4.8-.8.8-.8-.4-.8-.8.4-.8.8-.8zM5.5 11.7c1.4 0 2.5-1.1 2.5-2.5S6.9 6.7 5.5 6.7 3 7.8 3 9.2s1.1 2.5 2.5 2.5zm0-3.3c.4 0 .8.4.8.8s-.4.8-.8.8-.8-.3-.8-.8.4-.8.8-.8z" })
), i2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(M2), S2 = i2, z2 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M13 2H0V0h13v2ZM13 16H0v-2h13v2ZM0 9h20V7H0v2Z" })
), x2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(z2), H2 = x2, R2 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M16.2 4C18.5 4 20 5.6 20 8c0 3.5-3.1 6.7-7.5 10.8l-.5.4-.5-.5C7.1 14.7 4 11.5 4 8c0-2.4 1.5-4 3.8-4 .9 0 1.7.3 2.4 1 .7.6 1.3.7 1.8.7s1.1-.1 1.8-.7c.7-.7 1.5-1 2.4-1m0-2c-1.4 0-2.7.5-3.8 1.5-.2.2-.2.2-.4.2s-.2 0-.4-.2C10.5 2.5 9.2 2 7.8 2 4.4 2 2 4.5 2 8c0 4.5 3.7 8.1 8.2 12.2L12 22l1.8-1.8C18.3 16.1 22 12.5 22 8c0-3.5-2.4-6-5.8-6z" })
), C2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(R2), L2 = C2, O2 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M16.2 2c-1.4 0-2.7.5-3.7 1.5-.2.2-.2.2-.4.2s-.2 0-.4-.2C10.5 2.5 9.2 2 7.8 2 4.4 2 2 4.5 2 8c0 4.5 3.7 8.1 8.2 12.2L12 22l1.8-1.8C18.3 16.1 22 12.5 22 8c0-3.5-2.4-6-5.8-6z" })
), A2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(O2), B2 = A2, T2 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M12.2 14.1C8.6 13.2 7 11.5 7 8.4V2H5v6.4c0 2.3.7 4 2.1 5.3V22h2v-6.9c.8.4 1.6.7 2.7.9 3.4.8 4.2 1.3 4.2 4v2h2v-2c0-4.3-2.3-5.1-5.8-5.9z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M12.6 12c2.1 0 3.9-1.7 3.9-3.9s-1.7-3.9-3.9-3.9c-2.1 0-3.9 1.7-3.9 3.9s1.7 3.9 3.9 3.9zm0-5.8c1 0 1.9.8 1.9 1.9 0 1-.8 1.9-1.9 1.9-1 0-1.9-.8-1.9-1.9 0-1 .8-1.9 1.9-1.9z" })
), V2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(T2), F2 = V2, _2 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M11 11h2v7h-2z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 12, cy: 7.5, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z" })
), f2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(_2), N2 = f2, $2 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M14 16v-1c0-1.1-.9-2-2-2s-2 .9-2 2v1h4z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M7.9 16v-1c0-2.3 1.8-4.1 4.1-4.1s4.1 1.8 4.1 4.1v1H18v-1c0-3.3-2.7-6-6-6s-6 2.7-6 6v1h1.9z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M3.9 16v-1c0-4.5 3.6-8.1 8.1-8.1s8.1 3.6 8.1 8.1v1H22v-1c0-5.5-4.5-10-10-10S2 9.5 2 15v1h1.9z" })
), u2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)($2), y2 = u2, U2 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M9 4h13v2H9zM9 18h13v2H9zM9 11h13v2H9zM4.5 2.5C3.1 2.5 2 3.6 2 5s1.1 2.5 2.5 2.5S7 6.4 7 5 5.9 2.5 4.5 2.5zm0 3.2c-.4 0-.7-.3-.7-.7s.3-.7.7-.7.7.3.7.7-.3.7-.7.7zM4.5 16.5C3.1 16.5 2 17.6 2 19s1.1 2.5 2.5 2.5S7 20.4 7 19s-1.1-2.5-2.5-2.5zm0 3.2c-.4 0-.7-.3-.7-.7s.3-.7.7-.7.7.3.7.7-.3.7-.7.7zM4.5 9.5C3.1 9.5 2 10.6 2 12s1.1 2.5 2.5 2.5S7 13.4 7 12 5.9 9.5 4.5 9.5zm0 3.2c-.4 0-.7-.3-.7-.7s.3-.7.7-.7.7.3.7.7-.3.7-.7.7z" })
), P2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(U2), Z2 = P2, D2 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 12, cy: 10.5, r: 3 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M18.5 3.7C16.7 1.9 14.4 1 12 1c-2.4 0-4.7.9-6.5 2.7-1.8 1.8-2.7 4.1-2.7 6.4 0 2.3.9 4.7 2.7 6.4L12 23l6.5-6.5c1.8-1.8 2.7-4.1 2.7-6.4 0-2.3-.9-4.7-2.7-6.4zm-1.4 11.4L12 20.2l-5.1-5.1c-1.3-1.3-2.1-3.1-2.1-5s.7-3.7 2.1-5C8.3 3.7 10.1 3 12 3c1.9 0 3.7.7 5.1 2.1 1.3 1.3 2.1 3.1 2.1 5s-.8 3.7-2.1 5z" })
), G2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(D2), I2 = G2, k2 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M16.7 3.7c-1.1.3-1.8.3-2.6.1L10 2.4c-.9-.3-1.8-.3-2.8-.1L2 3.3v18.1l5.6-1.1c.6-.1 1.2-.1 1.8.1l4.1 1.4c.5.2 1 .2 1.5.2.6 0 1.4-.1 2.2-.3l4.8-1.5V2l-5.3 1.7zM7.2 18.4l-3.3.7V4.9l3.7-.7c.2 0 .3-.1.5-.1v14.3c-.3-.1-.6 0-.9 0zm2.9.2h-.2V4.4l3.6 1.2c.2.1.4.1.6.2V20l-4-1.4zm10 .2-3.4 1.1c-.3.1-.5.1-.8.2V5.8c.4-.1.9-.2 1.3-.3l2.9-.9v14.2z" })
), b2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(k2), Y2 = b2, K2 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M2 4h13v2H2zM2 18h13v2H2zM2 11h20v2H2z" })
), j2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(K2), q2 = j2, J2 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M2 11h20v2H2z" })
), Q2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(J2), X2 = Q2, W2 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M6 3h12v2H6zM4 7h16v2H4zM6 19h12v2H6zM2 11h20v2H2zM4 15h16v2H4z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" })
), ee = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(W2), te = ee, ce = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M6.6 6v.9c0 5.8 4.7 10.5 10.4 10.5.4 0 .7 0 1.1-.1-1.5 1.7-3.6 2.8-6 2.8-4.4 0-8.2-3.7-8.2-8.1 0-2.4 1.1-4.5 2.7-6M10 2.1c-4.5 1-8.1 5-8.1 9.9 0 5.6 4.7 10.1 10.2 10.1 4.9 0 8.9-3.5 9.8-8.4-1.4 1-3.1 1.6-4.9 1.6-4.6 0-8.4-3.8-8.4-8.5 0-1.7.5-3.4 1.4-4.7z" })
), re = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(ce), le = re, ne = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M2 20h20v2H2zM7.6 15.8c.7 0 1.5-.2 2.2-.5l9.8-4.1c1.5-.6 2.3-1.8 2.3-3.1 0-1-.4-1.8-1.2-2.3-.9-.6-2.2-.7-3.5-.2L14.3 7l-3.4-3c-1.1-1-2.3-1.2-3.5-.7l-2.1.9 2.3 5.6L4.7 11l-.9-2-1.8.8 1.2 2.9c.9 2 2.5 3.1 4.4 3.1zm2.6-5L7.9 5.2l.3-.1c.3-.1.8-.2 1.4.3l4.3 3.9 4.2-1.8c.6-.2 1.2-.2 1.6 0 .2.2.3.4.3.7 0 .7-.8 1.1-1.1 1.2l-9.8 4.1c-1.5.6-2.7.3-3.5-.8l4.6-1.9z" })
), he = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(ne), ae = he, se = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M22 11h-9V2h-2v9H2v2h9v9h2v-9h9z" })
), me = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(se), oe = me, ve = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M12 2C7 2 2 5.3 2 12h1.7c.4-1.1 1.3-1.7 2.2-1.7s1.7.6 2.1 1.7h1.7c.4-1.1 1.4-1.7 2.3-1.7s1.9.6 2.3 1.7H16c.4-1.1 1.3-1.7 2.2-1.7.9 0 1.8.6 2.1 1.7H22c0-6.7-5-10-10-10zm6.2 6.4c-1.2 0-2.3.5-3.1 1.4A4.1 4.1 0 0 0 12 8.4c-1.2 0-2.3.5-3.1 1.4a4.1 4.1 0 0 0-3.1-1.4c-.5 0-.9.1-1.3.2C5.8 5.4 9 3.9 12 3.9c3.1 0 6.2 1.5 7.5 4.7-.4-.1-.8-.2-1.3-.2zM11 19.4c0 .4-.3.7-.7.7s-.7-.3-.7-.7v-1H7.7v1c0 1.5 1.2 2.6 2.6 2.6s2.6-1.2 2.6-2.6V12H11v7.4z" })
), we = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(ve), Ee = we, ge = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      style: {
        fill: "none"
      },
      d: "M0 0h24v24H0z"
    }
  ),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M2 15h2v7H2zM20.7 16.5l-2.9 2.4c-.9.7-2.2 1.2-3.4 1.2H8v-3h7c.6 0 1-.4 1-1s-.4-1-1-1H6V22h8.4c1.8 0 3.5-.6 4.7-1.6L22 18l-1.3-1.5zM11.1 7.6V13h4.7v-1.8h-2.9V7.6c.4-.1.8-.4 1.1-.7.5-.5.8-1.3.8-2 0-.4-.1-.8-.2-1.1-.1-.4-.4-.7-.6-.9-.3-.3-.6-.5-.9-.6-.3-.1-.7-.2-1-.2H12c-.4 0-.7.1-1.1.2-.4.1-.7.4-.9.6-.3.2-.5.5-.7.9-.1.3-.2.7-.2 1.1 0 .8.3 1.5.8 2 .4.3.8.5 1.2.7zm-.2-3.2c.1-.1.1-.3.3-.4.1-.1.2-.2.4-.2.1-.1.3-.1.4-.1.1 0 .3 0 .4.1.1.1.3.1.4.2.1.1.2.2.2.4.1.1.1.3.1.5 0 .3-.1.6-.3.8-.2.2-.5.3-.8.4-.3 0-.6-.1-.8-.4-.2-.2-.3-.5-.3-.9-.1-.1 0-.3 0-.4z" })
), pe = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(ge), de = pe, Me = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M12 1.7 2 10.6V22h2V11.4l8-7.1 8 7.1V22h2V10.6z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M13.1 16c0-.1-.1-.2-.1-.3-.2-.5-.4-1-.4-1.8 0-.7.2-1.3.5-1.9h-1.9c-.3.6-.5 1.2-.5 1.9 0 .9.2 1.3.4 1.8 0 .1.1.2.1.3.2.6.3 1.2.3 1.9 0 1-.2 1.6-.4 2.1H13c.2-.5.4-1.2.4-2.1 0-.7-.1-1.3-.3-1.9zM9.1 16c0-.1-.1-.2-.1-.3-.2-.5-.4-1-.4-1.8 0-.7.2-1.3.5-1.9h-2c-.3.6-.5 1.2-.5 1.9 0 .9.2 1.3.4 1.8 0 .1.1.2.1.3.2.6.3 1.2.3 1.9 0 1-.2 1.6-.4 2.1h2c.2-.5.4-1.2.4-2.1 0-.7-.1-1.3-.3-1.9zM17.1 16c0-.1-.1-.2-.1-.3-.2-.5-.4-1-.4-1.8 0-.7.2-1.3.5-1.9h-1.9c-.3.6-.5 1.2-.5 1.9 0 .9.2 1.3.4 1.8 0 .1.1.2.1.3.2.6.3 1.2.3 1.9 0 1-.2 1.6-.4 2.1H17c.2-.5.4-1.2.4-2.1 0-.7-.1-1.3-.3-1.9z" })
), ie = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Me), Se = ie, ze = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M9.5 2C5.3 2 2 5.3 2 9.5S5.3 17 9.5 17 17 13.7 17 9.5 13.7 2 9.5 2zm0 13C6.4 15 4 12.6 4 9.5S6.4 4 9.5 4c1.5 0 2.9.6 3.9 1.6S15 8 15 9.5c0 3.1-2.4 5.5-5.5 5.5zM15.78 17.215l1.415-1.414 4.738 4.737-1.415 1.415z" })
), xe = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(ze), He = xe, Re = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M20 10v7c0 1.7-1.3 3-3 3H7c-1.7 0-3-1.3-3-3v-7H2v7c0 2.8 2.2 5 5 5h10c2.8 0 5-2.2 5-5v-7h-2z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M11 5.6v9.8h2V5.6L15.3 8l1.4-1.3L12 2 7.3 6.7 8.7 8z" })
), Ce = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Re), Le = Ce, Oe = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M16.6 7v-.2c0-2.6-2.1-4.8-4.8-4.8C9.2 2.1 7 4.2 7 6.8V7H2v10c0 2.8 2.2 5 5 5h10c2.8 0 5-2.2 5-5V7h-5.4zM9 6.8C9 5.2 10.2 4 11.8 4s2.9 1.3 2.9 2.9V7H9v-.2zM20 17c0 1.7-1.3 3-3 3H7c-1.7 0-3-1.3-3-3V9h3v2h2V9h5.7v2h1.9V9H20v8z" })
), Ae = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Oe), Be = Ae, Te = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "m16.7 6-1.2-3h-7L7.3 6H2v10c0 2.8 2.2 5 5 5h10c2.8 0 5-2.2 5-5V6h-5.3zM20 16c0 1.7-1.3 3-3 3H7c-1.7 0-3-1.3-3-3V8H8.7l.5-1.3.7-1.7h4.3l.7 1.7.4 1.3H20v8z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M12 9c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0 6.1c-1.2 0-2.1-.9-2.1-2.1s.9-2.1 2.1-2.1 2.1.9 2.1 2.1-.9 2.1-2.1 2.1z" })
), Ve = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Te), Fe = Ve, _e = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M22 11.1h-4.4l2.8-2.9-1.3-1.3-4.2 4.2H13v-2l4.1-4.2-1.3-1.3L13 6.4V2h-2v4.4L8.2 3.6 6.9 4.9 11 9.1v2H9.1L4.9 6.9 3.6 8.2l2.8 2.9H2V13h4.4l-2.8 2.8 1.3 1.3L9.1 13H11v1.9l-4.1 4.2 1.3 1.3 2.8-2.8V22h2v-4.4l2.8 2.8 1.3-1.3-4.1-4.2V13h1.9l4.2 4.1 1.3-1.3-2.8-2.8H22z" })
), fe = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(_e), Ne = fe, $e = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      clipRule: "evenodd",
      d: "M20.44 10.238a9.656 9.656 0 0 0-1.632-.178c-1.173 0-1.25.51-1.25 1.326v1.453h2.933l-.256 3.009h-2.677V25h-3.671v-9.152H12v-3.01h1.887v-1.86c0-2.55 1.198-3.978 4.207-3.978 1.045 0 1.81.153 2.804.357l-.458 2.881Z"
    }
  )
), ue = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)($e), ye = ue, Ue = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      clipRule: "evenodd",
      d: "M16.005 10.864a5.14 5.14 0 0 0-5.14 5.138 5.14 5.14 0 0 0 10.28 0 5.14 5.14 0 0 0-5.14-5.138Zm0 8.47a3.334 3.334 0 1 1 0-6.667 3.334 3.334 0 0 1 0 6.668Z"
    }
  ),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M21.348 11.86a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4Z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      clipRule: "evenodd",
      d: "M16.006 6c-2.717 0-3.057.012-4.124.059-1.063.046-1.794.218-2.427.465-.66.257-1.22.597-1.774 1.156a4.9 4.9 0 0 0-1.157 1.77c-.246.637-.418 1.363-.465 2.426-.047 1.07-.059 1.41-.059 4.126 0 2.715.012 3.055.059 4.122.047 1.063.219 1.793.465 2.426.258.66.598 1.22 1.157 1.774a4.892 4.892 0 0 0 1.77 1.152c.637.247 1.364.419 2.427.465 1.067.047 1.408.059 4.124.059 2.716 0 3.056-.012 4.123-.059 1.064-.046 1.794-.218 2.428-.464a4.892 4.892 0 0 0 1.77-1.153 4.889 4.889 0 0 0 1.153-1.77c.247-.637.419-1.363.465-2.426.047-1.067.059-1.407.059-4.122 0-2.716-.012-3.055-.059-4.122-.046-1.063-.218-1.793-.465-2.426a4.685 4.685 0 0 0-1.145-1.778 4.892 4.892 0 0 0-1.77-1.153c-.638-.246-1.365-.418-2.428-.464-1.07-.051-1.41-.063-4.127-.063Zm0 1.801c2.673 0 2.99.012 4.041.059.977.043 1.505.207 1.857.344.465.18.801.398 1.149.746.352.351.567.684.746 1.149.137.351.302.882.344 1.855.047 1.055.06 1.372.06 4.04 0 2.672-.013 2.989-.06 4.04-.043.977-.207 1.504-.344 1.856-.18.465-.398.8-.746 1.148a3.078 3.078 0 0 1-1.15.747c-.35.137-.883.3-1.856.343-1.055.047-1.372.06-4.041.06-2.674 0-2.99-.013-4.042-.06-.977-.042-1.504-.206-1.856-.343a3.094 3.094 0 0 1-1.15-.747 3.076 3.076 0 0 1-.746-1.148c-.137-.352-.3-.883-.344-1.856-.047-1.055-.058-1.371-.058-4.04 0-2.672.011-2.989.058-4.04.043-.977.207-1.504.344-1.856.18-.464.399-.8.747-1.148a3.078 3.078 0 0 1 1.149-.746c.352-.137.883-.301 1.856-.344 1.052-.047 1.368-.059 4.042-.059Z"
    }
  )
), Pe = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Ue), Ze = Pe, De = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M24.5 6h-17C6.7 6 6 6.6 6 7.4v17.1c0 .9.7 1.5 1.5 1.5h17c.8 0 1.5-.6 1.5-1.4V7.4c0-.8-.7-1.4-1.5-1.4zM11.9 23H9v-9.5h3V23zm-1.5-10.8c-1 0-1.7-.8-1.7-1.7 0-.9.8-1.7 1.7-1.7.9 0 1.7.8 1.7 1.7.1.9-.7 1.7-1.7 1.7zM23 23h-3v-4.6c0-1.1 0-2.5-1.5-2.5s-1.8 1.2-1.8 2.5V23h-3v-9.5h2.8v1.3c.4-.8 1.4-1.5 2.8-1.5 3 0 3.6 2 3.6 4.5V23z" })
), Ge = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(De), Ie = Ge, ke = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M16 5.01c-6.2 0-11 4.53-11 10.66a10.46 10.46 0 0 0 3.45 7.9.88.88 0 0 1 .3.62l.06 2a.89.89 0 0 0 1.24.78l2.18-1a.85.85 0 0 1 .59-.05 11.8 11.8 0 0 0 3.18.42c6.2 0 11-4.54 11-10.67S22.2 5.01 16 5.01Zm6.6 8.22-3.22 5.12a1.66 1.66 0 0 1-2.39.44l-2.57-1.93a.66.66 0 0 0-.79 0l-3.48 2.63a.52.52 0 0 1-.75-.7l3.23-5.12a1.64 1.64 0 0 1 2.37-.44l2.57 1.93a.68.68 0 0 0 .8 0l3.47-2.63a.52.52 0 0 1 .76.69v.01Z" })
), be = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(ke), Ye = be, Ke = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M20.558 19.35c-1.178.748-2.796 1.046-3.867 1.153l.9.885 3.275 3.276c1.198 1.227-.753 3.149-1.965 1.965-.822-.83-2.024-2.033-3.276-3.29l-3.276 3.286c-1.212 1.183-3.163-.758-1.95-1.966.83-.831 2.024-2.034 3.275-3.276l.885-.884c-1.056-.113-2.704-.392-3.892-1.154-1.398-.905-2.014-1.433-1.471-2.533.318-.626 1.188-1.154 2.347-.244 0 0 1.56 1.241 4.077 1.241 2.518 0 4.078-1.241 4.078-1.241 1.153-.905 2.024-.382 2.346.244.528 1.1-.088 1.628-1.486 2.538Zm-10.516-8.776A5.577 5.577 0 0 1 15.615 5a5.577 5.577 0 0 1 5.574 5.574c0 3.065-2.503 5.559-5.574 5.559-3.07 0-5.573-2.494-5.573-5.56Zm2.835 0a2.743 2.743 0 0 0 2.738 2.738 2.74 2.74 0 0 0 2.738-2.738 2.742 2.742 0 0 0-2.738-2.748 2.742 2.742 0 0 0-2.738 2.748Z" })
), je = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Ke), qe = je, Je = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M16 5C9.924 5 5 9.924 5 16c0 4.662 2.9 8.641 6.991 10.244-.095-.872-.185-2.204.039-3.154l1.289-5.466s-.331-.657-.331-1.633c0-1.53.885-2.672 1.99-2.672.936 0 1.391.704 1.391 1.55 0 .946-.601 2.356-.91 3.662-.258 1.096.55 1.99 1.628 1.99 1.955 0 3.46-2.063 3.46-5.037 0-2.634-1.892-4.477-4.594-4.477-3.128 0-4.967 2.346-4.967 4.774 0 .945.365 1.96.82 2.51.09.107.103.206.078.313-.082.348-.271 1.096-.306 1.246-.047.202-.159.245-.369.146-1.375-.64-2.234-2.647-2.234-4.262 0-3.472 2.522-6.656 7.266-6.656 3.815 0 6.78 2.72 6.78 6.355 0 3.79-2.389 6.84-5.706 6.84-1.113 0-2.162-.58-2.522-1.263l-.684 2.617c-.249.954-.92 2.153-1.366 2.883 1.031.318 2.123.49 3.257.49 6.076 0 11-4.924 11-11S22.076 5 16 5Z" })
), Qe = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Je), Xe = Qe, We = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M11.921 24.876c8.3 0 12.84-6.878 12.84-12.841 0-.194-.003-.391-.012-.585A9.168 9.168 0 0 0 27 9.114a8.9 8.9 0 0 1-2.59.709 4.538 4.538 0 0 0 1.984-2.496 9.072 9.072 0 0 1-2.865 1.095 4.52 4.52 0 0 0-7.694 4.116 12.819 12.819 0 0 1-9.301-4.713 4.519 4.519 0 0 0 1.396 6.023 4.52 4.52 0 0 1-2.045-.563v.056a4.512 4.512 0 0 0 3.622 4.426 4.488 4.488 0 0 1-2.037.077 4.523 4.523 0 0 0 4.215 3.137A9.052 9.052 0 0 1 5 22.848a12.805 12.805 0 0 0 6.921 2.028Z" })
), e0 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(We), t0 = e0, c0 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      clipRule: "evenodd",
      d: "M8.134 10H5.8c-.667 0-.8.314-.8.66 0 .618.79 3.685 3.684 7.739 1.928 2.77 4.646 4.27 7.118 4.27 1.484 0 1.667-.333 1.667-.906V19.67c0-.667.141-.8.61-.8.347 0 .94.172 2.325 1.507 1.583 1.583 1.843 2.293 2.733 2.293h2.334c.667 0 1.001-.334.808-.992-.21-.655-.966-1.607-1.968-2.735-.545-.642-1.36-1.335-1.607-1.681-.347-.445-.248-.643 0-1.039 0 0 2.843-4.005 3.14-5.365.15-.494 0-.858-.707-.858h-2.333c-.593 0-.867.314-1.016.66 0 0-1.186 2.893-2.868 4.772-.544.544-.791.718-1.088.718-.148 0-.363-.174-.363-.668v-4.624c0-.593-.172-.858-.667-.858h-3.668c-.37 0-.593.275-.593.537 0 .562.84.692.927 2.274v3.437c0 .754-.135.89-.433.89-.79 0-2.715-2.906-3.857-6.23C8.954 10.261 8.73 10 8.134 10Z"
    }
  )
), r0 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(c0), l0 = r0, n0 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      clipRule: "evenodd",
      d: "M21.306 12.166a6.636 6.636 0 0 0-.366-.008c-4.377 0-7.928 2.974-7.928 6.645 0 .601.098 1.183.276 1.737a10.28 10.28 0 0 1-3.339-.353l-.148-.043-3.146 1.602.841-2.634-.08-.05C5.34 17.732 4 15.636 4 13.279 4 9.259 7.896 6 12.703 6c4.354 0 7.962 2.673 8.603 6.166Zm-11.631-.21c-.675 0-1.222-.531-1.222-1.184 0-.654.547-1.183 1.222-1.183.675 0 1.223.53 1.223 1.183s-.548 1.184-1.223 1.184Zm6.057-2.367c.675 0 1.222.53 1.222 1.183s-.547 1.184-1.222 1.184c-.676 0-1.221-.531-1.221-1.184 0-.654.545-1.183 1.221-1.183Z"
    }
  ),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      clipRule: "evenodd",
      d: "M21.006 24.996c-4.061 0-7.354-2.753-7.354-6.15 0-3.396 3.293-6.149 7.354-6.149 4.06 0 7.352 2.754 7.352 6.149 0 1.992-1.133 3.762-2.887 4.886l-.067.042.71 2.226-2.657-1.355s-.083.025-.125.036a8.644 8.644 0 0 1-2.326.315Zm-3.592-8.268c0-.551.463-1 1.032-1 .571 0 1.034.449 1.034 1 0 .553-.463 1.001-1.034 1.001-.57 0-1.032-.448-1.032-1.002Zm5.117 0c0-.551.462-1 1.032-1 .571 0 1.033.449 1.033 1 0 .553-.462 1.001-1.033 1.001-.57 0-1.032-.448-1.032-1.002Z"
    }
  )
), h0 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(n0), a0 = h0, s0 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M26.361 14.851c.834-.073 1.048-1.565.95-2.812-.258-3.299-3.036-5.796-6.716-5.312l-.151.018c-.435.05-.836.097-.926.607-.182 1.06.756.97 1.441.903.15-.015.286-.028.397-.028 2.188 0 4.422 1.793 4.372 4.374-.004.22-.051.476-.099.735-.144.79-.293 1.605.732 1.515Z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      clipRule: "evenodd",
      d: "M9.825 20.724c1.286 3.46 8.32 1.589 6.97-2.436-.405-1.202-1.775-2.126-3.612-1.94-2.154.224-4.22 2.063-3.358 4.376Z"
    }
  ),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      clipRule: "evenodd",
      d: "M22.04 15.414c-.25-.12-.503-.243-.748-.375.347-.89.562-2.042.003-2.688-.914-1.048-2.655-.574-4.068-.189-.555.151-1.06.289-1.444.314.631-1.902-.06-3.831-2.408-3.25-2.163.537-3.754 1.7-5.259 3.188-1.58 1.558-3.19 3.387-3.422 5.75-.27 2.743 1.479 4.12 3.168 5.062 5.035 2.807 13.101 1.255 15.775-2.438.376-.518.748-1.329.824-1.936.265-2.142-1.051-2.777-2.42-3.438Zm-1.445 3.189c.003 1.004-.506 1.867-1.013 2.435-1.386 1.552-4.306 2.568-7.224 2.378-2.525-.168-5.963-1.634-5.322-4.752.285-1.386 1.43-2.308 2.408-2.874 1.2-.694 2.348-1.049 4.055-1.187 3.122-.253 7.09.893 7.096 4Z"
    }
  ),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M24.21 12.039c.133.95-.144 1.776-.697 1.812-.692.045-.671-.328-.641-.861.01-.177.02-.373.007-.576-.035-.501-.456-1.08-.824-1.25-.265-.122-.583-.122-.879-.122-.511 0-.958 0-.958-.628 0-.648.502-.667.872-.68l.142-.007c1.602-.12 2.787.97 2.978 2.312Z" })
), m0 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(s0), o0 = m0, v0 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M23.802 8.21A10.957 10.957 0 0 0 6.558 21.427L5 27.102l5.809-1.523a10.95 10.95 0 0 0 11.32-.513A10.956 10.956 0 0 0 23.794 8.21h.01Zm-7.75 16.852c-1.63 0-3.23-.438-4.633-1.27l-.332-.197-3.457.904.92-3.359-.217-.344a9.107 9.107 0 1 1 7.714 4.266h.005Zm4.996-6.818c-.274-.137-1.62-.8-1.871-.89-.25-.092-.433-.137-.616.136s-.708.89-.867 1.073c-.159.183-.32.205-.593.069a7.464 7.464 0 0 1-2.207-1.359 8.302 8.302 0 0 1-1.523-1.895c-.16-.274-.016-.422.125-.558.142-.137.274-.321.411-.48.113-.139.205-.293.274-.457a.501.501 0 0 0-.024-.48c-.067-.136-.614-1.484-.842-2.031-.228-.547-.449-.462-.617-.47-.167-.007-.343-.01-.524-.01a1 1 0 0 0-.73.342c-.25.274-.959.937-.959 2.283 0 1.346.981 2.649 1.118 2.832.136.183 1.93 2.947 4.677 4.133.51.219 1.03.411 1.56.576.559.17 1.149.207 1.724.109.527-.08 1.62-.663 1.849-1.303.227-.64.227-1.187.16-1.301-.068-.114-.252-.182-.525-.32Z" })
), w0 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(v0), E0 = w0, g0 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M27.76 10.976s-.233-1.655-.955-2.382c-.914-.956-1.936-.96-2.405-1.017-3.356-.244-8.395-.244-8.395-.244h-.01s-5.039 0-8.395.244c-.469.056-1.49.061-2.405 1.017-.722.727-.951 2.382-.951 2.382S4 12.92 4 14.86v1.82c0 1.94.24 3.885.24 3.885s.233 1.655.95 2.381c.915.957 2.115.924 2.65 1.027 1.92.183 8.16.24 8.16.24s5.044-.01 8.4-.25c.469-.056 1.49-.06 2.405-1.017.722-.726.956-2.38.956-2.38S28 18.625 28 16.68v-1.819c0-1.94-.24-3.885-.24-3.885Zm-14.24 7.912v-6.745l6.483 3.384-6.483 3.361Z" })
), p0 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(g0), d0 = p0, M0 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "m12 5.5 1.7 3.6.4.9 1 .1 3.7.5-2.7 2.5-.7.7.2 1 .6 3.6-3.4-1.7-.8-.3-.9.4-3.4 1.7.6-3.6.2-1-.7-.7-2.7-2.5 3.7-.5 1-.1.4-.9L12 5.5M12 1 8.6 8.2 1 9.4l5.5 5.2L5.2 22l6.8-3.4 6.8 3.4-1.3-7.4L23 9.4l-7.6-1.1L12 1z" })
), i0 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(M0), S0 = i0, z0 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M12 7.5c-2.5 0-4.5 2-4.5 4.5s2 4.5 4.5 4.5 4.5-2 4.5-4.5-2-4.5-4.5-4.5zm0 7c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5zM11 2h2v4h-2zM4.16 5.636 5.576 4.22 8.403 7.05 6.99 8.464zM2 11h4v2H2zM4.222 18.425l2.828-2.829 1.414 1.415-2.828 2.828zM11 18h2v4h-2zM15.596 16.949l1.414-1.415 2.83 2.828-1.415 1.415zM18 11h4v2h-4zM15.535 6.99l2.829-2.829 1.414 1.414-2.828 2.829z" })
), x0 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(z0), H0 = x0, R0 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 3.2, cy: 20.8, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 6.4, cy: 20.8, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 9.5, cy: 20.8, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 14.5, cy: 20.8, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 17.6, cy: 20.8, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 20.8, cy: 20.8, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 3.2, cy: 16.4, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 6.4, cy: 16.4, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 9.5, cy: 16.4, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 14.5, cy: 16.4, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 17.6, cy: 16.4, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 20.8, cy: 16.4, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 3.2, cy: 12, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 6.4, cy: 12, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 9.5, cy: 12, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 14.5, cy: 12, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 17.6, cy: 12, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 20.8, cy: 12, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 3.2, cy: 7.7, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 6.4, cy: 7.7, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 9.5, cy: 7.7, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 14.5, cy: 7.7, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 17.6, cy: 7.7, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 20.8, cy: 7.7, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 3.2, cy: 3.3, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 6.4, cy: 3.3, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 9.5, cy: 3.3, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 14.5, cy: 3.3, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 17.6, cy: 3.3, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 20.8, cy: 3.3, r: 1.2 })
), C0 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(R0), L0 = C0, O0 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "116",
    height: "134",
    viewBox: "0 0 116 134",
    fill: "none",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      d: "M47.4704 134H63.1795V122.833H47.4704C25.2247 122.833 10.5699 110.103 10.5699 88.2167C10.5699 71.4667 19.2152 66.33 30.0745 58.8483C39.6686 52.26 50.0007 44.555 54.6397 25.125L57.2754 14.07C57.6971 12.1717 59.2786 11.1667 60.5438 11.1667C61.9143 11.1667 63.1795 12.1717 63.1795 14.2933V44.6667H73.7225V14.2933C73.7225 4.91333 67.2913 0 60.6492 0C55.694 0 49.6845 2.79166 47.6813 10.05L43.8858 24.0083C40.0903 38.19 32.0776 44.3317 23.0106 50.6967C10.4644 59.5183 0.65945 65.4367 0.0268696 87.1C-0.816571 117.808 18.2663 134 47.4704 134ZM73.8279 134H94.914V122.833H73.8279V134ZM73.8279 111.667H110.728V100.5H73.8279V111.667ZM73.8279 89.3333H116V78.1667H73.8279V89.3333ZM73.8279 67H105.457V55.8333H73.8279V67Z",
      fill: "#F8FCFF"
    }
  )
), A0 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(O0), B0 = A0, T0 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M19 15V6c0-2.2-1.8-4-4-4H9C6.8 2 5 3.8 5 6v9c0 1.9 1.3 3.5 3.1 3.9L5.9 22h2.5l2.1-3h2.9l2.1 3H18l-2.2-3.1c1.8-.4 3.2-2 3.2-3.9zm-2-9v3h-4.1V4H15c1.1 0 2 .9 2 2zM9 4h2.1v5H7V6c0-1.1.9-2 2-2zm6 13H9c-1.1 0-2-.9-2-2v-4.2h10V15c0 1.1-.9 2-2 2z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 12, cy: 13.9, r: 1.5 })
), V0 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(T0), F0 = V0, _0 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M21 13.1h-4.4L15 10l-2 4-3-6-2.6 5.1h-.5c-1 0-2-.6-2.4-1.6C4.2 10.7 4 9.9 4 9c0-2.4 1.5-4 3.8-4 .9 0 1.7.3 2.4 1 .7.6 1.3.7 1.8.7s1.1-.1 1.8-.7 1.5-1 2.4-1C18.5 5 20 6.6 20 9c0 .8-.2 1.5-.4 2.3h2.1c.2-.8.3-1.5.3-2.3 0-3.5-2.4-6-5.8-6-1.4 0-2.7.5-3.8 1.5-.2.2-.2.2-.4.2s-.2 0-.4-.2C10.5 3.5 9.2 3 7.8 3 4.4 3 2 5.5 2 9c0 1.1.2 2.2.7 3.2.7 1.6 2.3 2.7 4 2.7h1.9L10 12l3 6 2-4 .4.9h1.9c-1.3 1.5-2.9 3.1-4.9 4.9l-.4.4-.5-.5c-1.2-1.1-2.2-2.1-3.2-3.1H5.6c1.3 1.5 2.9 3 4.6 4.5L12 23l1.8-1.8c2.4-2.2 4.5-4.2 6-6.3H22v-1.8h-1z" })
), f0 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(_0), N0 = f0, $0 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M18.5 6C16.6 6 15 7.6 15 9.5h2c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5-.7 1.5-1.5 1.5H2v2h16.7c1.9-.1 3.4-1.6 3.4-3.5C22 7.6 20.4 6 18.5 6z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M14 5.5C14 3.6 12.4 2 10.5 2S7 3.6 7 5.5h2c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5S11.3 7 10.5 7H2v2h8.5C12.4 9 14 7.4 14 5.5zM15.5 15H2v2h13.5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5c-.5 0-.9-.2-1.2-.6-.2-.3-.3-.6-.3-.9h-2c0 .8.2 1.5.7 2.1.7.9 1.7 1.4 2.8 1.4 1.9 0 3.5-1.6 3.5-3.5S17.4 15 15.5 15z" })
), u0 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)($0), y0 = u0;
var U0 = /* @__PURE__ */ ((t) => (t.ACCOMMODATION = "ACCOMMODATION", t.ACTIVITY = "ACTIVITY", t.ARROW_DOWN = "ARROW_DOWN", t.ARROW_LEFT = "ARROW_LEFT", t.ARROW_RIGHT = "ARROW_RIGHT", t.ARROW_UP = "ARROW_UP", t.ARROW_UP_RIGHT = "ARROW_UP_RIGHT", t.ART_CULTURE = "ART_CULTURE", t.ATTRACTION = "ATTRACTION", t.BAR = "BAR", t.BICYCLE = "BICYCLE", t.BOARDROOM = "BOARDROOM", t.BUBBLES = "BUBBLES", t.BUS = "BUS", t.CAR = "CAR", t.CHECK = "CHECK", t.CHEVRON_DOWN = "CHEVRON_DOWN", t.CHEVRON_LEFT = "CHEVRON_LEFT", t.CHEVRON_RIGHT = "CHEVRON_RIGHT", t.CHEVRON_UP = "CHEVRON_UP", t.CLASSROOM = "CLASSROOM", t.CLOCK = "CLOCK", t.CLOSE = "CLOSE", t.CLOUD = "CLOUD", t.CONTACT = "CONTACT", t.COPY = "COPY", t.DOWNLOAD = "DOWNLOAD", t.EMPLOYER = "EMPLOYER", t.EMPLOYEE = "EMPLOYEE", t.EURO = "EURO", t.EVENT = "EVENT", t.EYE = "EYE", t.FAMILY = "FAMILY", t.FERRY = "FERRY", t.FILTER = "FILTER", t.FOOD = "FOOD", t.GLOBE = "GLOBE", t.GROUP = "GROUP", t.HAMBURGER = "HAMBURGER", t.HEART = "HEART", t.HEART_FILLED = "HEART_FILLED", t.INDIVIDUAL = "INDIVIDUAL", t.INFO = "INFO", t.LGBT = "LGBT", t.LIST = "LIST", t.LOCATION = "LOCATION", t.MAP = "MAP", t.MENU = "MENU", t.MINUS = "MINUS", t.MIST = "MIST", t.NIGHT = "NIGHT", t.PLANE = "PLANE", t.PLUS = "PLUS", t.RAIN = "RAIN", t.RENTAL = "RENTAL", t.SAUNA = "SAUNA", t.SEARCH = "SEARCH", t.SHARE = "SHARE", t.SHOPPING = "SHOPPING", t.SIGHTSEEING = "SIGHTSEEING", t.SNOW = "SNOW", t.SO_ME_FACEBOOK = "SO_ME_FACEBOOK", t.SO_ME_INSTAGRAM = "SO_ME_INSTAGRAM", t.SO_ME_LINKEDIN = "SO_ME_LINKEDIN", t.SO_ME_MESSENGER = "SO_ME_MESSENGER", t.SO_ME_ODNOKLASSISKI = "SO_ME_ODNOKLASSISKI", t.SO_ME_PINTEREST = "SO_ME_PINTEREST", t.SO_ME_TWITTER = "SO_ME_TWITTER", t.SO_ME_V_KONTAKTE = "SO_ME_V_KONTAKTE", t.SO_ME_WECHAT = "SO_ME_WECHAT", t.SO_ME_WEIBO = "SO_ME_WEIBO", t.SO_ME_WHATSAPP = "SO_ME_WHATSAPP", t.SO_ME_YOUTUBE = "SO_ME_YOUTUBE", t.STAR = "STAR", t.SUN = "SUN", t.THEATER = "THEATER", t.THUMBSUP = "THUMBSUP", t.TRAIN = "TRAIN", t.WELLBEING = "WELLBEING", t.WIND = "WIND", t))(U0 || {});
const P0 = {
  ACCOMMODATION: d,
  ACTIVITY: S,
  ARROW_DOWN: H,
  ARROW_LEFT: L,
  ARROW_RIGHT: B,
  ARROW_UP: F,
  ARROW_UP_RIGHT: N,
  ART_CULTURE: y,
  ATTRACTION: Z,
  BAR: I,
  BICYCLE: Y,
  BOARDROOM: q,
  BUBBLES: X,
  BUS: t1,
  CAR: l1,
  CHECK: a1,
  CHEVRON_DOWN: o1,
  CHEVRON_LEFT: E1,
  CHEVRON_RIGHT: d1,
  CHEVRON_UP: S1,
  CLASSROOM: H1,
  CLOCK: L1,
  CLOSE: B1,
  CLOUD: F1,
  CONTACT: N1,
  COPY: y1,
  DOWNLOAD: Z1,
  EMPLOYER: I1,
  EMPLOYEE: Y1,
  EURO: q1,
  EVENT: X1,
  EYE: t2,
  FAMILY: l2,
  FERRY: a2,
  FILTER: o2,
  FOOD: E2,
  GLOBE: d2,
  GROUP: S2,
  HAMBURGER: H2,
  HEART: L2,
  HEART_FILLED: B2,
  INDIVIDUAL: F2,
  INFO: N2,
  LGBT: y2,
  LIST: Z2,
  LOCATION: I2,
  MAP: Y2,
  MENU: q2,
  MINUS: X2,
  MIST: te,
  NIGHT: le,
  PLANE: ae,
  PLUS: oe,
  RAIN: Ee,
  RENTAL: de,
  SAUNA: Se,
  SEARCH: He,
  SHARE: Le,
  SHOPPING: Be,
  SIGHTSEEING: Fe,
  SNOW: Ne,
  SO_ME_FACEBOOK: ye,
  SO_ME_INSTAGRAM: Ze,
  SO_ME_LINKEDIN: Ie,
  SO_ME_MESSENGER: Ye,
  SO_ME_ODNOKLASSISKI: qe,
  SO_ME_PINTEREST: Xe,
  SO_ME_TWITTER: t0,
  SO_ME_V_KONTAKTE: l0,
  SO_ME_WECHAT: a0,
  SO_ME_WEIBO: o0,
  SO_ME_WHATSAPP: E0,
  SO_ME_YOUTUBE: d0,
  STAR: S0,
  SUN: H0,
  THEATER: L0,
  THUMBSUP: B0,
  TRAIN: F0,
  WELLBEING: N0,
  WIND: y0
}, G0 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function({ icon: c, size: l, width: s, height: m, color: o, className: v, viewBox: n, ...w }, E) {
  const h = {
    ...w,
    height: m || l || 30,
    width: s || l || 30,
    fill: o,
    className: v
  };
  n && (h.viewBox = n);
  const a = P0[c];
  return a ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(a, { ...h, ref: E }) : null;
});

//# sourceMappingURL=Icon-3122c134.mjs.map


/***/ }),

/***/ 5905:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ P; },
/* harmony export */   "a": function() { return /* binding */ g; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3406);
/* harmony import */ var _ImageContext_57256dc1_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2355);
/* harmony import */ var _Image_module_8b345b58_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9083);




var g = /* @__PURE__ */ ((e) => (e.ARTICLE_QUOTE = "imageArticleQuote", e.HERO = "imageHero", e.CARD = "imageCard", e.PROMOTION = "imagePromotion", e.MASONRY_CARD = "imageMasonryCard", e.ARTICLE_PAGE_HERO = "imageArticlePageHero", e.PREVIEW_CARD = "imagePreviewCard", e.MAPBOX = "imageMapBox", e))(g || {});
function P({
  src: e,
  width: i,
  height: m,
  altText: n,
  imageLoader: c,
  styling: r,
  className: p,
  errorHandler: u,
  credits: A
}) {
  const C = (0,_ImageContext_57256dc1_mjs__WEBPACK_IMPORTED_MODULE_1__.u)(), E = [n, A].filter(Boolean).join(" - ").trim() || "Image";
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "picture",
    {
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(_Image_module_8b345b58_mjs__WEBPACK_IMPORTED_MODULE_3__.i.picture),
      itemProp: "image",
      itemScope: !0,
      itemType: "https://schema.org/ImageObject"
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      C,
      {
        src: e,
        width: i,
        height: m,
        alt: E,
        loading: "lazy",
        loader: c,
        className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(p, r ? _Image_module_8b345b58_mjs__WEBPACK_IMPORTED_MODULE_3__.i[r] : void 0),
        onError: u,
        itemProp: "contentUrl",
        quality: 100
      }
    )
  );
}

//# sourceMappingURL=Image-d6406817.mjs.map


/***/ }),

/***/ 9083:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ p; }
/* harmony export */ });
const e = "picture", a = "picture--fall-back", i = "picture--animation", o = "skeleton-loading", t = "image__hero", r = "image__article-quote", m = "image__promotion", c = "image__card", n = "image__masonry-card", g = "image__article-page-hero", s = "image__preview_card", l = "image__map-box", _ = "mobile", p = {
  picture: e,
  pictureFallBack: a,
  pictureAnimation: i,
  skeletonLoading: o,
  imageHero: t,
  imageArticleQuote: r,
  imagePromotion: m,
  imageCard: c,
  imageMasonryCard: n,
  imageArticlePageHero: g,
  imagePreviewCard: s,
  imageMapBox: l,
  mobile: _
};

//# sourceMappingURL=Image.module-8b345b58.mjs.map


/***/ }),

/***/ 2355:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ a; },
/* harmony export */   "u": function() { return /* binding */ s; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);

const a = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(
  void 0
);
function s() {
  const t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(a);
  return t || c;
}
function c(t) {
  const e = { ...t };
  return delete e.loader, delete e.blurDataURL, delete e.onLoadingComplete, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", { ...e, src: e.src.toString() });
}

//# sourceMappingURL=ImageContext-57256dc1.mjs.map


/***/ }),

/***/ 965:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ N; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3406);
/* harmony import */ var _LinkContext_0c83848a_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2659);



const L = "link", x = "error", g = "no-href", a = {
  link: L,
  error: x,
  noHref: g
}, N = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function({
  className: l,
  children: n,
  href: t,
  disabled: i,
  disableLinkTextStyle: c,
  ...r
}, f) {
  const m = (0,_LinkContext_0c83848a_mjs__WEBPACK_IMPORTED_MODULE_1__.u)();
  if (!t)
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, n);
  const o = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
    !c && [a.link, _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.t.textsLink],
    l
  );
  return i ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(a.noHref, o) }, n) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    m,
    {
      href: t,
      prefetch: !1,
      className: o,
      ...r,
      ref: f,
      rel: r.target === "_blank" ? "noopener" : void 0
    },
    n
  );
});

//# sourceMappingURL=Link-479ac100.mjs.map


/***/ }),

/***/ 2659:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ a; },
/* harmony export */   "u": function() { return /* binding */ s; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);

const a = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(
  void 0
);
function s() {
  const t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(a);
  return t || l;
}
const l = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(e, o) {
  const r = typeof e.href == "string" ? e.href : e.href.href ?? "";
  if (!r)
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, e.children);
  const f = { ...e };
  return delete f.prefetch, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", { ...f, href: r, ref: o });
});

//# sourceMappingURL=LinkContext-0c83848a.mjs.map


/***/ }),

/***/ 4659:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ E; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _index_615eb227_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8517);


const l = {
  width: "100%",
  height: "100%",
  aspectRatio: "1",
  objectFit: "contain"
}, E = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function({ src: n, fallbackImgSrc: e }, s) {
  const [u, c] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), r = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1), t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => e ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", { src: e, alt: "", "aria-hidden": !0, style: l }) : null,
    [e]
  );
  return (0,_index_615eb227_mjs__WEBPACK_IMPORTED_MODULE_1__.u)(t, (m) => {
    const a = t.current;
    !a || !m || r.current || (r.current = !0, a?.play()?.catch(() => c(!0)));
  }), !n || u ? d : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "video",
    {
      ref: (0,_index_615eb227_mjs__WEBPACK_IMPORTED_MODULE_1__.m)(s, t),
      src: n,
      style: l,
      muted: !0,
      playsInline: !0,
      disablePictureInPicture: !0,
      disableRemotePlayback: !0,
      tabIndex: -1,
      preload: "true",
      "x-webkit-airplay": "deny",
      "aria-hidden": !0
    }
  );
});

//# sourceMappingURL=VideoIcon-87fb4a33.mjs.map


/***/ }),

/***/ 3406:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ j; },
/* harmony export */   "c": function() { return /* binding */ q; },
/* harmony export */   "t": function() { return /* binding */ w; }
/* harmony export */ });
function a(t) {
  var o, n, e = "";
  if (typeof t == "string" || typeof t == "number")
    e += t;
  else if (typeof t == "object")
    if (Array.isArray(t))
      for (o = 0; o < t.length; o++)
        t[o] && (n = a(t[o])) && (e && (e += " "), e += n);
    else
      for (o in t)
        t[o] && (e && (e += " "), e += o);
  return e;
}
function q() {
  for (var t, o, n = 0, e = ""; n < arguments.length; )
    (t = arguments[n++]) && (o = a(t)) && (e && (e += " "), e += o);
  return e;
}
const s = "rich-text", x = "hero__text", l = "mobile", _ = "tablet", r = "desktop", d = "button__text-primary", i = "button__title", p = "button__title__map", g = "button__heroTitle", b = "heading__page", c = "heading__section", u = "heading__menu", T = "texts__component_title", h = "texts__component_title--bold", m = "texts__lead_text", y = "page__lead_text", B = "texts__lead_text--bold", f = "texts__paragraph_subtitle", C = "texts__paragraph_subtitle--bold", L = "texts__body_text", P = "texts__body_text--bold", k = "texts__link", H = "texts__caption", M = "texts__caption--bold", A = "page__heading", w = {
  richText: s,
  heroText: x,
  mobile: l,
  tablet: _,
  desktop: r,
  buttonTextPrimary: d,
  buttonTitle: i,
  buttonTitleMap: p,
  buttonHeroTitle: g,
  headingPage: b,
  headingSection: c,
  headingMenu: u,
  textsComponentTitle: T,
  textsComponentTitleBold: h,
  textsLeadText: m,
  pageLeadText: y,
  textsLeadTextBold: B,
  textsParagraphSubtitle: f,
  textsParagraphSubtitleBold: C,
  textsBodyText: L,
  textsBodyTextBold: P,
  textsLink: k,
  textsCaption: H,
  textsCaptionBold: M,
  pageHeading: A
};
var j = /* @__PURE__ */ ((t) => (t[t.xs = 0] = "xs", t[t.sm = 600] = "sm", t[t.md = 900] = "md", t[t.lg = 1024] = "lg", t[t.xl = 1440] = "xl", t))(j || {});

//# sourceMappingURL=app-a75c1d35.mjs.map


/***/ }),

/***/ 3011:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ Gr; },
/* harmony export */   "a": function() { return /* binding */ Jr; },
/* harmony export */   "b": function() { return /* binding */ br; },
/* harmony export */   "c": function() { return /* binding */ qr; },
/* harmony export */   "d": function() { return /* binding */ zr; },
/* harmony export */   "e": function() { return /* binding */ Zr; },
/* harmony export */   "f": function() { return /* binding */ Kr; },
/* harmony export */   "g": function() { return /* binding */ Xr; },
/* harmony export */   "h": function() { return /* binding */ Wr; },
/* harmony export */   "i": function() { return /* binding */ ee; },
/* harmony export */   "j": function() { return /* binding */ F; },
/* harmony export */   "k": function() { return /* binding */ pe; },
/* harmony export */   "u": function() { return /* binding */ de; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1542);



var fe = { exports: {} }, J = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $e;
function Rr() {
  if ($e)
    return J;
  $e = 1;
  var r = react__WEBPACK_IMPORTED_MODULE_0__, t = Symbol.for("react.element"), o = Symbol.for("react.fragment"), s = Object.prototype.hasOwnProperty, i = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, c = { key: !0, ref: !0, __self: !0, __source: !0 };
  function p(l, f, v) {
    var m, y = {}, O = null, C = null;
    v !== void 0 && (O = "" + v), f.key !== void 0 && (O = "" + f.key), f.ref !== void 0 && (C = f.ref);
    for (m in f)
      s.call(f, m) && !c.hasOwnProperty(m) && (y[m] = f[m]);
    if (l && l.defaultProps)
      for (m in f = l.defaultProps, f)
        y[m] === void 0 && (y[m] = f[m]);
    return { $$typeof: t, type: l, key: O, ref: C, props: y, _owner: i.current };
  }
  return J.Fragment = o, J.jsx = p, J.jsxs = p, J;
}
var q = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var We;
function hr() {
  return We || (We = 1,  false && 0), q;
}
 true ? fe.exports = Rr() : 0;
var F = fe.exports;
function br(r, t = []) {
  let o = [];
  function s(c, p) {
    const l = react__WEBPACK_IMPORTED_MODULE_0__.createContext(p), f = o.length;
    o = [...o, p];
    const v = (y) => {
      const { scope: O, children: C, ...A } = y, x = O?.[r]?.[f] || l, T = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => A, Object.values(A));
      return /* @__PURE__ */ F.jsx(x.Provider, { value: T, children: C });
    };
    v.displayName = c + "Provider";
    function m(y, O) {
      const C = O?.[r]?.[f] || l, A = react__WEBPACK_IMPORTED_MODULE_0__.useContext(C);
      if (A)
        return A;
      if (p !== void 0)
        return p;
      throw new Error(`\`${y}\` must be used within \`${c}\``);
    }
    return [v, m];
  }
  const i = () => {
    const c = o.map((p) => react__WEBPACK_IMPORTED_MODULE_0__.createContext(p));
    return function(l) {
      const f = l?.[r] || c;
      return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(
        () => ({ [`__scope${r}`]: { ...l, [r]: f } }),
        [l, f]
      );
    };
  };
  return i.scopeName = r, [s, _r(i, ...t)];
}
function _r(...r) {
  const t = r[0];
  if (r.length === 1)
    return t;
  const o = () => {
    const s = r.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(c) {
      const p = s.reduce((l, { useScope: f, scopeName: v }) => {
        const y = f(c)[`__scope${v}`];
        return { ...l, ...y };
      }, {});
      return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => ({ [`__scope${t.scopeName}`]: p }), [p]);
    };
  };
  return o.scopeName = t.scopeName, o;
}
function Le(r, t) {
  if (typeof r == "function")
    return r(t);
  r != null && (r.current = t);
}
function pe(...r) {
  return (t) => {
    let o = !1;
    const s = r.map((i) => {
      const c = Le(i, t);
      return !o && typeof c == "function" && (o = !0), c;
    });
    if (o)
      return () => {
        for (let i = 0; i < s.length; i++) {
          const c = s[i];
          typeof c == "function" ? c() : Le(r[i], null);
        }
      };
  };
}
function de(...r) {
  return react__WEBPACK_IMPORTED_MODULE_0__.useCallback(pe(...r), r);
}
// @__NO_SIDE_EFFECTS__
function Ve(r) {
  const t = /* @__PURE__ */ Cr(r), o = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((s, i) => {
    const { children: c, ...p } = s, l = react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(c), f = l.find(Or);
    if (f) {
      const v = f.props.children, m = l.map((y) => y === f ? react__WEBPACK_IMPORTED_MODULE_0__.Children.count(v) > 1 ? react__WEBPACK_IMPORTED_MODULE_0__.Children.only(null) : react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(v) ? v.props.children : null : y);
      return /* @__PURE__ */ F.jsx(t, { ...p, ref: i, children: react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(v) ? react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(v, void 0, m) : null });
    }
    return /* @__PURE__ */ F.jsx(t, { ...p, ref: i, children: c });
  });
  return o.displayName = `${r}.Slot`, o;
}
// @__NO_SIDE_EFFECTS__
function Cr(r) {
  const t = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((o, s) => {
    const { children: i, ...c } = o;
    if (react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(i)) {
      const p = Pr(i), l = Tr(c, i.props);
      return i.type !== react__WEBPACK_IMPORTED_MODULE_0__.Fragment && (l.ref = s ? pe(s, p) : p), react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(i, l);
    }
    return react__WEBPACK_IMPORTED_MODULE_0__.Children.count(i) > 1 ? react__WEBPACK_IMPORTED_MODULE_0__.Children.only(null) : null;
  });
  return t.displayName = `${r}.SlotClone`, t;
}
var Sr = Symbol("radix.slottable");
function Or(r) {
  return react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(r) && typeof r.type == "function" && "__radixId" in r.type && r.type.__radixId === Sr;
}
function Tr(r, t) {
  const o = { ...t };
  for (const s in t) {
    const i = r[s], c = t[s];
    /^on[A-Z]/.test(s) ? i && c ? o[s] = (...l) => {
      const f = c(...l);
      return i(...l), f;
    } : i && (o[s] = i) : s === "style" ? o[s] = { ...i, ...c } : s === "className" && (o[s] = [i, c].filter(Boolean).join(" "));
  }
  return { ...r, ...o };
}
function Pr(r) {
  let t = Object.getOwnPropertyDescriptor(r.props, "ref")?.get, o = t && "isReactWarning" in t && t.isReactWarning;
  return o ? r.ref : (t = Object.getOwnPropertyDescriptor(r, "ref")?.get, o = t && "isReactWarning" in t && t.isReactWarning, o ? r.props.ref : r.props.ref || r.ref);
}
function Jr(r) {
  const t = r + "CollectionProvider", [o, s] = br(t), [i, c] = o(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), p = (x) => {
    const { scope: T, children: j } = x, b = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null), I = react__WEBPACK_IMPORTED_MODULE_0__.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ F.jsx(i, { scope: T, itemMap: I, collectionRef: b, children: j });
  };
  p.displayName = t;
  const l = r + "CollectionSlot", f = /* @__PURE__ */ Ve(l), v = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(
    (x, T) => {
      const { scope: j, children: b } = x, I = c(l, j), k = de(T, I.collectionRef);
      return /* @__PURE__ */ F.jsx(f, { ref: k, children: b });
    }
  );
  v.displayName = l;
  const m = r + "CollectionItemSlot", y = "data-radix-collection-item", O = /* @__PURE__ */ Ve(m), C = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(
    (x, T) => {
      const { scope: j, children: b, ...I } = x, k = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null), K = de(T, k), L = c(m, j);
      return react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => (L.itemMap.set(k, { ref: k, ...I }), () => void L.itemMap.delete(k))), /* @__PURE__ */ F.jsx(O, { [y]: "", ref: K, children: b });
    }
  );
  C.displayName = m;
  function A(x) {
    const T = c(r + "CollectionConsumer", x);
    return react__WEBPACK_IMPORTED_MODULE_0__.useCallback(() => {
      const b = T.collectionRef.current;
      if (!b)
        return [];
      const I = Array.from(b.querySelectorAll(`[${y}]`));
      return Array.from(T.itemMap.values()).sort(
        (L, re) => I.indexOf(L.ref.current) - I.indexOf(re.ref.current)
      );
    }, [T.collectionRef, T.itemMap]);
  }
  return [
    { Provider: p, Slot: v, ItemSlot: C },
    A,
    s
  ];
}
function qr(r, t, { checkForDefaultPrevented: o = !0 } = {}) {
  return function(i) {
    if (r?.(i), o === !1 || !i.defaultPrevented)
      return t?.(i);
  };
}
var ee = globalThis?.document ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : () => {
}, wr = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))[" useInsertionEffect ".trim().toString()] || ee;
function Kr({
  prop: r,
  defaultProp: t,
  onChange: o = () => {
  },
  caller: s
}) {
  const [i, c, p] = xr({
    defaultProp: t,
    onChange: o
  }), l = r !== void 0, f = l ? r : i;
  {
    const m = react__WEBPACK_IMPORTED_MODULE_0__.useRef(r !== void 0);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
      const y = m.current;
      y !== l && console.warn(
        `${s} is changing from ${y ? "controlled" : "uncontrolled"} to ${l ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), m.current = l;
    }, [l, s]);
  }
  const v = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(
    (m) => {
      if (l) {
        const y = jr(m) ? m(r) : m;
        y !== r && p.current?.(y);
      } else
        c(m);
    },
    [l, r, c, p]
  );
  return [f, v];
}
function xr({
  defaultProp: r,
  onChange: t
}) {
  const [o, s] = react__WEBPACK_IMPORTED_MODULE_0__.useState(r), i = react__WEBPACK_IMPORTED_MODULE_0__.useRef(o), c = react__WEBPACK_IMPORTED_MODULE_0__.useRef(t);
  return wr(() => {
    c.current = t;
  }, [t]), react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    i.current !== o && (c.current?.(o), i.current = o);
  }, [o, i]), [o, s, c];
}
function jr(r) {
  return typeof r == "function";
}
// @__NO_SIDE_EFFECTS__
function Ar(r) {
  const t = /* @__PURE__ */ Nr(r), o = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((s, i) => {
    const { children: c, ...p } = s, l = react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(c), f = l.find(Dr);
    if (f) {
      const v = f.props.children, m = l.map((y) => y === f ? react__WEBPACK_IMPORTED_MODULE_0__.Children.count(v) > 1 ? react__WEBPACK_IMPORTED_MODULE_0__.Children.only(null) : react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(v) ? v.props.children : null : y);
      return /* @__PURE__ */ F.jsx(t, { ...p, ref: i, children: react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(v) ? react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(v, void 0, m) : null });
    }
    return /* @__PURE__ */ F.jsx(t, { ...p, ref: i, children: c });
  });
  return o.displayName = `${r}.Slot`, o;
}
// @__NO_SIDE_EFFECTS__
function Nr(r) {
  const t = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((o, s) => {
    const { children: i, ...c } = o;
    if (react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(i)) {
      const p = Mr(i), l = kr(c, i.props);
      return i.type !== react__WEBPACK_IMPORTED_MODULE_0__.Fragment && (l.ref = s ? pe(s, p) : p), react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(i, l);
    }
    return react__WEBPACK_IMPORTED_MODULE_0__.Children.count(i) > 1 ? react__WEBPACK_IMPORTED_MODULE_0__.Children.only(null) : null;
  });
  return t.displayName = `${r}.SlotClone`, t;
}
var Ir = Symbol("radix.slottable");
function Dr(r) {
  return react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(r) && typeof r.type == "function" && "__radixId" in r.type && r.type.__radixId === Ir;
}
function kr(r, t) {
  const o = { ...t };
  for (const s in t) {
    const i = r[s], c = t[s];
    /^on[A-Z]/.test(s) ? i && c ? o[s] = (...l) => {
      const f = c(...l);
      return i(...l), f;
    } : i && (o[s] = i) : s === "style" ? o[s] = { ...i, ...c } : s === "className" && (o[s] = [i, c].filter(Boolean).join(" "));
  }
  return { ...r, ...o };
}
function Mr(r) {
  let t = Object.getOwnPropertyDescriptor(r.props, "ref")?.get, o = t && "isReactWarning" in t && t.isReactWarning;
  return o ? r.ref : (t = Object.getOwnPropertyDescriptor(r, "ref")?.get, o = t && "isReactWarning" in t && t.isReactWarning, o ? r.props.ref : r.props.ref || r.ref);
}
var Fr = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Gr = Fr.reduce((r, t) => {
  const o = /* @__PURE__ */ Ar(`Primitive.${t}`), s = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((i, c) => {
    const { asChild: p, ...l } = i, f = p ? o : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ F.jsx(f, { ...l, ref: c });
  });
  return s.displayName = `Primitive.${t}`, { ...r, [t]: s };
}, {});
function zr(r, t) {
  r && react_dom__WEBPACK_IMPORTED_MODULE_1__.flushSync(() => r.dispatchEvent(t));
}
function $r(r, t) {
  return react__WEBPACK_IMPORTED_MODULE_0__.useReducer((o, s) => t[o][s] ?? o, r);
}
var Wr = (r) => {
  const { present: t, children: o } = r, s = Lr(t), i = typeof o == "function" ? o({ present: s.isPresent }) : react__WEBPACK_IMPORTED_MODULE_0__.Children.only(o), c = de(s.ref, Vr(i));
  return typeof o == "function" || s.isPresent ? react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(i, { ref: c }) : null;
};
Wr.displayName = "Presence";
function Lr(r) {
  const [t, o] = react__WEBPACK_IMPORTED_MODULE_0__.useState(), s = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null), i = react__WEBPACK_IMPORTED_MODULE_0__.useRef(r), c = react__WEBPACK_IMPORTED_MODULE_0__.useRef("none"), p = r ? "mounted" : "unmounted", [l, f] = $r(p, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    const v = Q(s.current);
    c.current = l === "mounted" ? v : "none";
  }, [l]), ee(() => {
    const v = s.current, m = i.current;
    if (m !== r) {
      const O = c.current, C = Q(v);
      r ? f("MOUNT") : C === "none" || v?.display === "none" ? f("UNMOUNT") : f(m && O !== C ? "ANIMATION_OUT" : "UNMOUNT"), i.current = r;
    }
  }, [r, f]), ee(() => {
    if (t) {
      let v;
      const m = t.ownerDocument.defaultView ?? window, y = (C) => {
        const x = Q(s.current).includes(CSS.escape(C.animationName));
        if (C.target === t && x && (f("ANIMATION_END"), !i.current)) {
          const T = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", v = m.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = T);
          });
        }
      }, O = (C) => {
        C.target === t && (c.current = Q(s.current));
      };
      return t.addEventListener("animationstart", O), t.addEventListener("animationcancel", y), t.addEventListener("animationend", y), () => {
        m.clearTimeout(v), t.removeEventListener("animationstart", O), t.removeEventListener("animationcancel", y), t.removeEventListener("animationend", y);
      };
    } else
      f("ANIMATION_END");
  }, [t, f]), {
    isPresent: ["mounted", "unmountSuspended"].includes(l),
    ref: react__WEBPACK_IMPORTED_MODULE_0__.useCallback((v) => {
      s.current = v ? getComputedStyle(v) : null, o(v);
    }, [])
  };
}
function Q(r) {
  return r?.animationName || "none";
}
function Vr(r) {
  let t = Object.getOwnPropertyDescriptor(r.props, "ref")?.get, o = t && "isReactWarning" in t && t.isReactWarning;
  return o ? r.ref : (t = Object.getOwnPropertyDescriptor(r, "ref")?.get, o = t && "isReactWarning" in t && t.isReactWarning, o ? r.props.ref : r.props.ref || r.ref);
}
var Ur = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))[" useId ".trim().toString()] || (() => {
}), Yr = 0;
function Xr(r) {
  const [t, o] = react__WEBPACK_IMPORTED_MODULE_0__.useState(Ur());
  return ee(() => {
    r || o((s) => s ?? String(Yr++));
  }, [r]), r || (t ? `radix-${t}` : "");
}
var Br = react__WEBPACK_IMPORTED_MODULE_0__.createContext(void 0);
function Zr(r) {
  const t = react__WEBPACK_IMPORTED_MODULE_0__.useContext(Br);
  return r || t || "ltr";
}

//# sourceMappingURL=index-099c513a.mjs.map


/***/ }),

/***/ 8517:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ p; },
/* harmony export */   "c": function() { return /* binding */ a; },
/* harmony export */   "d": function() { return /* binding */ y; },
/* harmony export */   "m": function() { return /* binding */ h; },
/* harmony export */   "u": function() { return /* binding */ g; }
/* harmony export */ });
/* unused harmony exports N, b */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);

const S = () => {
}, E = typeof window > "u" ? react__WEBPACK_IMPORTED_MODULE_0__.useEffect : react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;
function a(t) {
  const e = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(t);
  return E(() => {
    e.current = t;
  }, [t]), e;
}
function p(t) {
  const e = a(t);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((...n) => e.current(...n), [e]);
}
function y(t) {
  const e = a(t);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => e.current, [e]);
}
function g(t, e, n) {
  const r = p(e), s = y(n);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!s?.disabled)
      try {
        const c = t.current;
        if (!c)
          return;
        const o = new IntersectionObserver((f) => {
          f.forEach((i) => {
            r(i.isIntersecting);
          });
        }, s);
        return o.observe(c), () => o.unobserve(c);
      } catch {
        return r(!0), () => r(!1);
      }
  }, [r, s, t]);
}
function h(...t) {
  return (e) => {
    t.forEach((n) => {
      n && (typeof n == "function" ? n(e) : n.current = e);
    });
  };
}

//# sourceMappingURL=index-615eb227.mjs.map


/***/ }),

/***/ 5038:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ Xi; },
/* harmony export */   "a": function() { return /* binding */ Yi; },
/* harmony export */   "g": function() { return /* binding */ I; },
/* harmony export */   "n": function() { return /* binding */ le; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);

function ce(e) {
  return e !== null && typeof e == "object" && "constructor" in e && e.constructor === Object;
}
function de(e = {}, i = {}) {
  Object.keys(i).forEach((t) => {
    typeof e[t] > "u" ? e[t] = i[t] : ce(i[t]) && ce(e[t]) && Object.keys(i[t]).length > 0 && de(e[t], i[t]);
  });
}
const we = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function I() {
  const e = typeof document < "u" ? document : {};
  return de(e, we), e;
}
const ke = {
  document: we,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(e) {
    return typeof setTimeout > "u" ? (e(), null) : setTimeout(e, 0);
  },
  cancelAnimationFrame(e) {
    typeof setTimeout > "u" || clearTimeout(e);
  }
};
function O() {
  const e = typeof window < "u" ? window : {};
  return de(e, ke), e;
}
function De(e) {
  const i = e.__proto__;
  Object.defineProperty(e, "__proto__", {
    get() {
      return i;
    },
    set(t) {
      i.__proto__ = t;
    }
  });
}
class D extends Array {
  constructor(i) {
    typeof i == "number" ? super(i) : (super(...i || []), De(this));
  }
}
function X(e = []) {
  const i = [];
  return e.forEach((t) => {
    Array.isArray(t) ? i.push(...X(t)) : i.push(t);
  }), i;
}
function Se(e, i) {
  return Array.prototype.filter.call(e, i);
}
function Ne(e) {
  const i = [];
  for (let t = 0; t < e.length; t += 1)
    i.indexOf(e[t]) === -1 && i.push(e[t]);
  return i;
}
function Ge(e, i) {
  if (typeof e != "string")
    return [e];
  const t = [], s = i.querySelectorAll(e);
  for (let n = 0; n < s.length; n += 1)
    t.push(s[n]);
  return t;
}
function m(e, i) {
  const t = O(), s = I();
  let n = [];
  if (!i && e instanceof D)
    return e;
  if (!e)
    return new D(n);
  if (typeof e == "string") {
    const r = e.trim();
    if (r.indexOf("<") >= 0 && r.indexOf(">") >= 0) {
      let a = "div";
      r.indexOf("<li") === 0 && (a = "ul"), r.indexOf("<tr") === 0 && (a = "tbody"), (r.indexOf("<td") === 0 || r.indexOf("<th") === 0) && (a = "tr"), r.indexOf("<tbody") === 0 && (a = "table"), r.indexOf("<option") === 0 && (a = "select");
      const d = s.createElement(a);
      d.innerHTML = r;
      for (let l = 0; l < d.childNodes.length; l += 1)
        n.push(d.childNodes[l]);
    } else
      n = Ge(e.trim(), i || s);
  } else if (e.nodeType || e === t || e === s)
    n.push(e);
  else if (Array.isArray(e)) {
    if (e instanceof D)
      return e;
    n = e;
  }
  return new D(Ne(n));
}
m.fn = D.prototype;
function Be(...e) {
  const i = X(e.map((t) => t.split(" ")));
  return this.forEach((t) => {
    t.classList.add(...i);
  }), this;
}
function Ve(...e) {
  const i = X(e.map((t) => t.split(" ")));
  return this.forEach((t) => {
    t.classList.remove(...i);
  }), this;
}
function je(...e) {
  const i = X(e.map((t) => t.split(" ")));
  this.forEach((t) => {
    i.forEach((s) => {
      t.classList.toggle(s);
    });
  });
}
function He(...e) {
  const i = X(e.map((t) => t.split(" ")));
  return Se(this, (t) => i.filter((s) => t.classList.contains(s)).length > 0).length > 0;
}
function Re(e, i) {
  if (arguments.length === 1 && typeof e == "string")
    return this[0] ? this[0].getAttribute(e) : void 0;
  for (let t = 0; t < this.length; t += 1)
    if (arguments.length === 2)
      this[t].setAttribute(e, i);
    else
      for (const s in e)
        this[t][s] = e[s], this[t].setAttribute(s, e[s]);
  return this;
}
function Fe(e) {
  for (let i = 0; i < this.length; i += 1)
    this[i].removeAttribute(e);
  return this;
}
function We(e) {
  for (let i = 0; i < this.length; i += 1)
    this[i].style.transform = e;
  return this;
}
function qe(e) {
  for (let i = 0; i < this.length; i += 1)
    this[i].style.transitionDuration = typeof e != "string" ? `${e}ms` : e;
  return this;
}
function Xe(...e) {
  let [i, t, s, n] = e;
  typeof e[1] == "function" && ([i, s, n] = e, t = void 0), n || (n = !1);
  function r(o) {
    const c = o.target;
    if (!c)
      return;
    const u = o.target.dom7EventData || [];
    if (u.indexOf(o) < 0 && u.unshift(o), m(c).is(t))
      s.apply(c, u);
    else {
      const f = m(c).parents();
      for (let h = 0; h < f.length; h += 1)
        m(f[h]).is(t) && s.apply(f[h], u);
    }
  }
  function a(o) {
    const c = o && o.target ? o.target.dom7EventData || [] : [];
    c.indexOf(o) < 0 && c.unshift(o), s.apply(this, c);
  }
  const d = i.split(" ");
  let l;
  for (let o = 0; o < this.length; o += 1) {
    const c = this[o];
    if (t)
      for (l = 0; l < d.length; l += 1) {
        const u = d[l];
        c.dom7LiveListeners || (c.dom7LiveListeners = {}), c.dom7LiveListeners[u] || (c.dom7LiveListeners[u] = []), c.dom7LiveListeners[u].push({
          listener: s,
          proxyListener: r
        }), c.addEventListener(u, r, n);
      }
    else
      for (l = 0; l < d.length; l += 1) {
        const u = d[l];
        c.dom7Listeners || (c.dom7Listeners = {}), c.dom7Listeners[u] || (c.dom7Listeners[u] = []), c.dom7Listeners[u].push({
          listener: s,
          proxyListener: a
        }), c.addEventListener(u, a, n);
      }
  }
  return this;
}
function Ye(...e) {
  let [i, t, s, n] = e;
  typeof e[1] == "function" && ([i, s, n] = e, t = void 0), n || (n = !1);
  const r = i.split(" ");
  for (let a = 0; a < r.length; a += 1) {
    const d = r[a];
    for (let l = 0; l < this.length; l += 1) {
      const o = this[l];
      let c;
      if (!t && o.dom7Listeners ? c = o.dom7Listeners[d] : t && o.dom7LiveListeners && (c = o.dom7LiveListeners[d]), c && c.length)
        for (let u = c.length - 1; u >= 0; u -= 1) {
          const f = c[u];
          s && f.listener === s || s && f.listener && f.listener.dom7proxy && f.listener.dom7proxy === s ? (o.removeEventListener(d, f.proxyListener, n), c.splice(u, 1)) : s || (o.removeEventListener(d, f.proxyListener, n), c.splice(u, 1));
        }
    }
  }
  return this;
}
function Ke(...e) {
  const i = O(), t = e[0].split(" "), s = e[1];
  for (let n = 0; n < t.length; n += 1) {
    const r = t[n];
    for (let a = 0; a < this.length; a += 1) {
      const d = this[a];
      if (i.CustomEvent) {
        const l = new i.CustomEvent(r, {
          detail: s,
          bubbles: !0,
          cancelable: !0
        });
        d.dom7EventData = e.filter((o, c) => c > 0), d.dispatchEvent(l), d.dom7EventData = [], delete d.dom7EventData;
      }
    }
  }
  return this;
}
function Ue(e) {
  const i = this;
  function t(s) {
    s.target === this && (e.call(this, s), i.off("transitionend", t));
  }
  return e && i.on("transitionend", t), this;
}
function Ze(e) {
  if (this.length > 0) {
    if (e) {
      const i = this.styles();
      return this[0].offsetWidth + parseFloat(i.getPropertyValue("margin-right")) + parseFloat(i.getPropertyValue("margin-left"));
    }
    return this[0].offsetWidth;
  }
  return null;
}
function Je(e) {
  if (this.length > 0) {
    if (e) {
      const i = this.styles();
      return this[0].offsetHeight + parseFloat(i.getPropertyValue("margin-top")) + parseFloat(i.getPropertyValue("margin-bottom"));
    }
    return this[0].offsetHeight;
  }
  return null;
}
function Qe() {
  if (this.length > 0) {
    const e = O(), i = I(), t = this[0], s = t.getBoundingClientRect(), n = i.body, r = t.clientTop || n.clientTop || 0, a = t.clientLeft || n.clientLeft || 0, d = t === e ? e.scrollY : t.scrollTop, l = t === e ? e.scrollX : t.scrollLeft;
    return {
      top: s.top + d - r,
      left: s.left + l - a
    };
  }
  return null;
}
function et() {
  const e = O();
  return this[0] ? e.getComputedStyle(this[0], null) : {};
}
function tt(e, i) {
  const t = O();
  let s;
  if (arguments.length === 1)
    if (typeof e == "string") {
      if (this[0])
        return t.getComputedStyle(this[0], null).getPropertyValue(e);
    } else {
      for (s = 0; s < this.length; s += 1)
        for (const n in e)
          this[s].style[n] = e[n];
      return this;
    }
  if (arguments.length === 2 && typeof e == "string") {
    for (s = 0; s < this.length; s += 1)
      this[s].style[e] = i;
    return this;
  }
  return this;
}
function it(e) {
  return e ? (this.forEach((i, t) => {
    e.apply(i, [i, t]);
  }), this) : this;
}
function st(e) {
  const i = Se(this, e);
  return m(i);
}
function nt(e) {
  if (typeof e > "u")
    return this[0] ? this[0].innerHTML : null;
  for (let i = 0; i < this.length; i += 1)
    this[i].innerHTML = e;
  return this;
}
function rt(e) {
  if (typeof e > "u")
    return this[0] ? this[0].textContent.trim() : null;
  for (let i = 0; i < this.length; i += 1)
    this[i].textContent = e;
  return this;
}
function lt(e) {
  const i = O(), t = I(), s = this[0];
  let n, r;
  if (!s || typeof e > "u")
    return !1;
  if (typeof e == "string") {
    if (s.matches)
      return s.matches(e);
    if (s.webkitMatchesSelector)
      return s.webkitMatchesSelector(e);
    if (s.msMatchesSelector)
      return s.msMatchesSelector(e);
    for (n = m(e), r = 0; r < n.length; r += 1)
      if (n[r] === s)
        return !0;
    return !1;
  }
  if (e === t)
    return s === t;
  if (e === i)
    return s === i;
  if (e.nodeType || e instanceof D) {
    for (n = e.nodeType ? [e] : e, r = 0; r < n.length; r += 1)
      if (n[r] === s)
        return !0;
    return !1;
  }
  return !1;
}
function at() {
  let e = this[0], i;
  if (e) {
    for (i = 0; (e = e.previousSibling) !== null; )
      e.nodeType === 1 && (i += 1);
    return i;
  }
}
function ot(e) {
  if (typeof e > "u")
    return this;
  const i = this.length;
  if (e > i - 1)
    return m([]);
  if (e < 0) {
    const t = i + e;
    return t < 0 ? m([]) : m([this[t]]);
  }
  return m([this[e]]);
}
function dt(...e) {
  let i;
  const t = I();
  for (let s = 0; s < e.length; s += 1) {
    i = e[s];
    for (let n = 0; n < this.length; n += 1)
      if (typeof i == "string") {
        const r = t.createElement("div");
        for (r.innerHTML = i; r.firstChild; )
          this[n].appendChild(r.firstChild);
      } else if (i instanceof D)
        for (let r = 0; r < i.length; r += 1)
          this[n].appendChild(i[r]);
      else
        this[n].appendChild(i);
  }
  return this;
}
function ct(e) {
  const i = I();
  let t, s;
  for (t = 0; t < this.length; t += 1)
    if (typeof e == "string") {
      const n = i.createElement("div");
      for (n.innerHTML = e, s = n.childNodes.length - 1; s >= 0; s -= 1)
        this[t].insertBefore(n.childNodes[s], this[t].childNodes[0]);
    } else if (e instanceof D)
      for (s = 0; s < e.length; s += 1)
        this[t].insertBefore(e[s], this[t].childNodes[0]);
    else
      this[t].insertBefore(e, this[t].childNodes[0]);
  return this;
}
function ft(e) {
  return this.length > 0 ? e ? this[0].nextElementSibling && m(this[0].nextElementSibling).is(e) ? m([this[0].nextElementSibling]) : m([]) : this[0].nextElementSibling ? m([this[0].nextElementSibling]) : m([]) : m([]);
}
function ut(e) {
  const i = [];
  let t = this[0];
  if (!t)
    return m([]);
  for (; t.nextElementSibling; ) {
    const s = t.nextElementSibling;
    e ? m(s).is(e) && i.push(s) : i.push(s), t = s;
  }
  return m(i);
}
function pt(e) {
  if (this.length > 0) {
    const i = this[0];
    return e ? i.previousElementSibling && m(i.previousElementSibling).is(e) ? m([i.previousElementSibling]) : m([]) : i.previousElementSibling ? m([i.previousElementSibling]) : m([]);
  }
  return m([]);
}
function ht(e) {
  const i = [];
  let t = this[0];
  if (!t)
    return m([]);
  for (; t.previousElementSibling; ) {
    const s = t.previousElementSibling;
    e ? m(s).is(e) && i.push(s) : i.push(s), t = s;
  }
  return m(i);
}
function mt(e) {
  const i = [];
  for (let t = 0; t < this.length; t += 1)
    this[t].parentNode !== null && (e ? m(this[t].parentNode).is(e) && i.push(this[t].parentNode) : i.push(this[t].parentNode));
  return m(i);
}
function gt(e) {
  const i = [];
  for (let t = 0; t < this.length; t += 1) {
    let s = this[t].parentNode;
    for (; s; )
      e ? m(s).is(e) && i.push(s) : i.push(s), s = s.parentNode;
  }
  return m(i);
}
function vt(e) {
  let i = this;
  return typeof e > "u" ? m([]) : (i.is(e) || (i = i.parents(e).eq(0)), i);
}
function wt(e) {
  const i = [];
  for (let t = 0; t < this.length; t += 1) {
    const s = this[t].querySelectorAll(e);
    for (let n = 0; n < s.length; n += 1)
      i.push(s[n]);
  }
  return m(i);
}
function St(e) {
  const i = [];
  for (let t = 0; t < this.length; t += 1) {
    const s = this[t].children;
    for (let n = 0; n < s.length; n += 1)
      (!e || m(s[n]).is(e)) && i.push(s[n]);
  }
  return m(i);
}
function Tt() {
  for (let e = 0; e < this.length; e += 1)
    this[e].parentNode && this[e].parentNode.removeChild(this[e]);
  return this;
}
const fe = {
  addClass: Be,
  removeClass: Ve,
  hasClass: He,
  toggleClass: je,
  attr: Re,
  removeAttr: Fe,
  transform: We,
  transition: qe,
  on: Xe,
  off: Ye,
  trigger: Ke,
  transitionEnd: Ue,
  outerWidth: Ze,
  outerHeight: Je,
  styles: et,
  offset: Qe,
  css: tt,
  each: it,
  html: nt,
  text: rt,
  is: lt,
  index: at,
  eq: ot,
  append: dt,
  prepend: ct,
  next: ft,
  nextAll: ut,
  prev: pt,
  prevAll: ht,
  parent: mt,
  parents: gt,
  closest: vt,
  find: wt,
  children: St,
  filter: st,
  remove: Tt
};
Object.keys(fe).forEach((e) => {
  Object.defineProperty(m.fn, e, {
    value: fe[e],
    writable: !0
  });
});
function bt(e) {
  const i = e;
  Object.keys(i).forEach((t) => {
    try {
      i[t] = null;
    } catch {
    }
    try {
      delete i[t];
    } catch {
    }
  });
}
function le(e, i = 0) {
  return setTimeout(e, i);
}
function q() {
  return Date.now();
}
function Et(e) {
  const i = O();
  let t;
  return i.getComputedStyle && (t = i.getComputedStyle(e, null)), !t && e.currentStyle && (t = e.currentStyle), t || (t = e.style), t;
}
function xt(e, i = "x") {
  const t = O();
  let s, n, r;
  const a = Et(e);
  return t.WebKitCSSMatrix ? (n = a.transform || a.webkitTransform, n.split(",").length > 6 && (n = n.split(", ").map((d) => d.replace(",", ".")).join(", ")), r = new t.WebKitCSSMatrix(n === "none" ? "" : n)) : (r = a.MozTransform || a.OTransform || a.MsTransform || a.msTransform || a.transform || a.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), s = r.toString().split(",")), i === "x" && (t.WebKitCSSMatrix ? n = r.m41 : s.length === 16 ? n = parseFloat(s[12]) : n = parseFloat(s[4])), i === "y" && (t.WebKitCSSMatrix ? n = r.m42 : s.length === 16 ? n = parseFloat(s[13]) : n = parseFloat(s[5])), n || 0;
}
function K(e) {
  return typeof e == "object" && e !== null && e.constructor && Object.prototype.toString.call(e).slice(8, -1) === "Object";
}
function Ct(e) {
  return typeof window < "u" && typeof window.HTMLElement < "u" ? e instanceof HTMLElement : e && (e.nodeType === 1 || e.nodeType === 11);
}
function _(...e) {
  const i = Object(e[0]), t = ["__proto__", "constructor", "prototype"];
  for (let s = 1; s < e.length; s += 1) {
    const n = e[s];
    if (n != null && !Ct(n)) {
      const r = Object.keys(Object(n)).filter((a) => t.indexOf(a) < 0);
      for (let a = 0, d = r.length; a < d; a += 1) {
        const l = r[a], o = Object.getOwnPropertyDescriptor(n, l);
        o !== void 0 && o.enumerable && (K(i[l]) && K(n[l]) ? n[l].__swiper__ ? i[l] = n[l] : _(i[l], n[l]) : !K(i[l]) && K(n[l]) ? (i[l] = {}, n[l].__swiper__ ? i[l] = n[l] : _(i[l], n[l])) : i[l] = n[l]);
      }
    }
  }
  return i;
}
function U(e, i, t) {
  e.style.setProperty(i, t);
}
function Te({
  swiper: e,
  targetPosition: i,
  side: t
}) {
  const s = O(), n = -e.translate;
  let r = null, a;
  const d = e.params.speed;
  e.wrapperEl.style.scrollSnapType = "none", s.cancelAnimationFrame(e.cssModeFrameID);
  const l = i > n ? "next" : "prev", o = (u, f) => l === "next" && u >= f || l === "prev" && u <= f, c = () => {
    a = (/* @__PURE__ */ new Date()).getTime(), r === null && (r = a);
    const u = Math.max(Math.min((a - r) / d, 1), 0), f = 0.5 - Math.cos(u * Math.PI) / 2;
    let h = n + f * (i - n);
    if (o(h, i) && (h = i), e.wrapperEl.scrollTo({
      [t]: h
    }), o(h, i)) {
      e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
        e.wrapperEl.style.overflow = "", e.wrapperEl.scrollTo({
          [t]: h
        });
      }), s.cancelAnimationFrame(e.cssModeFrameID);
      return;
    }
    e.cssModeFrameID = s.requestAnimationFrame(c);
  };
  c();
}
let ee;
function yt() {
  const e = O(), i = I();
  return {
    smoothScroll: i.documentElement && "scrollBehavior" in i.documentElement.style,
    touch: !!("ontouchstart" in e || e.DocumentTouch && i instanceof e.DocumentTouch),
    passiveListener: function() {
      let s = !1;
      try {
        const n = Object.defineProperty({}, "passive", {
          // eslint-disable-next-line
          get() {
            s = !0;
          }
        });
        e.addEventListener("testPassiveListener", null, n);
      } catch {
      }
      return s;
    }(),
    gestures: function() {
      return "ongesturestart" in e;
    }()
  };
}
function be() {
  return ee || (ee = yt()), ee;
}
let te;
function Mt({
  userAgent: e
} = {}) {
  const i = be(), t = O(), s = t.navigator.platform, n = e || t.navigator.userAgent, r = {
    ios: !1,
    android: !1
  }, a = t.screen.width, d = t.screen.height, l = n.match(/(Android);?[\s\/]+([\d.]+)?/);
  let o = n.match(/(iPad).*OS\s([\d_]+)/);
  const c = n.match(/(iPod)(.*OS\s([\d_]+))?/), u = !o && n.match(/(iPhone\sOS|iOS)\s([\d_]+)/), f = s === "Win32";
  let h = s === "MacIntel";
  const v = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  return !o && h && i.touch && v.indexOf(`${a}x${d}`) >= 0 && (o = n.match(/(Version)\/([\d.]+)/), o || (o = [0, 1, "13_0_0"]), h = !1), l && !f && (r.os = "android", r.android = !0), (o || u || c) && (r.os = "ios", r.ios = !0), r;
}
function Lt(e = {}) {
  return te || (te = Mt(e)), te;
}
let ie;
function Ot() {
  const e = O();
  function i() {
    const t = e.navigator.userAgent.toLowerCase();
    return t.indexOf("safari") >= 0 && t.indexOf("chrome") < 0 && t.indexOf("android") < 0;
  }
  return {
    isSafari: i(),
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent)
  };
}
function Pt() {
  return ie || (ie = Ot()), ie;
}
function $t({
  swiper: e,
  on: i,
  emit: t
}) {
  const s = O();
  let n = null, r = null;
  const a = () => {
    !e || e.destroyed || !e.initialized || (t("beforeResize"), t("resize"));
  }, d = () => {
    !e || e.destroyed || !e.initialized || (n = new ResizeObserver((c) => {
      r = s.requestAnimationFrame(() => {
        const {
          width: u,
          height: f
        } = e;
        let h = u, v = f;
        c.forEach(({
          contentBoxSize: w,
          contentRect: g,
          target: p
        }) => {
          p && p !== e.el || (h = g ? g.width : (w[0] || w).inlineSize, v = g ? g.height : (w[0] || w).blockSize);
        }), (h !== u || v !== f) && a();
      });
    }), n.observe(e.el));
  }, l = () => {
    r && s.cancelAnimationFrame(r), n && n.unobserve && e.el && (n.unobserve(e.el), n = null);
  }, o = () => {
    !e || e.destroyed || !e.initialized || t("orientationchange");
  };
  i("init", () => {
    if (e.params.resizeObserver && typeof s.ResizeObserver < "u") {
      d();
      return;
    }
    s.addEventListener("resize", a), s.addEventListener("orientationchange", o);
  }), i("destroy", () => {
    l(), s.removeEventListener("resize", a), s.removeEventListener("orientationchange", o);
  });
}
function _t({
  swiper: e,
  extendParams: i,
  on: t,
  emit: s
}) {
  const n = [], r = O(), a = (o, c = {}) => {
    const u = r.MutationObserver || r.WebkitMutationObserver, f = new u((h) => {
      if (h.length === 1) {
        s("observerUpdate", h[0]);
        return;
      }
      const v = function() {
        s("observerUpdate", h[0]);
      };
      r.requestAnimationFrame ? r.requestAnimationFrame(v) : r.setTimeout(v, 0);
    });
    f.observe(o, {
      attributes: typeof c.attributes > "u" ? !0 : c.attributes,
      childList: typeof c.childList > "u" ? !0 : c.childList,
      characterData: typeof c.characterData > "u" ? !0 : c.characterData
    }), n.push(f);
  }, d = () => {
    if (e.params.observer) {
      if (e.params.observeParents) {
        const o = e.$el.parents();
        for (let c = 0; c < o.length; c += 1)
          a(o[c]);
      }
      a(e.$el[0], {
        childList: e.params.observeSlideChildren
      }), a(e.$wrapperEl[0], {
        attributes: !1
      });
    }
  }, l = () => {
    n.forEach((o) => {
      o.disconnect();
    }), n.splice(0, n.length);
  };
  i({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), t("init", d), t("destroy", l);
}
const It = {
  on(e, i, t) {
    const s = this;
    if (!s.eventsListeners || s.destroyed || typeof i != "function")
      return s;
    const n = t ? "unshift" : "push";
    return e.split(" ").forEach((r) => {
      s.eventsListeners[r] || (s.eventsListeners[r] = []), s.eventsListeners[r][n](i);
    }), s;
  },
  once(e, i, t) {
    const s = this;
    if (!s.eventsListeners || s.destroyed || typeof i != "function")
      return s;
    function n(...r) {
      s.off(e, n), n.__emitterProxy && delete n.__emitterProxy, i.apply(s, r);
    }
    return n.__emitterProxy = i, s.on(e, n, t);
  },
  onAny(e, i) {
    const t = this;
    if (!t.eventsListeners || t.destroyed || typeof e != "function")
      return t;
    const s = i ? "unshift" : "push";
    return t.eventsAnyListeners.indexOf(e) < 0 && t.eventsAnyListeners[s](e), t;
  },
  offAny(e) {
    const i = this;
    if (!i.eventsListeners || i.destroyed || !i.eventsAnyListeners)
      return i;
    const t = i.eventsAnyListeners.indexOf(e);
    return t >= 0 && i.eventsAnyListeners.splice(t, 1), i;
  },
  off(e, i) {
    const t = this;
    return !t.eventsListeners || t.destroyed || !t.eventsListeners || e.split(" ").forEach((s) => {
      typeof i > "u" ? t.eventsListeners[s] = [] : t.eventsListeners[s] && t.eventsListeners[s].forEach((n, r) => {
        (n === i || n.__emitterProxy && n.__emitterProxy === i) && t.eventsListeners[s].splice(r, 1);
      });
    }), t;
  },
  emit(...e) {
    const i = this;
    if (!i.eventsListeners || i.destroyed || !i.eventsListeners)
      return i;
    let t, s, n;
    return typeof e[0] == "string" || Array.isArray(e[0]) ? (t = e[0], s = e.slice(1, e.length), n = i) : (t = e[0].events, s = e[0].data, n = e[0].context || i), s.unshift(n), (Array.isArray(t) ? t : t.split(" ")).forEach((a) => {
      i.eventsAnyListeners && i.eventsAnyListeners.length && i.eventsAnyListeners.forEach((d) => {
        d.apply(n, [a, ...s]);
      }), i.eventsListeners && i.eventsListeners[a] && i.eventsListeners[a].forEach((d) => {
        d.apply(n, s);
      });
    }), i;
  }
};
function zt() {
  const e = this;
  let i, t;
  const s = e.$el;
  typeof e.params.width < "u" && e.params.width !== null ? i = e.params.width : i = s[0].clientWidth, typeof e.params.height < "u" && e.params.height !== null ? t = e.params.height : t = s[0].clientHeight, !(i === 0 && e.isHorizontal() || t === 0 && e.isVertical()) && (i = i - parseInt(s.css("padding-left") || 0, 10) - parseInt(s.css("padding-right") || 0, 10), t = t - parseInt(s.css("padding-top") || 0, 10) - parseInt(s.css("padding-bottom") || 0, 10), Number.isNaN(i) && (i = 0), Number.isNaN(t) && (t = 0), Object.assign(e, {
    width: i,
    height: t,
    size: e.isHorizontal() ? i : t
  }));
}
function At() {
  const e = this;
  function i(x) {
    return e.isHorizontal() ? x : {
      width: "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      marginRight: "marginBottom"
    }[x];
  }
  function t(x, E) {
    return parseFloat(x.getPropertyValue(i(E)) || 0);
  }
  const s = e.params, {
    $wrapperEl: n,
    size: r,
    rtlTranslate: a,
    wrongRTL: d
  } = e, l = e.virtual && s.virtual.enabled, o = l ? e.virtual.slides.length : e.slides.length, c = n.children(`.${e.params.slideClass}`), u = l ? e.virtual.slides.length : c.length;
  let f = [];
  const h = [], v = [];
  let w = s.slidesOffsetBefore;
  typeof w == "function" && (w = s.slidesOffsetBefore.call(e));
  let g = s.slidesOffsetAfter;
  typeof g == "function" && (g = s.slidesOffsetAfter.call(e));
  const p = e.snapGrid.length, S = e.slidesGrid.length;
  let T = s.spaceBetween, C = -w, b = 0, $ = 0;
  if (typeof r > "u")
    return;
  typeof T == "string" && T.indexOf("%") >= 0 && (T = parseFloat(T.replace("%", "")) / 100 * r), e.virtualSize = -T, a ? c.css({
    marginLeft: "",
    marginBottom: "",
    marginTop: ""
  }) : c.css({
    marginRight: "",
    marginBottom: "",
    marginTop: ""
  }), s.centeredSlides && s.cssMode && (U(e.wrapperEl, "--swiper-centered-offset-before", ""), U(e.wrapperEl, "--swiper-centered-offset-after", ""));
  const G = s.grid && s.grid.rows > 1 && e.grid;
  G && e.grid.initSlides(u);
  let M;
  const R = s.slidesPerView === "auto" && s.breakpoints && Object.keys(s.breakpoints).filter((x) => typeof s.breakpoints[x].slidesPerView < "u").length > 0;
  for (let x = 0; x < u; x += 1) {
    M = 0;
    const E = c.eq(x);
    if (G && e.grid.updateSlide(x, E, u, i), E.css("display") !== "none") {
      if (s.slidesPerView === "auto") {
        R && (c[x].style[i("width")] = "");
        const y = getComputedStyle(E[0]), z = E[0].style.transform, V = E[0].style.webkitTransform;
        if (z && (E[0].style.transform = "none"), V && (E[0].style.webkitTransform = "none"), s.roundLengths)
          M = e.isHorizontal() ? E.outerWidth(!0) : E.outerHeight(!0);
        else {
          const F = t(y, "width"), J = t(y, "padding-left"), Q = t(y, "padding-right"), Y = t(y, "margin-left"), P = t(y, "margin-right"), j = y.getPropertyValue("box-sizing");
          if (j && j === "border-box")
            M = F + Y + P;
          else {
            const {
              clientWidth: Ie,
              offsetWidth: ze
            } = E[0];
            M = F + J + Q + Y + P + (ze - Ie);
          }
        }
        z && (E[0].style.transform = z), V && (E[0].style.webkitTransform = V), s.roundLengths && (M = Math.floor(M));
      } else
        M = (r - (s.slidesPerView - 1) * T) / s.slidesPerView, s.roundLengths && (M = Math.floor(M)), c[x] && (c[x].style[i("width")] = `${M}px`);
      c[x] && (c[x].swiperSlideSize = M), v.push(M), s.centeredSlides ? (C = C + M / 2 + b / 2 + T, b === 0 && x !== 0 && (C = C - r / 2 - T), x === 0 && (C = C - r / 2 - T), Math.abs(C) < 1 / 1e3 && (C = 0), s.roundLengths && (C = Math.floor(C)), $ % s.slidesPerGroup === 0 && f.push(C), h.push(C)) : (s.roundLengths && (C = Math.floor(C)), ($ - Math.min(e.params.slidesPerGroupSkip, $)) % e.params.slidesPerGroup === 0 && f.push(C), h.push(C), C = C + M + T), e.virtualSize += M + T, b = M, $ += 1;
    }
  }
  if (e.virtualSize = Math.max(e.virtualSize, r) + g, a && d && (s.effect === "slide" || s.effect === "coverflow") && n.css({
    width: `${e.virtualSize + s.spaceBetween}px`
  }), s.setWrapperSize && n.css({
    [i("width")]: `${e.virtualSize + s.spaceBetween}px`
  }), G && e.grid.updateWrapperSize(M, f, i), !s.centeredSlides) {
    const x = [];
    for (let E = 0; E < f.length; E += 1) {
      let y = f[E];
      s.roundLengths && (y = Math.floor(y)), f[E] <= e.virtualSize - r && x.push(y);
    }
    f = x, Math.floor(e.virtualSize - r) - Math.floor(f[f.length - 1]) > 1 && f.push(e.virtualSize - r);
  }
  if (f.length === 0 && (f = [0]), s.spaceBetween !== 0) {
    const x = e.isHorizontal() && a ? "marginLeft" : i("marginRight");
    c.filter((E, y) => s.cssMode ? y !== c.length - 1 : !0).css({
      [x]: `${T}px`
    });
  }
  if (s.centeredSlides && s.centeredSlidesBounds) {
    let x = 0;
    v.forEach((y) => {
      x += y + (s.spaceBetween ? s.spaceBetween : 0);
    }), x -= s.spaceBetween;
    const E = x - r;
    f = f.map((y) => y < 0 ? -w : y > E ? E + g : y);
  }
  if (s.centerInsufficientSlides) {
    let x = 0;
    if (v.forEach((E) => {
      x += E + (s.spaceBetween ? s.spaceBetween : 0);
    }), x -= s.spaceBetween, x < r) {
      const E = (r - x) / 2;
      f.forEach((y, z) => {
        f[z] = y - E;
      }), h.forEach((y, z) => {
        h[z] = y + E;
      });
    }
  }
  if (Object.assign(e, {
    slides: c,
    snapGrid: f,
    slidesGrid: h,
    slidesSizesGrid: v
  }), s.centeredSlides && s.cssMode && !s.centeredSlidesBounds) {
    U(e.wrapperEl, "--swiper-centered-offset-before", `${-f[0]}px`), U(e.wrapperEl, "--swiper-centered-offset-after", `${e.size / 2 - v[v.length - 1] / 2}px`);
    const x = -e.snapGrid[0], E = -e.slidesGrid[0];
    e.snapGrid = e.snapGrid.map((y) => y + x), e.slidesGrid = e.slidesGrid.map((y) => y + E);
  }
  if (u !== o && e.emit("slidesLengthChange"), f.length !== p && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")), h.length !== S && e.emit("slidesGridLengthChange"), s.watchSlidesProgress && e.updateSlidesOffset(), !l && !s.cssMode && (s.effect === "slide" || s.effect === "fade")) {
    const x = `${s.containerModifierClass}backface-hidden`, E = e.$el.hasClass(x);
    u <= s.maxBackfaceHiddenSlides ? E || e.$el.addClass(x) : E && e.$el.removeClass(x);
  }
}
function kt(e) {
  const i = this, t = [], s = i.virtual && i.params.virtual.enabled;
  let n = 0, r;
  typeof e == "number" ? i.setTransition(e) : e === !0 && i.setTransition(i.params.speed);
  const a = (d) => s ? i.slides.filter((l) => parseInt(l.getAttribute("data-swiper-slide-index"), 10) === d)[0] : i.slides.eq(d)[0];
  if (i.params.slidesPerView !== "auto" && i.params.slidesPerView > 1)
    if (i.params.centeredSlides)
      (i.visibleSlides || m([])).each((d) => {
        t.push(d);
      });
    else
      for (r = 0; r < Math.ceil(i.params.slidesPerView); r += 1) {
        const d = i.activeIndex + r;
        if (d > i.slides.length && !s)
          break;
        t.push(a(d));
      }
  else
    t.push(a(i.activeIndex));
  for (r = 0; r < t.length; r += 1)
    if (typeof t[r] < "u") {
      const d = t[r].offsetHeight;
      n = d > n ? d : n;
    }
  (n || n === 0) && i.$wrapperEl.css("height", `${n}px`);
}
function Dt() {
  const e = this, i = e.slides;
  for (let t = 0; t < i.length; t += 1)
    i[t].swiperSlideOffset = e.isHorizontal() ? i[t].offsetLeft : i[t].offsetTop;
}
function Nt(e = this && this.translate || 0) {
  const i = this, t = i.params, {
    slides: s,
    rtlTranslate: n,
    snapGrid: r
  } = i;
  if (s.length === 0)
    return;
  typeof s[0].swiperSlideOffset > "u" && i.updateSlidesOffset();
  let a = -e;
  n && (a = e), s.removeClass(t.slideVisibleClass), i.visibleSlidesIndexes = [], i.visibleSlides = [];
  for (let d = 0; d < s.length; d += 1) {
    const l = s[d];
    let o = l.swiperSlideOffset;
    t.cssMode && t.centeredSlides && (o -= s[0].swiperSlideOffset);
    const c = (a + (t.centeredSlides ? i.minTranslate() : 0) - o) / (l.swiperSlideSize + t.spaceBetween), u = (a - r[0] + (t.centeredSlides ? i.minTranslate() : 0) - o) / (l.swiperSlideSize + t.spaceBetween), f = -(a - o), h = f + i.slidesSizesGrid[d];
    (f >= 0 && f < i.size - 1 || h > 1 && h <= i.size || f <= 0 && h >= i.size) && (i.visibleSlides.push(l), i.visibleSlidesIndexes.push(d), s.eq(d).addClass(t.slideVisibleClass)), l.progress = n ? -c : c, l.originalProgress = n ? -u : u;
  }
  i.visibleSlides = m(i.visibleSlides);
}
function Gt(e) {
  const i = this;
  if (typeof e > "u") {
    const o = i.rtlTranslate ? -1 : 1;
    e = i && i.translate && i.translate * o || 0;
  }
  const t = i.params, s = i.maxTranslate() - i.minTranslate();
  let {
    progress: n,
    isBeginning: r,
    isEnd: a
  } = i;
  const d = r, l = a;
  s === 0 ? (n = 0, r = !0, a = !0) : (n = (e - i.minTranslate()) / s, r = n <= 0, a = n >= 1), Object.assign(i, {
    progress: n,
    isBeginning: r,
    isEnd: a
  }), (t.watchSlidesProgress || t.centeredSlides && t.autoHeight) && i.updateSlidesProgress(e), r && !d && i.emit("reachBeginning toEdge"), a && !l && i.emit("reachEnd toEdge"), (d && !r || l && !a) && i.emit("fromEdge"), i.emit("progress", n);
}
function Bt() {
  const e = this, {
    slides: i,
    params: t,
    $wrapperEl: s,
    activeIndex: n,
    realIndex: r
  } = e, a = e.virtual && t.virtual.enabled;
  i.removeClass(`${t.slideActiveClass} ${t.slideNextClass} ${t.slidePrevClass} ${t.slideDuplicateActiveClass} ${t.slideDuplicateNextClass} ${t.slideDuplicatePrevClass}`);
  let d;
  a ? d = e.$wrapperEl.find(`.${t.slideClass}[data-swiper-slide-index="${n}"]`) : d = i.eq(n), d.addClass(t.slideActiveClass), t.loop && (d.hasClass(t.slideDuplicateClass) ? s.children(`.${t.slideClass}:not(.${t.slideDuplicateClass})[data-swiper-slide-index="${r}"]`).addClass(t.slideDuplicateActiveClass) : s.children(`.${t.slideClass}.${t.slideDuplicateClass}[data-swiper-slide-index="${r}"]`).addClass(t.slideDuplicateActiveClass));
  let l = d.nextAll(`.${t.slideClass}`).eq(0).addClass(t.slideNextClass);
  t.loop && l.length === 0 && (l = i.eq(0), l.addClass(t.slideNextClass));
  let o = d.prevAll(`.${t.slideClass}`).eq(0).addClass(t.slidePrevClass);
  t.loop && o.length === 0 && (o = i.eq(-1), o.addClass(t.slidePrevClass)), t.loop && (l.hasClass(t.slideDuplicateClass) ? s.children(`.${t.slideClass}:not(.${t.slideDuplicateClass})[data-swiper-slide-index="${l.attr("data-swiper-slide-index")}"]`).addClass(t.slideDuplicateNextClass) : s.children(`.${t.slideClass}.${t.slideDuplicateClass}[data-swiper-slide-index="${l.attr("data-swiper-slide-index")}"]`).addClass(t.slideDuplicateNextClass), o.hasClass(t.slideDuplicateClass) ? s.children(`.${t.slideClass}:not(.${t.slideDuplicateClass})[data-swiper-slide-index="${o.attr("data-swiper-slide-index")}"]`).addClass(t.slideDuplicatePrevClass) : s.children(`.${t.slideClass}.${t.slideDuplicateClass}[data-swiper-slide-index="${o.attr("data-swiper-slide-index")}"]`).addClass(t.slideDuplicatePrevClass)), e.emitSlidesClasses();
}
function Vt(e) {
  const i = this, t = i.rtlTranslate ? i.translate : -i.translate, {
    slidesGrid: s,
    snapGrid: n,
    params: r,
    activeIndex: a,
    realIndex: d,
    snapIndex: l
  } = i;
  let o = e, c;
  if (typeof o > "u") {
    for (let f = 0; f < s.length; f += 1)
      typeof s[f + 1] < "u" ? t >= s[f] && t < s[f + 1] - (s[f + 1] - s[f]) / 2 ? o = f : t >= s[f] && t < s[f + 1] && (o = f + 1) : t >= s[f] && (o = f);
    r.normalizeSlideIndex && (o < 0 || typeof o > "u") && (o = 0);
  }
  if (n.indexOf(t) >= 0)
    c = n.indexOf(t);
  else {
    const f = Math.min(r.slidesPerGroupSkip, o);
    c = f + Math.floor((o - f) / r.slidesPerGroup);
  }
  if (c >= n.length && (c = n.length - 1), o === a) {
    c !== l && (i.snapIndex = c, i.emit("snapIndexChange"));
    return;
  }
  const u = parseInt(i.slides.eq(o).attr("data-swiper-slide-index") || o, 10);
  Object.assign(i, {
    snapIndex: c,
    realIndex: u,
    previousIndex: a,
    activeIndex: o
  }), i.emit("activeIndexChange"), i.emit("snapIndexChange"), d !== u && i.emit("realIndexChange"), (i.initialized || i.params.runCallbacksOnInit) && i.emit("slideChange");
}
function jt(e) {
  const i = this, t = i.params, s = m(e).closest(`.${t.slideClass}`)[0];
  let n = !1, r;
  if (s) {
    for (let a = 0; a < i.slides.length; a += 1)
      if (i.slides[a] === s) {
        n = !0, r = a;
        break;
      }
  }
  if (s && n)
    i.clickedSlide = s, i.virtual && i.params.virtual.enabled ? i.clickedIndex = parseInt(m(s).attr("data-swiper-slide-index"), 10) : i.clickedIndex = r;
  else {
    i.clickedSlide = void 0, i.clickedIndex = void 0;
    return;
  }
  t.slideToClickedSlide && i.clickedIndex !== void 0 && i.clickedIndex !== i.activeIndex && i.slideToClickedSlide();
}
const Ht = {
  updateSize: zt,
  updateSlides: At,
  updateAutoHeight: kt,
  updateSlidesOffset: Dt,
  updateSlidesProgress: Nt,
  updateProgress: Gt,
  updateSlidesClasses: Bt,
  updateActiveIndex: Vt,
  updateClickedSlide: jt
};
function Rt(e = this.isHorizontal() ? "x" : "y") {
  const i = this, {
    params: t,
    rtlTranslate: s,
    translate: n,
    $wrapperEl: r
  } = i;
  if (t.virtualTranslate)
    return s ? -n : n;
  if (t.cssMode)
    return n;
  let a = xt(r[0], e);
  return s && (a = -a), a || 0;
}
function Ft(e, i) {
  const t = this, {
    rtlTranslate: s,
    params: n,
    $wrapperEl: r,
    wrapperEl: a,
    progress: d
  } = t;
  let l = 0, o = 0;
  const c = 0;
  t.isHorizontal() ? l = s ? -e : e : o = e, n.roundLengths && (l = Math.floor(l), o = Math.floor(o)), n.cssMode ? a[t.isHorizontal() ? "scrollLeft" : "scrollTop"] = t.isHorizontal() ? -l : -o : n.virtualTranslate || r.transform(`translate3d(${l}px, ${o}px, ${c}px)`), t.previousTranslate = t.translate, t.translate = t.isHorizontal() ? l : o;
  let u;
  const f = t.maxTranslate() - t.minTranslate();
  f === 0 ? u = 0 : u = (e - t.minTranslate()) / f, u !== d && t.updateProgress(e), t.emit("setTranslate", t.translate, i);
}
function Wt() {
  return -this.snapGrid[0];
}
function qt() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function Xt(e = 0, i = this.params.speed, t = !0, s = !0, n) {
  const r = this, {
    params: a,
    wrapperEl: d
  } = r;
  if (r.animating && a.preventInteractionOnTransition)
    return !1;
  const l = r.minTranslate(), o = r.maxTranslate();
  let c;
  if (s && e > l ? c = l : s && e < o ? c = o : c = e, r.updateProgress(c), a.cssMode) {
    const u = r.isHorizontal();
    if (i === 0)
      d[u ? "scrollLeft" : "scrollTop"] = -c;
    else {
      if (!r.support.smoothScroll)
        return Te({
          swiper: r,
          targetPosition: -c,
          side: u ? "left" : "top"
        }), !0;
      d.scrollTo({
        [u ? "left" : "top"]: -c,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return i === 0 ? (r.setTransition(0), r.setTranslate(c), t && (r.emit("beforeTransitionStart", i, n), r.emit("transitionEnd"))) : (r.setTransition(i), r.setTranslate(c), t && (r.emit("beforeTransitionStart", i, n), r.emit("transitionStart")), r.animating || (r.animating = !0, r.onTranslateToWrapperTransitionEnd || (r.onTranslateToWrapperTransitionEnd = function(f) {
    !r || r.destroyed || f.target === this && (r.$wrapperEl[0].removeEventListener("transitionend", r.onTranslateToWrapperTransitionEnd), r.$wrapperEl[0].removeEventListener("webkitTransitionEnd", r.onTranslateToWrapperTransitionEnd), r.onTranslateToWrapperTransitionEnd = null, delete r.onTranslateToWrapperTransitionEnd, t && r.emit("transitionEnd"));
  }), r.$wrapperEl[0].addEventListener("transitionend", r.onTranslateToWrapperTransitionEnd), r.$wrapperEl[0].addEventListener("webkitTransitionEnd", r.onTranslateToWrapperTransitionEnd))), !0;
}
const Yt = {
  getTranslate: Rt,
  setTranslate: Ft,
  minTranslate: Wt,
  maxTranslate: qt,
  translateTo: Xt
};
function Kt(e, i) {
  const t = this;
  t.params.cssMode || t.$wrapperEl.transition(e), t.emit("setTransition", e, i);
}
function Ee({
  swiper: e,
  runCallbacks: i,
  direction: t,
  step: s
}) {
  const {
    activeIndex: n,
    previousIndex: r
  } = e;
  let a = t;
  if (a || (n > r ? a = "next" : n < r ? a = "prev" : a = "reset"), e.emit(`transition${s}`), i && n !== r) {
    if (a === "reset") {
      e.emit(`slideResetTransition${s}`);
      return;
    }
    e.emit(`slideChangeTransition${s}`), a === "next" ? e.emit(`slideNextTransition${s}`) : e.emit(`slidePrevTransition${s}`);
  }
}
function Ut(e = !0, i) {
  const t = this, {
    params: s
  } = t;
  s.cssMode || (s.autoHeight && t.updateAutoHeight(), Ee({
    swiper: t,
    runCallbacks: e,
    direction: i,
    step: "Start"
  }));
}
function Zt(e = !0, i) {
  const t = this, {
    params: s
  } = t;
  t.animating = !1, !s.cssMode && (t.setTransition(0), Ee({
    swiper: t,
    runCallbacks: e,
    direction: i,
    step: "End"
  }));
}
const Jt = {
  setTransition: Kt,
  transitionStart: Ut,
  transitionEnd: Zt
};
function Qt(e = 0, i = this.params.speed, t = !0, s, n) {
  if (typeof e != "number" && typeof e != "string")
    throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof e}] given.`);
  if (typeof e == "string") {
    const T = parseInt(e, 10);
    if (!isFinite(T))
      throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${e}] given.`);
    e = T;
  }
  const r = this;
  let a = e;
  a < 0 && (a = 0);
  const {
    params: d,
    snapGrid: l,
    slidesGrid: o,
    previousIndex: c,
    activeIndex: u,
    rtlTranslate: f,
    wrapperEl: h,
    enabled: v
  } = r;
  if (r.animating && d.preventInteractionOnTransition || !v && !s && !n)
    return !1;
  const w = Math.min(r.params.slidesPerGroupSkip, a);
  let g = w + Math.floor((a - w) / r.params.slidesPerGroup);
  g >= l.length && (g = l.length - 1);
  const p = -l[g];
  if (d.normalizeSlideIndex)
    for (let T = 0; T < o.length; T += 1) {
      const C = -Math.floor(p * 100), b = Math.floor(o[T] * 100), $ = Math.floor(o[T + 1] * 100);
      typeof o[T + 1] < "u" ? C >= b && C < $ - ($ - b) / 2 ? a = T : C >= b && C < $ && (a = T + 1) : C >= b && (a = T);
    }
  if (r.initialized && a !== u && (!r.allowSlideNext && p < r.translate && p < r.minTranslate() || !r.allowSlidePrev && p > r.translate && p > r.maxTranslate() && (u || 0) !== a))
    return !1;
  a !== (c || 0) && t && r.emit("beforeSlideChangeStart"), r.updateProgress(p);
  let S;
  if (a > u ? S = "next" : a < u ? S = "prev" : S = "reset", f && -p === r.translate || !f && p === r.translate)
    return r.updateActiveIndex(a), d.autoHeight && r.updateAutoHeight(), r.updateSlidesClasses(), d.effect !== "slide" && r.setTranslate(p), S !== "reset" && (r.transitionStart(t, S), r.transitionEnd(t, S)), !1;
  if (d.cssMode) {
    const T = r.isHorizontal(), C = f ? p : -p;
    if (i === 0) {
      const b = r.virtual && r.params.virtual.enabled;
      b && (r.wrapperEl.style.scrollSnapType = "none", r._immediateVirtual = !0), h[T ? "scrollLeft" : "scrollTop"] = C, b && requestAnimationFrame(() => {
        r.wrapperEl.style.scrollSnapType = "", r._swiperImmediateVirtual = !1;
      });
    } else {
      if (!r.support.smoothScroll)
        return Te({
          swiper: r,
          targetPosition: C,
          side: T ? "left" : "top"
        }), !0;
      h.scrollTo({
        [T ? "left" : "top"]: C,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return r.setTransition(i), r.setTranslate(p), r.updateActiveIndex(a), r.updateSlidesClasses(), r.emit("beforeTransitionStart", i, s), r.transitionStart(t, S), i === 0 ? r.transitionEnd(t, S) : r.animating || (r.animating = !0, r.onSlideToWrapperTransitionEnd || (r.onSlideToWrapperTransitionEnd = function(C) {
    !r || r.destroyed || C.target === this && (r.$wrapperEl[0].removeEventListener("transitionend", r.onSlideToWrapperTransitionEnd), r.$wrapperEl[0].removeEventListener("webkitTransitionEnd", r.onSlideToWrapperTransitionEnd), r.onSlideToWrapperTransitionEnd = null, delete r.onSlideToWrapperTransitionEnd, r.transitionEnd(t, S));
  }), r.$wrapperEl[0].addEventListener("transitionend", r.onSlideToWrapperTransitionEnd), r.$wrapperEl[0].addEventListener("webkitTransitionEnd", r.onSlideToWrapperTransitionEnd)), !0;
}
function ei(e = 0, i = this.params.speed, t = !0, s) {
  if (typeof e == "string") {
    const a = parseInt(e, 10);
    if (!isFinite(a))
      throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${e}] given.`);
    e = a;
  }
  const n = this;
  let r = e;
  return n.params.loop && (r += n.loopedSlides), n.slideTo(r, i, t, s);
}
function ti(e = this.params.speed, i = !0, t) {
  const s = this, {
    animating: n,
    enabled: r,
    params: a
  } = s;
  if (!r)
    return s;
  let d = a.slidesPerGroup;
  a.slidesPerView === "auto" && a.slidesPerGroup === 1 && a.slidesPerGroupAuto && (d = Math.max(s.slidesPerViewDynamic("current", !0), 1));
  const l = s.activeIndex < a.slidesPerGroupSkip ? 1 : d;
  if (a.loop) {
    if (n && a.loopPreventsSlide)
      return !1;
    s.loopFix(), s._clientLeft = s.$wrapperEl[0].clientLeft;
  }
  return a.rewind && s.isEnd ? s.slideTo(0, e, i, t) : s.slideTo(s.activeIndex + l, e, i, t);
}
function ii(e = this.params.speed, i = !0, t) {
  const s = this, {
    params: n,
    animating: r,
    snapGrid: a,
    slidesGrid: d,
    rtlTranslate: l,
    enabled: o
  } = s;
  if (!o)
    return s;
  if (n.loop) {
    if (r && n.loopPreventsSlide)
      return !1;
    s.loopFix(), s._clientLeft = s.$wrapperEl[0].clientLeft;
  }
  const c = l ? s.translate : -s.translate;
  function u(g) {
    return g < 0 ? -Math.floor(Math.abs(g)) : Math.floor(g);
  }
  const f = u(c), h = a.map((g) => u(g));
  let v = a[h.indexOf(f) - 1];
  if (typeof v > "u" && n.cssMode) {
    let g;
    a.forEach((p, S) => {
      f >= p && (g = S);
    }), typeof g < "u" && (v = a[g > 0 ? g - 1 : g]);
  }
  let w = 0;
  if (typeof v < "u" && (w = d.indexOf(v), w < 0 && (w = s.activeIndex - 1), n.slidesPerView === "auto" && n.slidesPerGroup === 1 && n.slidesPerGroupAuto && (w = w - s.slidesPerViewDynamic("previous", !0) + 1, w = Math.max(w, 0))), n.rewind && s.isBeginning) {
    const g = s.params.virtual && s.params.virtual.enabled && s.virtual ? s.virtual.slides.length - 1 : s.slides.length - 1;
    return s.slideTo(g, e, i, t);
  }
  return s.slideTo(w, e, i, t);
}
function si(e = this.params.speed, i = !0, t) {
  const s = this;
  return s.slideTo(s.activeIndex, e, i, t);
}
function ni(e = this.params.speed, i = !0, t, s = 0.5) {
  const n = this;
  let r = n.activeIndex;
  const a = Math.min(n.params.slidesPerGroupSkip, r), d = a + Math.floor((r - a) / n.params.slidesPerGroup), l = n.rtlTranslate ? n.translate : -n.translate;
  if (l >= n.snapGrid[d]) {
    const o = n.snapGrid[d], c = n.snapGrid[d + 1];
    l - o > (c - o) * s && (r += n.params.slidesPerGroup);
  } else {
    const o = n.snapGrid[d - 1], c = n.snapGrid[d];
    l - o <= (c - o) * s && (r -= n.params.slidesPerGroup);
  }
  return r = Math.max(r, 0), r = Math.min(r, n.slidesGrid.length - 1), n.slideTo(r, e, i, t);
}
function ri() {
  const e = this, {
    params: i,
    $wrapperEl: t
  } = e, s = i.slidesPerView === "auto" ? e.slidesPerViewDynamic() : i.slidesPerView;
  let n = e.clickedIndex, r;
  if (i.loop) {
    if (e.animating)
      return;
    r = parseInt(m(e.clickedSlide).attr("data-swiper-slide-index"), 10), i.centeredSlides ? n < e.loopedSlides - s / 2 || n > e.slides.length - e.loopedSlides + s / 2 ? (e.loopFix(), n = t.children(`.${i.slideClass}[data-swiper-slide-index="${r}"]:not(.${i.slideDuplicateClass})`).eq(0).index(), le(() => {
      e.slideTo(n);
    })) : e.slideTo(n) : n > e.slides.length - s ? (e.loopFix(), n = t.children(`.${i.slideClass}[data-swiper-slide-index="${r}"]:not(.${i.slideDuplicateClass})`).eq(0).index(), le(() => {
      e.slideTo(n);
    })) : e.slideTo(n);
  } else
    e.slideTo(n);
}
const li = {
  slideTo: Qt,
  slideToLoop: ei,
  slideNext: ti,
  slidePrev: ii,
  slideReset: si,
  slideToClosest: ni,
  slideToClickedSlide: ri
};
function ai() {
  const e = this, i = I(), {
    params: t,
    $wrapperEl: s
  } = e, n = s.children().length > 0 ? m(s.children()[0].parentNode) : s;
  n.children(`.${t.slideClass}.${t.slideDuplicateClass}`).remove();
  let r = n.children(`.${t.slideClass}`);
  if (t.loopFillGroupWithBlank) {
    const l = t.slidesPerGroup - r.length % t.slidesPerGroup;
    if (l !== t.slidesPerGroup) {
      for (let o = 0; o < l; o += 1) {
        const c = m(i.createElement("div")).addClass(`${t.slideClass} ${t.slideBlankClass}`);
        n.append(c);
      }
      r = n.children(`.${t.slideClass}`);
    }
  }
  t.slidesPerView === "auto" && !t.loopedSlides && (t.loopedSlides = r.length), e.loopedSlides = Math.ceil(parseFloat(t.loopedSlides || t.slidesPerView, 10)), e.loopedSlides += t.loopAdditionalSlides, e.loopedSlides > r.length && e.params.loopedSlidesLimit && (e.loopedSlides = r.length);
  const a = [], d = [];
  r.each((l, o) => {
    m(l).attr("data-swiper-slide-index", o);
  });
  for (let l = 0; l < e.loopedSlides; l += 1) {
    const o = l - Math.floor(l / r.length) * r.length;
    d.push(r.eq(o)[0]), a.unshift(r.eq(r.length - o - 1)[0]);
  }
  for (let l = 0; l < d.length; l += 1)
    n.append(m(d[l].cloneNode(!0)).addClass(t.slideDuplicateClass));
  for (let l = a.length - 1; l >= 0; l -= 1)
    n.prepend(m(a[l].cloneNode(!0)).addClass(t.slideDuplicateClass));
}
function oi() {
  const e = this;
  e.emit("beforeLoopFix");
  const {
    activeIndex: i,
    slides: t,
    loopedSlides: s,
    allowSlidePrev: n,
    allowSlideNext: r,
    snapGrid: a,
    rtlTranslate: d
  } = e;
  let l;
  e.allowSlidePrev = !0, e.allowSlideNext = !0;
  const c = -a[i] - e.getTranslate();
  i < s ? (l = t.length - s * 3 + i, l += s, e.slideTo(l, 0, !1, !0) && c !== 0 && e.setTranslate((d ? -e.translate : e.translate) - c)) : i >= t.length - s && (l = -t.length + i + s, l += s, e.slideTo(l, 0, !1, !0) && c !== 0 && e.setTranslate((d ? -e.translate : e.translate) - c)), e.allowSlidePrev = n, e.allowSlideNext = r, e.emit("loopFix");
}
function di() {
  const e = this, {
    $wrapperEl: i,
    params: t,
    slides: s
  } = e;
  i.children(`.${t.slideClass}.${t.slideDuplicateClass},.${t.slideClass}.${t.slideBlankClass}`).remove(), s.removeAttr("data-swiper-slide-index");
}
const ci = {
  loopCreate: ai,
  loopFix: oi,
  loopDestroy: di
};
function fi(e) {
  const i = this;
  if (i.support.touch || !i.params.simulateTouch || i.params.watchOverflow && i.isLocked || i.params.cssMode)
    return;
  const t = i.params.touchEventsTarget === "container" ? i.el : i.wrapperEl;
  t.style.cursor = "move", t.style.cursor = e ? "grabbing" : "grab";
}
function ui() {
  const e = this;
  e.support.touch || e.params.watchOverflow && e.isLocked || e.params.cssMode || (e[e.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "");
}
const pi = {
  setGrabCursor: fi,
  unsetGrabCursor: ui
};
function hi(e, i = this) {
  function t(s) {
    if (!s || s === I() || s === O())
      return null;
    s.assignedSlot && (s = s.assignedSlot);
    const n = s.closest(e);
    return !n && !s.getRootNode ? null : n || t(s.getRootNode().host);
  }
  return t(i);
}
function mi(e) {
  const i = this, t = I(), s = O(), n = i.touchEventsData, {
    params: r,
    touches: a,
    enabled: d
  } = i;
  if (!d || i.animating && r.preventInteractionOnTransition)
    return;
  !i.animating && r.cssMode && r.loop && i.loopFix();
  let l = e;
  l.originalEvent && (l = l.originalEvent);
  let o = m(l.target);
  if (r.touchEventsTarget === "wrapper" && !o.closest(i.wrapperEl).length || (n.isTouchEvent = l.type === "touchstart", !n.isTouchEvent && "which" in l && l.which === 3) || !n.isTouchEvent && "button" in l && l.button > 0 || n.isTouched && n.isMoved)
    return;
  const c = !!r.noSwipingClass && r.noSwipingClass !== "", u = e.composedPath ? e.composedPath() : e.path;
  c && l.target && l.target.shadowRoot && u && (o = m(u[0]));
  const f = r.noSwipingSelector ? r.noSwipingSelector : `.${r.noSwipingClass}`, h = !!(l.target && l.target.shadowRoot);
  if (r.noSwiping && (h ? hi(f, o[0]) : o.closest(f)[0])) {
    i.allowClick = !0;
    return;
  }
  if (r.swipeHandler && !o.closest(r.swipeHandler)[0])
    return;
  a.currentX = l.type === "touchstart" ? l.targetTouches[0].pageX : l.pageX, a.currentY = l.type === "touchstart" ? l.targetTouches[0].pageY : l.pageY;
  const v = a.currentX, w = a.currentY, g = r.edgeSwipeDetection || r.iOSEdgeSwipeDetection, p = r.edgeSwipeThreshold || r.iOSEdgeSwipeThreshold;
  if (g && (v <= p || v >= s.innerWidth - p))
    if (g === "prevent")
      e.preventDefault();
    else
      return;
  if (Object.assign(n, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), a.startX = v, a.startY = w, n.touchStartTime = q(), i.allowClick = !0, i.updateSize(), i.swipeDirection = void 0, r.threshold > 0 && (n.allowThresholdMove = !1), l.type !== "touchstart") {
    let S = !0;
    o.is(n.focusableElements) && (S = !1, o[0].nodeName === "SELECT" && (n.isTouched = !1)), t.activeElement && m(t.activeElement).is(n.focusableElements) && t.activeElement !== o[0] && t.activeElement.blur();
    const T = S && i.allowTouchMove && r.touchStartPreventDefault;
    (r.touchStartForcePreventDefault || T) && !o[0].isContentEditable && l.preventDefault();
  }
  i.params.freeMode && i.params.freeMode.enabled && i.freeMode && i.animating && !r.cssMode && i.freeMode.onTouchStart(), i.emit("touchStart", l);
}
function gi(e) {
  const i = I(), t = this, s = t.touchEventsData, {
    params: n,
    touches: r,
    rtlTranslate: a,
    enabled: d
  } = t;
  if (!d)
    return;
  let l = e;
  if (l.originalEvent && (l = l.originalEvent), !s.isTouched) {
    s.startMoving && s.isScrolling && t.emit("touchMoveOpposite", l);
    return;
  }
  if (s.isTouchEvent && l.type !== "touchmove")
    return;
  const o = l.type === "touchmove" && l.targetTouches && (l.targetTouches[0] || l.changedTouches[0]), c = l.type === "touchmove" ? o.pageX : l.pageX, u = l.type === "touchmove" ? o.pageY : l.pageY;
  if (l.preventedByNestedSwiper) {
    r.startX = c, r.startY = u;
    return;
  }
  if (!t.allowTouchMove) {
    m(l.target).is(s.focusableElements) || (t.allowClick = !1), s.isTouched && (Object.assign(r, {
      startX: c,
      startY: u,
      currentX: c,
      currentY: u
    }), s.touchStartTime = q());
    return;
  }
  if (s.isTouchEvent && n.touchReleaseOnEdges && !n.loop) {
    if (t.isVertical()) {
      if (u < r.startY && t.translate <= t.maxTranslate() || u > r.startY && t.translate >= t.minTranslate()) {
        s.isTouched = !1, s.isMoved = !1;
        return;
      }
    } else if (c < r.startX && t.translate <= t.maxTranslate() || c > r.startX && t.translate >= t.minTranslate())
      return;
  }
  if (s.isTouchEvent && i.activeElement && l.target === i.activeElement && m(l.target).is(s.focusableElements)) {
    s.isMoved = !0, t.allowClick = !1;
    return;
  }
  if (s.allowTouchCallbacks && t.emit("touchMove", l), l.targetTouches && l.targetTouches.length > 1)
    return;
  r.currentX = c, r.currentY = u;
  const f = r.currentX - r.startX, h = r.currentY - r.startY;
  if (t.params.threshold && Math.sqrt(f ** 2 + h ** 2) < t.params.threshold)
    return;
  if (typeof s.isScrolling > "u") {
    let p;
    t.isHorizontal() && r.currentY === r.startY || t.isVertical() && r.currentX === r.startX ? s.isScrolling = !1 : f * f + h * h >= 25 && (p = Math.atan2(Math.abs(h), Math.abs(f)) * 180 / Math.PI, s.isScrolling = t.isHorizontal() ? p > n.touchAngle : 90 - p > n.touchAngle);
  }
  if (s.isScrolling && t.emit("touchMoveOpposite", l), typeof s.startMoving > "u" && (r.currentX !== r.startX || r.currentY !== r.startY) && (s.startMoving = !0), s.isScrolling) {
    s.isTouched = !1;
    return;
  }
  if (!s.startMoving)
    return;
  t.allowClick = !1, !n.cssMode && l.cancelable && l.preventDefault(), n.touchMoveStopPropagation && !n.nested && l.stopPropagation(), s.isMoved || (n.loop && !n.cssMode && t.loopFix(), s.startTranslate = t.getTranslate(), t.setTransition(0), t.animating && t.$wrapperEl.trigger("webkitTransitionEnd transitionend"), s.allowMomentumBounce = !1, n.grabCursor && (t.allowSlideNext === !0 || t.allowSlidePrev === !0) && t.setGrabCursor(!0), t.emit("sliderFirstMove", l)), t.emit("sliderMove", l), s.isMoved = !0;
  let v = t.isHorizontal() ? f : h;
  r.diff = v, v *= n.touchRatio, a && (v = -v), t.swipeDirection = v > 0 ? "prev" : "next", s.currentTranslate = v + s.startTranslate;
  let w = !0, g = n.resistanceRatio;
  if (n.touchReleaseOnEdges && (g = 0), v > 0 && s.currentTranslate > t.minTranslate() ? (w = !1, n.resistance && (s.currentTranslate = t.minTranslate() - 1 + (-t.minTranslate() + s.startTranslate + v) ** g)) : v < 0 && s.currentTranslate < t.maxTranslate() && (w = !1, n.resistance && (s.currentTranslate = t.maxTranslate() + 1 - (t.maxTranslate() - s.startTranslate - v) ** g)), w && (l.preventedByNestedSwiper = !0), !t.allowSlideNext && t.swipeDirection === "next" && s.currentTranslate < s.startTranslate && (s.currentTranslate = s.startTranslate), !t.allowSlidePrev && t.swipeDirection === "prev" && s.currentTranslate > s.startTranslate && (s.currentTranslate = s.startTranslate), !t.allowSlidePrev && !t.allowSlideNext && (s.currentTranslate = s.startTranslate), n.threshold > 0)
    if (Math.abs(v) > n.threshold || s.allowThresholdMove) {
      if (!s.allowThresholdMove) {
        s.allowThresholdMove = !0, r.startX = r.currentX, r.startY = r.currentY, s.currentTranslate = s.startTranslate, r.diff = t.isHorizontal() ? r.currentX - r.startX : r.currentY - r.startY;
        return;
      }
    } else {
      s.currentTranslate = s.startTranslate;
      return;
    }
  !n.followFinger || n.cssMode || ((n.freeMode && n.freeMode.enabled && t.freeMode || n.watchSlidesProgress) && (t.updateActiveIndex(), t.updateSlidesClasses()), t.params.freeMode && n.freeMode.enabled && t.freeMode && t.freeMode.onTouchMove(), t.updateProgress(s.currentTranslate), t.setTranslate(s.currentTranslate));
}
function vi(e) {
  const i = this, t = i.touchEventsData, {
    params: s,
    touches: n,
    rtlTranslate: r,
    slidesGrid: a,
    enabled: d
  } = i;
  if (!d)
    return;
  let l = e;
  if (l.originalEvent && (l = l.originalEvent), t.allowTouchCallbacks && i.emit("touchEnd", l), t.allowTouchCallbacks = !1, !t.isTouched) {
    t.isMoved && s.grabCursor && i.setGrabCursor(!1), t.isMoved = !1, t.startMoving = !1;
    return;
  }
  s.grabCursor && t.isMoved && t.isTouched && (i.allowSlideNext === !0 || i.allowSlidePrev === !0) && i.setGrabCursor(!1);
  const o = q(), c = o - t.touchStartTime;
  if (i.allowClick) {
    const S = l.path || l.composedPath && l.composedPath();
    i.updateClickedSlide(S && S[0] || l.target), i.emit("tap click", l), c < 300 && o - t.lastClickTime < 300 && i.emit("doubleTap doubleClick", l);
  }
  if (t.lastClickTime = q(), le(() => {
    i.destroyed || (i.allowClick = !0);
  }), !t.isTouched || !t.isMoved || !i.swipeDirection || n.diff === 0 || t.currentTranslate === t.startTranslate) {
    t.isTouched = !1, t.isMoved = !1, t.startMoving = !1;
    return;
  }
  t.isTouched = !1, t.isMoved = !1, t.startMoving = !1;
  let u;
  if (s.followFinger ? u = r ? i.translate : -i.translate : u = -t.currentTranslate, s.cssMode)
    return;
  if (i.params.freeMode && s.freeMode.enabled) {
    i.freeMode.onTouchEnd({
      currentPos: u
    });
    return;
  }
  let f = 0, h = i.slidesSizesGrid[0];
  for (let S = 0; S < a.length; S += S < s.slidesPerGroupSkip ? 1 : s.slidesPerGroup) {
    const T = S < s.slidesPerGroupSkip - 1 ? 1 : s.slidesPerGroup;
    typeof a[S + T] < "u" ? u >= a[S] && u < a[S + T] && (f = S, h = a[S + T] - a[S]) : u >= a[S] && (f = S, h = a[a.length - 1] - a[a.length - 2]);
  }
  let v = null, w = null;
  s.rewind && (i.isBeginning ? w = i.params.virtual && i.params.virtual.enabled && i.virtual ? i.virtual.slides.length - 1 : i.slides.length - 1 : i.isEnd && (v = 0));
  const g = (u - a[f]) / h, p = f < s.slidesPerGroupSkip - 1 ? 1 : s.slidesPerGroup;
  if (c > s.longSwipesMs) {
    if (!s.longSwipes) {
      i.slideTo(i.activeIndex);
      return;
    }
    i.swipeDirection === "next" && (g >= s.longSwipesRatio ? i.slideTo(s.rewind && i.isEnd ? v : f + p) : i.slideTo(f)), i.swipeDirection === "prev" && (g > 1 - s.longSwipesRatio ? i.slideTo(f + p) : w !== null && g < 0 && Math.abs(g) > s.longSwipesRatio ? i.slideTo(w) : i.slideTo(f));
  } else {
    if (!s.shortSwipes) {
      i.slideTo(i.activeIndex);
      return;
    }
    i.navigation && (l.target === i.navigation.nextEl || l.target === i.navigation.prevEl) ? l.target === i.navigation.nextEl ? i.slideTo(f + p) : i.slideTo(f) : (i.swipeDirection === "next" && i.slideTo(v !== null ? v : f + p), i.swipeDirection === "prev" && i.slideTo(w !== null ? w : f));
  }
}
function ue() {
  const e = this, {
    params: i,
    el: t
  } = e;
  if (t && t.offsetWidth === 0)
    return;
  i.breakpoints && e.setBreakpoint();
  const {
    allowSlideNext: s,
    allowSlidePrev: n,
    snapGrid: r
  } = e;
  e.allowSlideNext = !0, e.allowSlidePrev = !0, e.updateSize(), e.updateSlides(), e.updateSlidesClasses(), (i.slidesPerView === "auto" || i.slidesPerView > 1) && e.isEnd && !e.isBeginning && !e.params.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0), e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.run(), e.allowSlidePrev = n, e.allowSlideNext = s, e.params.watchOverflow && r !== e.snapGrid && e.checkOverflow();
}
function wi(e) {
  const i = this;
  i.enabled && (i.allowClick || (i.params.preventClicks && e.preventDefault(), i.params.preventClicksPropagation && i.animating && (e.stopPropagation(), e.stopImmediatePropagation())));
}
function Si() {
  const e = this, {
    wrapperEl: i,
    rtlTranslate: t,
    enabled: s
  } = e;
  if (!s)
    return;
  e.previousTranslate = e.translate, e.isHorizontal() ? e.translate = -i.scrollLeft : e.translate = -i.scrollTop, e.translate === 0 && (e.translate = 0), e.updateActiveIndex(), e.updateSlidesClasses();
  let n;
  const r = e.maxTranslate() - e.minTranslate();
  r === 0 ? n = 0 : n = (e.translate - e.minTranslate()) / r, n !== e.progress && e.updateProgress(t ? -e.translate : e.translate), e.emit("setTranslate", e.translate, !1);
}
let pe = !1;
function Ti() {
}
const xe = (e, i) => {
  const t = I(), {
    params: s,
    touchEvents: n,
    el: r,
    wrapperEl: a,
    device: d,
    support: l
  } = e, o = !!s.nested, c = i === "on" ? "addEventListener" : "removeEventListener", u = i;
  if (!l.touch)
    r[c](n.start, e.onTouchStart, !1), t[c](n.move, e.onTouchMove, o), t[c](n.end, e.onTouchEnd, !1);
  else {
    const f = n.start === "touchstart" && l.passiveListener && s.passiveListeners ? {
      passive: !0,
      capture: !1
    } : !1;
    r[c](n.start, e.onTouchStart, f), r[c](n.move, e.onTouchMove, l.passiveListener ? {
      passive: !1,
      capture: o
    } : o), r[c](n.end, e.onTouchEnd, f), n.cancel && r[c](n.cancel, e.onTouchEnd, f);
  }
  (s.preventClicks || s.preventClicksPropagation) && r[c]("click", e.onClick, !0), s.cssMode && a[c]("scroll", e.onScroll), s.updateOnWindowResize ? e[u](d.ios || d.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", ue, !0) : e[u]("observerUpdate", ue, !0);
};
function bi() {
  const e = this, i = I(), {
    params: t,
    support: s
  } = e;
  e.onTouchStart = mi.bind(e), e.onTouchMove = gi.bind(e), e.onTouchEnd = vi.bind(e), t.cssMode && (e.onScroll = Si.bind(e)), e.onClick = wi.bind(e), s.touch && !pe && (i.addEventListener("touchstart", Ti), pe = !0), xe(e, "on");
}
function Ei() {
  xe(this, "off");
}
const xi = {
  attachEvents: bi,
  detachEvents: Ei
}, he = (e, i) => e.grid && i.grid && i.grid.rows > 1;
function Ci() {
  const e = this, {
    activeIndex: i,
    initialized: t,
    loopedSlides: s = 0,
    params: n,
    $el: r
  } = e, a = n.breakpoints;
  if (!a || a && Object.keys(a).length === 0)
    return;
  const d = e.getBreakpoint(a, e.params.breakpointsBase, e.el);
  if (!d || e.currentBreakpoint === d)
    return;
  const o = (d in a ? a[d] : void 0) || e.originalParams, c = he(e, n), u = he(e, o), f = n.enabled;
  c && !u ? (r.removeClass(`${n.containerModifierClass}grid ${n.containerModifierClass}grid-column`), e.emitContainerClasses()) : !c && u && (r.addClass(`${n.containerModifierClass}grid`), (o.grid.fill && o.grid.fill === "column" || !o.grid.fill && n.grid.fill === "column") && r.addClass(`${n.containerModifierClass}grid-column`), e.emitContainerClasses()), ["navigation", "pagination", "scrollbar"].forEach((g) => {
    const p = n[g] && n[g].enabled, S = o[g] && o[g].enabled;
    p && !S && e[g].disable(), !p && S && e[g].enable();
  });
  const h = o.direction && o.direction !== n.direction, v = n.loop && (o.slidesPerView !== n.slidesPerView || h);
  h && t && e.changeDirection(), _(e.params, o);
  const w = e.params.enabled;
  Object.assign(e, {
    allowTouchMove: e.params.allowTouchMove,
    allowSlideNext: e.params.allowSlideNext,
    allowSlidePrev: e.params.allowSlidePrev
  }), f && !w ? e.disable() : !f && w && e.enable(), e.currentBreakpoint = d, e.emit("_beforeBreakpoint", o), v && t && (e.loopDestroy(), e.loopCreate(), e.updateSlides(), e.slideTo(i - s + e.loopedSlides, 0, !1)), e.emit("breakpoint", o);
}
function yi(e, i = "window", t) {
  if (!e || i === "container" && !t)
    return;
  let s = !1;
  const n = O(), r = i === "window" ? n.innerHeight : t.clientHeight, a = Object.keys(e).map((d) => {
    if (typeof d == "string" && d.indexOf("@") === 0) {
      const l = parseFloat(d.substr(1));
      return {
        value: r * l,
        point: d
      };
    }
    return {
      value: d,
      point: d
    };
  });
  a.sort((d, l) => parseInt(d.value, 10) - parseInt(l.value, 10));
  for (let d = 0; d < a.length; d += 1) {
    const {
      point: l,
      value: o
    } = a[d];
    i === "window" ? n.matchMedia(`(min-width: ${o}px)`).matches && (s = l) : o <= t.clientWidth && (s = l);
  }
  return s || "max";
}
const Mi = {
  setBreakpoint: Ci,
  getBreakpoint: yi
};
function Li(e, i) {
  const t = [];
  return e.forEach((s) => {
    typeof s == "object" ? Object.keys(s).forEach((n) => {
      s[n] && t.push(i + n);
    }) : typeof s == "string" && t.push(i + s);
  }), t;
}
function Oi() {
  const e = this, {
    classNames: i,
    params: t,
    rtl: s,
    $el: n,
    device: r,
    support: a
  } = e, d = Li(["initialized", t.direction, {
    "pointer-events": !a.touch
  }, {
    "free-mode": e.params.freeMode && t.freeMode.enabled
  }, {
    autoheight: t.autoHeight
  }, {
    rtl: s
  }, {
    grid: t.grid && t.grid.rows > 1
  }, {
    "grid-column": t.grid && t.grid.rows > 1 && t.grid.fill === "column"
  }, {
    android: r.android
  }, {
    ios: r.ios
  }, {
    "css-mode": t.cssMode
  }, {
    centered: t.cssMode && t.centeredSlides
  }, {
    "watch-progress": t.watchSlidesProgress
  }], t.containerModifierClass);
  i.push(...d), n.addClass([...i].join(" ")), e.emitContainerClasses();
}
function Pi() {
  const e = this, {
    $el: i,
    classNames: t
  } = e;
  i.removeClass(t.join(" ")), e.emitContainerClasses();
}
const $i = {
  addClasses: Oi,
  removeClasses: Pi
};
function _i(e, i, t, s, n, r) {
  const a = O();
  let d;
  function l() {
    r && r();
  }
  !m(e).parent("picture")[0] && (!e.complete || !n) && i ? (d = new a.Image(), d.onload = l, d.onerror = l, s && (d.sizes = s), t && (d.srcset = t), i && (d.src = i)) : l();
}
function Ii() {
  const e = this;
  e.imagesToLoad = e.$el.find("img");
  function i() {
    typeof e > "u" || e === null || !e || e.destroyed || (e.imagesLoaded !== void 0 && (e.imagesLoaded += 1), e.imagesLoaded === e.imagesToLoad.length && (e.params.updateOnImagesReady && e.update(), e.emit("imagesReady")));
  }
  for (let t = 0; t < e.imagesToLoad.length; t += 1) {
    const s = e.imagesToLoad[t];
    e.loadImage(s, s.currentSrc || s.getAttribute("src"), s.srcset || s.getAttribute("srcset"), s.sizes || s.getAttribute("sizes"), !0, i);
  }
}
const zi = {
  loadImage: _i,
  preloadImages: Ii
};
function Ai() {
  const e = this, {
    isLocked: i,
    params: t
  } = e, {
    slidesOffsetBefore: s
  } = t;
  if (s) {
    const n = e.slides.length - 1, r = e.slidesGrid[n] + e.slidesSizesGrid[n] + s * 2;
    e.isLocked = e.size > r;
  } else
    e.isLocked = e.snapGrid.length === 1;
  t.allowSlideNext === !0 && (e.allowSlideNext = !e.isLocked), t.allowSlidePrev === !0 && (e.allowSlidePrev = !e.isLocked), i && i !== e.isLocked && (e.isEnd = !1), i !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
}
const ki = {
  checkOverflow: Ai
}, me = {
  init: !0,
  direction: "horizontal",
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: !1,
  updateOnWindowResize: !0,
  resizeObserver: !0,
  nested: !1,
  createElements: !1,
  enabled: !0,
  focusableElements: "input, select, option, textarea, button, video, label",
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: !1,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: !1,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: !1,
  // Set wrapper width
  setWrapperSize: !1,
  // Virtual Translate
  virtualTranslate: !1,
  // Effects
  effect: "slide",
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: void 0,
  breakpointsBase: "window",
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: !1,
  centeredSlides: !1,
  centeredSlidesBounds: !1,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: !0,
  centerInsufficientSlides: !1,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: !0,
  // Round length
  roundLengths: !1,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: !0,
  shortSwipes: !0,
  longSwipes: !0,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: !0,
  allowTouchMove: !0,
  threshold: 0,
  touchMoveStopPropagation: !1,
  touchStartPreventDefault: !0,
  touchStartForcePreventDefault: !1,
  touchReleaseOnEdges: !1,
  // Unique Navigation Elements
  uniqueNavElements: !0,
  // Resistance
  resistance: !0,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: !1,
  // Cursor
  grabCursor: !1,
  // Clicks
  preventClicks: !0,
  preventClicksPropagation: !0,
  slideToClickedSlide: !1,
  // Images
  preloadImages: !0,
  updateOnImagesReady: !0,
  // loop
  loop: !1,
  loopAdditionalSlides: 0,
  loopedSlides: null,
  loopedSlidesLimit: !0,
  loopFillGroupWithBlank: !1,
  loopPreventsSlide: !0,
  // rewind
  rewind: !1,
  // Swiping/no swiping
  allowSlidePrev: !0,
  allowSlideNext: !0,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: !0,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: !0,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: "swiper-",
  // NEW
  slideClass: "swiper-slide",
  slideBlankClass: "swiper-slide-invisible-blank",
  slideActiveClass: "swiper-slide-active",
  slideDuplicateActiveClass: "swiper-slide-duplicate-active",
  slideVisibleClass: "swiper-slide-visible",
  slideDuplicateClass: "swiper-slide-duplicate",
  slideNextClass: "swiper-slide-next",
  slideDuplicateNextClass: "swiper-slide-duplicate-next",
  slidePrevClass: "swiper-slide-prev",
  slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
  wrapperClass: "swiper-wrapper",
  // Callbacks
  runCallbacksOnInit: !0,
  // Internals
  _emitClasses: !1
};
function Di(e, i) {
  return function(s = {}) {
    const n = Object.keys(s)[0], r = s[n];
    if (typeof r != "object" || r === null) {
      _(i, s);
      return;
    }
    if (["navigation", "pagination", "scrollbar"].indexOf(n) >= 0 && e[n] === !0 && (e[n] = {
      auto: !0
    }), !(n in e && "enabled" in r)) {
      _(i, s);
      return;
    }
    e[n] === !0 && (e[n] = {
      enabled: !0
    }), typeof e[n] == "object" && !("enabled" in e[n]) && (e[n].enabled = !0), e[n] || (e[n] = {
      enabled: !1
    }), _(i, s);
  };
}
const se = {
  eventsEmitter: It,
  update: Ht,
  translate: Yt,
  transition: Jt,
  slide: li,
  loop: ci,
  grabCursor: pi,
  events: xi,
  breakpoints: Mi,
  checkOverflow: ki,
  classes: $i,
  images: zi
}, ne = {};
let H = class k {
  constructor(...i) {
    let t, s;
    if (i.length === 1 && i[0].constructor && Object.prototype.toString.call(i[0]).slice(8, -1) === "Object" ? s = i[0] : [t, s] = i, s || (s = {}), s = _({}, s), t && !s.el && (s.el = t), s.el && m(s.el).length > 1) {
      const d = [];
      return m(s.el).each((l) => {
        const o = _({}, s, {
          el: l
        });
        d.push(new k(o));
      }), d;
    }
    const n = this;
    n.__swiper__ = !0, n.support = be(), n.device = Lt({
      userAgent: s.userAgent
    }), n.browser = Pt(), n.eventsListeners = {}, n.eventsAnyListeners = [], n.modules = [...n.__modules__], s.modules && Array.isArray(s.modules) && n.modules.push(...s.modules);
    const r = {};
    n.modules.forEach((d) => {
      d({
        swiper: n,
        extendParams: Di(s, r),
        on: n.on.bind(n),
        once: n.once.bind(n),
        off: n.off.bind(n),
        emit: n.emit.bind(n)
      });
    });
    const a = _({}, me, r);
    return n.params = _({}, a, ne, s), n.originalParams = _({}, n.params), n.passedParams = _({}, s), n.params && n.params.on && Object.keys(n.params.on).forEach((d) => {
      n.on(d, n.params.on[d]);
    }), n.params && n.params.onAny && n.onAny(n.params.onAny), n.$ = m, Object.assign(n, {
      enabled: n.params.enabled,
      el: t,
      // Classes
      classNames: [],
      // Slides
      slides: m(),
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return n.params.direction === "horizontal";
      },
      isVertical() {
        return n.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: !0,
      isEnd: !1,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      // Locks
      allowSlideNext: n.params.allowSlideNext,
      allowSlidePrev: n.params.allowSlidePrev,
      // Touch Events
      touchEvents: function() {
        const l = ["touchstart", "touchmove", "touchend", "touchcancel"], o = ["pointerdown", "pointermove", "pointerup"];
        return n.touchEventsTouch = {
          start: l[0],
          move: l[1],
          end: l[2],
          cancel: l[3]
        }, n.touchEventsDesktop = {
          start: o[0],
          move: o[1],
          end: o[2]
        }, n.support.touch || !n.params.simulateTouch ? n.touchEventsTouch : n.touchEventsDesktop;
      }(),
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: n.params.focusableElements,
        // Last click time
        lastClickTime: q(),
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        isTouchEvent: void 0,
        startMoving: void 0
      },
      // Clicks
      allowClick: !0,
      // Touches
      allowTouchMove: n.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }), n.emit("_swiper"), n.params.init && n.init(), n;
  }
  enable() {
    const i = this;
    i.enabled || (i.enabled = !0, i.params.grabCursor && i.setGrabCursor(), i.emit("enable"));
  }
  disable() {
    const i = this;
    i.enabled && (i.enabled = !1, i.params.grabCursor && i.unsetGrabCursor(), i.emit("disable"));
  }
  setProgress(i, t) {
    const s = this;
    i = Math.min(Math.max(i, 0), 1);
    const n = s.minTranslate(), a = (s.maxTranslate() - n) * i + n;
    s.translateTo(a, typeof t > "u" ? 0 : t), s.updateActiveIndex(), s.updateSlidesClasses();
  }
  emitContainerClasses() {
    const i = this;
    if (!i.params._emitClasses || !i.el)
      return;
    const t = i.el.className.split(" ").filter((s) => s.indexOf("swiper") === 0 || s.indexOf(i.params.containerModifierClass) === 0);
    i.emit("_containerClasses", t.join(" "));
  }
  getSlideClasses(i) {
    const t = this;
    return t.destroyed ? "" : i.className.split(" ").filter((s) => s.indexOf("swiper-slide") === 0 || s.indexOf(t.params.slideClass) === 0).join(" ");
  }
  emitSlidesClasses() {
    const i = this;
    if (!i.params._emitClasses || !i.el)
      return;
    const t = [];
    i.slides.each((s) => {
      const n = i.getSlideClasses(s);
      t.push({
        slideEl: s,
        classNames: n
      }), i.emit("_slideClass", s, n);
    }), i.emit("_slideClasses", t);
  }
  slidesPerViewDynamic(i = "current", t = !1) {
    const s = this, {
      params: n,
      slides: r,
      slidesGrid: a,
      slidesSizesGrid: d,
      size: l,
      activeIndex: o
    } = s;
    let c = 1;
    if (n.centeredSlides) {
      let u = r[o].swiperSlideSize, f;
      for (let h = o + 1; h < r.length; h += 1)
        r[h] && !f && (u += r[h].swiperSlideSize, c += 1, u > l && (f = !0));
      for (let h = o - 1; h >= 0; h -= 1)
        r[h] && !f && (u += r[h].swiperSlideSize, c += 1, u > l && (f = !0));
    } else if (i === "current")
      for (let u = o + 1; u < r.length; u += 1)
        (t ? a[u] + d[u] - a[o] < l : a[u] - a[o] < l) && (c += 1);
    else
      for (let u = o - 1; u >= 0; u -= 1)
        a[o] - a[u] < l && (c += 1);
    return c;
  }
  update() {
    const i = this;
    if (!i || i.destroyed)
      return;
    const {
      snapGrid: t,
      params: s
    } = i;
    s.breakpoints && i.setBreakpoint(), i.updateSize(), i.updateSlides(), i.updateProgress(), i.updateSlidesClasses();
    function n() {
      const a = i.rtlTranslate ? i.translate * -1 : i.translate, d = Math.min(Math.max(a, i.maxTranslate()), i.minTranslate());
      i.setTranslate(d), i.updateActiveIndex(), i.updateSlidesClasses();
    }
    let r;
    i.params.freeMode && i.params.freeMode.enabled ? (n(), i.params.autoHeight && i.updateAutoHeight()) : ((i.params.slidesPerView === "auto" || i.params.slidesPerView > 1) && i.isEnd && !i.params.centeredSlides ? r = i.slideTo(i.slides.length - 1, 0, !1, !0) : r = i.slideTo(i.activeIndex, 0, !1, !0), r || n()), s.watchOverflow && t !== i.snapGrid && i.checkOverflow(), i.emit("update");
  }
  changeDirection(i, t = !0) {
    const s = this, n = s.params.direction;
    return i || (i = n === "horizontal" ? "vertical" : "horizontal"), i === n || i !== "horizontal" && i !== "vertical" || (s.$el.removeClass(`${s.params.containerModifierClass}${n}`).addClass(`${s.params.containerModifierClass}${i}`), s.emitContainerClasses(), s.params.direction = i, s.slides.each((r) => {
      i === "vertical" ? r.style.width = "" : r.style.height = "";
    }), s.emit("changeDirection"), t && s.update()), s;
  }
  changeLanguageDirection(i) {
    const t = this;
    t.rtl && i === "rtl" || !t.rtl && i === "ltr" || (t.rtl = i === "rtl", t.rtlTranslate = t.params.direction === "horizontal" && t.rtl, t.rtl ? (t.$el.addClass(`${t.params.containerModifierClass}rtl`), t.el.dir = "rtl") : (t.$el.removeClass(`${t.params.containerModifierClass}rtl`), t.el.dir = "ltr"), t.update());
  }
  mount(i) {
    const t = this;
    if (t.mounted)
      return !0;
    const s = m(i || t.params.el);
    if (i = s[0], !i)
      return !1;
    i.swiper = t;
    const n = () => `.${(t.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let a = (() => {
      if (i && i.shadowRoot && i.shadowRoot.querySelector) {
        const d = m(i.shadowRoot.querySelector(n()));
        return d.children = (l) => s.children(l), d;
      }
      return s.children ? s.children(n()) : m(s).children(n());
    })();
    if (a.length === 0 && t.params.createElements) {
      const l = I().createElement("div");
      a = m(l), l.className = t.params.wrapperClass, s.append(l), s.children(`.${t.params.slideClass}`).each((o) => {
        a.append(o);
      });
    }
    return Object.assign(t, {
      $el: s,
      el: i,
      $wrapperEl: a,
      wrapperEl: a[0],
      mounted: !0,
      // RTL
      rtl: i.dir.toLowerCase() === "rtl" || s.css("direction") === "rtl",
      rtlTranslate: t.params.direction === "horizontal" && (i.dir.toLowerCase() === "rtl" || s.css("direction") === "rtl"),
      wrongRTL: a.css("display") === "-webkit-box"
    }), !0;
  }
  init(i) {
    const t = this;
    return t.initialized || t.mount(i) === !1 || (t.emit("beforeInit"), t.params.breakpoints && t.setBreakpoint(), t.addClasses(), t.params.loop && t.loopCreate(), t.updateSize(), t.updateSlides(), t.params.watchOverflow && t.checkOverflow(), t.params.grabCursor && t.enabled && t.setGrabCursor(), t.params.preloadImages && t.preloadImages(), t.params.loop ? t.slideTo(t.params.initialSlide + t.loopedSlides, 0, t.params.runCallbacksOnInit, !1, !0) : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0), t.attachEvents(), t.initialized = !0, t.emit("init"), t.emit("afterInit")), t;
  }
  destroy(i = !0, t = !0) {
    const s = this, {
      params: n,
      $el: r,
      $wrapperEl: a,
      slides: d
    } = s;
    return typeof s.params > "u" || s.destroyed || (s.emit("beforeDestroy"), s.initialized = !1, s.detachEvents(), n.loop && s.loopDestroy(), t && (s.removeClasses(), r.removeAttr("style"), a.removeAttr("style"), d && d.length && d.removeClass([n.slideVisibleClass, n.slideActiveClass, n.slideNextClass, n.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index")), s.emit("destroy"), Object.keys(s.eventsListeners).forEach((l) => {
      s.off(l);
    }), i !== !1 && (s.$el[0].swiper = null, bt(s)), s.destroyed = !0), null;
  }
  static extendDefaults(i) {
    _(ne, i);
  }
  static get extendedDefaults() {
    return ne;
  }
  static get defaults() {
    return me;
  }
  static installModule(i) {
    k.prototype.__modules__ || (k.prototype.__modules__ = []);
    const t = k.prototype.__modules__;
    typeof i == "function" && t.indexOf(i) < 0 && t.push(i);
  }
  static use(i) {
    return Array.isArray(i) ? (i.forEach((t) => k.installModule(t)), k) : (k.installModule(i), k);
  }
};
Object.keys(se).forEach((e) => {
  Object.keys(se[e]).forEach((i) => {
    H.prototype[i] = se[e][i];
  });
});
H.use([$t, _t]);
function B(e) {
  return typeof e == "object" && e !== null && e.constructor && Object.prototype.toString.call(e).slice(8, -1) === "Object";
}
function N(e, i) {
  const t = ["__proto__", "constructor", "prototype"];
  Object.keys(i).filter((s) => t.indexOf(s) < 0).forEach((s) => {
    typeof e[s] > "u" ? e[s] = i[s] : B(i[s]) && B(e[s]) && Object.keys(i[s]).length > 0 ? i[s].__swiper__ ? e[s] = i[s] : N(e[s], i[s]) : e[s] = i[s];
  });
}
function Ce(e = {}) {
  return e.navigation && typeof e.navigation.nextEl > "u" && typeof e.navigation.prevEl > "u";
}
function ye(e = {}) {
  return e.pagination && typeof e.pagination.el > "u";
}
function Me(e = {}) {
  return e.scrollbar && typeof e.scrollbar.el > "u";
}
function Le(e = "") {
  const i = e.split(" ").map((s) => s.trim()).filter((s) => !!s), t = [];
  return i.forEach((s) => {
    t.indexOf(s) < 0 && t.push(s);
  }), t.join(" ");
}
const Oe = [
  "modules",
  "init",
  "_direction",
  "touchEventsTarget",
  "initialSlide",
  "_speed",
  "cssMode",
  "updateOnWindowResize",
  "resizeObserver",
  "nested",
  "focusableElements",
  "_enabled",
  "_width",
  "_height",
  "preventInteractionOnTransition",
  "userAgent",
  "url",
  "_edgeSwipeDetection",
  "_edgeSwipeThreshold",
  "_freeMode",
  "_autoHeight",
  "setWrapperSize",
  "virtualTranslate",
  "_effect",
  "breakpoints",
  "_spaceBetween",
  "_slidesPerView",
  "maxBackfaceHiddenSlides",
  "_grid",
  "_slidesPerGroup",
  "_slidesPerGroupSkip",
  "_slidesPerGroupAuto",
  "_centeredSlides",
  "_centeredSlidesBounds",
  "_slidesOffsetBefore",
  "_slidesOffsetAfter",
  "normalizeSlideIndex",
  "_centerInsufficientSlides",
  "_watchOverflow",
  "roundLengths",
  "touchRatio",
  "touchAngle",
  "simulateTouch",
  "_shortSwipes",
  "_longSwipes",
  "longSwipesRatio",
  "longSwipesMs",
  "_followFinger",
  "allowTouchMove",
  "_threshold",
  "touchMoveStopPropagation",
  "touchStartPreventDefault",
  "touchStartForcePreventDefault",
  "touchReleaseOnEdges",
  "uniqueNavElements",
  "_resistance",
  "_resistanceRatio",
  "_watchSlidesProgress",
  "_grabCursor",
  "preventClicks",
  "preventClicksPropagation",
  "_slideToClickedSlide",
  "_preloadImages",
  "updateOnImagesReady",
  "_loop",
  "_loopAdditionalSlides",
  "_loopedSlides",
  "_loopedSlidesLimit",
  "_loopFillGroupWithBlank",
  "loopPreventsSlide",
  "_rewind",
  "_allowSlidePrev",
  "_allowSlideNext",
  "_swipeHandler",
  "_noSwiping",
  "noSwipingClass",
  "noSwipingSelector",
  "passiveListeners",
  "containerModifierClass",
  "slideClass",
  "slideBlankClass",
  "slideActiveClass",
  "slideDuplicateActiveClass",
  "slideVisibleClass",
  "slideDuplicateClass",
  "slideNextClass",
  "slideDuplicateNextClass",
  "slidePrevClass",
  "slideDuplicatePrevClass",
  "wrapperClass",
  "runCallbacksOnInit",
  "observer",
  "observeParents",
  "observeSlideChildren",
  // modules
  "a11y",
  "_autoplay",
  "_controller",
  "coverflowEffect",
  "cubeEffect",
  "fadeEffect",
  "flipEffect",
  "creativeEffect",
  "cardsEffect",
  "hashNavigation",
  "history",
  "keyboard",
  "lazy",
  "mousewheel",
  "_navigation",
  "_pagination",
  "parallax",
  "_scrollbar",
  "_thumbs",
  "virtual",
  "zoom"
];
function Ni(e = {}, i = !0) {
  const t = {
    on: {}
  }, s = {}, n = {};
  N(t, H.defaults), N(t, H.extendedDefaults), t._emitClasses = !0, t.init = !1;
  const r = {}, a = Oe.map((l) => l.replace(/_/, "")), d = Object.assign({}, e);
  return Object.keys(d).forEach((l) => {
    typeof e[l] > "u" || (a.indexOf(l) >= 0 ? B(e[l]) ? (t[l] = {}, n[l] = {}, N(t[l], e[l]), N(n[l], e[l])) : (t[l] = e[l], n[l] = e[l]) : l.search(/on[A-Z]/) === 0 && typeof e[l] == "function" ? i ? s[`${l[2].toLowerCase()}${l.substr(3)}`] = e[l] : t.on[`${l[2].toLowerCase()}${l.substr(3)}`] = e[l] : r[l] = e[l]);
  }), ["navigation", "pagination", "scrollbar"].forEach((l) => {
    t[l] === !0 && (t[l] = {}), t[l] === !1 && delete t[l];
  }), {
    params: t,
    passedParams: n,
    rest: r,
    events: s
  };
}
function Gi({
  el: e,
  nextEl: i,
  prevEl: t,
  paginationEl: s,
  scrollbarEl: n,
  swiper: r
}, a) {
  Ce(a) && i && t && (r.params.navigation.nextEl = i, r.originalParams.navigation.nextEl = i, r.params.navigation.prevEl = t, r.originalParams.navigation.prevEl = t), ye(a) && s && (r.params.pagination.el = s, r.originalParams.pagination.el = s), Me(a) && n && (r.params.scrollbar.el = n, r.originalParams.scrollbar.el = n), r.init(e);
}
const Pe = (e, i) => {
  let t = i.slidesPerView;
  if (i.breakpoints) {
    const n = H.prototype.getBreakpoint(i.breakpoints), r = n in i.breakpoints ? i.breakpoints[n] : void 0;
    r && r.slidesPerView && (t = r.slidesPerView);
  }
  let s = Math.ceil(parseFloat(i.loopedSlides || t, 10));
  return s += i.loopAdditionalSlides, s > e.length && i.loopedSlidesLimit && (s = e.length), s;
};
function Bi(e, i, t) {
  const s = i.map((l, o) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(l, {
    swiper: e,
    "data-swiper-slide-index": o
  }));
  function n(l, o, c) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(l, {
      key: `${l.key}-duplicate-${o}-${c}`,
      className: `${l.props.className || ""} ${t.slideDuplicateClass}`
    });
  }
  if (t.loopFillGroupWithBlank) {
    const l = t.slidesPerGroup - s.length % t.slidesPerGroup;
    if (l !== t.slidesPerGroup)
      for (let o = 0; o < l; o += 1) {
        const c = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
          className: `${t.slideClass} ${t.slideBlankClass}`
        });
        s.push(c);
      }
  }
  t.slidesPerView === "auto" && !t.loopedSlides && (t.loopedSlides = s.length);
  const r = Pe(s, t), a = [], d = [];
  for (let l = 0; l < r; l += 1) {
    const o = l - Math.floor(l / s.length) * s.length;
    d.push(n(s[o], l, "append")), a.unshift(n(s[s.length - o - 1], l, "prepend"));
  }
  return e && (e.loopedSlides = r), [...a, ...s, ...d];
}
function Vi(e, i, t, s, n) {
  const r = [];
  if (!i)
    return r;
  const a = (l) => {
    r.indexOf(l) < 0 && r.push(l);
  };
  if (t && s) {
    const l = s.map(n), o = t.map(n);
    l.join("") !== o.join("") && a("children"), s.length !== t.length && a("children");
  }
  return Oe.filter((l) => l[0] === "_").map((l) => l.replace(/_/, "")).forEach((l) => {
    if (l in e && l in i)
      if (B(e[l]) && B(i[l])) {
        const o = Object.keys(e[l]), c = Object.keys(i[l]);
        o.length !== c.length ? a(l) : (o.forEach((u) => {
          e[l][u] !== i[l][u] && a(l);
        }), c.forEach((u) => {
          e[l][u] !== i[l][u] && a(l);
        }));
      } else
        e[l] !== i[l] && a(l);
  }), r;
}
function $e(e) {
  return e.type && e.type.displayName && e.type.displayName.includes("SwiperSlide");
}
function _e(e) {
  const i = [];
  return react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(e).forEach((t) => {
    $e(t) ? i.push(t) : t.props && t.props.children && _e(t.props.children).forEach((s) => i.push(s));
  }), i;
}
function ji(e) {
  const i = [], t = {
    "container-start": [],
    "container-end": [],
    "wrapper-start": [],
    "wrapper-end": []
  };
  return react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(e).forEach((s) => {
    if ($e(s))
      i.push(s);
    else if (s.props && s.props.slot && t[s.props.slot])
      t[s.props.slot].push(s);
    else if (s.props && s.props.children) {
      const n = _e(s.props.children);
      n.length > 0 ? n.forEach((r) => i.push(r)) : t["container-end"].push(s);
    } else
      t["container-end"].push(s);
  }), {
    slides: i,
    slots: t
  };
}
function Hi({
  swiper: e,
  slides: i,
  passedParams: t,
  changedParams: s,
  nextEl: n,
  prevEl: r,
  scrollbarEl: a,
  paginationEl: d
}) {
  const l = s.filter((b) => b !== "children" && b !== "direction"), {
    params: o,
    pagination: c,
    navigation: u,
    scrollbar: f,
    virtual: h,
    thumbs: v
  } = e;
  let w, g, p, S, T;
  s.includes("thumbs") && t.thumbs && t.thumbs.swiper && o.thumbs && !o.thumbs.swiper && (w = !0), s.includes("controller") && t.controller && t.controller.control && o.controller && !o.controller.control && (g = !0), s.includes("pagination") && t.pagination && (t.pagination.el || d) && (o.pagination || o.pagination === !1) && c && !c.el && (p = !0), s.includes("scrollbar") && t.scrollbar && (t.scrollbar.el || a) && (o.scrollbar || o.scrollbar === !1) && f && !f.el && (S = !0), s.includes("navigation") && t.navigation && (t.navigation.prevEl || r) && (t.navigation.nextEl || n) && (o.navigation || o.navigation === !1) && u && !u.prevEl && !u.nextEl && (T = !0);
  const C = (b) => {
    e[b] && (e[b].destroy(), b === "navigation" ? (o[b].prevEl = void 0, o[b].nextEl = void 0, e[b].prevEl = void 0, e[b].nextEl = void 0) : (o[b].el = void 0, e[b].el = void 0));
  };
  l.forEach((b) => {
    if (B(o[b]) && B(t[b]))
      N(o[b], t[b]);
    else {
      const $ = t[b];
      ($ === !0 || $ === !1) && (b === "navigation" || b === "pagination" || b === "scrollbar") ? $ === !1 && C(b) : o[b] = t[b];
    }
  }), l.includes("controller") && !g && e.controller && e.controller.control && o.controller && o.controller.control && (e.controller.control = o.controller.control), s.includes("children") && i && h && o.virtual.enabled ? (h.slides = i, h.update(!0)) : s.includes("children") && e.lazy && e.params.lazy.enabled && e.lazy.load(), w && v.init() && v.update(!0), g && (e.controller.control = o.controller.control), p && (d && (o.pagination.el = d), c.init(), c.render(), c.update()), S && (a && (o.scrollbar.el = a), f.init(), f.updateSize(), f.setTranslate()), T && (n && (o.navigation.nextEl = n), r && (o.navigation.prevEl = r), u.init(), u.update()), s.includes("allowSlideNext") && (e.allowSlideNext = t.allowSlideNext), s.includes("allowSlidePrev") && (e.allowSlidePrev = t.allowSlidePrev), s.includes("direction") && e.changeDirection(t.direction, !1), e.update();
}
function Ri(e, i, t) {
  if (!t)
    return null;
  const s = e.isHorizontal() ? {
    [e.rtlTranslate ? "right" : "left"]: `${t.offset}px`
  } : {
    top: `${t.offset}px`
  };
  return i.filter((n, r) => r >= t.from && r <= t.to).map((n) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(n, {
    swiper: e,
    style: s
  }));
}
const Fi = (e) => {
  !e || e.destroyed || !e.params.virtual || e.params.virtual && !e.params.virtual.enabled || (e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), e.lazy && e.params.lazy.enabled && e.lazy.load(), e.parallax && e.params.parallax && e.params.parallax.enabled && e.parallax.setTranslate());
};
function W(e, i) {
  return typeof window > "u" ? (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(e, i) : (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(e, i);
}
const Wi = /* @__PURE__ */ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null), qi = /* @__PURE__ */ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
function ae() {
  return ae = Object.assign ? Object.assign.bind() : function(e) {
    for (var i = 1; i < arguments.length; i++) {
      var t = arguments[i];
      for (var s in t)
        Object.prototype.hasOwnProperty.call(t, s) && (e[s] = t[s]);
    }
    return e;
  }, ae.apply(this, arguments);
}
const Xi = /* @__PURE__ */ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(e, i) {
  let {
    className: t,
    tag: s = "div",
    wrapperTag: n = "div",
    children: r,
    onSwiper: a,
    ...d
  } = e === void 0 ? {} : e, l = !1;
  const [o, c] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("swiper"), [u, f] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), [h, v] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), w = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1), g = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), p = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), S = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), T = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), C = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), b = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), $ = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), G = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), {
    params: M,
    passedParams: R,
    rest: x,
    events: E
  } = Ni(d), {
    slides: y,
    slots: z
  } = ji(r), V = () => {
    v(!h);
  };
  Object.assign(M.on, {
    _containerClasses(P, j) {
      c(j);
    }
  });
  const F = () => {
    if (Object.assign(M.on, E), l = !0, p.current = new H(M), p.current.loopCreate = () => {
    }, p.current.loopDestroy = () => {
    }, M.loop && (p.current.loopedSlides = Pe(y, M)), p.current.virtual && p.current.params.virtual.enabled) {
      p.current.virtual.slides = y;
      const P = {
        cache: !1,
        slides: y,
        renderExternal: f,
        renderExternalUpdate: !1
      };
      N(p.current.params.virtual, P), N(p.current.originalParams.virtual, P);
    }
  };
  g.current || F(), p.current && p.current.on("_beforeBreakpoint", V);
  const J = () => {
    l || !E || !p.current || Object.keys(E).forEach((P) => {
      p.current.on(P, E[P]);
    });
  }, Q = () => {
    !E || !p.current || Object.keys(E).forEach((P) => {
      p.current.off(P, E[P]);
    });
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => () => {
    p.current && p.current.off("_beforeBreakpoint", V);
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    !w.current && p.current && (p.current.emitSlidesClasses(), w.current = !0);
  }), W(() => {
    if (i && (i.current = g.current), !!g.current)
      return p.current.destroyed && F(), Gi({
        el: g.current,
        nextEl: C.current,
        prevEl: b.current,
        paginationEl: $.current,
        scrollbarEl: G.current,
        swiper: p.current
      }, M), a && a(p.current), () => {
        p.current && !p.current.destroyed && p.current.destroy(!0, !1);
      };
  }, []), W(() => {
    J();
    const P = Vi(R, S.current, y, T.current, (j) => j.key);
    return S.current = R, T.current = y, P.length && p.current && !p.current.destroyed && Hi({
      swiper: p.current,
      slides: y,
      passedParams: R,
      changedParams: P,
      nextEl: C.current,
      prevEl: b.current,
      scrollbarEl: G.current,
      paginationEl: $.current
    }), () => {
      Q();
    };
  }), W(() => {
    Fi(p.current);
  }, [u]);
  function Y() {
    return M.virtual ? Ri(p.current, y, u) : !M.loop || p.current && p.current.destroyed ? y.map((P) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(P, {
      swiper: p.current
    })) : Bi(p.current, y, M);
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(s, ae({
    ref: g,
    className: Le(`${o}${t ? ` ${t}` : ""}`)
  }, x), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(qi.Provider, {
    value: p.current
  }, z["container-start"], /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(n, {
    className: "swiper-wrapper"
  }, z["wrapper-start"], Y(), z["wrapper-end"]), Ce(M) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    ref: b,
    className: "swiper-button-prev"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    ref: C,
    className: "swiper-button-next"
  })), Me(M) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    ref: G,
    className: "swiper-scrollbar"
  }), ye(M) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    ref: $,
    className: "swiper-pagination"
  }), z["container-end"]));
});
Xi.displayName = "Swiper";
function oe() {
  return oe = Object.assign ? Object.assign.bind() : function(e) {
    for (var i = 1; i < arguments.length; i++) {
      var t = arguments[i];
      for (var s in t)
        Object.prototype.hasOwnProperty.call(t, s) && (e[s] = t[s]);
    }
    return e;
  }, oe.apply(this, arguments);
}
const Yi = /* @__PURE__ */ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(e, i) {
  let {
    tag: t = "div",
    children: s,
    className: n = "",
    swiper: r,
    zoom: a,
    virtualIndex: d,
    ...l
  } = e === void 0 ? {} : e;
  const o = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), [c, u] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("swiper-slide");
  function f(w, g, p) {
    g === o.current && u(p);
  }
  W(() => {
    if (i && (i.current = o.current), !(!o.current || !r)) {
      if (r.destroyed) {
        c !== "swiper-slide" && u("swiper-slide");
        return;
      }
      return r.on("_slideClass", f), () => {
        r && r.off("_slideClass", f);
      };
    }
  }), W(() => {
    r && o.current && !r.destroyed && u(r.getSlideClasses(o.current));
  }, [r]);
  const h = {
    isActive: c.indexOf("swiper-slide-active") >= 0 || c.indexOf("swiper-slide-duplicate-active") >= 0,
    isVisible: c.indexOf("swiper-slide-visible") >= 0,
    isDuplicate: c.indexOf("swiper-slide-duplicate") >= 0,
    isPrev: c.indexOf("swiper-slide-prev") >= 0 || c.indexOf("swiper-slide-duplicate-prev") >= 0,
    isNext: c.indexOf("swiper-slide-next") >= 0 || c.indexOf("swiper-slide-duplicate-next") >= 0
  }, v = () => typeof s == "function" ? s(h) : s;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t, oe({
    ref: o,
    className: Le(`${c}${n ? ` ${n}` : ""}`),
    "data-swiper-slide-index": d
  }, l), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wi.Provider, {
    value: h
  }, a ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof a == "number" ? a : void 0
  }, v()) : v()));
});
Yi.displayName = "SwiperSlide";

//# sourceMappingURL=swiper.min-13551361.mjs.map


/***/ }),

/***/ 8643:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ l; },
/* harmony export */   "a": function() { return /* binding */ m; },
/* harmony export */   "b": function() { return /* binding */ y; },
/* harmony export */   "u": function() { return /* binding */ v; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);

function m(n, e, i = {}) {
  const { disabled: t = !1 } = i;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (t)
      return;
    const s = (o) => {
      o.key === n && (o.preventDefault(), e());
    };
    return document.addEventListener("keydown", s), () => {
      document.removeEventListener("keydown", s);
    };
  }, [n, e, t]);
}
const l = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(!1);
function v() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(l);
}
function y(n, e, i = {}) {
  const { disabled: t = !1, enableEscKey: s = !0 } = i;
  m("Escape", e, { disabled: t || !s }), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (t)
      return;
    const o = (r) => {
      const u = r.target;
      n.some(
        (d) => d.current?.contains(u)
      ) || (r.stopPropagation(), e());
    };
    return document.addEventListener("click", o), () => {
      document.removeEventListener("click", o);
    };
  }, [e, n, t, s]);
}

//# sourceMappingURL=useClickOutside-726e7c36.mjs.map


/***/ }),

/***/ 6230:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ X; },
/* harmony export */   "u": function() { return /* binding */ Y; }
/* harmony export */ });
/* unused harmony export a */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3406);
/* harmony import */ var _useClickOutside_726e7c36_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8643);



function M(l) {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (l)
      return;
    const s = [
      window.document.documentElement,
      window.document.body,
      window.document.getElementById("__next")
    ], a = s.map((o) => {
      const t = {
        overflow: o?.style.overflow || "",
        overflowX: o?.style.overflowX || "",
        overflowY: o?.style.overflowY || ""
      };
      return o && (o.style.overflow = "hidden", o.style.overflowX = "hidden", o.style.overflowY = "hidden"), t;
    });
    return () => {
      s.forEach((o, t) => {
        const e = a[t];
        o && (o.style.overflow = e.overflow, o.style.overflowX = e.overflowX, o.style.overflowY = e.overflowY);
      });
    };
  }, [l]);
}
const C = "modal", E = "modal__content", m = {
  modal: C,
  modalContent: E
};
function X({
  children: l,
  className: s,
  backdropClassName: a,
  backdropStyle: o,
  style: t,
  modalRef: e,
  id: d,
  closeModal: r
}) {
  return M(), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      ref: e,
      id: d,
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(m.modal, a),
      style: o,
      onClick: (n) => {
        n.stopPropagation(), r?.();
      },
      "data-testid": "modal"
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "div",
      {
        onClick: (n) => n.stopPropagation(),
        className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(m.modalContent, s),
        style: t,
        "data-testid": "modal-content"
      },
      l
    )
  );
}
function Y(l = {}) {
  const { onClose: s, onOpen: a, defaultOpen: o = !1 } = l, [, t] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useTransition)(), [e, d] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(o), r = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    t(() => {
      d(!0), a?.();
    });
  }, [a]), n = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    t(() => {
      d(!1), s?.();
    });
  }, [s]), u = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    () => e ? n() : r(),
    [e, r, n]
  );
  return (0,_useClickOutside_726e7c36_mjs__WEBPACK_IMPORTED_MODULE_2__.a)("Escape", n, { disabled: !e }), {
    isModalOpen: e,
    openModal: r,
    closeModal: n,
    toggleModalOpen: u
  };
}

//# sourceMappingURL=useModal-4683a76a.mjs.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(6321), __webpack_exec__(5817); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);